import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
    [_ in K]?: never
}
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    AWSDateTime: { input: any; output: any }
    AWSJSON: { input: any; output: any }
    AWSPhone: { input: any; output: any }
    /**
     * Implement the DateTime<Utc> scalar
     *
     * The input/output is a string in RFC3339 format.
     */
    DateTime: { input: any; output: any }
    /** A scalar that can represent any JSON Object value. */
    JSONObject: { input: any; output: any }
    /**
     * ISO 8601 calendar date without timezone.
     * Format: %Y-%m-%d
     *
     * # Examples
     *
     * * `1994-11-13`
     * * `2000-02-24`
     */
    NaiveDate: { input: any; output: any }
    /**
     * ISO 8601 combined date and time without timezone.
     *
     * # Examples
     *
     * * `2015-07-01T08:59:60.123`,
     */
    NaiveDateTime: { input: any; output: any }
}

export type Account = {
    __typename?: 'Account'
    accountName?: Maybe<Scalars['String']['output']>
    adsLastFetched?: Maybe<Scalars['AWSDateTime']['output']>
    authorised: Scalars['Boolean']['output']
    autoDeleteSevereContent: Scalars['Boolean']['output']
    autoFetchContent: Scalars['Boolean']['output']
    autoHideAdComments?: Maybe<Scalars['Boolean']['output']>
    autoHideSevereContent: Scalars['Boolean']['output']
    autoMuteSevereAccount: Scalars['Boolean']['output']
    createdAt?: Maybe<Scalars['AWSDateTime']['output']>
    dmsEnabled: Scalars['Boolean']['output']
    engageAccountId?: Maybe<Scalars['Int']['output']>
    fetchAds: Scalars['Boolean']['output']
    fetchPosts: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    isAuthorisationFailing?: Maybe<Scalars['Boolean']['output']>
    isSubscribed: Scalars['Boolean']['output']
    lastFetched?: Maybe<Scalars['AWSDateTime']['output']>
    llmClassificationEnabled: Scalars['Boolean']['output']
    llmEnableSuggestedReplies: Scalars['Boolean']['output']
    ownedBy?: Maybe<Scalars['String']['output']>
    postsLastFetched?: Maybe<Scalars['AWSDateTime']['output']>
    profileCollectionEnabled: Scalars['Boolean']['output']
    profileModerationEnabled: Scalars['Boolean']['output']
    scrapeContent: Scalars['Boolean']['output']
    serviceAccountId: Scalars['String']['output']
    serviceAccountUsername?: Maybe<Scalars['String']['output']>
    socialMediaService: SocialMediaService
    team?: Maybe<Team>
}

export type AccountConnection = {
    __typename?: 'AccountConnection'
    items: Array<Account>
    total: Scalars['Int']['output']
}

/**
 * One health fact about one account, in the shape every health query
 * returns — so the UI has one pill component rather than one per datum,
 * and a new signal costs a query, not a design.
 */
export type AccountHealthSignal = {
    __typename?: 'AccountHealthSignal'
    accountId: Scalars['Int']['output']
    /** The tooltip — what is actually wrong, or what is going right. */
    detail?: Maybe<Scalars['String']['output']>
    /**
     * The pill's text: short enough to sit inline beside its siblings,
     * e.g. "jobs".
     */
    label: Scalars['String']['output']
    status: AccountHealthStatus
}

/**
 * How much attention an account health signal wants. Deliberately about
 * attention rather than about the mechanism, so every signal —
 * authorisation, permissions, webhook subscription, monitoring — sorts and
 * colours the same way wherever it is shown.
 *
 * Named for accounts because `HealthStatus` already belongs to SERVICE
 * health (see `heartbeat`), which is a different subject: whether a
 * process is alive, not whether a profile is configured to collect.
 */
export enum AccountHealthStatus {
    /** Working as intended. */
    Ok = 'OK',
    /** Needs a person. */
    Problem = 'PROBLEM',
    /** Not broken, but not delivering yet either. */
    Warning = 'WARNING'
}

/**
 * One account's monitoring, as its settings page needs it: the schedule,
 * and everything that has run for the account.
 */
export type AccountMonitoring = {
    __typename?: 'AccountMonitoring'
    /** The account's monitoring schedule, or null if it has none. */
    monitor?: Maybe<ScheduledWork>
    /**
     * Every run for this account, newest first: the monitor's runs, its
     * retries, and any historic fetches.
     */
    runs: Array<ScheduledWorkRun>
    /**
     * What that schedule was set up to do. Null when there is no
     * monitor, or when its stored params cannot be read.
     */
    settings?: Maybe<MonitorSettings>
}

/** Maps to `AccountRecord` */
export type AccountRecord = {
    __typename?: 'AccountRecord'
    accountName?: Maybe<Scalars['String']['output']>
    adsLastFetched?: Maybe<Scalars['NaiveDateTime']['output']>
    autoDeleteSevereContent: Scalars['Boolean']['output']
    autoHideAllAdComments?: Maybe<Scalars['Boolean']['output']>
    autoHideSevereContent: Scalars['Boolean']['output']
    autoMuteSevereAccount: Scalars['Boolean']['output']
    classifyContent: Scalars['Boolean']['output']
    createdAt: Scalars['DateTime']['output']
    dmsEnabled: Scalars['Boolean']['output']
    engageAccountId?: Maybe<Scalars['Int']['output']>
    fetchAds: Scalars['Boolean']['output']
    fetchContent: Scalars['Boolean']['output']
    fetchPosts: Scalars['Boolean']['output']
    hasAuthorisation: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    /**
     * For Instagram accounts, indicates whether the account was added via
     * "Individual" (direct Instagram auth) or "Organisation" (Facebook-based auth).
     * Returns None for non-Instagram accounts or accounts without authorisation.
     */
    instagramAuthMethod?: Maybe<Scalars['String']['output']>
    isSubscribed: Scalars['Boolean']['output']
    lastFetched?: Maybe<Scalars['DateTime']['output']>
    latestFetchedServiceContentId?: Maybe<Scalars['String']['output']>
    llmClassificationEnabled: Scalars['Boolean']['output']
    llmEnableSuggestedReplies: Scalars['Boolean']['output']
    ownedBy?: Maybe<Scalars['String']['output']>
    pageId?: Maybe<Scalars['String']['output']>
    postsLastFetched?: Maybe<Scalars['NaiveDateTime']['output']>
    profileCollectionEnabled: Scalars['Boolean']['output']
    profileModerationEnabled: Scalars['Boolean']['output']
    /** Days after publishing that a post stops being fetched or scraped. */
    retirePostDays: Scalars['Int']['output']
    scrapeContent: Scalars['Boolean']['output']
    serviceAccountId: Scalars['String']['output']
    serviceAccountUsername?: Maybe<Scalars['String']['output']>
    shadowBanningEnabled: Scalars['Boolean']['output']
    shadowBanningRangeInDays: Scalars['Int']['output']
    shadowBanningThreshold: Scalars['Int']['output']
    socialMediaServiceDisplayName?: Maybe<Scalars['String']['output']>
    socialMediaServiceId: Scalars['Int']['output']
    socialMediaServiceShortName?: Maybe<Scalars['String']['output']>
    teamId?: Maybe<Scalars['Int']['output']>
    teamName?: Maybe<Scalars['String']['output']>
    toggles: AccountTogglesView
    updatedAt?: Maybe<Scalars['DateTime']['output']>
    userId: Scalars['Int']['output']
}

export type AccountTogglesView = {
    __typename?: 'AccountTogglesView'
    crossProfileEngage: Scalars['Boolean']['output']
    enableScreenshots: Scalars['Boolean']['output']
}

export type AddYouTubeSubcription = {
    __typename?: 'AddYouTubeSubcription'
    success?: Maybe<Scalars['Boolean']['output']>
}

/**
 * Scope for the admin Posts page. As with the content search, explicit
 * account ids take precedence over team ids rather than combining with them.
 */
export type AdminPostSearchParamsView = {
    accountIds?: InputMaybe<Array<Scalars['Int']['input']>>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    socialMediaServiceIds?: InputMaybe<Array<Scalars['Int']['input']>>
    teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
    /** Case-insensitive substring match on the post title. */
    titleContains?: InputMaybe<Scalars['String']['input']>
}

export type AdminPostSearchResultView = {
    __typename?: 'AdminPostSearchResultView'
    posts: Array<AdminPostView>
    /** Posts matching the scope, ignoring paging. */
    total: Scalars['Int']['output']
}

/**
 * A post as the admin Posts page shows it: the post, who owns it, and how many
 * comments we hold for it by moderation outcome.
 */
export type AdminPostView = {
    __typename?: 'AdminPostView'
    accountId: Scalars['Int']['output']
    accountName?: Maybe<Scalars['String']['output']>
    /** Every Content row we hold under this post, moderated or not. */
    collectedCommentCount: Scalars['Int']['output']
    /**
     * When Arwen first ingested the post, as distinct from when it was
     * published; the gap is how late collection started.
     */
    createdAt: Scalars['DateTime']['output']
    id: Scalars['Int']['output']
    isAd: Scalars['Boolean']['output']
    isDeleted: Scalars['Boolean']['output']
    lastFetched?: Maybe<Scalars['DateTime']['output']>
    /**
     * The platform's own comment count where the fetcher records one. Not
     * the same as `collected_comment_count`: collection is not uniform across
     * platforms, so the two can legitimately differ.
     */
    platformCommentCount?: Maybe<Scalars['Int']['output']>
    /** When `platform_comment_count` was last read from the platform. */
    platformCommentCountFetchedAt?: Maybe<Scalars['DateTime']['output']>
    /** The `PostType` variant name, e.g. `InstagramPost`. */
    postType: Scalars['String']['output']
    publishTime: Scalars['DateTime']['output']
    safeCount: Scalars['Int']['output']
    serviceAccountUsername?: Maybe<Scalars['String']['output']>
    servicePostId: Scalars['String']['output']
    severeCount: Scalars['Int']['output']
    shouldFetch: Scalars['Boolean']['output']
    socialMediaServiceId: Scalars['Int']['output']
    socialMediaServiceShortName: Scalars['String']['output']
    suspectCount: Scalars['Int']['output']
    teamId?: Maybe<Scalars['Int']['output']>
    teamName?: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    uri: Scalars['String']['output']
}

export enum AdsOrOrganicFilterView {
    Ads = 'ADS',
    Both = 'BOTH',
    Organic = 'ORGANIC'
}

export enum AuthorisationStatusFilter {
    All = 'ALL',
    AuthorisationFailing = 'AUTHORISATION_FAILING',
    Authorised = 'AUTHORISED',
    Unauthorised = 'UNAUTHORISED'
}

/**
 * This represents an authorised account. On the server-side this struct incldues
 * the tokens, but this struct is a view of that, and it goes to the browser, so it
 * must not include the tokens, which are secrets.
 */
export type AuthorisedAccountView = {
    __typename?: 'AuthorisedAccountView'
    accountName?: Maybe<Scalars['String']['output']>
    failureDate?: Maybe<Scalars['DateTime']['output']>
    id: Scalars['Int']['output']
    isFailing: Scalars['Boolean']['output']
    lastFailureNotificationDate?: Maybe<Scalars['DateTime']['output']>
    pageId?: Maybe<Scalars['String']['output']>
    serviceAccountId: Scalars['String']['output']
    serviceAccountUsername?: Maybe<Scalars['String']['output']>
    socialMediaServiceName: Scalars['String']['output']
}

export type BooleanFilterInput = {
    eq?: InputMaybe<Scalars['Boolean']['input']>
    ne?: InputMaybe<Scalars['Boolean']['input']>
}

export type ChatResponse = {
    __typename?: 'ChatResponse'
    /** The assistant's reply generated for the final user message in the conversation. */
    reply: Scalars['String']['output']
    /** High-level summary of the dataset used to seed the chat context. */
    summary: Scalars['String']['output']
}

/** Response from polling a chat task status. */
export type ChatTaskStatusResponse = {
    __typename?: 'ChatTaskStatusResponse'
    /** When the task was created. */
    createdAt: Scalars['DateTime']['output']
    /** Error message if status is FAILED. */
    errorMessage?: Maybe<Scalars['String']['output']>
    /** The result if status is SUCCESS. */
    result?: Maybe<ChatResponse>
    /** Current status of the task. */
    status: ChatTaskStatusView
    /** When the task was last updated. */
    updatedAt: Scalars['DateTime']['output']
}

/** Status of an asynchronous chat task. */
export enum ChatTaskStatusView {
    /** Task failed with an error. */
    Failed = 'FAILED',
    /** Task created, waiting to start processing. */
    Pending = 'PENDING',
    /** Task completed successfully. */
    Success = 'SUCCESS',
    /** LLM is processing the request. */
    Thinking = 'THINKING'
}

export type ClassificationResult = {
    __typename?: 'ClassificationResult'
    classification: Scalars['Float']['output']
    classifier?: Maybe<ClassifierDetails>
    contentId: Scalars['Int']['output']
}

/**
 * What one classifier concluded about one comment, as stamped at
 * classification time by `raku_service::stamp` against the account's
 * boundaries then in force. The discriminants are the `tinyint` stored in
 * `ClassificationResult.result`.
 *
 * Sent to the UI so a pill can colour itself without refetching the account's
 * moderation boundaries and recomparing every score. The trade is that a
 * client who edits their boundaries does not recolour old comments until those
 * are reclassified. — Claude
 */
export enum ClassificationResultView {
    Maybe = 'MAYBE',
    No = 'NO',
    Unevaluated = 'UNEVALUATED',
    Yes = 'YES'
}

export type ClassificationResultsConnection = {
    __typename?: 'ClassificationResultsConnection'
    result?: Maybe<Array<ClassificationResult>>
}

export type ClassificationService = {
    __typename?: 'ClassificationService'
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription?: Maybe<Scalars['String']['output']>
    shortDescription?: Maybe<Scalars['String']['output']>
    shortName: Scalars['String']['output']
}

/** A page of the Profiles view (EN-259 "Applied to"). */
export type ClassifierDeployedProfiles = {
    __typename?: 'ClassifierDeployedProfiles'
    items: Array<DeployedProfile>
    total: Scalars['Int']['output']
}

/** A page of the Teams view (EN-259 "Applied to"). */
export type ClassifierDeploymentTeams = {
    __typename?: 'ClassifierDeploymentTeams'
    items: Array<TeamCoverage>
    total: Scalars['Int']['output']
}

/**
 * The full classifier definition including the EN-258 fields (client-facing name,
 * modality). Used by the admin management UI.
 */
export type ClassifierDetailFull = {
    __typename?: 'ClassifierDetailFull'
    archived: Scalars['Boolean']['output']
    clientFacingName: Scalars['String']['output']
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription: Scalars['String']['output']
    modality: Modality
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
    valence: Valence
}

export type ClassifierDetailView = {
    __typename?: 'ClassifierDetailView'
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription: Scalars['String']['output']
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

export type ClassifierDetails = {
    __typename?: 'ClassifierDetails'
    displayName: Scalars['String']['output']
    id?: Maybe<Scalars['Int']['output']>
    longDescription?: Maybe<Scalars['String']['output']>
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

/** A page of classifier-library rows plus the total count, for pagination. */
export type ClassifierLibrary = {
    __typename?: 'ClassifierLibrary'
    items: Array<ClassifierLibraryRow>
    total: Scalars['Int']['output']
}

/** One row of the classifier-library list (EN-259). */
export type ClassifierLibraryRow = {
    __typename?: 'ClassifierLibraryRow'
    archived: Scalars['Boolean']['output']
    coveredProfiles: Scalars['Int']['output']
    coveredTeams: Scalars['Int']['output']
    displayName: Scalars['String']['output']
    draftVersion?: Maybe<Scalars['Int']['output']>
    id: Scalars['Int']['output']
    latestVersion: Scalars['Int']['output']
    liveVersion?: Maybe<Scalars['Int']['output']>
    modality: Modality
    /** Stored name of the newest version's model, e.g. "gemini-2.5-flash-lite". */
    model: Scalars['String']['output']
    shortDescription: Scalars['String']['output']
    updatedAt: Scalars['DateTime']['output']
    valence: Valence
    versionCount: Scalars['Int']['output']
}

/**
 * Whether a proposed classifier shortName is free. `conflictingDisplayName` names
 * the classifier holding it — worth returning because the collision is often with a
 * legacy classifier the admin cannot see anywhere in the library.
 */
export type ClassifierNameAvailability = {
    __typename?: 'ClassifierNameAvailability'
    available: Scalars['Boolean']['output']
    conflictingDisplayName?: Maybe<Scalars['String']['output']>
}

export type ClassifierPrompt = {
    __typename?: 'ClassifierPrompt'
    classifierDetailsId: Scalars['Int']['output']
    createdAt: Scalars['DateTime']['output']
    createdBy?: Maybe<Scalars['Int']['output']>
    defaultBorderlineThreshold?: Maybe<Scalars['Float']['output']>
    defaultConfirmedThreshold?: Maybe<Scalars['Float']['output']>
    id: Scalars['Int']['output']
    model: Scalars['String']['output']
    prompt: Scalars['String']['output']
    status: ClassifierPromptStatus
    updatedAt: Scalars['DateTime']['output']
    updatedBy?: Maybe<Scalars['Int']['output']>
    version: Scalars['Int']['output']
}

export enum ClassifierPromptStatus {
    Archived = 'ARCHIVED',
    Draft = 'DRAFT',
    Live = 'LIVE'
}

export type ClassifierSearchParamsInput = {
    category?: InputMaybe<Scalars['String']['input']>
    classifierName: Scalars['String']['input']
    threshold?: InputMaybe<Scalars['Float']['input']>
}

export type ClassifierSearchParamsView = {
    __typename?: 'ClassifierSearchParamsView'
    category?: Maybe<Scalars['String']['output']>
    classifierName: Scalars['String']['output']
    threshold?: Maybe<Scalars['Float']['output']>
}

/** Filters and paging for the classifier library. Every filter is optional. */
export type ClassifierSearchView = {
    /** Only classifiers deployed to any of these profiles. */
    accountIds?: InputMaybe<Array<Scalars['Int']['input']>>
    /** `false` = active only, `true` = archived only, omitted = both. */
    archived?: InputMaybe<Scalars['Boolean']['input']>
    limit: Scalars['Int']['input']
    modality?: InputMaybe<Modality>
    offset: Scalars['Int']['input']
    /** Matches display name or short description. */
    search?: InputMaybe<Scalars['String']['input']>
    /** Only classifiers deployed to any profile in this team. */
    teamId?: InputMaybe<Scalars['Int']['input']>
    valence?: InputMaybe<Valence>
}

export type ClassifierView = {
    __typename?: 'ClassifierView'
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription: Scalars['String']['output']
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

/**
 * One comment's whole thread, for the conversation drawer: the drawer opens
 * from a single comment card and shows the post, the thread's top-level
 * comment and every reply Arwen holds under it.
 *
 * `replies` is a flat list in date order, not a tree. Each reply carries its
 * parent's platform id in `inReplyToStatusId`, and the frontend nests a reply
 * under the comment whose `serviceContentId` equals it. Sending a flat list
 * keeps one shape for every depth of thread, and the drawer needs the date
 * order anyway to show replies chronologically within each level.
 *
 * The post conversation page uses `PostConversationPageView` instead, because it
 * answers a different question. The drawer shows one thread completely and
 * unfiltered, so it needs no paging and no filter flags. The post page shows
 * every thread on a post, so it pages through them, applies the filter bar,
 * previews only a few replies per thread, and flags each comment as matching
 * or filtered. Folding the two into one type would leave most fields
 * meaningless on one screen or the other.
 */
export type CommentThreadView = {
    __typename?: 'CommentThreadView'
    /** True when the platform supports an on-demand fetch and the cooldown allows one. */
    canRefresh: Scalars['Boolean']['output']
    /** The comment the drawer was opened from. */
    focusContentId: Scalars['Int']['output']
    /** Non-fatal problems from the last refresh, in plain English; empty on a plain read. */
    notices: Array<Scalars['String']['output']>
    /** True when `root` names a parent Arwen does not hold. */
    parentMissing: Scalars['Boolean']['output']
    /** Null when Arwen does not hold the post. */
    post?: Maybe<ConversationPostView>
    /** Every held descendant of `root`, ordered by date posted. */
    replies: Array<ContentView>
    /**
     * The top of the thread as far as Arwen holds it. Equals the focus comment
     * when it is top-level or its parent is not held.
     */
    root?: Maybe<ContentView>
}

export type Content = {
    __typename?: 'Content'
    account?: Maybe<Account>
    accountId: Scalars['Int']['output']
    actions: Array<ContentAction>
    classificationResults?: Maybe<Array<Maybe<ClassificationResult>>>
    content: Scalars['String']['output']
    datePosted: Scalars['AWSDateTime']['output']
    id: Scalars['Int']['output']
    inReplyToStatusId?: Maybe<Scalars['String']['output']>
    inReplyToUserId?: Maybe<Scalars['String']['output']>
    inReplyToUsername?: Maybe<Scalars['String']['output']>
    is_owned?: Maybe<Scalars['Boolean']['output']>
    media: Array<ContentMedia>
    moderations: Array<Moderation>
    originalPostAuthorId?: Maybe<Scalars['String']['output']>
    originalPostAuthorName?: Maybe<Scalars['String']['output']>
    originalPostId?: Maybe<Scalars['String']['output']>
    originalPostLink?: Maybe<Scalars['String']['output']>
    originalPostLinkId?: Maybe<Scalars['String']['output']>
    public: Scalars['Boolean']['output']
    queuedActions: Array<ContentAction>
    serviceAuthorId?: Maybe<Scalars['String']['output']>
    serviceAuthorName?: Maybe<Scalars['String']['output']>
    serviceAuthorUsername?: Maybe<Scalars['String']['output']>
    serviceContentId: Scalars['String']['output']
}

export enum ContentAction {
    Block = 'BLOCK',
    ConfirmSpam = 'CONFIRM_SPAM',
    Delete = 'DELETE',
    Dismiss = 'DISMISS',
    Hide = 'HIDE',
    Like = 'LIKE',
    Mute = 'MUTE',
    Reply = 'REPLY',
    Report = 'REPORT',
    Unblock = 'UNBLOCK'
}

export type ContentActionBusiness = {
    __typename?: 'ContentActionBusiness'
    action: Scalars['String']['output']
    actionOn: Scalars['AWSDateTime']['output']
    active: Scalars['Boolean']['output']
    automated: Scalars['Boolean']['output']
    contentId: Scalars['Int']['output']
    createdAt: Scalars['AWSDateTime']['output']
    id?: Maybe<Scalars['Int']['output']>
    message?: Maybe<Scalars['String']['output']>
    queued: Scalars['Boolean']['output']
    retryAt?: Maybe<Scalars['AWSDateTime']['output']>
    updatedAt?: Maybe<Scalars['AWSDateTime']['output']>
    userId?: Maybe<Scalars['Int']['output']>
}

export type ContentActionResult = {
    __typename?: 'ContentActionResult'
    contentAction?: Maybe<ContentActionView>
    contentId: Scalars['Int']['output']
    message?: Maybe<Scalars['String']['output']>
    success: Scalars['Boolean']['output']
}

export type ContentActionView = {
    __typename?: 'ContentActionView'
    action: Scalars['String']['output']
    actionOn: Scalars['NaiveDateTime']['output']
    actionedByAccountId?: Maybe<Scalars['Int']['output']>
    active: Scalars['Boolean']['output']
    automated: Scalars['Boolean']['output']
    contentId: Scalars['Int']['output']
    id: Scalars['Int']['output']
    message?: Maybe<Scalars['String']['output']>
    queued: Scalars['Boolean']['output']
    replyContentId?: Maybe<Scalars['Int']['output']>
    retryAt?: Maybe<Scalars['NaiveDateTime']['output']>
    userId?: Maybe<Scalars['Int']['output']>
}

export type ContentClassificationView = {
    __typename?: 'ContentClassificationView'
    classification?: Maybe<Scalars['Float']['output']>
    /**
     * `ClassifierDetails.clientFacingName`, the label a pill shows. `None` for
     * image classifications, which have no name to offer beyond
     * `classifier_name`. — Claude
     */
    classifierDisplayName?: Maybe<Scalars['String']['output']>
    classifierName: Scalars['String']['output']
    /**
     * `None` where only a score was stored and no verdict with it. Callers
     * must fall back to comparing `classification` against the account's
     * boundaries when it is absent. — Claude
     */
    result?: Maybe<ClassificationResultView>
}

export type ContentClassifierMetadataView = {
    __typename?: 'ContentClassifierMetadataView'
    classifierDisplayName: Scalars['String']['output']
    classifierId: Scalars['Int']['output']
    classifierName: Scalars['String']['output']
    contentCount: Scalars['Int']['output']
}

export type ContentConnection = {
    __typename?: 'ContentConnection'
    items?: Maybe<Array<Content>>
}

export type ContentFeedCreate = {
    description?: InputMaybe<Scalars['String']['input']>
    displayName: Scalars['String']['input']
    searchParameters: ContentSearchParams
    userId?: InputMaybe<Scalars['Int']['input']>
}

export type ContentFeedUpdate = {
    description?: InputMaybe<Scalars['String']['input']>
    displayName?: InputMaybe<Scalars['String']['input']>
    id: Scalars['Int']['input']
    searchParameters?: InputMaybe<ContentSearchParams>
    userId?: InputMaybe<Scalars['Int']['input']>
}

export type ContentFeedView = {
    __typename?: 'ContentFeedView'
    createdAt: Scalars['DateTime']['output']
    description?: Maybe<Scalars['String']['output']>
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    searchParameters: ContentSearchParamsView
    updatedAt: Scalars['DateTime']['output']
    userId: Scalars['Int']['output']
}

export type ContentFilterInput = {
    accountIds: Array<Scalars['Int']['input']>
    endDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>
    moderation?: InputMaybe<Scalars['String']['input']>
    socialMediaServiceIds: Array<Scalars['Int']['input']>
    startDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>
}

export type ContentMedia = {
    __typename?: 'ContentMedia'
    mediaClassifications?: Maybe<Array<Maybe<MediaClassification>>>
    mediaType?: Maybe<Scalars['String']['output']>
    publicUrl?: Maybe<Scalars['String']['output']>
    serviceMediaId?: Maybe<Scalars['String']['output']>
}

/**
 * The enums attached to this struct and it's members aren't seralizable
 * by Apollo, so we're going to send them as Strings.
 *
 * `public_url` is the original platform CDN URL (kept for audit and as a
 * fallback). `presigned_url` is a short-lived URL for our S3 copy, minted on
 * every resolve — this is what the frontend should render. Same shape as
 * `ScreenshotView`, which uses the same presigner.
 */
export type ContentMediaView = {
    __typename?: 'ContentMediaView'
    mediaClassifications: Array<ContentClassificationView>
    mediaType: Scalars['String']['output']
    presignedUrl?: Maybe<Scalars['String']['output']>
    publicUrl: Scalars['String']['output']
    serviceMediaId: Scalars['String']['output']
}

/**
 * This is the input parameter list associated with the GraphQL endpoints. It must remain a subset of
 * `ContentSearchParamsRecord` and ideally be identical. We require this and ContentSearchParamsView because you
 * cannot implement SimpleObject and InputObject on the same struct.
 */
export type ContentSearchParams = {
    accountIds?: InputMaybe<Array<Scalars['Int']['input']>>
    adsOrOrganic?: InputMaybe<AdsOrOrganicFilterView>
    authorProfileIds: Array<Scalars['Int']['input']>
    before?: InputMaybe<Scalars['DateTime']['input']>
    classifierSearchParams?: InputMaybe<Array<ClassifierSearchParamsInput>>
    containsText?: InputMaybe<Scalars['String']['input']>
    contentIds?: InputMaybe<Array<Scalars['Int']['input']>>
    dmFilter: DmFilter
    excludeOwnComments?: InputMaybe<Scalars['Boolean']['input']>
    hasMedia?: InputMaybe<Scalars['Boolean']['input']>
    maxResults?: InputMaybe<Scalars['Int']['input']>
    moderationCode?: InputMaybe<Array<Scalars['Int']['input']>>
    moderationString?: InputMaybe<Array<Scalars['String']['input']>>
    owned?: InputMaybe<Scalars['Boolean']['input']>
    /** Comments under these posts only. Drives the admin Posts detail page. */
    postIds?: InputMaybe<Array<Scalars['Int']['input']>>
    readFilter?: InputMaybe<ReadFilterView>
    since?: InputMaybe<Scalars['DateTime']['input']>
    skipResults?: InputMaybe<Scalars['Int']['input']>
    socialMediaServiceIds?: InputMaybe<Array<Scalars['Int']['input']>>
    teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
    timeDuration?: InputMaybe<Scalars['String']['input']>
    timeOffset?: InputMaybe<Scalars['String']['input']>
}

/**
 * This is the output parameter list associated with the GraphQL endpoints. It must remain a subset of
 * `ContentSearchParamsRecord` and ideally be identical. We require this and ContentSearchParamsInput because you
 * cannot implement SimpleObject and InputObject on the same struct. These are all option, not because of
 * the front end, but because there are JSONs in the database without some of these fields, and if we add
 * one which is not optional, then deserialising into it will break.
 */
export type ContentSearchParamsView = {
    __typename?: 'ContentSearchParamsView'
    accountIds?: Maybe<Array<Scalars['Int']['output']>>
    adsOrOrganic?: Maybe<AdsOrOrganicFilterView>
    authorProfileIds?: Maybe<Array<Scalars['Int']['output']>>
    before?: Maybe<Scalars['DateTime']['output']>
    classifierSearchParams?: Maybe<Array<ClassifierSearchParamsView>>
    containsText?: Maybe<Scalars['String']['output']>
    contentIds?: Maybe<Array<Scalars['Int']['output']>>
    dmFilter: DmFilter
    excludeOwnComments?: Maybe<Scalars['Boolean']['output']>
    hasMedia?: Maybe<Scalars['Boolean']['output']>
    maxResults?: Maybe<Scalars['Int']['output']>
    moderationCode?: Maybe<Array<Scalars['Int']['output']>>
    moderationString?: Maybe<Array<Scalars['String']['output']>>
    owned?: Maybe<Scalars['Boolean']['output']>
    postIds?: Maybe<Array<Scalars['Int']['output']>>
    readFilter?: Maybe<ReadFilterView>
    since?: Maybe<Scalars['DateTime']['output']>
    skipResults?: Maybe<Scalars['Int']['output']>
    socialMediaServiceIds?: Maybe<Array<Scalars['Int']['output']>>
    teamIds?: Maybe<Array<Scalars['Int']['output']>>
    timeDuration?: Maybe<Scalars['String']['output']>
    timeOffset?: Maybe<Scalars['String']['output']>
}

/** GraphQL response for getting the status/results of a content search task. */
export type ContentSearchTaskResult = {
    __typename?: 'ContentSearchTaskResult'
    /** When the task completed (if finished) */
    completedAt?: Maybe<Scalars['DateTime']['output']>
    /** Elapsed time in milliseconds since task started */
    elapsedMs: Scalars['Int']['output']
    /** Error message if the task failed */
    error?: Maybe<Scalars['String']['output']>
    /** Human-readable status message */
    message: Scalars['String']['output']
    /** Search results (only populated when status is Completed) */
    results?: Maybe<Array<ContentView>>
    /** When the task was started */
    startedAt: Scalars['DateTime']['output']
    /** Current status of the task */
    status: ContentSearchTaskStatus
}

/** GraphQL response for starting a content search task. */
export type ContentSearchTaskStarted = {
    __typename?: 'ContentSearchTaskStarted'
    /**
     * Inline result if the search completed within the wait window.
     * When present, the frontend can skip polling entirely.
     */
    result?: Maybe<ContentSearchTaskResult>
    /** When the task was started */
    startedAt: Scalars['DateTime']['output']
    /** Unique identifier for the task (use this to poll for results) */
    taskId: Scalars['String']['output']
}

/** Status of an async content search task. */
export enum ContentSearchTaskStatus {
    /** Task completed successfully */
    Completed = 'COMPLETED',
    /** Task failed with an error */
    Failed = 'FAILED',
    /** Task has been created but not yet started processing */
    Pending = 'PENDING',
    /** Task is retrieving content from the database */
    RetrievingData = 'RETRIEVING_DATA'
}

/** A summary of content with the usual severe/suspect/safe buckets */
export type ContentSummary = {
    __typename?: 'ContentSummary'
    countSafe?: Maybe<Scalars['Int']['output']>
    countSevere?: Maybe<Scalars['Int']['output']>
    countSuspect?: Maybe<Scalars['Int']['output']>
}

export type ContentToEnrich = {
    accountId: Scalars['Int']['input']
    id: Scalars['Int']['input']
    originalPostId?: InputMaybe<Scalars['String']['input']>
    originalPostLinkId?: InputMaybe<Scalars['String']['input']>
    serviceAuthorId?: InputMaybe<Scalars['String']['input']>
    serviceAuthorName?: InputMaybe<Scalars['String']['input']>
    serviceAuthorUsername?: InputMaybe<Scalars['String']['input']>
    serviceContentId: Scalars['String']['input']
    socialMediaServiceShortName: Scalars['String']['input']
}

export enum ContentTypeView {
    FacebookAdComment = 'FACEBOOK_AD_COMMENT',
    FacebookMessengerMessage = 'FACEBOOK_MESSENGER_MESSAGE',
    FacebookPagePostComment = 'FACEBOOK_PAGE_POST_COMMENT',
    InstagramAdComment = 'INSTAGRAM_AD_COMMENT',
    InstagramPostComment = 'INSTAGRAM_POST_COMMENT',
    TikTokAdComment = 'TIK_TOK_AD_COMMENT',
    TikTokUserVideoComment = 'TIK_TOK_USER_VIDEO_COMMENT',
    TwitterPostReply = 'TWITTER_POST_REPLY',
    Unknown = 'UNKNOWN',
    YouTubeVideoComment = 'YOU_TUBE_VIDEO_COMMENT'
}

/**
 * The model we use when displaying lists of content, i.e. in
 * `frontend/src/components/content/ContentList.tsx`
 *
 * SOMEDAY: after moving some logic to the server (e.g. link generation) perhaps we
 * can get rid of some of these properties? Review them all again. See
 * here for the original items: frontend/src/components/content/ContentCard.tsx
 */
export type ContentView = {
    __typename?: 'ContentView'
    account: AccountRecord
    actions: Array<ContentActionView>
    allClassifications: Array<ContentClassificationView>
    authorProfileId?: Maybe<Scalars['Int']['output']>
    authorised: Scalars['Boolean']['output']
    content: Scalars['String']['output']
    contentType: ContentTypeView
    datePosted?: Maybe<Scalars['DateTime']['output']>
    id: Scalars['Int']['output']
    inReplyToStatusId?: Maybe<Scalars['String']['output']>
    inReplyToUserId?: Maybe<Scalars['String']['output']>
    inReplyToUsername?: Maybe<Scalars['String']['output']>
    isOwned?: Maybe<Scalars['Boolean']['output']>
    isPublic: Scalars['Boolean']['output']
    isReply: Scalars['Boolean']['output']
    media: Array<ContentMediaView>
    moderation?: Maybe<Scalars['String']['output']>
    originalPostAuthorId?: Maybe<Scalars['String']['output']>
    originalPostAuthorName?: Maybe<Scalars['String']['output']>
    originalPostId?: Maybe<Scalars['String']['output']>
    originalPostLink?: Maybe<Scalars['String']['output']>
    originalPostLinkId?: Maybe<Scalars['String']['output']>
    readReceipts: Array<ReadReceiptView>
    serviceAuthorDisplayUsername?: Maybe<Scalars['String']['output']>
    serviceAuthorId?: Maybe<Scalars['String']['output']>
    serviceAuthorName?: Maybe<Scalars['String']['output']>
    serviceContentId: Scalars['String']['output']
    shouldEnrich: Scalars['Boolean']['output']
    socialMediaAuthorLink?: Maybe<Scalars['String']['output']>
    socialMediaContentLink?: Maybe<Scalars['String']['output']>
    socialMediaContentName: Scalars['String']['output']
    socialMediaPostLink?: Maybe<Scalars['String']['output']>
    socialMediaServiceName: Scalars['String']['output']
}

/** The post a thread hangs off, trimmed to what the drawer's post strip shows. */
export type ConversationPostView = {
    __typename?: 'ConversationPostView'
    commentCount?: Maybe<Scalars['Int']['output']>
    id: Scalars['Int']['output']
    publishTime: Scalars['DateTime']['output']
    title: Scalars['String']['output']
    uri: Scalars['String']['output']
}

export enum CookiePlatform {
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    Twitter = 'TWITTER'
}

export enum CookieStatus {
    Active = 'ACTIVE',
    Dead = 'DEAD'
}

export type CookieSummary = {
    __typename?: 'CookieSummary'
    createdAt: Scalars['DateTime']['output']
    failCount: Scalars['Int']['output']
    id: Scalars['Int']['output']
    lastUsedAt?: Maybe<Scalars['DateTime']['output']>
    notes?: Maybe<Scalars['String']['output']>
    platform: CookiePlatform
    serviceUsername: Scalars['String']['output']
    status: CookieStatus
    updatedAt: Scalars['DateTime']['output']
}

export type CountContentConnection = {
    __typename?: 'CountContentConnection'
    total?: Maybe<Scalars['Int']['output']>
}

export type CreateClassifierDetailInput = {
    clientFacingName: Scalars['String']['input']
    displayName: Scalars['String']['input']
    longDescription: Scalars['String']['input']
    modality: Modality
    shortDescription: Scalars['String']['input']
    /** Unique slug for the classifier (immutable once created). */
    shortName: Scalars['String']['input']
    valence: Valence
}

/**
 * Creates the next draft version — the version number is assigned server-side
 * and the status is always `draft`, so neither is an input. `model` is one of
 * the stored model names (`LlmModel`); anything else is rejected. Thresholds are
 * individually optional: a version may define any combination of bands, like
 * moderation boundaries.
 */
export type CreateClassifierPromptInput = {
    classifierDetailsId: Scalars['Int']['input']
    defaultBorderlineThreshold?: InputMaybe<Scalars['Float']['input']>
    defaultConfirmedThreshold?: InputMaybe<Scalars['Float']['input']>
    model: Scalars['String']['input']
    prompt: Scalars['String']['input']
}

export type CreateCookieInput = {
    cookieJson: Scalars['String']['input']
    notes?: InputMaybe<Scalars['String']['input']>
    platform: CookiePlatform
    serviceUsername: Scalars['String']['input']
}

export type CreateKeywordParamsView = {
    accountId: Scalars['Int']['input']
    allowableRegex?: InputMaybe<Scalars['String']['input']>
    classifierDetailId: Scalars['Int']['input']
    description?: InputMaybe<Scalars['String']['input']>
    keyword: Scalars['String']['input']
    regex: Scalars['Boolean']['input']
}

/**
 * Input for `createMonitorProfileSchedule`: field-for-field the
 * `ScrapeCommentFetch` params contract in `jobs`, plus the cron.
 * Mapped verbatim and validated there and only there, so this mutation
 * can never accept params the executor would later reject.
 */
export type CreateMonitorProfileScheduleInput = {
    /**
     * Cron expression in the scheduler's seconds-first dialect, e.g.
     * "0 0 6 * * *" for daily at 06:00 UTC.
     */
    cron: Scalars['String']['input']
    mode: MonitorMode
    /**
     * Canonical platform name as the backend parses it: "instagram",
     * "facebook", "tiktokuser", "youtube".
     */
    platform: Scalars['String']['input']
    /**
     * Named run-budget preset: "daily" (the default), "batch_min",
     * "batch_medium" or "batch_high".
     */
    scrapeProfile?: InputMaybe<Scalars['String']['input']>
    /**
     * The monitored account's handle. The account must already exist —
     * creating it is the New Monitored Account page's job.
     */
    serviceAccountUsername: Scalars['String']['input']
    /**
     * Fixed campaign start date (UTC). Mutually exclusive with
     * `windowDays`; the posts-mode default form.
     */
    since?: InputMaybe<Scalars['NaiveDate']['input']>
    /**
     * Posts-mode targets: post URLs (Instagram/TikTok) or video ids
     * (YouTube). Must be empty or absent in profile mode.
     */
    targets?: InputMaybe<Array<Scalars['String']['input']>>
    /**
     * Rolling window: comments from the last N days of each run.
     * Mutually exclusive with `since`; profile mode defaults to 2 when
     * neither is given.
     */
    windowDays?: InputMaybe<Scalars['Int']['input']>
}

export type CustomerPaymentPortal = {
    __typename?: 'CustomerPaymentPortal'
    url?: Maybe<Scalars['String']['output']>
}

export enum DmFilter {
    All = 'ALL',
    CommentsOnly = 'COMMENTS_ONLY',
    DmsOnly = 'DMS_ONLY'
}

export type DashboardView = {
    __typename?: 'DashboardView'
    createdAt: Scalars['DateTime']['output']
    description: Scalars['String']['output']
    displayName: Scalars['String']['output']
    extEmbeddedId: Scalars['String']['output']
    id: Scalars['Int']['output']
    updatedAt: Scalars['DateTime']['output']
}

/** Response from polling a dataset preparation task status. */
export type DatasetPrepTaskStatusResponse = {
    __typename?: 'DatasetPrepTaskStatusResponse'
    /** When the task was created. */
    createdAt: Scalars['DateTime']['output']
    /** Error message if status is FAILED. */
    errorMessage?: Maybe<Scalars['String']['output']>
    /** Progress message describing current activity. */
    progressMessage?: Maybe<Scalars['String']['output']>
    /** The result if status is SUCCESS. */
    result?: Maybe<PreparedChatSession>
    /** Current status of the task. */
    status: DatasetPrepTaskStatusView
    /** When the task was last updated. */
    updatedAt: Scalars['DateTime']['output']
}

/** Status of an asynchronous dataset preparation task. */
export enum DatasetPrepTaskStatusView {
    /** Adjusting dataset size to fit within token limits. */
    Adjusting = 'ADJUSTING',
    /** Task failed with an error. */
    Failed = 'FAILED',
    /** Actively fetching batches from the database. */
    Fetching = 'FETCHING',
    /** Task created, waiting to start processing. */
    Pending = 'PENDING',
    /** Task completed successfully. */
    Success = 'SUCCESS',
    /** Counting tokens for the dataset. */
    Tokenizing = 'TOKENIZING'
}

export type DebugTokenResponseView = {
    __typename?: 'DebugTokenResponseView'
    appId: Scalars['String']['output']
    application: Scalars['String']['output']
    dataAccessExpiresAt: Scalars['Int']['output']
    dataType: Scalars['String']['output']
    expiresAt?: Maybe<Scalars['Int']['output']>
    isValid: Scalars['Boolean']['output']
    issuedAt?: Maybe<Scalars['Int']['output']>
    scopes: Array<Scalars['String']['output']>
    userId: Scalars['String']['output']
}

export type DeployedProfile = {
    __typename?: 'DeployedProfile'
    id: Scalars['Int']['output']
    name?: Maybe<Scalars['String']['output']>
    platform: Scalars['String']['output']
    teamId?: Maybe<Scalars['Int']['output']>
    teamName?: Maybe<Scalars['String']['output']>
}

export type DetectedLanguageView = {
    __typename?: 'DetectedLanguageView'
    detectedSourceLanguage?: Maybe<Scalars['String']['output']>
    sourceText: Scalars['String']['output']
}

export type EditableDashboardView = {
    __typename?: 'EditableDashboardView'
    dashboard: DashboardView
    users: Array<UserView>
}

export type EmbeddedDashboardView = {
    __typename?: 'EmbeddedDashboardView'
    dashboard: DashboardView
    guestToken: Scalars['String']['output']
    workspaceUrl: Scalars['String']['output']
}

export type EnrichedContent = {
    __typename?: 'EnrichedContent'
    id: Scalars['Int']['output']
    originalPostId?: Maybe<Scalars['String']['output']>
    originalPostLinkId?: Maybe<Scalars['String']['output']>
    serviceAuthorName?: Maybe<Scalars['String']['output']>
    serviceAuthorUsername?: Maybe<Scalars['String']['output']>
}

export type FetchUserDetailsConnection = {
    __typename?: 'FetchUserDetailsConnection'
    error?: Maybe<FetchUserDetailsErrorDetails>
    userDetails?: Maybe<FetchedUserDetails>
}

export enum FetchUserDetailsError {
    UserNotFound = 'USER_NOT_FOUND'
}

export type FetchUserDetailsErrorDetails = {
    __typename?: 'FetchUserDetailsErrorDetails'
    message?: Maybe<Scalars['String']['output']>
    type?: Maybe<FetchUserDetailsError>
}

export type FetchedUserDetails = {
    __typename?: 'FetchedUserDetails'
    name?: Maybe<Scalars['String']['output']>
    serviceAccountId?: Maybe<Scalars['String']['output']>
    username?: Maybe<Scalars['String']['output']>
}

/**
 * A fleet job: one job that covers every account on a platform. The
 * Scheduled jobs page uses these to filter its list and, in a row's
 * details, to show and change its cadence.
 */
export type FleetJob = {
    __typename?: 'FleetJob'
    /**
     * Whether its cadence can be changed from the page. False for renewal,
     * which fires daily on a cron, and for the heartbeat, whose cadence the
     * Service Health page depends on.
     */
    cadenceEditable: Scalars['Boolean']['output']
    /** The cadence boot creates its row on, in seconds, for interval work. */
    defaultIntervalSecs?: Maybe<Scalars['Int']['output']>
    /** What it does, for the page. */
    description: Scalars['String']['output']
    /** The stable name `changeFleetJobCadence` takes. */
    key: Scalars['String']['output']
    /** The shortest cadence it accepts, in seconds, for interval work. */
    minIntervalSecs?: Maybe<Scalars['Int']['output']>
    name: Scalars['String']['output']
    /** The tag its row holds. */
    tag: Scalars['String']['output']
}

export type FloatFilterInput = {
    between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    contains?: InputMaybe<Scalars['Float']['input']>
    eq?: InputMaybe<Scalars['Float']['input']>
    ge?: InputMaybe<Scalars['Float']['input']>
    gt?: InputMaybe<Scalars['Float']['input']>
    le?: InputMaybe<Scalars['Float']['input']>
    lt?: InputMaybe<Scalars['Float']['input']>
    ne?: InputMaybe<Scalars['Float']['input']>
    notContains?: InputMaybe<Scalars['Float']['input']>
}

export type GetAccountsInTeamParamsView = {
    teamId: Scalars['Int']['input']
}

export enum HealthStatus {
    Critical = 'CRITICAL',
    Healthy = 'HEALTHY',
    Warning = 'WARNING'
}

/** The result of asking for a historic scrape. */
export type HistoricFetchResult = {
    __typename?: 'HistoricFetchResult'
    /** False when this call created the historic fetch, true when it found one. */
    alreadyExisted: Scalars['Boolean']['output']
    /** A sentence ready for a toast, saying which of those happened. */
    message: Scalars['String']['output']
    /**
     * The historic fetch work: newly created, or the one that already covered
     * this range.
     */
    work: ScheduledWork
}

export type IdFilterInput = {
    beginsWith?: InputMaybe<Scalars['ID']['input']>
    between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
    contains?: InputMaybe<Scalars['ID']['input']>
    eq?: InputMaybe<Scalars['ID']['input']>
    ge?: InputMaybe<Scalars['ID']['input']>
    gt?: InputMaybe<Scalars['ID']['input']>
    le?: InputMaybe<Scalars['ID']['input']>
    lt?: InputMaybe<Scalars['ID']['input']>
    ne?: InputMaybe<Scalars['ID']['input']>
    notContains?: InputMaybe<Scalars['ID']['input']>
}

/**
 * Response type for Instagram auth that distinguishes new accounts from re-authorizations.
 * Aligned with the TypeScript SaveAuthorisationCodeResponse pattern.
 */
export type InstagramAuthResponse = {
    __typename?: 'InstagramAuthResponse'
    /** Account IDs that were newly created */
    new: Array<Scalars['Int']['output']>
    /** Account IDs that already existed and were re-authorized */
    updated: Array<Scalars['Int']['output']>
}

export type IntFilterInput = {
    between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    contains?: InputMaybe<Scalars['Int']['input']>
    eq?: InputMaybe<Scalars['Int']['input']>
    ge?: InputMaybe<Scalars['Int']['input']>
    gt?: InputMaybe<Scalars['Int']['input']>
    le?: InputMaybe<Scalars['Int']['input']>
    lt?: InputMaybe<Scalars['Int']['input']>
    ne?: InputMaybe<Scalars['Int']['input']>
    notContains?: InputMaybe<Scalars['Int']['input']>
}

export type KeywordParamsList = {
    accountId: Scalars['Int']['input']
}

export type KeywordView = {
    __typename?: 'KeywordView'
    accountId: Scalars['Int']['output']
    allowableRegex?: Maybe<Scalars['String']['output']>
    classifierDetailsDisplayName: Scalars['String']['output']
    classifierDetailsId: Scalars['Int']['output']
    createdAt: Scalars['DateTime']['output']
    description?: Maybe<Scalars['String']['output']>
    id: Scalars['Int']['output']
    keyword: Scalars['String']['output']
    regex: Scalars['Boolean']['output']
}

/** GraphQL input type for classification test cases */
export type LlmClassificationTestInput = {
    target: Scalars['String']['input']
    text: Scalars['String']['input']
}

/** GraphQL output type for classification with justification */
export type LlmClassificationView = {
    __typename?: 'LlmClassificationView'
    justification: Scalars['String']['output']
    score?: Maybe<Scalars['Float']['output']>
    target: Scalars['String']['output']
    text: Scalars['String']['output']
}

/** GraphQL input type for image classification test cases */
export type LlmImageClassificationTestInput = {
    fileName: Scalars['String']['input']
    imageBase64: Scalars['String']['input']
    mimeType: Scalars['String']['input']
    target: Scalars['String']['input']
}

/** GraphQL output type for image classification results */
export type LlmImageClassificationView = {
    __typename?: 'LlmImageClassificationView'
    fileName: Scalars['String']['output']
    justification: Scalars['String']['output']
    score?: Maybe<Scalars['Float']['output']>
    target: Scalars['String']['output']
}

/** Information about an available LLM model */
export type LlmModelInfo = {
    __typename?: 'LlmModelInfo'
    /** Human-readable display name */
    displayName: Scalars['String']['output']
    /** The model identifier (e.g., "gemini-2.5-flash-lite", "gpt-5-mini") */
    id: Scalars['String']['output']
    /** Whether this is the default model for new prompts */
    isDefault: Scalars['Boolean']['output']
}

export type MediaClassification = {
    __typename?: 'MediaClassification'
    classification?: Maybe<Scalars['Float']['output']>
    classifierName: Scalars['String']['output']
}

/** Maps to [`MetaAdVisibilityReport`]. */
export type MetaAdVisibility = {
    __typename?: 'MetaAdVisibility'
    accountId: Scalars['Int']['output']
    accountName?: Maybe<Scalars['String']['output']>
    adAccounts: Array<MetaAdVisibilityAdAccount>
    adsLastFetched?: Maybe<Scalars['DateTime']['output']>
    /** Human label for the attachment list ("promote_pages" / "instagram_accounts"). */
    attachmentLabel: Scalars['String']['output']
    authoriser?: Maybe<MetaAdVisibilityAuthoriser>
    daysWindow: Scalars['Int']['output']
    /** Human label for `service_account_id` ("page ID" / "IG user ID"). */
    identityLabel: Scalars['String']['output']
    matchedCount: Scalars['Int']['output']
    serviceAccountId: Scalars['String']['output']
    serviceAccountUsername?: Maybe<Scalars['String']['output']>
    /** "Facebook" or "Instagram". */
    socialMediaService: Scalars['String']['output']
    totalComments: Scalars['Int']['output']
    totalCount: Scalars['Int']['output']
    unmatchedComments: Scalars['Int']['output']
}

export type MetaAdVisibilityAdAccount = {
    __typename?: 'MetaAdVisibilityAdAccount'
    attachments: Array<MetaAdVisibilityAttachment>
    id: Scalars['String']['output']
    /** True if this ad account references the monitored page/IG account. */
    isMatch: Scalars['Boolean']['output']
    name: Scalars['String']['output']
}

export type MetaAdVisibilityAttachment = {
    __typename?: 'MetaAdVisibilityAttachment'
    id: Scalars['String']['output']
    name: Scalars['String']['output']
}

export type MetaAdVisibilityAuthoriser = {
    __typename?: 'MetaAdVisibilityAuthoriser'
    applicationName: Scalars['String']['output']
    email?: Maybe<Scalars['String']['output']>
    name?: Maybe<Scalars['String']['output']>
    scopes: Array<Scalars['String']['output']>
    tokenDataAccessExpiresAt?: Maybe<Scalars['DateTime']['output']>
    tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>
    tokenIsValid: Scalars['Boolean']['output']
    userId: Scalars['String']['output']
}

export enum Modality {
    Image = 'IMAGE',
    Text = 'TEXT'
}

export type Moderation = {
    __typename?: 'Moderation'
    dismissed?: Maybe<Scalars['Boolean']['output']>
    id: Scalars['Int']['output']
    moderatedOn: Scalars['AWSDateTime']['output']
    moderation?: Maybe<Scalars['String']['output']>
}

export type ModerationBoundaryCreate = {
    accountId: Scalars['Int']['input']
    classifierId: Scalars['Int']['input']
    probability?: InputMaybe<Scalars['Float']['input']>
    queue: Scalars['String']['input']
}

export type ModerationBoundaryInput = {
    id: Scalars['Int']['input']
    probability?: InputMaybe<Scalars['Float']['input']>
}

export type ModerationBoundaryView = {
    __typename?: 'ModerationBoundaryView'
    account: Scalars['Int']['output']
    classifier: ClassifierView
    id: Scalars['Int']['output']
    probability?: Maybe<Scalars['Float']['output']>
    queue: Scalars['String']['output']
}

/**
 * What a Monitor watches: the account's whole profile, or a fixed set
 * of posts. Maps one-to-one onto `jobs::scrape_comment_fetch::ScrapeMode`,
 * which owns the meaning.
 * SOMEDAY: we need to add a place to store the posts we want to fetch.
 */
export enum MonitorMode {
    Posts = 'POSTS',
    Profile = 'PROFILE'
}

/**
 * A monitor's own settings, read back from the work's params.
 *
 * Exposed so the settings page can show what a monitor does — and offer
 * the same choices again when copying it to another profile — rather
 * than only what it is called and when it next runs.
 */
export type MonitorSettings = {
    __typename?: 'MonitorSettings'
    mode: MonitorMode
    /**
     * The run-budget preset, when one was chosen. Null means the
     * backend's default.
     */
    scrapeProfile?: Maybe<Scalars['String']['output']>
    /** The fixed start date, when the monitor has one instead of a window. */
    since?: Maybe<Scalars['NaiveDate']['output']>
    /**
     * The posts this monitor watches, in posts mode: post URLs, or video
     * ids on YouTube. Empty in profile mode.
     */
    targets: Array<Scalars['String']['output']>
    /** The rolling window in days, when the monitor uses one. */
    windowDays?: Maybe<Scalars['Int']['output']>
}

/**
 * One page of a thread's replies: every held reply in date order, matching or
 * not, each flagged. A first call (`after: null`) starts from the thread's first
 * reply and so repeats the preview; replace the preview with it.
 */
export type MoreThreadRepliesView = {
    __typename?: 'MoreThreadRepliesView'
    nextCursor?: Maybe<Scalars['String']['output']>
    replies: Array<PostConversationReplyView>
}

export type Mutation = {
    __typename?: 'Mutation'
    addDefaultKeywords: Scalars['Boolean']['output']
    /**
     * Add posts to a posts-mode monitor's list, keeping the schedule and
     * its history. Duplicates are ignored, so asking twice is safe.
     */
    addMonitorTargets: ScheduledWorkActionResult
    /**
     * Subscribes a Twitter account to the X v2 webhook so the platform receives
     * account-activity events. Admin only.
     *
     * DEPRECATED: the X Account Activity API is not on Arwen's current X
     * subscription plan, so this mutation cannot succeed in production.
     * @deprecated X Account Activity API is not available on the current X plan
     */
    addTwitterSubscription: Scalars['Boolean']['output']
    addYouTubeSubscription: AddYouTubeSubcription
    /**
     * Archives a classifier: undeploys it from every profile (deletes all its
     * moderation boundaries) and hides it by default. Reversible via unarchive,
     * but deployments are NOT restored. We never delete (that would orphan
     * ClassificationResults). Admin only.
     */
    archiveClassifierDetail: ClassifierDetailFull
    bulkUpdateModerationBoundary: Scalars['Boolean']['output']
    /**
     * Take a screenshot for the given content ID (admin only).
     *
     * Uses the screenshot service to look up cookies/proxy and persists the attempt.
     */
    captureScreenshot: ScreenshotAttempt
    /**
     * Change a fleet job's cadence in place. `expectedRowId`
     * is the row the caller read, so a change aimed at a row that has
     * since moved on is refused rather than applied blind.
     */
    changeFleetJobCadence: ScheduledWorkActionResult
    classifyContent: Scalars['Int']['output']
    copyKeywordsToAccount: Scalars['Boolean']['output']
    copyModerationBoundaries: Scalars['Boolean']['output']
    createAccount?: Maybe<AccountRecord>
    /** Creates a new (dynamic) classifier definition. Admin only. */
    createClassifierDetail: ClassifierDetailFull
    /** Creates the next draft version of a classifier. Admin only. */
    createClassifierPrompt: ClassifierPrompt
    createContentFeed: ContentFeedView
    createCookie: CookieSummary
    createDashboard: DashboardView
    createKeyword: KeywordView
    createModerationBoundary: ModerationBoundaryView
    /**
     * Create the Monitor for one scraped account: recurring
     * `scrape_comment_fetch` work firing on `input.cron`.
     */
    createMonitorProfileSchedule: ScheduledWork
    /**
     * Creates a monitored account: an account row with no authorisation that
     * content is scraped into. Admin-only — unlike `create_account`, which any
     * user reaches at the end of an OAuth flow, this creates an account from
     * just a handle, so it must not be open to all users.
     */
    createMonitoredAccount?: Maybe<AccountRecord>
    createNotificationConfiguration: NotificationConfigurationView
    createPaymentPortal: Scalars['String']['output']
    createReadReceipt: ReadReceiptView
    createReadReceipts: Array<ReadReceiptView>
    /** Scrape one account's history from a fixed date, once. */
    createScrapedHistoricFetch: HistoricFetchResult
    createTeam: TeamView
    /**
     * This is the final step in the OAuth2 authorisation grant flow. The user will have selected
     * which ad accounts they want to add to Arwen, and will call this function with the key we gave them
     * to finally create the accounts.
     */
    createTiktokAccounts: Array<AuthorisedAccountView>
    createUser: Scalars['Boolean']['output']
    /**
     * Removes Twitter and Meta subscriptions, soft-deletes the account, and
     * schedules a background hard-delete of all associated posts.
     */
    deleteAccount: Scalars['Boolean']['output']
    deleteAuthorisation?: Maybe<Scalars['Boolean']['output']>
    /**
     * Hard-deletes a classifier definition. Only safe for a just-created classifier
     * with no results (used by the create-flow rollback) — the user-facing action
     * is archive, which preserves results. Admin only.
     */
    deleteClassifierDetail: Scalars['Boolean']['output']
    /** Hard-deletes a version. Admin only. */
    deleteClassifierPrompt: Scalars['Boolean']['output']
    deleteContentFeed: ContentFeedView
    deleteCookie: Scalars['Boolean']['output']
    deleteDashboard: Scalars['Boolean']['output']
    deleteKeyword: Scalars['Boolean']['output']
    deleteModerationBoundary: ModerationBoundaryView
    deleteNotificationConfiguration: NotificationConfigurationView
    deleteReadReceipt: ReadReceiptView
    deleteReadReceipts: Array<ReadReceiptView>
    deleteReply: ContentActionView
    deleteTeam: Scalars['Boolean']['output']
    deleteUser: Scalars['Boolean']['output']
    /** Deploys the classifier's live version to specific accounts. Admin only. */
    deployClassifierToAccounts: Scalars['Boolean']['output']
    /** Deploys the classifier's live version to every account in a team. Admin only. */
    deployClassifierToTeam: Scalars['Boolean']['output']
    /** Discards a draft version. Admin only. */
    discardClassifierPromptDraft: ClassifierPrompt
    editAccountTeam: AccountRecord
    editTeam: TeamView
    editUser: Scalars['Boolean']['output']
    fetchHistoricContent?: Maybe<Scalars['Boolean']['output']>
    fetchHistoricYouTubeVideos?: Maybe<Scalars['Boolean']['output']>
    giveUserAccessToDashboard: Scalars['Boolean']['output']
    /**
     * Makes a version live — go-live from a draft, or rollback from an archived
     * version — archiving the current live version. Admin only.
     */
    goLiveClassifierPrompt: ClassifierPrompt
    incrementCookieFailCount: Scalars['Boolean']['output']
    /**
     * This is a step in the OAuth2 authorisation grant flow. The user will have authorised
     * us on Instagrams's site, and Instagram will have redirected the browser back to us, with the auth code.
     * The browser then calls this function, which exchanges the auth code for a long-lived access token and returns
     * information about whether accounts were newly created or re-authorized.
     *
     * This is only used for the Instagram direct API login method.
     */
    instagramAuthCodeToAccessToken: InstagramAuthResponse
    likeContent: Array<ContentActionResult>
    markCookieDead: Scalars['Boolean']['output']
    metaHistoricFetch: Scalars['Boolean']['output']
    moderateContent: Scalars['Int']['output']
    /**
     * Ask the platform for a thread's missing parent and latest replies, save
     * them, and return the refreshed thread. Rate limited per comment.
     */
    refreshCommentThread: CommentThreadView
    /**
     * Refresh the media URLs for a content record.
     * Called by the frontend when an image fails to load, typically
     * because a cached Facebook image URL has expired.
     */
    refreshContentMedia: Array<ContentMediaView>
    /** Refresh conversations and messages for this account. */
    refreshMessengerConversations: Array<Scalars['Int']['output']>
    refreshToken: Scalars['Boolean']['output']
    removeItemFromSpamModel?: Maybe<Scalars['Boolean']['output']>
    /** Remove an existing manual shadow ban from a profile for a given account. */
    removeManualShadowBanForAccount: SetManualShadowBanResponse
    removeSpamItems: Scalars['Boolean']['output']
    /**
     * Unsubscribes a Twitter account from the X v2 webhook. Admin only.
     *
     * DEPRECATED: the X Account Activity API is not on Arwen's current X
     * subscription plan, so this mutation cannot succeed in production.
     * @deprecated X Account Activity API is not available on the current X plan
     */
    removeTwitterSubscription: Scalars['Boolean']['output']
    replyToContent: ContentActionView
    /**
     * Bring this work's queued run forward to now, instead of waiting
     * out its schedule.
     */
    runScheduledWorkNow: ScheduledWorkActionResult
    saveAuthorisationCode?: Maybe<SaveAuthorisationCodeResponse>
    saveLlmReplyPrompt: PromptView
    /**
     * Send a notification when new accounts are connected via OAuth.
     * This notifies via Courier so that Support can configure the new profiles.
     * The notification service handles environment-based routing to different distribution lists.
     */
    sendNewAccountNotification: SendNotificationResponse
    setAccountToggle: Scalars['Boolean']['output']
    /** Manually toggle the shadow-banned status for a profile within a specific account. */
    setManualShadowBanForAccount: SetManualShadowBanResponse
    setUserToggle: Scalars['Boolean']['output']
    /**
     * Start an asynchronous chat task. Returns immediately with a task_id.
     *
     * Use the `getChatTaskStatus` query to poll for the result. The task will
     * process the message in the background and update its status in Redis.
     *
     * Requires an existing session id produced by `prepareChatSession`.
     */
    startChat: StartChatResponse
    /**
     * Start an async content search task.
     *
     * This mutation initiates a long-running content search that won't time out.
     * Returns a task ID immediately that can be used to poll for results using
     * the `getContentSearchTask` query.
     *
     * Use this rather than `contentSearch` for any search that might take
     * longer than 30 seconds (wide date ranges, many accounts) — a single
     * request cannot survive one. — Claude
     */
    startContentSearch: ContentSearchTaskStarted
    /**
     * Start re-fetching a post's comments and replies from the platform, so
     * the post conversation's Threaded tab can show parent links for comments
     * ingested before they were recorded and comments Arwen has not received.
     * Rate limited per post. A whole post can take longer to fetch than a
     * request may last, so this returns a task to poll with
     * `postConversationRefreshTask`, with the result inline when the refresh
     * was quick.
     */
    startPostConversationRefresh: PostRefreshTaskStarted
    /**
     * Start an asynchronous dataset preparation task. Returns immediately with a task_id.
     *
     * Use the `getDatasetPrepTaskStatus` query to poll for the result. The task will
     * process the dataset in the background and update its status in Redis with
     * progress messages.
     *
     * This is the async alternative to `prepareChatSession` that doesn't timeout
     * on large datasets.
     */
    startPrepareChatSession: StartDatasetPrepResponse
    /** Stop this work: no further runs. */
    stopScheduledWork: ScheduledWorkActionResult
    takeContentAction?: Maybe<TakeContentActionResponse>
    takeContentActions?: Maybe<TakeContentActionsResponse>
    /**
     * This is a step in the OAuth2 authorisation grant flow. The user will have authorised
     * us on TikTok's site, and TikTok will have redirected the browser back to us, with the auth code.
     * The browser then calls this function, which exchanges the auth code for a long-lived access token,
     * and also fetches and returns ad accounts. Each ad account may become an Arwen account, depending
     * on the user's choice (a mutation elsewhere).
     */
    tiktokAuthCodeToAccessToken: TikTokAccountSelectionView
    tiktokCreateUserAccountWithAuth: TikTokUserAccountSelectionView
    /** Enable or disable DMs for the given account. */
    toggleDms: AccountRecord
    /**
     * Returns an archived classifier to active. Prior deployments are not
     * restored — it must be re-applied to profiles. Admin only.
     */
    unarchiveClassifierDetail: ClassifierDetailFull
    /** Removes the classifier from specific accounts. Admin only. */
    undeployClassifierFromAccounts: Scalars['Boolean']['output']
    /** Removes the classifier from every account in a team. Admin only. */
    undeployClassifierFromTeam: Scalars['Boolean']['output']
    updateAccount: Scalars['Boolean']['output']
    /** Set whether automatic content fetching is enabled for this account. */
    updateAutoFetchContent: AccountRecord
    /**
     * Set whether all ad comments are automatically hidden for this account.
     * The field is nullable in the database but this mutation always sets a concrete value.
     */
    updateAutoHideAdComments: AccountRecord
    /** Updates a classifier's metadata. Admin only. */
    updateClassifierDetail: ClassifierDetailFull
    /**
     * Edits a draft version's prompt/model/thresholds. Only drafts are editable —
     * live and archived versions are immutable history. Admin only.
     */
    updateClassifierPrompt: ClassifierPrompt
    updateContentFeed: ContentFeedView
    updateCookie: CookieSummary
    updateDashboard: Scalars['Boolean']['output']
    /**
     * Updates the engage account ID
     *
     * The account that's used for engage: replies and likes.
     *
     * If the `engage_account_id` is `undefined`, the default action account
     * will be removed.
     */
    updateEngageAccountId: AccountRecord
    /** Set whether ad fetching is enabled for this account. */
    updateFetchAds: AccountRecord
    /** Set whether post fetching is enabled for this account. */
    updateFetchPosts: AccountRecord
    /** Set whether LLM classification is enabled for this account. */
    updateLlmClassificationEnabled: AccountRecord
    /** Set whether LLM suggested replies are enabled for this account. */
    updateLlmSuggestedReplyEnabled: AccountRecord
    updateModerationBoundary: ModerationBoundaryView
    updateNotificationConfiguration: NotificationConfigurationView
    /** Set whether profile collection is enabled for this account. */
    updateProfileCollectionEnabled: AccountRecord
    /** Set whether profile moderation is enabled for this account. */
    updateProfileModerationEnabled: AccountRecord
    /** Set how many days after publishing this account's posts stop being fetched or scraped. */
    updateRetirePostDays: AccountRecord
    /** Set whether content scraping is enabled for this account. */
    updateScrapeContent: AccountRecord
    /**
     * Update an account's shadow banning settings with the supplied values.
     *
     * Admins can use this mutation to toggle the feature and adjust its
     * enforcement window (`range_in_days`) and strike threshold in a single
     * call. The refreshed `AccountRecordView` is returned so clients can
     * immediately reflect the change.
     */
    updateShadowBanning: AccountRecord
    validateUserIdentity: UserView
}

export type MutationAddDefaultKeywordsArgs = {
    accountId: Scalars['Int']['input']
    reset: Scalars['Boolean']['input']
}

export type MutationAddMonitorTargetsArgs = {
    monitorTag: Scalars['String']['input']
    targets: Array<Scalars['String']['input']>
}

export type MutationAddTwitterSubscriptionArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationAddYouTubeSubscriptionArgs = {
    channelId?: InputMaybe<Scalars['String']['input']>
}

export type MutationArchiveClassifierDetailArgs = {
    id: Scalars['Int']['input']
}

export type MutationBulkUpdateModerationBoundaryArgs = {
    accountId: Scalars['Int']['input']
    moderationBoundaries: Array<ModerationBoundaryCreate>
}

export type MutationCaptureScreenshotArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationChangeFleetJobCadenceArgs = {
    expectedRowId: Scalars['String']['input']
    intervalSecs: Scalars['Int']['input']
    key: Scalars['String']['input']
}

export type MutationClassifyContentArgs = {
    reason?: InputMaybe<Scalars['String']['input']>
}

export type MutationCopyKeywordsToAccountArgs = {
    sourceAccountId: Scalars['Int']['input']
    targetAccountId: Scalars['Int']['input']
}

export type MutationCopyModerationBoundariesArgs = {
    sourceAccountId: Scalars['Int']['input']
    targetAccountIds: Array<Scalars['Int']['input']>
}

export type MutationCreateAccountArgs = {
    accountName: Scalars['String']['input']
    description?: InputMaybe<Scalars['String']['input']>
    serviceAccountId: Scalars['String']['input']
    serviceAccountUsername: Scalars['String']['input']
    serviceName: Scalars['String']['input']
}

export type MutationCreateClassifierDetailArgs = {
    input: CreateClassifierDetailInput
}

export type MutationCreateClassifierPromptArgs = {
    input: CreateClassifierPromptInput
}

export type MutationCreateContentFeedArgs = {
    contentFeed: ContentFeedCreate
}

export type MutationCreateCookieArgs = {
    params: CreateCookieInput
}

export type MutationCreateDashboardArgs = {
    dashboard: NewDashboardView
}

export type MutationCreateKeywordArgs = {
    params: CreateKeywordParamsView
}

export type MutationCreateModerationBoundaryArgs = {
    moderationBoundary: ModerationBoundaryCreate
}

export type MutationCreateMonitorProfileScheduleArgs = {
    input: CreateMonitorProfileScheduleInput
}

export type MutationCreateMonitoredAccountArgs = {
    accountName?: InputMaybe<Scalars['String']['input']>
    serviceAccountUsername: Scalars['String']['input']
    serviceName: Scalars['String']['input']
    teamId: Scalars['Int']['input']
    youtubeChannelId?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateNotificationConfigurationArgs = {
    accountId: Scalars['Int']['input']
    notificationTemplateId: Scalars['String']['input']
    recipientListId: Scalars['String']['input']
}

export type MutationCreatePaymentPortalArgs = {
    cancelUrl: Scalars['String']['input']
    successUrl: Scalars['String']['input']
}

export type MutationCreateReadReceiptArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationCreateReadReceiptsArgs = {
    contentIds: Array<Scalars['Int']['input']>
}

export type MutationCreateScrapedHistoricFetchArgs = {
    monitorTag: Scalars['String']['input']
    scrapeProfile?: InputMaybe<Scalars['String']['input']>
    since: Scalars['NaiveDate']['input']
}

export type MutationCreateTeamArgs = {
    teamName: Scalars['String']['input']
}

export type MutationCreateTiktokAccountsArgs = {
    adAccountIds: Array<Scalars['String']['input']>
    sessionKey: Scalars['String']['input']
}

export type MutationCreateUserArgs = {
    userParams: UserCreateParamsView
}

export type MutationDeleteAccountArgs = {
    accountId: Scalars['Int']['input']
    authCode?: InputMaybe<Scalars['String']['input']>
}

export type MutationDeleteAuthorisationArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationDeleteClassifierDetailArgs = {
    id: Scalars['Int']['input']
}

export type MutationDeleteClassifierPromptArgs = {
    id: Scalars['Int']['input']
}

export type MutationDeleteContentFeedArgs = {
    contentFeedId: Scalars['Int']['input']
}

export type MutationDeleteCookieArgs = {
    cookieId: Scalars['Int']['input']
}

export type MutationDeleteDashboardArgs = {
    dashboardId: Scalars['Int']['input']
}

export type MutationDeleteKeywordArgs = {
    keywordId: Scalars['Int']['input']
}

export type MutationDeleteModerationBoundaryArgs = {
    moderationBoundaryId: Scalars['Int']['input']
}

export type MutationDeleteNotificationConfigurationArgs = {
    notificationConfigurationId: Scalars['Int']['input']
}

export type MutationDeleteReadReceiptArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationDeleteReadReceiptsArgs = {
    contentIds: Array<Scalars['Int']['input']>
}

export type MutationDeleteReplyArgs = {
    actionId: Scalars['Int']['input']
}

export type MutationDeleteTeamArgs = {
    force: Scalars['Boolean']['input']
    teamId: Scalars['Int']['input']
}

export type MutationDeleteUserArgs = {
    userId: Scalars['Int']['input']
}

export type MutationDeployClassifierToAccountsArgs = {
    accountIds: Array<Scalars['Int']['input']>
    classifierDetailsId: Scalars['Int']['input']
}

export type MutationDeployClassifierToTeamArgs = {
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}

export type MutationDiscardClassifierPromptDraftArgs = {
    id: Scalars['Int']['input']
}

export type MutationEditAccountTeamArgs = {
    accountId: Scalars['Int']['input']
    teamId?: InputMaybe<Scalars['Int']['input']>
}

export type MutationEditTeamArgs = {
    name: Scalars['String']['input']
    teamId: Scalars['Int']['input']
}

export type MutationEditUserArgs = {
    userParams: UserEditParamsView
}

export type MutationFetchHistoricContentArgs = {
    accountId: Scalars['Int']['input']
    tweetsRequested: Scalars['Int']['input']
}

export type MutationFetchHistoricYouTubeVideosArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationGiveUserAccessToDashboardArgs = {
    dashboardId: Scalars['Int']['input']
    userId: Scalars['Int']['input']
}

export type MutationGoLiveClassifierPromptArgs = {
    id: Scalars['Int']['input']
}

export type MutationIncrementCookieFailCountArgs = {
    cookieId: Scalars['Int']['input']
}

export type MutationInstagramAuthCodeToAccessTokenArgs = {
    code: Scalars['String']['input']
    redirectUri: Scalars['String']['input']
}

export type MutationLikeContentArgs = {
    actionByAccountIdOverride?: InputMaybe<Scalars['Int']['input']>
    contentIds: Array<Scalars['Int']['input']>
    like: Scalars['Boolean']['input']
}

export type MutationMarkCookieDeadArgs = {
    cookieId: Scalars['Int']['input']
    reason?: InputMaybe<Scalars['String']['input']>
}

export type MutationMetaHistoricFetchArgs = {
    accountId: Scalars['Int']['input']
    from: Scalars['DateTime']['input']
    to: Scalars['DateTime']['input']
}

export type MutationModerateContentArgs = {
    reason?: InputMaybe<Scalars['String']['input']>
}

export type MutationRefreshCommentThreadArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationRefreshContentMediaArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationRefreshMessengerConversationsArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationRefreshTokenArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationRemoveItemFromSpamModelArgs = {
    contentId: Scalars['Int']['input']
}

export type MutationRemoveManualShadowBanForAccountArgs = {
    accountId: Scalars['Int']['input']
    profileId: Scalars['Int']['input']
}

export type MutationRemoveSpamItemsArgs = {
    contentIds: Array<Scalars['Int']['input']>
}

export type MutationRemoveTwitterSubscriptionArgs = {
    accountId: Scalars['Int']['input']
}

export type MutationReplyToContentArgs = {
    actionByAccountIdOverride?: InputMaybe<Scalars['Int']['input']>
    contentId: Scalars['Int']['input']
    message: Scalars['String']['input']
    suggestedReplies?: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationRunScheduledWorkNowArgs = {
    tag: Scalars['String']['input']
}

export type MutationSaveAuthorisationCodeArgs = {
    accountId?: InputMaybe<Scalars['Int']['input']>
    authCode: Scalars['String']['input']
    authVerifier?: InputMaybe<Scalars['String']['input']>
    baseUrl?: InputMaybe<Scalars['String']['input']>
    socialMediaServiceName?: InputMaybe<Scalars['String']['input']>
}

export type MutationSaveLlmReplyPromptArgs = {
    accountId: Scalars['Int']['input']
    model?: InputMaybe<Scalars['String']['input']>
    prompt: Scalars['String']['input']
}

export type MutationSendNewAccountNotificationArgs = {
    accountIds: Array<Scalars['Int']['input']>
}

export type MutationSetAccountToggleArgs = {
    accountId: Scalars['Int']['input']
    toggleName: Scalars['String']['input']
    value: Scalars['Boolean']['input']
}

export type MutationSetManualShadowBanForAccountArgs = {
    accountId: Scalars['Int']['input']
    contentId?: InputMaybe<Scalars['Int']['input']>
    enabled: Scalars['Boolean']['input']
    profileId?: InputMaybe<Scalars['Int']['input']>
}

export type MutationSetUserToggleArgs = {
    toggleName: Scalars['String']['input']
    userId: Scalars['Int']['input']
    value: Scalars['Boolean']['input']
}

export type MutationStartChatArgs = {
    accountId: Scalars['Int']['input']
    message: Scalars['String']['input']
    sessionId: Scalars['String']['input']
}

export type MutationStartContentSearchArgs = {
    params: ContentSearchParams
}

export type MutationStartPostConversationRefreshArgs = {
    postId: Scalars['Int']['input']
}

export type MutationStartPrepareChatSessionArgs = {
    accountId: Scalars['Int']['input']
    model: Scalars['String']['input']
    searchParameters?: InputMaybe<ContentSearchParams>
    systemPrompt?: InputMaybe<Scalars['String']['input']>
}

export type MutationStopScheduledWorkArgs = {
    tag: Scalars['String']['input']
}

export type MutationTakeContentActionArgs = {
    action: ContentAction
    baseUrl?: InputMaybe<Scalars['String']['input']>
    contentId: Scalars['Int']['input']
    toggle: Scalars['Boolean']['input']
}

export type MutationTakeContentActionsArgs = {
    action: ContentAction
    baseUrl?: InputMaybe<Scalars['String']['input']>
    contentIds: Array<Scalars['Int']['input']>
    toggle: Scalars['Boolean']['input']
}

export type MutationTiktokAuthCodeToAccessTokenArgs = {
    authCode: Scalars['String']['input']
    code: Scalars['String']['input']
}

export type MutationTiktokCreateUserAccountWithAuthArgs = {
    authCode: Scalars['String']['input']
    code: Scalars['String']['input']
    redirectUri: Scalars['String']['input']
}

export type MutationToggleDmsArgs = {
    accountId: Scalars['Int']['input']
    enabled: Scalars['Boolean']['input']
}

export type MutationUnarchiveClassifierDetailArgs = {
    id: Scalars['Int']['input']
}

export type MutationUndeployClassifierFromAccountsArgs = {
    accountIds: Array<Scalars['Int']['input']>
    classifierDetailsId: Scalars['Int']['input']
}

export type MutationUndeployClassifierFromTeamArgs = {
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}

export type MutationUpdateAccountArgs = {
    accountName?: InputMaybe<Scalars['String']['input']>
    autoDeleteSevereContent?: InputMaybe<Scalars['Boolean']['input']>
    autoHideSevereContent?: InputMaybe<Scalars['Boolean']['input']>
    autoMuteSevereAccount?: InputMaybe<Scalars['Boolean']['input']>
    id: Scalars['Int']['input']
    isSubscribed?: InputMaybe<Scalars['Boolean']['input']>
}

export type MutationUpdateAutoFetchContentArgs = {
    accountId: Scalars['Int']['input']
    autoFetchContent: Scalars['Boolean']['input']
}

export type MutationUpdateAutoHideAdCommentsArgs = {
    accountId: Scalars['Int']['input']
    autoHideAdComments: Scalars['Boolean']['input']
}

export type MutationUpdateClassifierDetailArgs = {
    input: UpdateClassifierDetailInput
}

export type MutationUpdateClassifierPromptArgs = {
    input: UpdateClassifierPromptInput
}

export type MutationUpdateContentFeedArgs = {
    contentFeed: ContentFeedUpdate
}

export type MutationUpdateCookieArgs = {
    params: UpdateCookieInput
}

export type MutationUpdateDashboardArgs = {
    dashboard: UpdatedDashboardView
}

export type MutationUpdateEngageAccountIdArgs = {
    accountId: Scalars['Int']['input']
    engageAccountId?: InputMaybe<Scalars['Int']['input']>
}

export type MutationUpdateFetchAdsArgs = {
    accountId: Scalars['Int']['input']
    fetchAds: Scalars['Boolean']['input']
}

export type MutationUpdateFetchPostsArgs = {
    accountId: Scalars['Int']['input']
    fetchPosts: Scalars['Boolean']['input']
}

export type MutationUpdateLlmClassificationEnabledArgs = {
    accountId: Scalars['Int']['input']
    llmClassificationEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateLlmSuggestedReplyEnabledArgs = {
    accountId: Scalars['Int']['input']
    llmSuggestedReplyEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateModerationBoundaryArgs = {
    moderationBoundary: ModerationBoundaryInput
}

export type MutationUpdateNotificationConfigurationArgs = {
    accountId: Scalars['Int']['input']
    id: Scalars['Int']['input']
    notificationTemplateId: Scalars['String']['input']
    recipientListId: Scalars['String']['input']
}

export type MutationUpdateProfileCollectionEnabledArgs = {
    accountId: Scalars['Int']['input']
    profileCollectionEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateProfileModerationEnabledArgs = {
    accountId: Scalars['Int']['input']
    profileModerationEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateRetirePostDaysArgs = {
    accountId: Scalars['Int']['input']
    retirePostDays: Scalars['Int']['input']
}

export type MutationUpdateScrapeContentArgs = {
    accountId: Scalars['Int']['input']
    scrapeContent: Scalars['Boolean']['input']
}

export type MutationUpdateShadowBanningArgs = {
    accountId: Scalars['Int']['input']
    enabled: Scalars['Boolean']['input']
    rangeInDays: Scalars['Int']['input']
    threshold: Scalars['Int']['input']
}

export type MutationValidateUserIdentityArgs = {
    referrerUuid?: InputMaybe<Scalars['String']['input']>
}

export type NewDashboardView = {
    description: Scalars['String']['input']
    displayName: Scalars['String']['input']
    extEmbeddedId: Scalars['String']['input']
    userIds: Array<Scalars['Int']['input']>
}

export type NotificationConfigurationView = {
    __typename?: 'NotificationConfigurationView'
    accountId: Scalars['Int']['output']
    id: Scalars['Int']['output']
    notificationTemplateId: Scalars['String']['output']
    recipientListId: Scalars['String']['output']
}

/** Exactly one of `gap_count` and `thread` is set. */
export type PostConversationItemView = {
    __typename?: 'PostConversationItemView'
    /**
     * How many of `gap_count` are comments with no Moderation row yet: stored,
     * typically by a refresh moments ago, but not classified. Set with `gap_count`.
     */
    gapAwaitingModerationCount?: Maybe<Scalars['Int']['output']>
    gapCount?: Maybe<Scalars['Int']['output']>
    thread?: Maybe<PostConversationThreadView>
}

export type PostConversationPageView = {
    __typename?: 'PostConversationPageView'
    canRefresh: Scalars['Boolean']['output']
    items: Array<PostConversationItemView>
    /**
     * True when `matching_total` hit the cap. Past it the oldest matching comments
     * are missing from the matching set, so they show as filtered gaps.
     */
    matchingCapped: Scalars['Boolean']['output']
    /**
     * How many comments on the post match the filters, capped at 20,000
     * (`POST_MATCHING_CAP` in `conversation_service`).
     */
    matchingTotal: Scalars['Int']['output']
    /** Null when the scan reached the oldest top-level comment. */
    nextCursor?: Maybe<Scalars['String']['output']>
    post: ConversationPostView
}

export type PostConversationReplyView = {
    __typename?: 'PostConversationReplyView'
    /**
     * The reply has no Moderation row yet, so the feed's default filter hides it.
     * Only set when `matches` is false; the client words the gap accordingly.
     */
    awaitingModeration: Scalars['Boolean']['output']
    content: ContentView
    /** False when the current filters exclude this reply; the client collapses runs of these into "N replies filtered". */
    matches: Scalars['Boolean']['output']
}

export type PostConversationThreadView = {
    __typename?: 'PostConversationThreadView'
    /**
     * True when the thread holds replies the preview leaves out. `getMoreThreadReplies`
     * pages through all of them; it has no cursor from this preview, so its first
     * call takes `after: null` and starts from the thread's first reply. The client
     * must replace the preview with the paged list, never append to it.
     */
    hasMoreReplies: Scalars['Boolean']['output']
    /**
     * A preview, not a continuous prefix: the first 3 matching replies in date
     * order plus their non-matching ancestors, so no reply appears without its
     * parent. Non-matching replies between them are left out.
     */
    replies: Array<PostConversationReplyView>
    /** How many of `replies_filtered_count` have no Moderation row yet. */
    repliesAwaitingModerationCount: Scalars['Int']['output']
    /** How many of `reply_count` the filters exclude. */
    repliesFilteredCount: Scalars['Int']['output']
    /** Every held reply at any depth (up to five levels, at most 500), matching or not. */
    replyCount: Scalars['Int']['output']
    root: ContentView
    /** The root has no Moderation row yet. Only set when `root_matches` is false. */
    rootAwaitingModeration: Scalars['Boolean']['output']
    /** False when only replies matched the filters; the client de-emphasises the root. */
    rootMatches: Scalars['Boolean']['output']
}

/**
 * What a post refresh (`startPostConversationRefresh`) did, carried in
 * `PostRefreshTaskResult.outcome`. `ran` is true when the platform was
 * asked, not that the fetch succeeded; false when the platform cannot be
 * refreshed or the post was refreshed within the last 10 minutes. Either way
 * the client refetches the threaded page.
 */
export type PostRefreshOutcomeView = {
    __typename?: 'PostRefreshOutcomeView'
    /**
     * Comments the refresh found that Arwen did not hold; zero when it did
     * not run. They appear on the page only once moderated. On YouTube some
     * replies arrive later through the pipeline, so this can undercount.
     */
    newComments: Scalars['Int']['output']
    /**
     * Non-fatal problems from the refresh, in plain English; empty when it
     * did not run or nothing went wrong.
     */
    notices: Array<Scalars['String']['output']>
    /** The post's platform, lowercase (`instagram`, `facebook`, `youtube`, ...). */
    platform: Scalars['String']['output']
    ran: Scalars['Boolean']['output']
}

/** GraphQL response for polling a post conversation refresh. */
export type PostRefreshTaskResult = {
    __typename?: 'PostRefreshTaskResult'
    completedAt?: Maybe<Scalars['DateTime']['output']>
    /** Elapsed time in milliseconds since the task started */
    elapsedMs: Scalars['Int']['output']
    /** Why the refresh failed, in plain English; only when status is Failed */
    error?: Maybe<Scalars['String']['output']>
    message: Scalars['String']['output']
    /** What the refresh did; only when status is Completed */
    outcome?: Maybe<PostRefreshOutcomeView>
    startedAt: Scalars['DateTime']['output']
    status: PostRefreshTaskStatus
}

/** GraphQL response for starting a post conversation refresh. */
export type PostRefreshTaskStarted = {
    __typename?: 'PostRefreshTaskStarted'
    /**
     * The result when the refresh finished within the wait window, so the
     * frontend can skip polling.
     */
    result?: Maybe<PostRefreshTaskResult>
    startedAt: Scalars['DateTime']['output']
    /** Unique identifier for the task (use this to poll for the result) */
    taskId: Scalars['String']['output']
}

/** Status of a post conversation refresh task. */
export enum PostRefreshTaskStatus {
    /** Task completed; `outcome` says what the refresh did */
    Completed = 'COMPLETED',
    /** Task failed; `error` is worded for the moderator */
    Failed = 'FAILED',
    /** The platform is being asked and the result persisted */
    Fetching = 'FETCHING',
    /** Task has been created but not yet started */
    Pending = 'PENDING'
}

export type PreparedChatSession = {
    __typename?: 'PreparedChatSession'
    /** Indicates if the date range was automatically reduced to fit within token limits. */
    dateRangeWasReduced: Scalars['Boolean']['output']
    earliest?: Maybe<Scalars['DateTime']['output']>
    itemCount: Scalars['Int']['output']
    latest?: Maybe<Scalars['DateTime']['output']>
    sessionId: Scalars['String']['output']
    /** Summary describing the dataset backing the session. */
    summary: Scalars['String']['output']
}

export type Price = {
    __typename?: 'Price'
    active: Scalars['Boolean']['output']
    currency: Scalars['String']['output']
    interval: Scalars['String']['output']
    price: Scalars['String']['output']
    priceId: Scalars['String']['output']
}

export type Product = {
    __typename?: 'Product'
    active: Scalars['Boolean']['output']
    allowedFacebookAccounts?: Maybe<Scalars['Int']['output']>
    allowedInstagramAccounts?: Maybe<Scalars['Int']['output']>
    allowedTotalFollowers?: Maybe<Scalars['String']['output']>
    allowedTwitterAccounts?: Maybe<Scalars['Int']['output']>
    customerType: Scalars['String']['output']
    description: Scalars['String']['output']
    directMessagesIncluded?: Maybe<Scalars['Boolean']['output']>
    languagesCovered?: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
    order: Scalars['Int']['output']
    prices?: Maybe<Array<Price>>
    productId: Scalars['String']['output']
    reportingLevel?: Maybe<Scalars['String']['output']>
    speedOfRemoval?: Maybe<Scalars['String']['output']>
}

export type ProductConnection = {
    __typename?: 'ProductConnection'
    items: Array<Product>
}

export type ProfileFilterInput = {
    followers?: InputMaybe<Scalars['Int']['input']>
    following?: InputMaybe<Scalars['Int']['input']>
    posts?: InputMaybe<Scalars['Int']['input']>
    username?: InputMaybe<Scalars['String']['input']>
}

export type ProfileSortInput = {
    field: Scalars['String']['input']
    order: Scalars['String']['input']
}

export type ProfileView = {
    __typename?: 'ProfileView'
    followers?: Maybe<Scalars['Int']['output']>
    following?: Maybe<Scalars['Int']['output']>
    id: Scalars['Int']['output']
    posts?: Maybe<Scalars['Int']['output']>
    /** The location of the saved profile image - S3 */
    profileImagePath?: Maybe<Scalars['String']['output']>
    profileImageUrl?: Maybe<Scalars['String']['output']>
    profileUrl: Scalars['String']['output']
    serviceProfileId: Scalars['String']['output']
    username: Scalars['String']['output']
}

/**
 * Profile view with optional shadow ban status.
 * When account_id is provided in the query, shadow_ban_status and shadow_ban_status_code
 * will be populated. Otherwise they will be None.
 */
export type ProfileViewWithShadowBan = {
    __typename?: 'ProfileViewWithShadowBan'
    followers?: Maybe<Scalars['Int']['output']>
    following?: Maybe<Scalars['Int']['output']>
    id: Scalars['Int']['output']
    posts?: Maybe<Scalars['Int']['output']>
    profileImagePath?: Maybe<Scalars['String']['output']>
    profileImageUrl?: Maybe<Scalars['String']['output']>
    profileUrl: Scalars['String']['output']
    serviceProfileId: Scalars['String']['output']
    /**
     * Shadow ban status string (e.g., "None", "Active", "Disabled")
     * Only populated when account_id is provided in the query
     */
    shadowBanStatus?: Maybe<Scalars['String']['output']>
    /**
     * Shadow ban status code (0 = None/Disabled, 1 = Active)
     * Only populated when account_id is provided in the query
     */
    shadowBanStatusCode?: Maybe<Scalars['Int']['output']>
    username: Scalars['String']['output']
}

/**
 * A profile's reply prompt, as read by the Engage reply settings page.
 *
 * Since EN-467 this is the only prompt the API serves: classification prompts
 * are versioned `ClassifierPromptView`s. The `category` and `prompt_type`
 * fields that distinguished the two went with that change.
 */
export type PromptView = {
    __typename?: 'PromptView'
    createdAt: Scalars['DateTime']['output']
    id: Scalars['Int']['output']
    model: Scalars['String']['output']
    prompt: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['DateTime']['output']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type Query = {
    __typename?: 'Query'
    /**
     * One account's monitoring: its schedule, and everything that has run
     * for it.
     */
    accountMonitoring: AccountMonitoring
    checkMetaAuthorisationForAccount: Scalars['Boolean']['output']
    checkMetaSubscriptionForAccount: Scalars['Boolean']['output']
    /**
     * Whether a proposed classifier shortName is still free, and if not, which
     * classifier holds it. Lets the create form report a collision against the name
     * the admin typed instead of failing on the unique index at submit. Admin only.
     */
    classifierNameAvailability: ClassifierNameAvailability
    /**
     * Synchronous content search over the normalised tables. Results only;
     * call contentSearchCount alongside it for the total.
     *
     * For callers that want a handful of rows and an answer in one round trip
     * — the shadow-banning table, the author page. The feed goes through
     * `startContentSearch` instead, because a feed search can run for two
     * minutes and a single request cannot survive that. — Claude
     */
    contentSearch: Array<ContentView>
    /**
     * The count twin of contentSearch, capped at 10,001 and rendered "10,000+"
     * at the cap. Counting past a number nobody can page to is wasted scan.
     * — Claude
     */
    contentSearchCount: Scalars['Int']['output']
    /**
     * The count the feed renders, and the only count it calls.
     *
     * Two things the plain `contentSearchCount` resolver doesn't do:
     *
     * 1. It owns a wall-clock budget and returns `GAVE_UP_COUNT` rather than an
     * error when it blows it. The give-up used to live in the client, which
     * could only guess at a number; here it is a decision the server makes
     * with the query in front of it. The budget wraps the whole call, not
     * just the statement, so resolve time and pool acquisition count against
     * it too.
     * 2. It is a sibling of the search rather than a stage of it — the client
     * fires this alongside `startContentSearch`, so a cheap count no longer
     * waits behind a two-minute search.
     */
    contentSearchTotal: Scalars['Int']['output']
    countContent?: Maybe<CountContentConnection>
    countProfiles: Scalars['Int']['output']
    /**
     * This doesn't change any information in the database so isn't strictly a mutation
     * Also it just makes sense to have it alongside the check query function
     */
    createMetaSubscriptionForAccount: Scalars['Boolean']['output']
    debugMetaAuthorisationForAccount: DebugTokenResponseView
    /**
     * This doesn't change any information in the database so isn't strictly a mutation
     * Also it just makes sense to have it alongside the check query function
     */
    deleteMetaSubscriptionForAccount: Scalars['Boolean']['output']
    /**
     * Detects the language of the provided texts using lingua (local, restricted language set).
     * Used by the frontend to decide whether to show the "Translate" button,
     * avoiding unnecessary Google Cloud Translation API calls.
     */
    detectLanguages: Array<DetectedLanguageView>
    enrichContent: Array<EnrichedContent>
    fetchUserDetails?: Maybe<FetchUserDetailsConnection>
    /**
     * The fleet jobs: work that covers every account on a platform in one
     * job. Their rows are in `scheduledWork` like any other. Admin-only.
     */
    fleetJobs: Array<FleetJob>
    getAccount: AccountRecord
    /** Gets all accounts in the given team */
    getAccountsInTeam: Array<AccountRecord>
    /** One post with its comment counts, or null if we never ingested it. Admin only. */
    getAdminPost?: Maybe<AdminPostView>
    /** Get all services health with status indicators (admin only) */
    getAllServicesHealth: ServiceHealthConnection
    getAuthorisationUrl: Scalars['String']['output']
    /** Returns all available LLM models that can be used for prompts */
    getAvailableLlmModels: Array<LlmModelInfo>
    /**
     * Poll for the status and result of an async chat task.
     *
     * Use this query to check on a task started by `startChat`.
     * Keep polling until `status` is `SUCCESS` or `FAILED`.
     */
    getChatTaskStatus: ChatTaskStatusResponse
    getClassificationResults: Array<ClassificationResult>
    /**
     * One page of the individual profiles a classifier is deployed to. Optional
     * profile-name search. Admin only.
     */
    getClassifierDeployedProfiles: ClassifierDeployedProfiles
    /**
     * Profiles this classifier is applied to that have LLM classification
     * switched off, so the prompt never runs for them. Drives the warning on
     * the classifier page; the flag is on by default, so this is normally
     * empty. Admin only.
     */
    getClassifierDeployedProfilesWithoutLlmClassification: Array<DeployedProfile>
    /**
     * One page of the teams a classifier is deployed to, with coverage. Optional
     * team-name search. Admin only.
     */
    getClassifierDeploymentTeams: ClassifierDeploymentTeams
    /**
     * Returns the catalogue of available classifiers (descriptions, names, ids).
     * Authenticated users only.
     */
    getClassifierDetails: Array<ClassifierDetailView>
    /**
     * Paginated list of classifiers that have a prompt, each with a version
     * summary, narrowed by the optional filters in `params`. Admin only.
     */
    getClassifierLibrary: ClassifierLibrary
    /** A single classifier prompt version by id. Admin only. */
    getClassifierPrompt: ClassifierPrompt
    /** All versions of a classifier (by ClassifierDetails id), newest first. Admin only. */
    getClassifierPromptVersions: Array<ClassifierPrompt>
    /**
     * The profiles in a team that this classifier isn't applied to yet — exactly
     * who "Apply to remaining" would newly cover. Admin only.
     */
    getClassifierRemainingTeamProfiles: Array<DeployedProfile>
    /**
     * The thread a comment sits in: its post, the top held comment and every
     * held reply, scoped to this user's accounts.
     */
    getCommentThread: CommentThreadView
    /** One comment by id, scoped to this user's accounts. */
    getContentById: ContentView
    /**
     * Which classifiers flagged comments in this search, and how many each
     * flagged. Published verbatim as the GraphQL field description.
     */
    getContentClassifierMetadata: Array<ContentClassifierMetadataView>
    /**
     * Which classifiers flagged comments in this search, names only. The
     * classifier filter shows this while `getContentClassifierMetadata` is
     * still counting, so the two are the same set over the same search.
     * Published verbatim as the GraphQL field description.
     */
    getContentClassifierOptions: Array<ClassifierDetailView>
    getContentFeed: ContentFeedView
    getContentFeedsForUser: Array<ContentFeedView>
    /**
     * Get the status and results of an async content search task.
     *
     * Use this to poll for the results of a search started with `startContentSearch`.
     * The task will be in one of the following states:
     * - Pending: Task created but not yet processing
     * - RetrievingData: Querying the database
     * - Completed: Results available
     * - Failed: Task failed with an error
     */
    getContentSearchTask: ContentSearchTaskResult
    getCookie?: Maybe<CookieSummary>
    getCookies: Array<CookieSummary>
    getCustomerPaymentPortalUrl: CustomerPaymentPortal
    /** Gets a dashboard by its ID. */
    getDashboard: DashboardView
    /** Gets all the dashboards that the user has access to. */
    getDashboards: Array<DashboardView>
    /**
     * Poll for the status and result of an async dataset preparation task.
     *
     * Use this query to check on a task started by `startPrepareChatSession`.
     * Keep polling until `status` is `SUCCESS` or `FAILED`.
     *
     * When `status` is `SUCCESS`, the `result` field will contain the prepared
     * session information including `sessionId` to use with `startChat`.
     */
    getDatasetPrepTaskStatus: DatasetPrepTaskStatusResponse
    /** Gets a dashboard by its ID, along with the users that have access to it. */
    getEditableDashboard: EditableDashboardView
    /** Gets the guest token and the config needed to embed a Preset.io dashboard in an iframe. */
    getEmbeddedDashboard: EmbeddedDashboardView
    getKeywordsForAccount: Array<KeywordView>
    getLabelledSpam?: Maybe<Array<Maybe<SpamSearchResult>>>
    getLlmReplyPrompt?: Maybe<PromptView>
    /**
     * The full classifier catalogue including client-facing name + modality, for
     * the admin management UI. Admin only.
     */
    getManagedClassifierDetails: Array<ClassifierDetailFull>
    getManyClassificationResults: Array<ClassificationResult>
    getModerationBoundaries: Array<ModerationBoundaryView>
    /**
     * The next page of replies for one thread on the post conversation page, for
     * "View N more replies". `contentId` is the thread's top-level comment.
     * Returns every held reply in date order, matching or not, each flagged
     * against the same filters `getPostConversationPage` was given.
     */
    getMoreThreadReplies: MoreThreadRepliesView
    getMyContentFeeds: Array<ContentFeedView>
    getNotificationConfiguration: NotificationConfigurationView
    getNotificationConfigurationForAccount: Array<NotificationConfigurationView>
    /**
     * Gets the authorisation URL for the OAuth 2 authorisation grant flow.
     * This is the initial platform URL the user visits: they approve our
     * request and are redirected back to us with a code.
     *
     * 2024-02: get_authorisation_url exists in Tenmoku, and gets the OAuth url for the
     * other platforms. New authorisation URLs should be added here, as part of the migration
     * away from Tenmoku and Typescript.
     */
    getOauthUrl: Scalars['String']['output']
    /**
     * One page of the post conversation page (the post's "Threaded" tab): the
     * post's top-level comments newest first, each with a preview of its replies.
     *
     * `params` are the filter bar's filters, the same input the Chronological
     * list takes, and `params.postIds` must name exactly one post. Comments the
     * filters exclude are not dropped: each run of top-level comments with
     * nothing matching comes back as one gap item ("N comments filtered"), so
     * the reader can see where they were. `after` is the previous page's
     * `nextCursor`; `limit` is how many threads to return (default 20, at most 50).
     * See `conversation_service` for the terms used here.
     */
    getPostConversationPage: PostConversationPageView
    /**
     * Returns the profile by content id.
     *
     * Scrapes and persists the profile if we don't have it.
     *
     * Instagram only.
     */
    getProfile: ProfileView
    /**
     * Returns profiles by IDs. When account_id is provided, includes shadow ban status
     * for that account. Otherwise shadow_ban_status and shadow_ban_status_code will be None.
     */
    getProfilesByIds: Array<ProfileViewWithShadowBan>
    /**
     * The ids of classifiers that have a live prompt version. Their moderation
     * boundaries are written and re-pointed by classifier deployment, so the
     * moderation boundaries page uses this to disable hand-editing them — an edit
     * there would be discarded by the next redeployment.
     *
     * Authenticated rather than admin-only: it gates controls on a page any
     * authenticated user can open, and it exposes nothing but classifier ids.
     */
    getPromptManagedClassifierIds: Array<Scalars['Int']['output']>
    /**
     * Get paginated list of all screenshots for admin view
     * Includes full logs for debugging
     * Authorization: Admin only
     */
    getScreenshotAdminList: ScreenshotAdminListResponse
    /**
     * Get all screenshot attempts for a content item (admin only)
     * Includes full logs for debugging
     * Authorization: Admin only
     */
    getScreenshotAttemptsByContentId: Array<ScreenshotAttempt>
    /**
     * Get the latest screenshot for a content item (any status: success, failed, or pending).
     * Used by the frontend to display screenshot state in the UI.
     * Authorization: User must have access to the content's account
     */
    getScreenshotByContentId?: Maybe<Screenshot>
    /**
     * Get screenshot summaries grouped by content for admin view
     * Returns aggregated stats per content with latest screenshot details
     * Authorization: Admin only
     */
    getScreenshotContentSummary: ScreenshotContentSummaryResponse
    /**
     * Returns the catalogue of supported social media services. Authenticated users only.
     * Cached in Redis for 10 minutes under key `all_services` to match TS parity.
     */
    getSocialMediaServices: Array<SocialMediaServiceView>
    /** Get suggested replies for a piece of content using LLM */
    getSuggestedReplies: Array<Scalars['String']['output']>
    /**
     * Returns counts of SAFE/SUSPECT/SEVERE for a given set of content.
     * What content is determined by the given params.
     *
     * Counts over `arwen.Content` from the same `SearchScope` the feed uses,
     * so the filter bar always describes the rows the feed lists. — Claude
     *
     * Bounded by `FILTER_BUDGET`. Past it the three counts come back null and
     * the UI shows no number at all. That is deliberately not the "10,000+"
     * treatment the row count gets: "at least 10,000" is still true of a
     * truncated count, whereas a truncated *breakdown* is just wrong, and "0
     * severe" is a claim in a way that a blank is not. — Claude
     */
    getSummaryForAccounts: ContentSummary
    getTeam?: Maybe<Team>
    /**
     * Gets a team by ID.
     *
     * Will reject the request if:
     * 1. The user is not an admin OR
     * 2. The user is not in the team.
     */
    getTeamById: TeamView
    /**
     * Gets all the teams that the user has permission to view.
     * For example, an admin can view all teams, a non-admin only the team they are a member of.
     * A non-admin user who is not part of a team just gets an empty string.
     */
    getTeams: Array<TeamView>
    getUserAuthEvents: Array<UserAuthEventView>
    getUserById: UserView
    /**
     * The currently logged in user is allowed to get user details about their other team members.
     * Given how we define our user ids, using sequentially increasing numbers, we can't allow users to
     * get user details about other users. This is a security measure.
     */
    getUserIfAllowed: UserView
    getUserPermissions: UsersPermissionsView
    getUserSubscription: User
    getUserTeamsAdmin: Array<TeamView>
    getUsersByTeamId: Array<UserView>
    /**
     * Builds the PubSubHubbub diagnostic URL for a given YouTube channel.
     * Authenticated users only. Pure computation — no DB access.
     */
    getYouTubeSubscriptionDiagnosticUrl: YouTubeSubscriptionDiagrnostics
    isSubscribed: Scalars['Boolean']['output']
    listContent?: Maybe<ContentConnection>
    /** Lists all referrers with pagination. Admin only. */
    listReferrers: ReferrerListResponse
    /**
     * Live diagnostic for Meta ad-account visibility. Admin-only. Hits the
     * Marketing API on every call, so it's slow — caller should expect
     * seconds, not milliseconds. See EN-210.
     */
    metaAdVisibility: MetaAdVisibility
    /**
     * Monitoring health for a page of accounts, in one round trip.
     *
     * Batched by account id because the caller is a list: ten indicators
     * used to mean ten queries. Pass every account on screen — the `jobs`
     * crate decides which of them have a signal to give, so an authorised
     * profile comes back with nothing unless it is also being scraped,
     * which is the case worth flagging.
     */
    monitoringHealth: Array<AccountHealthSignal>
    /**
     * The state of a refresh started with `startPostConversationRefresh`.
     * Only the user who started it may read it.
     */
    postConversationRefreshTask: PostRefreshTaskResult
    /**
     * Every piece of scheduled work, newest first: the Scheduled Jobs
     * page's table. Admin-only, like the mutations beside it — this work
     * drives infrastructure-level monitoring, not any user's own data.
     */
    scheduledWork: Array<ScheduledWork>
    /**
     * How many pieces of live work are currently failing — the admin
     * sidebar's badge. Stopped work doesn't count.
     */
    scheduledWorkAttentionCount: Scalars['Int']['output']
    /** Every run of one piece of work, newest first. */
    scheduledWorkHistory: Array<ScheduledWorkRun>
    searchAccounts: SearchAccountResponse
    /**
     * One page of posts, newest first, scoped by account or team, with the
     * comment counts we hold for each. Admin only.
     */
    searchAdminPosts: AdminPostSearchResultView
    searchProfiles: Array<ProfileView>
    searchShadowBannedProfiles: Array<ProfileViewWithShadowBan>
    searchTeams: Array<TeamView>
    searchUsers: Array<UserView>
    searchUsersCount: Scalars['Int']['output']
    /** Test an LLM classification prompt against a specific message */
    testLlmClassificationPrompt: Scalars['Float']['output']
    /** Test an LLM classification prompt and return detailed results with justification */
    testLlmClassificationPrompts: Array<LlmClassificationView>
    /** Test an LLM image classification prompt against uploaded images */
    testLlmImageClassificationPrompts: Array<LlmImageClassificationView>
    /** Test an LLM reply prompt against a test message */
    testLlmReplyPrompt: Array<Scalars['String']['output']>
    translate: Array<TranslatedTextView>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryAccountMonitoringArgs = {
    platform: Scalars['String']['input']
    serviceAccountUsername: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryCheckMetaAuthorisationForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryCheckMetaSubscriptionForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryClassifierNameAvailabilityArgs = {
    shortName: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryContentSearchArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryContentSearchCountArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryContentSearchTotalArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryCountContentArgs = {
    endDateTime: Scalars['AWSDateTime']['input']
    filter?: InputMaybe<ContentFilterInput>
    keyword?: InputMaybe<Scalars['String']['input']>
    startDateTime: Scalars['AWSDateTime']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryCountProfilesArgs = {
    filter?: InputMaybe<ProfileFilterInput>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryCreateMetaSubscriptionForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryDebugMetaAuthorisationForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryDeleteMetaSubscriptionForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryDetectLanguagesArgs = {
    sourceTexts: Array<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryEnrichContentArgs = {
    contents: Array<ContentToEnrich>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryFetchUserDetailsArgs = {
    serviceAccountUsername: Scalars['String']['input']
    socialMediaService: SocialMediaServiceEnum
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetAccountsInTeamArgs = {
    params: GetAccountsInTeamParamsView
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetAdminPostArgs = {
    postId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetAuthorisationUrlArgs = {
    accountId: Scalars['Int']['input']
    baseUrl: Scalars['String']['input']
    socialMediaService: SocialMediaServiceEnum
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetChatTaskStatusArgs = {
    taskId: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassificationResultsArgs = {
    contentId?: InputMaybe<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierDeployedProfilesArgs = {
    classifierDetailsId: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    search?: InputMaybe<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierDeployedProfilesWithoutLlmClassificationArgs = {
    classifierDetailsId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierDeploymentTeamsArgs = {
    classifierDetailsId: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    search?: InputMaybe<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierLibraryArgs = {
    params: ClassifierSearchView
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierPromptArgs = {
    id: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierPromptVersionsArgs = {
    classifierDetailsId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetClassifierRemainingTeamProfilesArgs = {
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetCommentThreadArgs = {
    contentId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentByIdArgs = {
    id: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentClassifierMetadataArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentClassifierOptionsArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentFeedArgs = {
    contentFeedId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentFeedsForUserArgs = {
    userId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetContentSearchTaskArgs = {
    taskId: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetCookieArgs = {
    cookieId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetCookiesArgs = {
    platform: CookiePlatform
    status?: InputMaybe<CookieStatus>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetCustomerPaymentPortalUrlArgs = {
    returnUrl: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetDashboardArgs = {
    dashboardId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetDatasetPrepTaskStatusArgs = {
    taskId: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetEditableDashboardArgs = {
    dashboardId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetEmbeddedDashboardArgs = {
    dashboardId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetKeywordsForAccountArgs = {
    params: KeywordParamsList
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetLabelledSpamArgs = {
    message?: InputMaybe<Scalars['String']['input']>
    platform?: InputMaybe<Scalars['String']['input']>
    threshold?: InputMaybe<Scalars['Float']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetLlmReplyPromptArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetManyClassificationResultsArgs = {
    contentIds: Array<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetModerationBoundariesArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetMoreThreadRepliesArgs = {
    after?: InputMaybe<Scalars['String']['input']>
    contentId: Scalars['Int']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetNotificationConfigurationArgs = {
    notificationConfigurationId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetNotificationConfigurationForAccountArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetOauthUrlArgs = {
    baseUrl: Scalars['String']['input']
    socialMediaService: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetPostConversationPageArgs = {
    after?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetProfileArgs = {
    contentId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetProfilesByIdsArgs = {
    accountId?: InputMaybe<Scalars['Int']['input']>
    profileIds: Array<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetScreenshotAdminListArgs = {
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    status?: InputMaybe<ScreenshotStatus>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetScreenshotAttemptsByContentIdArgs = {
    contentId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetScreenshotByContentIdArgs = {
    contentId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetScreenshotContentSummaryArgs = {
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    status?: InputMaybe<ScreenshotStatus>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetSuggestedRepliesArgs = {
    contentId: Scalars['Int']['input']
    numberOfSuggestions?: InputMaybe<Scalars['Int']['input']>
    temperature?: InputMaybe<Scalars['Float']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetSummaryForAccountsArgs = {
    params: ContentSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetTeamArgs = {
    teamId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetTeamByIdArgs = {
    teamId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserAuthEventsArgs = {
    username: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserByIdArgs = {
    id: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserIfAllowedArgs = {
    id: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserPermissionsArgs = {
    usernames: Array<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserSubscriptionArgs = {
    referrer?: InputMaybe<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUserTeamsAdminArgs = {
    userId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetUsersByTeamIdArgs = {
    teamId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryGetYouTubeSubscriptionDiagnosticUrlArgs = {
    channelId: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryIsSubscribedArgs = {
    accountId: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryListContentArgs = {
    filter?: InputMaybe<ContentFilterInput>
    keyword?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
    offset?: InputMaybe<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryListReferrersArgs = {
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryMetaAdVisibilityArgs = {
    accountId: Scalars['Int']['input']
    days?: InputMaybe<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryMonitoringHealthArgs = {
    accountIds: Array<Scalars['Int']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryPostConversationRefreshTaskArgs = {
    taskId: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryScheduledWorkArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    status?: InputMaybe<Scalars['String']['input']>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryScheduledWorkHistoryArgs = {
    tag: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchAccountsArgs = {
    params: SearchAccountsParamsView
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchAdminPostsArgs = {
    params: AdminPostSearchParamsView
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchProfilesArgs = {
    filter?: InputMaybe<ProfileFilterInput>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    sort?: InputMaybe<ProfileSortInput>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchShadowBannedProfilesArgs = {
    accountId: Scalars['Int']['input']
    filter?: InputMaybe<ProfileFilterInput>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    sort?: InputMaybe<ProfileSortInput>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchTeamsArgs = {
    params: TeamsSearchParamsView
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchUsersArgs = {
    params: UserSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QuerySearchUsersCountArgs = {
    params: UserSearchParams
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryTestLlmClassificationPromptArgs = {
    model?: InputMaybe<Scalars['String']['input']>
    prompt: Scalars['String']['input']
    testMessage: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryTestLlmClassificationPromptsArgs = {
    model?: InputMaybe<Scalars['String']['input']>
    prompt: Scalars['String']['input']
    testCases: Array<LlmClassificationTestInput>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryTestLlmImageClassificationPromptsArgs = {
    model?: InputMaybe<Scalars['String']['input']>
    prompt: Scalars['String']['input']
    testCases: Array<LlmImageClassificationTestInput>
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryTestLlmReplyPromptArgs = {
    model?: InputMaybe<Scalars['String']['input']>
    numberOfSuggestions?: InputMaybe<Scalars['Int']['input']>
    prompt: Scalars['String']['input']
    temperature?: InputMaybe<Scalars['Float']['input']>
    testMessage: Scalars['String']['input']
}

/**
 * All the queries our rust graphql server supports.
 *
 * If you add something here make sure you add it to:
 * ```api-models/rust_graphql/src/queries.graphql```
 * If you don't you won't get generated client code, i.e. for TypeScript.
 *
 * When writing queries here you'll probably want to do some of the following:
 * ```text
 * // For access to information about the current user.
 * let logged_in_user = get_user(ctx).await?;
 * // For access to services and the database connection pool.
 * let state = ctx.data::<AppState>()?;
 * ```
 */
export type QueryTranslateArgs = {
    sourceTexts: Array<Scalars['String']['input']>
    targetLanguage: Scalars['String']['input']
}

export enum ReadFilterView {
    All = 'ALL',
    ReadByMe = 'READ_BY_ME',
    UnreadByEveryone = 'UNREAD_BY_EVERYONE',
    UnreadByMe = 'UNREAD_BY_ME'
}

export type ReadReceiptView = {
    __typename?: 'ReadReceiptView'
    contentOutcomeId: Scalars['Int']['output']
    createdAt: Scalars['DateTime']['output']
    userId: Scalars['Int']['output']
}

export type Referrer = {
    __typename?: 'Referrer'
    allowTrial: Scalars['Boolean']['output']
    creditCardRequired: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    isCobranded: Scalars['Boolean']['output']
    isGuidedOnboarding: Scalars['Boolean']['output']
    logoUrl?: Maybe<Scalars['String']['output']>
    priceId?: Maybe<Scalars['String']['output']>
    referrer: Scalars['String']['output']
    referrerUuid: Scalars['String']['output']
    signUpEnabled: Scalars['Boolean']['output']
    trialDays?: Maybe<Scalars['Int']['output']>
    trialEndDate?: Maybe<Scalars['AWSDateTime']['output']>
    userLimit?: Maybe<Scalars['Int']['output']>
}

export type ReferrerListResponse = {
    __typename?: 'ReferrerListResponse'
    referrers: Array<ReferrerView>
    total: Scalars['Int']['output']
}

export type ReferrerView = {
    __typename?: 'ReferrerView'
    allowTrial: Scalars['Boolean']['output']
    creditCardRequired: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    isCobranded: Scalars['Boolean']['output']
    isGuidedOnboarding: Scalars['Boolean']['output']
    logoUrl?: Maybe<Scalars['String']['output']>
    referrer: Scalars['String']['output']
    referrerUuid: Scalars['String']['output']
    requireSubscription: Scalars['Boolean']['output']
    signUpEnabled: Scalars['Boolean']['output']
    trialDays?: Maybe<Scalars['Int']['output']>
    trialEndDate?: Maybe<Scalars['DateTime']['output']>
    userCount: Scalars['Int']['output']
    userLimit?: Maybe<Scalars['Int']['output']>
}

export type SaveAuthorisationCodeResponse = {
    __typename?: 'SaveAuthorisationCodeResponse'
    new: Array<Maybe<Scalars['Int']['output']>>
    updated: Array<Maybe<Scalars['Int']['output']>>
}

/** One row of the Scheduled Jobs table. */
export type ScheduledWork = {
    __typename?: 'ScheduledWork'
    /**
     * Which try the newest row is on, counting from 1. Above 1 means a
     * failure was retried.
     */
    attempt: Scalars['Int']['output']
    /**
     * Failed runs in a row, newest backwards. Retries within one run
     * count once.
     */
    consecutiveFailures: Scalars['Int']['output']
    /** The cron expression this row was timed by, when it is cron-scheduled. */
    cron?: Maybe<Scalars['String']['output']>
    /**
     * The interval in seconds, when this row is interval-scheduled
     * rather than cron-scheduled.
     */
    intervalSecs?: Maybe<Scalars['Int']['output']>
    /** The job kind, e.g. `scrape_comment_fetch`. */
    kind: Scalars['String']['output']
    /** When that run finished, in UTC. */
    lastRunAt?: Maybe<Scalars['DateTime']['output']>
    /** What that run recorded — the error, or a successful run's summary. */
    lastRunLog?: Maybe<Scalars['String']['output']>
    /**
     * How the most recent FINISHED run ended: "Completed", "Failed" or
     * "Panicked". Distinct from `status`, which is the newest row: a
     * failing recurring job's newest row is the next Pending run, so the
     * failure only shows here.
     */
    lastRunStatus?: Maybe<Scalars['String']['output']>
    /**
     * Whether the work continues. The scheduler owns which statuses count
     * as live, so callers ask rather than deciding from `status`.
     */
    live: Scalars['Boolean']['output']
    /**
     * What happened on the newest row, in the words the handler or the
     * scheduler recorded: the error that failed it, the reason it was
     * deferred, or a note from a successful run.
     */
    log?: Maybe<Scalars['String']['output']>
    /**
     * Live work whose most recent finished run failed: still scheduled
     * to run again, and currently not delivering. The scheduler owns
     * this rule; stopped work is never flagged, however badly it ended.
     *
     * The same rule is decided set-wise in SQL by `scheduler_core`'s
     * `count_failing_live`, which backs `scheduledWorkAttentionCount`. The
     * badge and these flags are read as one answer, so the two definitions
     * have to keep agreeing — change one and check the other.
     */
    needsAttention: Scalars['Boolean']['output']
    /**
     * When the next run is due, in UTC. Present only while a run is
     * actually queued (the newest row is Pending): running work has not
     * decided its next time yet, and ended work has none.
     */
    nextRunAt?: Maybe<Scalars['DateTime']['output']>
    /**
     * The row's stored params, as they are. The list is generic, so the
     * details panel shows these for any kind; a kind the frontend knows
     * renders them in its own words, and one it does not gets a
     * key-and-value view. Null when the row has none or they are not an
     * object. A BTreeMap so the keys arrive in a stable order and the
     * panel does not reshuffle between fetches; the wire type is the same
     * `JSONObject` scalar either way.
     */
    params?: Maybe<Scalars['JSONObject']['output']>
    /**
     * The newest row's id, for cross-referencing with
     * `arwen schedule job show <id>` and the log stream. A string
     * because row ids are u64s and JavaScript numbers lose integer
     * precision above 2^53.
     */
    rowId: Scalars['String']['output']
    /**
     * The schedule in English ("At 06:00 AM", "every 900 seconds"),
     * when it can be rendered; fall back to `cron` when
     * absent.
     */
    scheduleEnglish?: Maybe<Scalars['String']['output']>
    /**
     * The work's state, which is simply its newest row's status:
     * "Pending", "Running", "Completed", "Failed", "Panicked",
     * "Cancelled" or "Deferred". A live status (Pending, Running) means
     * the work continues; a terminal one means it has ended.
     */
    status: Scalars['String']['output']
    /**
     * The row in one line, in the words of the kind that owns its
     * params: for a scrape, its mode, target count and window. Falls
     * back to the kind name when the kind has nothing to say. Searchable
     * on the list page, which is how "show me the posts monitors" is
     * answered without a per-kind column.
     */
    summary: Scalars['String']['output']
    /**
     * The work's tag: its name, its identity, and the handle every
     * lifecycle mutation takes. Chosen by whoever created the work —
     * for a Monitor, e.g. `{platform}:{handle}:scrape_comment_fetch`.
     */
    tag: Scalars['String']['output']
}

/**
 * The outcome of a lifecycle mutation. The scheduler's verbs
 * report more than success or failure ("already stopped" is not
 * "stopped"), and the UI should be able to say which happened —
 * `changed` drives whether to refresh, `outcome` is machine-readable,
 * `message` is ready for a toast.
 */
export type ScheduledWorkActionResult = {
    __typename?: 'ScheduledWorkActionResult'
    /** Whether this call changed anything. */
    changed: Scalars['Boolean']['output']
    /** A human-readable sentence describing what happened. */
    message: Scalars['String']['output']
    /**
     * Machine-readable outcome: "Stopped", "AlreadyStopped",
     * "NotFound", "Due", "AlreadyRunning" or "Ended".
     */
    outcome: Scalars['String']['output']
}

/**
 * One run in a piece of work's history: a single row, as the history view
 * shows it.
 */
export type ScheduledWorkRun = {
    __typename?: 'ScheduledWorkRun'
    /** Which try this run was, counting from 1. */
    attempt: Scalars['Int']['output']
    /**
     * When it reached a final state, in UTC. Absent while it is still
     * pending or running.
     */
    completedAt?: Maybe<Scalars['DateTime']['output']>
    /**
     * How many times this run was put off by a rate limit or a handler
     * asking to come back later. Deferrals are not failures and do not
     * consume an attempt.
     */
    deferralCount: Scalars['Int']['output']
    /**
     * How long the run took, in milliseconds. Absent unless it both
     * started and finished.
     */
    durationMs?: Maybe<Scalars['Int']['output']>
    /**
     * What happened, in the words the handler or the scheduler recorded.
     * The error that failed it, the reason it deferred, or a note from a
     * successful run.
     */
    log?: Maybe<Scalars['String']['output']>
    /**
     * The row's id. A string because row ids are u64s and JavaScript
     * numbers lose integer precision above 2^53.
     */
    rowId: Scalars['String']['output']
    /** When this row became eligible to be claimed, in UTC. */
    scheduledAt: Scalars['DateTime']['output']
    /**
     * Why this row exists and what set its time: `user`, `hint`,
     * `cron:<expr>`, `every:<secs>s`, `backoff:<secs>s`, `defer` or
     * `skip`. Reading this down a history tells you the story — a
     * `backoff:` row is a retry, a `cron:` row is a fresh scheduled run.
     */
    scheduledBy: Scalars['String']['output']
    /** When a worker picked it up, in UTC. Absent if it never ran. */
    startedAt?: Maybe<Scalars['DateTime']['output']>
    /**
     * How this run ended, or where it is now: "Pending", "Running",
     * "Completed", "Failed", "Panicked", "Cancelled", "Deferred".
     */
    status: Scalars['String']['output']
    /** Which piece of work this run belongs to. */
    tag: Scalars['String']['output']
}

/**
 * Screenshot metadata view (without logs)
 * Used for public queries - returns latest successful screenshot for a content item
 */
export type Screenshot = {
    __typename?: 'Screenshot'
    contentId: Scalars['Int']['output']
    cookieId?: Maybe<Scalars['Int']['output']>
    createdAt: Scalars['DateTime']['output']
    errorMessage?: Maybe<Scalars['String']['output']>
    id: Scalars['Int']['output']
    s3Url?: Maybe<Scalars['String']['output']>
    status: ScreenshotStatus
}

/** Admin list response with pagination info */
export type ScreenshotAdminListResponse = {
    __typename?: 'ScreenshotAdminListResponse'
    items: Array<ScreenshotAttempt>
    total: Scalars['Int']['output']
}

/**
 * Screenshot attempt view (with logs)
 * Used for admin queries - includes full sgraffito logs for debugging
 */
export type ScreenshotAttempt = {
    __typename?: 'ScreenshotAttempt'
    contentId: Scalars['Int']['output']
    contentText?: Maybe<Scalars['String']['output']>
    cookieId?: Maybe<Scalars['Int']['output']>
    createdAt: Scalars['DateTime']['output']
    errorMessage?: Maybe<Scalars['String']['output']>
    id: Scalars['Int']['output']
    logs?: Maybe<Scalars['String']['output']>
    s3Url?: Maybe<Scalars['String']['output']>
    status: ScreenshotStatus
}

/** Screenshot content summary - aggregated stats per content */
export type ScreenshotContentSummary = {
    __typename?: 'ScreenshotContentSummary'
    accountName?: Maybe<Scalars['String']['output']>
    authorName?: Maybe<Scalars['String']['output']>
    contentId: Scalars['Int']['output']
    contentText?: Maybe<Scalars['String']['output']>
    failedCount: Scalars['Int']['output']
    latestCreatedAt: Scalars['DateTime']['output']
    latestScreenshot?: Maybe<ScreenshotAttempt>
    pendingCount: Scalars['Int']['output']
    socialMediaService?: Maybe<Scalars['String']['output']>
    successCount: Scalars['Int']['output']
    totalAttempts: Scalars['Int']['output']
}

/** Content summary list response with pagination info */
export type ScreenshotContentSummaryResponse = {
    __typename?: 'ScreenshotContentSummaryResponse'
    items: Array<ScreenshotContentSummary>
    total: Scalars['Int']['output']
}

/** Screenshot status for GraphQL API */
export enum ScreenshotStatus {
    Failed = 'FAILED',
    Pending = 'PENDING',
    Success = 'SUCCESS'
}

export type SearchAccountResponse = {
    __typename?: 'SearchAccountResponse'
    accounts: Array<AccountRecord>
    total: Scalars['Int']['output']
}

/** Params for search for accounts */
export type SearchAccountsParamsView = {
    keyword?: InputMaybe<Scalars['String']['input']>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    socialMediaServices: Array<Scalars['String']['input']>
    teamIds: Array<Scalars['Int']['input']>
}

/** Response type for the sendNewAccountNotification mutation */
export type SendNotificationResponse = {
    __typename?: 'SendNotificationResponse'
    message?: Maybe<Scalars['String']['output']>
    success: Scalars['Boolean']['output']
}

export type ServiceHealth = {
    __typename?: 'ServiceHealth'
    createdAt: Scalars['DateTime']['output']
    expectedIntervalSeconds: Scalars['Int']['output']
    healthStatus: HealthStatus
    lastHeartbeat: Scalars['DateTime']['output']
    serviceName: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ServiceHealthConnection = {
    __typename?: 'ServiceHealthConnection'
    items: Array<ServiceHealth>
    total: Scalars['Int']['output']
}

/** Response from the setManualShadowBanForAccount mutation. */
export type SetManualShadowBanResponse = {
    __typename?: 'SetManualShadowBanResponse'
    /** The ID of the profile that was shadow banned (useful when a new profile was created) */
    profileId: Scalars['Int']['output']
    /** Whether the operation was successful */
    success: Scalars['Boolean']['output']
}

export type SocialMediaService = {
    __typename?: 'SocialMediaService'
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription?: Maybe<Scalars['String']['output']>
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

export enum SocialMediaServiceEnum {
    Facebook = 'FACEBOOK',
    Instagram = 'INSTAGRAM',
    Tiktokad = 'TIKTOKAD',
    Tiktokuser = 'TIKTOKUSER',
    Twitter = 'TWITTER',
    Youtube = 'YOUTUBE'
}

export type SocialMediaServiceView = {
    __typename?: 'SocialMediaServiceView'
    displayName: Scalars['String']['output']
    id: Scalars['Int']['output']
    longDescription: Scalars['String']['output']
    shortDescription: Scalars['String']['output']
    shortName: Scalars['String']['output']
}

export type SpamSearchResult = {
    __typename?: 'SpamSearchResult'
    contentId?: Maybe<Scalars['Int']['output']>
    similarityScore?: Maybe<Scalars['Float']['output']>
}

/** Response from starting an async chat task. */
export type StartChatResponse = {
    __typename?: 'StartChatResponse'
    /** Unique identifier for the chat task. Use this to poll for status. */
    taskId: Scalars['String']['output']
}

/** Response from starting an async dataset preparation task. */
export type StartDatasetPrepResponse = {
    __typename?: 'StartDatasetPrepResponse'
    /** Unique identifier for the dataset prep task. Use this to poll for status. */
    taskId: Scalars['String']['output']
}

export type StringFilterInput = {
    beginsWith?: InputMaybe<Scalars['String']['input']>
    between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    contains?: InputMaybe<Scalars['String']['input']>
    eq?: InputMaybe<Scalars['String']['input']>
    ge?: InputMaybe<Scalars['String']['input']>
    gt?: InputMaybe<Scalars['String']['input']>
    le?: InputMaybe<Scalars['String']['input']>
    lt?: InputMaybe<Scalars['String']['input']>
    ne?: InputMaybe<Scalars['String']['input']>
    notContains?: InputMaybe<Scalars['String']['input']>
}

export type Subscription = {
    __typename?: 'Subscription'
    todo?: Maybe<Scalars['String']['output']>
}

export type SubscriptionConnection = {
    __typename?: 'SubscriptionConnection'
    items: Array<Subscription>
    total?: Maybe<Scalars['Int']['output']>
}

export type TakeContentActionResponse = {
    __typename?: 'TakeContentActionResponse'
    contentAction?: Maybe<ContentActionBusiness>
    queued: Scalars['Boolean']['output']
}

export type TakeContentActionsResponse = {
    __typename?: 'TakeContentActionsResponse'
    contentActions?: Maybe<Array<Maybe<ContentActionBusiness>>>
}

export type Team = {
    __typename?: 'Team'
    accounts?: Maybe<Array<Account>>
    createdAt: Scalars['AWSDateTime']['output']
    id: Scalars['Int']['output']
    name: Scalars['String']['output']
    updatedAt?: Maybe<Scalars['AWSDateTime']['output']>
    users?: Maybe<Array<User>>
}

export type TeamCoverage = {
    __typename?: 'TeamCoverage'
    deployedCount: Scalars['Int']['output']
    teamId: Scalars['Int']['output']
    teamName: Scalars['String']['output']
    totalCount: Scalars['Int']['output']
}

export type TeamView = {
    __typename?: 'TeamView'
    createdAt: Scalars['DateTime']['output']
    id: Scalars['Int']['output']
    name: Scalars['String']['output']
}

export type TeamsSearchParamsView = {
    searchTerm: Scalars['String']['input']
}

export type TikTokAccountSelectionView = {
    __typename?: 'TikTokAccountSelectionView'
    adAccounts: Array<TikTokAdAccountView>
    key: TikTokSessionKey
}

export type TikTokAdAccountView = {
    __typename?: 'TikTokAdAccountView'
    advertiserId: Scalars['String']['output']
    advertiserName: Scalars['String']['output']
}

export type TikTokSessionKey = {
    __typename?: 'TikTokSessionKey'
    expiry: Scalars['DateTime']['output']
    key: Scalars['String']['output']
}

export type TikTokUserAccountSelectionView = {
    __typename?: 'TikTokUserAccountSelectionView'
    accountData: AuthorisedAccountView
    key: TikTokSessionKey
}

export type TranslatedTextView = {
    __typename?: 'TranslatedTextView'
    detectedSourceLanguage: Scalars['String']['output']
    sourceText: Scalars['String']['output']
    translatedText: Scalars['String']['output']
}

/**
 * Edits an existing classifier's metadata. `shortName` is the immutable slug and
 * cannot be changed. Omitted fields are left unchanged.
 */
export type UpdateClassifierDetailInput = {
    clientFacingName?: InputMaybe<Scalars['String']['input']>
    displayName?: InputMaybe<Scalars['String']['input']>
    id: Scalars['Int']['input']
    longDescription?: InputMaybe<Scalars['String']['input']>
    modality?: InputMaybe<Modality>
    shortDescription?: InputMaybe<Scalars['String']['input']>
    valence?: InputMaybe<Valence>
}

/**
 * Edits an existing draft. Omitted fields are left unchanged. The thresholds are
 * themselves nullable, so they distinguish omitted (unchanged) from an explicit
 * null (clear the band).
 */
export type UpdateClassifierPromptInput = {
    defaultBorderlineThreshold?: InputMaybe<Scalars['Float']['input']>
    defaultConfirmedThreshold?: InputMaybe<Scalars['Float']['input']>
    id: Scalars['Int']['input']
    model?: InputMaybe<Scalars['String']['input']>
    prompt?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCookieInput = {
    cookieId: Scalars['Int']['input']
    /** Use null to clear, omit to leave unchanged. */
    notes?: InputMaybe<Scalars['String']['input']>
    resetFailCount?: Scalars['Boolean']['input']
    status?: InputMaybe<CookieStatus>
}

export type UpdatedDashboardView = {
    description: Scalars['String']['input']
    displayName: Scalars['String']['input']
    extEmbeddedId: Scalars['String']['input']
    id: Scalars['Int']['input']
    userIds: Array<Scalars['Int']['input']>
}

export type User = {
    __typename?: 'User'
    canLikeContent: Scalars['Boolean']['output']
    canReplyToContent: Scalars['Boolean']['output']
    canUseReadStatus: Scalars['Boolean']['output']
    dashboardEnabled?: Maybe<Scalars['Boolean']['output']>
    dashboardId?: Maybe<Scalars['String']['output']>
    feedsEnabled: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    referrer?: Maybe<Referrer>
    shouldProvisionAccess: Scalars['Boolean']['output']
    stripeCustomerId?: Maybe<Scalars['String']['output']>
    stripeSubscriptionId?: Maybe<Scalars['String']['output']>
    stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>
    team?: Maybe<Team>
    username: Scalars['String']['output']
}

export type UserAuthEventView = {
    __typename?: 'UserAuthEventView'
    city: Scalars['String']['output']
    country: Scalars['String']['output']
    deviceName: Scalars['String']['output']
    eventResponse: Scalars['String']['output']
    eventTimestamp?: Maybe<Scalars['DateTime']['output']>
    eventType: Scalars['String']['output']
    ipAddress: Scalars['String']['output']
    username: Scalars['String']['output']
}

export type UserCreateParamsView = {
    admin: Scalars['Boolean']['input']
    allowAccessOverride: Scalars['Boolean']['input']
    canLike: Scalars['Boolean']['input']
    canReplyToContent: Scalars['Boolean']['input']
    canUseReadStatus: Scalars['Boolean']['input']
    dashboardEnabled: Scalars['Boolean']['input']
    dashboardId?: InputMaybe<Scalars['String']['input']>
    emailAddress: Scalars['String']['input']
    feedsEnabled: Scalars['Boolean']['input']
    selectedTeam?: InputMaybe<Scalars['Int']['input']>
    selectedTeams?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type UserEditParamsView = {
    admin: Scalars['Boolean']['input']
    allowAccessOverride: Scalars['Boolean']['input']
    canLike: Scalars['Boolean']['input']
    canReplyToContent: Scalars['Boolean']['input']
    canUseReadStatus: Scalars['Boolean']['input']
    dashboardEnabled: Scalars['Boolean']['input']
    dashboardId?: InputMaybe<Scalars['String']['input']>
    emailAddress: Scalars['String']['input']
    feedsEnabled: Scalars['Boolean']['input']
    id: Scalars['Int']['input']
    selectedTeam?: InputMaybe<Scalars['Int']['input']>
    selectedTeams?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type UserSearchParams = {
    containsText?: InputMaybe<Scalars['String']['input']>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
    teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type UserTogglesView = {
    __typename?: 'UserTogglesView'
    askArwenEnabled: Scalars['Boolean']['output']
    canBlockUser: Scalars['Boolean']['output']
    canDeleteContent: Scalars['Boolean']['output']
    canEngageCrossProfile: Scalars['Boolean']['output']
    canHideContent: Scalars['Boolean']['output']
    canLabelSpam: Scalars['Boolean']['output']
    canManageShadowBanning: Scalars['Boolean']['output']
    canModifyCrossProfileDefault: Scalars['Boolean']['output']
    canMuteUser: Scalars['Boolean']['output']
    canViewScreenshots: Scalars['Boolean']['output']
    conversationViewEnabled: Scalars['Boolean']['output']
    keywordsEnabled: Scalars['Boolean']['output']
}

export type UserView = {
    __typename?: 'UserView'
    admin?: Maybe<Scalars['Boolean']['output']>
    allowAccessOverride?: Maybe<Scalars['Boolean']['output']>
    canLikeContent: Scalars['Boolean']['output']
    canReplyToContent: Scalars['Boolean']['output']
    canUseReadStatus: Scalars['Boolean']['output']
    createdOn: Scalars['DateTime']['output']
    dashboardEnabled?: Maybe<Scalars['Boolean']['output']>
    dashboardId?: Maybe<Scalars['String']['output']>
    feedsEnabled: Scalars['Boolean']['output']
    id: Scalars['Int']['output']
    referrerId?: Maybe<Scalars['Int']['output']>
    stripeCustomerId?: Maybe<Scalars['String']['output']>
    stripeSubscriptionId?: Maybe<Scalars['String']['output']>
    stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>
    toggles: UserTogglesView
    username: Scalars['String']['output']
}

export type UsersPermissionsView = {
    __typename?: 'UsersPermissionsView'
    userPermissions: Scalars['JSONObject']['output']
}

/**
 * Whether a classifier argues for moderation. Only negative classifiers take
 * part in the queue decision; neutral and positive ones are still scored and
 * can still be filtered on. (EN-518) — Claude
 */
export enum Valence {
    Negative = 'NEGATIVE',
    Neutral = 'NEUTRAL',
    Positive = 'POSITIVE'
}

export type YouTubeSubscriptionDiagrnostics = {
    __typename?: 'YouTubeSubscriptionDiagrnostics'
    url?: Maybe<Scalars['String']['output']>
}

export type SetAccountToggleMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    toggleName: Scalars['String']['input']
    value: Scalars['Boolean']['input']
}>

export type SetAccountToggleMutation = { __typename?: 'Mutation'; setAccountToggle: boolean }

export type SetUserToggleMutationVariables = Exact<{
    userId: Scalars['Int']['input']
    toggleName: Scalars['String']['input']
    value: Scalars['Boolean']['input']
}>

export type SetUserToggleMutation = { __typename?: 'Mutation'; setUserToggle: boolean }

export type CreateContentFeedMutationVariables = Exact<{
    contentFeedNew: ContentFeedCreate
}>

export type CreateContentFeedMutation = {
    __typename?: 'Mutation'
    createContentFeed: {
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }
}

export type DeleteContentFeedMutationVariables = Exact<{
    contentFeedId: Scalars['Int']['input']
}>

export type DeleteContentFeedMutation = {
    __typename?: 'Mutation'
    deleteContentFeed: {
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }
}

export type UpdateContentFeedMutationVariables = Exact<{
    contentFeedUpdate: ContentFeedUpdate
}>

export type UpdateContentFeedMutation = {
    __typename?: 'Mutation'
    updateContentFeed: {
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }
}

export type CreateDashboardMutationVariables = Exact<{
    dashboard: NewDashboardView
}>

export type CreateDashboardMutation = {
    __typename?: 'Mutation'
    createDashboard: {
        __typename?: 'DashboardView'
        id: number
        displayName: string
        description: string
        extEmbeddedId: string
        createdAt: any
        updatedAt: any
    }
}

export type DeleteDashboardMutationVariables = Exact<{
    dashboardId: Scalars['Int']['input']
}>

export type DeleteDashboardMutation = { __typename?: 'Mutation'; deleteDashboard: boolean }

export type UpdateDashboardMutationVariables = Exact<{
    dashboard: UpdatedDashboardView
}>

export type UpdateDashboardMutation = { __typename?: 'Mutation'; updateDashboard: boolean }

export type GiveUserAccessToDashboardMutationVariables = Exact<{
    userId: Scalars['Int']['input']
    dashboardId: Scalars['Int']['input']
}>

export type GiveUserAccessToDashboardMutation = {
    __typename?: 'Mutation'
    giveUserAccessToDashboard: boolean
}

export type CreateReadReceiptMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type CreateReadReceiptMutation = {
    __typename?: 'Mutation'
    createReadReceipt: {
        __typename?: 'ReadReceiptView'
        userId: number
        contentOutcomeId: number
        createdAt: any
    }
}

export type CreateReadReceiptsMutationVariables = Exact<{
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type CreateReadReceiptsMutation = {
    __typename?: 'Mutation'
    createReadReceipts: Array<{
        __typename?: 'ReadReceiptView'
        userId: number
        contentOutcomeId: number
        createdAt: any
    }>
}

export type DeleteReadReceiptMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type DeleteReadReceiptMutation = {
    __typename?: 'Mutation'
    deleteReadReceipt: {
        __typename?: 'ReadReceiptView'
        userId: number
        contentOutcomeId: number
        createdAt: any
    }
}

export type DeleteReadReceiptsMutationVariables = Exact<{
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type DeleteReadReceiptsMutation = {
    __typename?: 'Mutation'
    deleteReadReceipts: Array<{
        __typename?: 'ReadReceiptView'
        userId: number
        contentOutcomeId: number
        createdAt: any
    }>
}

export type CreateNotificationConfigurationMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    recipientListId: Scalars['String']['input']
    notificationTemplateId: Scalars['String']['input']
}>

export type CreateNotificationConfigurationMutation = {
    __typename?: 'Mutation'
    createNotificationConfiguration: {
        __typename?: 'NotificationConfigurationView'
        id: number
        accountId: number
        recipientListId: string
        notificationTemplateId: string
    }
}

export type DeleteNotificationConfigurationMutationVariables = Exact<{
    notificationConfigurationId: Scalars['Int']['input']
}>

export type DeleteNotificationConfigurationMutation = {
    __typename?: 'Mutation'
    deleteNotificationConfiguration: {
        __typename?: 'NotificationConfigurationView'
        id: number
        accountId: number
        recipientListId: string
        notificationTemplateId: string
    }
}

export type UpdateNotificationConfigurationMutationVariables = Exact<{
    notificationConfigurationId: Scalars['Int']['input']
    accountId: Scalars['Int']['input']
    recipientListId: Scalars['String']['input']
    notificationTemplateId: Scalars['String']['input']
}>

export type UpdateNotificationConfigurationMutation = {
    __typename?: 'Mutation'
    updateNotificationConfiguration: {
        __typename?: 'NotificationConfigurationView'
        id: number
        accountId: number
        recipientListId: string
        notificationTemplateId: string
    }
}

export type UpdateModerationBoundaryMutationVariables = Exact<{
    moderationBoundaryInput: ModerationBoundaryInput
}>

export type UpdateModerationBoundaryMutation = {
    __typename?: 'Mutation'
    updateModerationBoundary: {
        __typename?: 'ModerationBoundaryView'
        id: number
        account: number
        queue: string
        probability?: number | null
        classifier: {
            __typename?: 'ClassifierView'
            id: number
            shortName: string
            displayName: string
            shortDescription: string
            longDescription: string
        }
    }
}

export type CaptureScreenshotMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type CaptureScreenshotMutation = {
    __typename?: 'Mutation'
    captureScreenshot: {
        __typename?: 'ScreenshotAttempt'
        id: number
        contentId: number
        contentText?: string | null
        s3Url?: string | null
        cookieId?: number | null
        status: ScreenshotStatus
        errorMessage?: string | null
        logs?: string | null
        createdAt: any
    }
}

export type CreateModerationBoundaryMutationVariables = Exact<{
    moderationBoundary: ModerationBoundaryCreate
}>

export type CreateModerationBoundaryMutation = {
    __typename?: 'Mutation'
    createModerationBoundary: {
        __typename?: 'ModerationBoundaryView'
        id: number
        account: number
        queue: string
        probability?: number | null
        classifier: {
            __typename?: 'ClassifierView'
            id: number
            shortName: string
            displayName: string
            shortDescription: string
            longDescription: string
        }
    }
}

export type DeleteModerationBoundaryMutationVariables = Exact<{
    moderationBoundaryId: Scalars['Int']['input']
}>

export type DeleteModerationBoundaryMutation = {
    __typename?: 'Mutation'
    deleteModerationBoundary: {
        __typename?: 'ModerationBoundaryView'
        id: number
        account: number
        queue: string
        probability?: number | null
        classifier: {
            __typename?: 'ClassifierView'
            id: number
            shortName: string
            displayName: string
            shortDescription: string
            longDescription: string
        }
    }
}

export type BulkUpdateModerationBoundaryMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    moderationBoundaries: Array<ModerationBoundaryCreate> | ModerationBoundaryCreate
}>

export type BulkUpdateModerationBoundaryMutation = {
    __typename?: 'Mutation'
    bulkUpdateModerationBoundary: boolean
}

export type CopyModerationBoundariesMutationVariables = Exact<{
    sourceAccountId: Scalars['Int']['input']
    targetAccountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type CopyModerationBoundariesMutation = {
    __typename?: 'Mutation'
    copyModerationBoundaries: boolean
}

export type SaveLlmReplyPromptMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    prompt: Scalars['String']['input']
    model?: InputMaybe<Scalars['String']['input']>
}>

export type SaveLlmReplyPromptMutation = {
    __typename?: 'Mutation'
    saveLlmReplyPrompt: {
        __typename?: 'PromptView'
        id: number
        prompt: string
        model: string
        createdAt: any
    }
}

export type LikeContentMutationVariables = Exact<{
    like: Scalars['Boolean']['input']
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
    actionByAccountIdOverride?: InputMaybe<Scalars['Int']['input']>
}>

export type LikeContentMutation = {
    __typename?: 'Mutation'
    likeContent: Array<{
        __typename?: 'ContentActionResult'
        success: boolean
        contentId: number
        message?: string | null
        contentAction?: {
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            automated: boolean
            active: boolean
            contentId: number
            userId?: number | null
            queued: boolean
            retryAt?: any | null
            message?: string | null
            actionedByAccountId?: number | null
        } | null
    }>
}

export type ReplyToContentMutationVariables = Exact<{
    message: Scalars['String']['input']
    contentId: Scalars['Int']['input']
    suggestedReplies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
    actionByAccountIdOverride?: InputMaybe<Scalars['Int']['input']>
}>

export type ReplyToContentMutation = {
    __typename?: 'Mutation'
    replyToContent: {
        __typename?: 'ContentActionView'
        id: number
        action: string
        actionOn: any
        automated: boolean
        active: boolean
        contentId: number
        userId?: number | null
        queued: boolean
        retryAt?: any | null
        message?: string | null
        actionedByAccountId?: number | null
    }
}

export type EditAccountTeamMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    teamId?: InputMaybe<Scalars['Int']['input']>
}>

export type EditAccountTeamMutation = {
    __typename?: 'Mutation'
    editAccountTeam: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type DeleteAccountMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    authCode?: InputMaybe<Scalars['String']['input']>
}>

export type DeleteAccountMutation = { __typename?: 'Mutation'; deleteAccount: boolean }

export type CreateAccountMutationVariables = Exact<{
    serviceAccountId: Scalars['String']['input']
    accountName: Scalars['String']['input']
    serviceAccountUsername: Scalars['String']['input']
    description?: InputMaybe<Scalars['String']['input']>
    serviceName: Scalars['String']['input']
}>

export type CreateAccountMutation = {
    __typename?: 'Mutation'
    createAccount?: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    } | null
}

export type CreateMonitoredAccountMutationVariables = Exact<{
    serviceAccountUsername: Scalars['String']['input']
    serviceName: Scalars['String']['input']
    teamId: Scalars['Int']['input']
    accountName?: InputMaybe<Scalars['String']['input']>
    youtubeChannelId?: InputMaybe<Scalars['String']['input']>
}>

export type CreateMonitoredAccountMutation = {
    __typename?: 'Mutation'
    createMonitoredAccount?: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    } | null
}

export type UpdateAccountMutationVariables = Exact<{
    id: Scalars['Int']['input']
    accountName?: InputMaybe<Scalars['String']['input']>
    autoMuteSevereAccount?: InputMaybe<Scalars['Boolean']['input']>
    autoHideSevereContent?: InputMaybe<Scalars['Boolean']['input']>
    autoDeleteSevereContent?: InputMaybe<Scalars['Boolean']['input']>
    isSubscribed?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateAccountMutation = { __typename?: 'Mutation'; updateAccount: boolean }

export type UpdateShadowBanningMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    enabled: Scalars['Boolean']['input']
    threshold: Scalars['Int']['input']
    rangeInDays: Scalars['Int']['input']
}>

export type UpdateShadowBanningMutation = {
    __typename?: 'Mutation'
    updateShadowBanning: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type SetManualShadowBanForAccountMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    profileId?: InputMaybe<Scalars['Int']['input']>
    contentId?: InputMaybe<Scalars['Int']['input']>
    enabled: Scalars['Boolean']['input']
}>

export type SetManualShadowBanForAccountMutation = {
    __typename?: 'Mutation'
    setManualShadowBanForAccount: {
        __typename?: 'SetManualShadowBanResponse'
        success: boolean
        profileId: number
    }
}

export type RemoveManualShadowBanForAccountMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    profileId: Scalars['Int']['input']
}>

export type RemoveManualShadowBanForAccountMutation = {
    __typename?: 'Mutation'
    removeManualShadowBanForAccount: {
        __typename?: 'SetManualShadowBanResponse'
        success: boolean
        profileId: number
    }
}

export type ToggleDmsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    enabled: Scalars['Boolean']['input']
}>

export type ToggleDmsMutation = {
    __typename?: 'Mutation'
    toggleDms: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type RefreshMessengerConversationsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type RefreshMessengerConversationsMutation = {
    __typename?: 'Mutation'
    refreshMessengerConversations: Array<number>
}

export type RemoveSpamItemsMutationVariables = Exact<{
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type RemoveSpamItemsMutation = { __typename?: 'Mutation'; removeSpamItems: boolean }

export type ContentActionResultFragment = {
    __typename?: 'ContentActionResult'
    success: boolean
    contentId: number
    message?: string | null
    contentAction?: {
        __typename?: 'ContentActionView'
        id: number
        action: string
        actionOn: any
        automated: boolean
        active: boolean
        contentId: number
        userId?: number | null
        queued: boolean
        retryAt?: any | null
        message?: string | null
        actionedByAccountId?: number | null
    } | null
}

export type ContentActionViewFragment = {
    __typename?: 'ContentActionView'
    id: number
    action: string
    actionOn: any
    automated: boolean
    active: boolean
    contentId: number
    userId?: number | null
    queued: boolean
    retryAt?: any | null
    message?: string | null
    actionedByAccountId?: number | null
}

export type CreateTeamMutationVariables = Exact<{
    teamName: Scalars['String']['input']
}>

export type CreateTeamMutation = {
    __typename?: 'Mutation'
    createTeam: { __typename?: 'TeamView'; id: number; name: string; createdAt: any }
}

export type EditTeamMutationVariables = Exact<{
    teamId: Scalars['Int']['input']
    name: Scalars['String']['input']
}>

export type EditTeamMutation = {
    __typename?: 'Mutation'
    editTeam: { __typename?: 'TeamView'; id: number; name: string }
}

export type DeleteTeamMutationVariables = Exact<{
    teamId: Scalars['Int']['input']
    force: Scalars['Boolean']['input']
}>

export type DeleteTeamMutation = { __typename?: 'Mutation'; deleteTeam: boolean }

export type CreateKeywordMutationVariables = Exact<{
    params: CreateKeywordParamsView
}>

export type CreateKeywordMutation = {
    __typename?: 'Mutation'
    createKeyword: {
        __typename?: 'KeywordView'
        keyword: string
        regex: boolean
        allowableRegex?: string | null
        description?: string | null
        accountId: number
        classifierDetailsId: number
    }
}

export type DeleteKeywordMutationVariables = Exact<{
    keywordId: Scalars['Int']['input']
}>

export type DeleteKeywordMutation = { __typename?: 'Mutation'; deleteKeyword: boolean }

export type CopyKeywordsToAccountMutationVariables = Exact<{
    sourceAccountId: Scalars['Int']['input']
    targetAccountId: Scalars['Int']['input']
}>

export type CopyKeywordsToAccountMutation = {
    __typename?: 'Mutation'
    copyKeywordsToAccount: boolean
}

export type ValidateUserIdentityMutationVariables = Exact<{
    referrerUuid?: InputMaybe<Scalars['String']['input']>
}>

export type ValidateUserIdentityMutation = {
    __typename?: 'Mutation'
    validateUserIdentity: {
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }
}

export type AddMutationVariables = Exact<{ [key: string]: never }>

export type AddMutation = {
    __typename?: 'Mutation'
    validateUserIdentity: {
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }
}

export type AddDefaultKeywordsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    reset: Scalars['Boolean']['input']
}>

export type AddDefaultKeywordsMutation = { __typename?: 'Mutation'; addDefaultKeywords: boolean }

export type UpdateEngageAccountIdMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    engageAccountId: Scalars['Int']['input']
}>

export type UpdateEngageAccountIdMutation = {
    __typename?: 'Mutation'
    updateEngageAccountId: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateScrapeContentMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    scrapeContent: Scalars['Boolean']['input']
}>

export type UpdateScrapeContentMutation = {
    __typename?: 'Mutation'
    updateScrapeContent: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateAutoFetchContentMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    autoFetchContent: Scalars['Boolean']['input']
}>

export type UpdateAutoFetchContentMutation = {
    __typename?: 'Mutation'
    updateAutoFetchContent: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateRetirePostDaysMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    retirePostDays: Scalars['Int']['input']
}>

export type UpdateRetirePostDaysMutation = {
    __typename?: 'Mutation'
    updateRetirePostDays: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateProfileCollectionEnabledMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    profileCollectionEnabled: Scalars['Boolean']['input']
}>

export type UpdateProfileCollectionEnabledMutation = {
    __typename?: 'Mutation'
    updateProfileCollectionEnabled: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateProfileModerationEnabledMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    profileModerationEnabled: Scalars['Boolean']['input']
}>

export type UpdateProfileModerationEnabledMutation = {
    __typename?: 'Mutation'
    updateProfileModerationEnabled: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateLlmClassificationEnabledMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    llmClassificationEnabled: Scalars['Boolean']['input']
}>

export type UpdateLlmClassificationEnabledMutation = {
    __typename?: 'Mutation'
    updateLlmClassificationEnabled: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateLlmSuggestedReplyEnabledMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    llmSuggestedReplyEnabled: Scalars['Boolean']['input']
}>

export type UpdateLlmSuggestedReplyEnabledMutation = {
    __typename?: 'Mutation'
    updateLlmSuggestedReplyEnabled: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateFetchAdsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    fetchAds: Scalars['Boolean']['input']
}>

export type UpdateFetchAdsMutation = {
    __typename?: 'Mutation'
    updateFetchAds: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateFetchPostsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    fetchPosts: Scalars['Boolean']['input']
}>

export type UpdateFetchPostsMutation = {
    __typename?: 'Mutation'
    updateFetchPosts: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type UpdateAutoHideAdCommentsMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    autoHideAdComments: Scalars['Boolean']['input']
}>

export type UpdateAutoHideAdCommentsMutation = {
    __typename?: 'Mutation'
    updateAutoHideAdComments: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type CreateUserMutationVariables = Exact<{
    userParams: UserCreateParamsView
}>

export type CreateUserMutation = { __typename?: 'Mutation'; createUser: boolean }

export type EditUserMutationVariables = Exact<{
    userParams: UserEditParamsView
}>

export type EditUserMutation = { __typename?: 'Mutation'; editUser: boolean }

export type DeleteUserMutationVariables = Exact<{
    userId: Scalars['Int']['input']
}>

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: boolean }

export type MetaHistoricFetchMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    from: Scalars['DateTime']['input']
    to: Scalars['DateTime']['input']
}>

export type MetaHistoricFetchMutation = { __typename?: 'Mutation'; metaHistoricFetch: boolean }

export type InstagramAuthCodeToAccessTokenMutationVariables = Exact<{
    code: Scalars['String']['input']
    redirectUri: Scalars['String']['input']
}>

export type InstagramAuthCodeToAccessTokenMutation = {
    __typename?: 'Mutation'
    instagramAuthCodeToAccessToken: {
        __typename?: 'InstagramAuthResponse'
        new: Array<number>
        updated: Array<number>
    }
}

export type TiktokAuthCodeToAccessTokenMutationVariables = Exact<{
    authCode: Scalars['String']['input']
    code: Scalars['String']['input']
}>

export type TiktokAuthCodeToAccessTokenMutation = {
    __typename?: 'Mutation'
    tiktokAuthCodeToAccessToken: {
        __typename?: 'TikTokAccountSelectionView'
        key: { __typename?: 'TikTokSessionKey'; key: string; expiry: any }
        adAccounts: Array<{
            __typename?: 'TikTokAdAccountView'
            advertiserId: string
            advertiserName: string
        }>
    }
}

export type TiktokCreateUserAccountWithAuthMutationVariables = Exact<{
    authCode: Scalars['String']['input']
    code: Scalars['String']['input']
    redirectUri: Scalars['String']['input']
}>

export type TiktokCreateUserAccountWithAuthMutation = {
    __typename?: 'Mutation'
    tiktokCreateUserAccountWithAuth: {
        __typename?: 'TikTokUserAccountSelectionView'
        key: { __typename?: 'TikTokSessionKey'; key: string; expiry: any }
        accountData: {
            __typename?: 'AuthorisedAccountView'
            id: number
            serviceAccountUsername?: string | null
            serviceAccountId: string
            accountName?: string | null
            pageId?: string | null
            isFailing: boolean
            failureDate?: any | null
            lastFailureNotificationDate?: any | null
            socialMediaServiceName: string
        }
    }
}

export type CreateTiktokAccountsMutationVariables = Exact<{
    sessionKey: Scalars['String']['input']
    adAccountIds: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type CreateTiktokAccountsMutation = {
    __typename?: 'Mutation'
    createTiktokAccounts: Array<{
        __typename?: 'AuthorisedAccountView'
        id: number
        serviceAccountUsername?: string | null
        serviceAccountId: string
        accountName?: string | null
        pageId?: string | null
        isFailing: boolean
        failureDate?: any | null
        lastFailureNotificationDate?: any | null
        socialMediaServiceName: string
    }>
}

export type DeleteReplyMutationVariables = Exact<{
    actionId: Scalars['Int']['input']
}>

export type DeleteReplyMutation = {
    __typename?: 'Mutation'
    deleteReply: {
        __typename?: 'ContentActionView'
        id: number
        action: string
        actionOn: any
        automated: boolean
        active: boolean
        contentId: number
        userId?: number | null
        queued: boolean
        retryAt?: any | null
        message?: string | null
        actionedByAccountId?: number | null
    }
}

export type TikTokUserAccountSelectionItemFragment = {
    __typename?: 'TikTokUserAccountSelectionView'
    key: { __typename?: 'TikTokSessionKey'; key: string; expiry: any }
    accountData: {
        __typename?: 'AuthorisedAccountView'
        id: number
        serviceAccountUsername?: string | null
        serviceAccountId: string
        accountName?: string | null
        pageId?: string | null
        isFailing: boolean
        failureDate?: any | null
        lastFailureNotificationDate?: any | null
        socialMediaServiceName: string
    }
}

export type TikTokAuthorisedAccountItemFragment = {
    __typename?: 'AuthorisedAccountView'
    id: number
    serviceAccountUsername?: string | null
    serviceAccountId: string
    accountName?: string | null
    pageId?: string | null
    isFailing: boolean
    failureDate?: any | null
    lastFailureNotificationDate?: any | null
    socialMediaServiceName: string
}

export type TikTokAccountSelectionItemFragment = {
    __typename?: 'TikTokAccountSelectionView'
    key: { __typename?: 'TikTokSessionKey'; key: string; expiry: any }
    adAccounts: Array<{
        __typename?: 'TikTokAdAccountView'
        advertiserId: string
        advertiserName: string
    }>
}

export type TikTokAccountsSelectionItemFragment = {
    __typename?: 'TikTokAccountSelectionView'
    key: { __typename?: 'TikTokSessionKey'; key: string; expiry: any }
}

export type TikTokAdAccountItemFragment = {
    __typename?: 'TikTokAdAccountView'
    advertiserId: string
    advertiserName: string
}

export type TikTokSessionKeyItemFragment = {
    __typename?: 'TikTokSessionKey'
    key: string
    expiry: any
}

export type CreateCookieMutationVariables = Exact<{
    input: CreateCookieInput
}>

export type CreateCookieMutation = {
    __typename?: 'Mutation'
    createCookie: {
        __typename?: 'CookieSummary'
        id: number
        platform: CookiePlatform
        serviceUsername: string
        status: CookieStatus
        failCount: number
        lastUsedAt?: any | null
        createdAt: any
        updatedAt: any
        notes?: string | null
    }
}

export type UpdateCookieMutationVariables = Exact<{
    input: UpdateCookieInput
}>

export type UpdateCookieMutation = {
    __typename?: 'Mutation'
    updateCookie: {
        __typename?: 'CookieSummary'
        id: number
        platform: CookiePlatform
        serviceUsername: string
        status: CookieStatus
        failCount: number
        lastUsedAt?: any | null
        createdAt: any
        updatedAt: any
        notes?: string | null
    }
}

export type MarkCookieDeadMutationVariables = Exact<{
    cookieId: Scalars['Int']['input']
    reason?: InputMaybe<Scalars['String']['input']>
}>

export type MarkCookieDeadMutation = { __typename?: 'Mutation'; markCookieDead: boolean }

export type IncrementCookieFailCountMutationVariables = Exact<{
    cookieId: Scalars['Int']['input']
}>

export type IncrementCookieFailCountMutation = {
    __typename?: 'Mutation'
    incrementCookieFailCount: boolean
}

export type DeleteCookieMutationVariables = Exact<{
    cookieId: Scalars['Int']['input']
}>

export type DeleteCookieMutation = { __typename?: 'Mutation'; deleteCookie: boolean }

export type RefreshContentMediaMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type RefreshContentMediaMutation = {
    __typename?: 'Mutation'
    refreshContentMedia: Array<{
        __typename?: 'ContentMediaView'
        serviceMediaId: string
        publicUrl: string
        presignedUrl?: string | null
        mediaType: string
        mediaClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classification?: number | null
            classifierName: string
        }>
    }>
}

export type StartContentSearchMutationVariables = Exact<{
    params: ContentSearchParams
}>

export type StartContentSearchMutation = {
    __typename?: 'Mutation'
    startContentSearch: {
        __typename?: 'ContentSearchTaskStarted'
        taskId: string
        startedAt: any
        result?: {
            __typename?: 'ContentSearchTaskResult'
            status: ContentSearchTaskStatus
            startedAt: any
            completedAt?: any | null
            elapsedMs: number
            message: string
            error?: string | null
            results?: Array<{
                __typename?: 'ContentView'
                id: number
                serviceContentId: string
                content: string
                contentType: ContentTypeView
                socialMediaServiceName: string
                isPublic: boolean
                serviceAuthorId?: string | null
                serviceAuthorName?: string | null
                serviceAuthorDisplayUsername?: string | null
                shouldEnrich: boolean
                moderation?: string | null
                authorised: boolean
                socialMediaAuthorLink?: string | null
                socialMediaPostLink?: string | null
                socialMediaContentLink?: string | null
                socialMediaContentName: string
                datePosted?: any | null
                isReply: boolean
                inReplyToUserId?: string | null
                inReplyToUsername?: string | null
                inReplyToStatusId?: string | null
                originalPostAuthorId?: string | null
                originalPostAuthorName?: string | null
                originalPostId?: string | null
                originalPostLinkId?: string | null
                originalPostLink?: string | null
                isOwned?: boolean | null
                authorProfileId?: number | null
                account: {
                    __typename?: 'AccountRecord'
                    id: number
                    accountName?: string | null
                    autoDeleteSevereContent: boolean
                    autoHideSevereContent: boolean
                    autoMuteSevereAccount: boolean
                    autoHideAllAdComments?: boolean | null
                    classifyContent: boolean
                    createdAt: any
                    fetchContent: boolean
                    isSubscribed: boolean
                    lastFetched?: any | null
                    latestFetchedServiceContentId?: string | null
                    pageId?: string | null
                    scrapeContent: boolean
                    serviceAccountId: string
                    serviceAccountUsername?: string | null
                    socialMediaServiceId: number
                    teamId?: number | null
                    updatedAt?: any | null
                    userId: number
                    profileCollectionEnabled: boolean
                    profileModerationEnabled: boolean
                    llmClassificationEnabled: boolean
                    llmEnableSuggestedReplies: boolean
                    socialMediaServiceShortName?: string | null
                    socialMediaServiceDisplayName?: string | null
                    hasAuthorisation: boolean
                    teamName?: string | null
                    ownedBy?: string | null
                    adsLastFetched?: any | null
                    postsLastFetched?: any | null
                    fetchPosts: boolean
                    fetchAds: boolean
                    retirePostDays: number
                    shadowBanningEnabled: boolean
                    shadowBanningThreshold: number
                    shadowBanningRangeInDays: number
                    dmsEnabled: boolean
                    engageAccountId?: number | null
                    instagramAuthMethod?: string | null
                    toggles: {
                        __typename?: 'AccountTogglesView'
                        crossProfileEngage: boolean
                        enableScreenshots: boolean
                    }
                }
                actions: Array<{
                    __typename?: 'ContentActionView'
                    id: number
                    action: string
                    actionOn: any
                    active: boolean
                    automated: boolean
                    contentId: number
                    queued: boolean
                    retryAt?: any | null
                    userId?: number | null
                    message?: string | null
                    replyContentId?: number | null
                    actionedByAccountId?: number | null
                }>
                media: Array<{
                    __typename?: 'ContentMediaView'
                    serviceMediaId: string
                    publicUrl: string
                    presignedUrl?: string | null
                    mediaType: string
                    mediaClassifications: Array<{
                        __typename?: 'ContentClassificationView'
                        classification?: number | null
                        classifierName: string
                    }>
                }>
                readReceipts: Array<{
                    __typename?: 'ReadReceiptView'
                    userId: number
                    contentOutcomeId: number
                    createdAt: any
                }>
                allClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classifierName: string
                    classification?: number | null
                    classifierDisplayName?: string | null
                    result?: ClassificationResultView | null
                }>
            }> | null
        } | null
    }
}

export type SendNewAccountNotificationMutationVariables = Exact<{
    accountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type SendNewAccountNotificationMutation = {
    __typename?: 'Mutation'
    sendNewAccountNotification: {
        __typename?: 'SendNotificationResponse'
        success: boolean
        message?: string | null
    }
}

export type AddTwitterSubscriptionMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type AddTwitterSubscriptionMutation = {
    __typename?: 'Mutation'
    addTwitterSubscription: boolean
}

export type RemoveTwitterSubscriptionMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type RemoveTwitterSubscriptionMutation = {
    __typename?: 'Mutation'
    removeTwitterSubscription: boolean
}

export type CreateClassifierPromptMutationVariables = Exact<{
    input: CreateClassifierPromptInput
}>

export type CreateClassifierPromptMutation = {
    __typename?: 'Mutation'
    createClassifierPrompt: {
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }
}

export type UpdateClassifierPromptMutationVariables = Exact<{
    input: UpdateClassifierPromptInput
}>

export type UpdateClassifierPromptMutation = {
    __typename?: 'Mutation'
    updateClassifierPrompt: {
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }
}

export type GoLiveClassifierPromptMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type GoLiveClassifierPromptMutation = {
    __typename?: 'Mutation'
    goLiveClassifierPrompt: {
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }
}

export type DiscardClassifierPromptDraftMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type DiscardClassifierPromptDraftMutation = {
    __typename?: 'Mutation'
    discardClassifierPromptDraft: {
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }
}

export type DeleteClassifierPromptMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type DeleteClassifierPromptMutation = {
    __typename?: 'Mutation'
    deleteClassifierPrompt: boolean
}

export type CreateClassifierDetailMutationVariables = Exact<{
    input: CreateClassifierDetailInput
}>

export type CreateClassifierDetailMutation = {
    __typename?: 'Mutation'
    createClassifierDetail: {
        __typename?: 'ClassifierDetailFull'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
        clientFacingName: string
        modality: Modality
        valence: Valence
        archived: boolean
    }
}

export type UpdateClassifierDetailMutationVariables = Exact<{
    input: UpdateClassifierDetailInput
}>

export type UpdateClassifierDetailMutation = {
    __typename?: 'Mutation'
    updateClassifierDetail: {
        __typename?: 'ClassifierDetailFull'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
        clientFacingName: string
        modality: Modality
        valence: Valence
        archived: boolean
    }
}

export type DeleteClassifierDetailMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type DeleteClassifierDetailMutation = {
    __typename?: 'Mutation'
    deleteClassifierDetail: boolean
}

export type ArchiveClassifierDetailMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type ArchiveClassifierDetailMutation = {
    __typename?: 'Mutation'
    archiveClassifierDetail: {
        __typename?: 'ClassifierDetailFull'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
        clientFacingName: string
        modality: Modality
        valence: Valence
        archived: boolean
    }
}

export type UnarchiveClassifierDetailMutationVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type UnarchiveClassifierDetailMutation = {
    __typename?: 'Mutation'
    unarchiveClassifierDetail: {
        __typename?: 'ClassifierDetailFull'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
        clientFacingName: string
        modality: Modality
        valence: Valence
        archived: boolean
    }
}

export type DeployClassifierToAccountsMutationVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    accountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type DeployClassifierToAccountsMutation = {
    __typename?: 'Mutation'
    deployClassifierToAccounts: boolean
}

export type DeployClassifierToTeamMutationVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}>

export type DeployClassifierToTeamMutation = {
    __typename?: 'Mutation'
    deployClassifierToTeam: boolean
}

export type UndeployClassifierFromAccountsMutationVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    accountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type UndeployClassifierFromAccountsMutation = {
    __typename?: 'Mutation'
    undeployClassifierFromAccounts: boolean
}

export type UndeployClassifierFromTeamMutationVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}>

export type UndeployClassifierFromTeamMutation = {
    __typename?: 'Mutation'
    undeployClassifierFromTeam: boolean
}

export type CreateMonitorProfileScheduleMutationVariables = Exact<{
    input: CreateMonitorProfileScheduleInput
}>

export type CreateMonitorProfileScheduleMutation = {
    __typename?: 'Mutation'
    createMonitorProfileSchedule: {
        __typename?: 'ScheduledWork'
        tag: string
        kind: string
        status: string
        rowId: string
        cron?: string | null
        intervalSecs?: number | null
        scheduleEnglish?: string | null
        nextRunAt?: any | null
        attempt: number
        log?: string | null
    }
}

export type StopScheduledWorkMutationVariables = Exact<{
    tag: Scalars['String']['input']
}>

export type StopScheduledWorkMutation = {
    __typename?: 'Mutation'
    stopScheduledWork: {
        __typename?: 'ScheduledWorkActionResult'
        changed: boolean
        outcome: string
        message: string
    }
}

export type RunScheduledWorkNowMutationVariables = Exact<{
    tag: Scalars['String']['input']
}>

export type RunScheduledWorkNowMutation = {
    __typename?: 'Mutation'
    runScheduledWorkNow: {
        __typename?: 'ScheduledWorkActionResult'
        changed: boolean
        outcome: string
        message: string
    }
}

export type ChangeFleetJobCadenceMutationVariables = Exact<{
    key: Scalars['String']['input']
    expectedRowId: Scalars['String']['input']
    intervalSecs: Scalars['Int']['input']
}>

export type ChangeFleetJobCadenceMutation = {
    __typename?: 'Mutation'
    changeFleetJobCadence: {
        __typename?: 'ScheduledWorkActionResult'
        changed: boolean
        outcome: string
        message: string
    }
}

export type AddMonitorTargetsMutationVariables = Exact<{
    monitorTag: Scalars['String']['input']
    targets: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type AddMonitorTargetsMutation = {
    __typename?: 'Mutation'
    addMonitorTargets: {
        __typename?: 'ScheduledWorkActionResult'
        changed: boolean
        outcome: string
        message: string
    }
}

export type CreateScrapedHistoricFetchMutationVariables = Exact<{
    monitorTag: Scalars['String']['input']
    since: Scalars['NaiveDate']['input']
    scrapeProfile?: InputMaybe<Scalars['String']['input']>
}>

export type CreateScrapedHistoricFetchMutation = {
    __typename?: 'Mutation'
    createScrapedHistoricFetch: {
        __typename?: 'HistoricFetchResult'
        alreadyExisted: boolean
        message: string
        work: {
            __typename?: 'ScheduledWork'
            tag: string
            kind: string
            status: string
            rowId: string
            cron?: string | null
            intervalSecs?: number | null
            scheduleEnglish?: string | null
            nextRunAt?: any | null
            attempt: number
            log?: string | null
        }
    }
}

export type RefreshCommentThreadMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type RefreshCommentThreadMutation = {
    __typename?: 'Mutation'
    refreshCommentThread: {
        __typename?: 'CommentThreadView'
        focusContentId: number
        parentMissing: boolean
        canRefresh: boolean
        notices: Array<string>
        post?: {
            __typename?: 'ConversationPostView'
            id: number
            title: string
            uri: string
            publishTime: any
            commentCount?: number | null
        } | null
        root?: {
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        } | null
        replies: Array<{
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        }>
    }
}

export type StartPostConversationRefreshMutationVariables = Exact<{
    postId: Scalars['Int']['input']
}>

export type StartPostConversationRefreshMutation = {
    __typename?: 'Mutation'
    startPostConversationRefresh: {
        __typename?: 'PostRefreshTaskStarted'
        taskId: string
        startedAt: any
        result?: {
            __typename?: 'PostRefreshTaskResult'
            status: PostRefreshTaskStatus
            completedAt?: any | null
            error?: string | null
            outcome?: {
                __typename?: 'PostRefreshOutcomeView'
                ran: boolean
                platform: string
                notices: Array<string>
                newComments: number
            } | null
        } | null
    }
}

export type ClassifierSearchParamsViewItemFragment = {
    __typename?: 'ClassifierSearchParamsView'
    classifierName: string
    threshold?: number | null
    category?: string | null
}

export type ContentSearchParamsViewItemFragment = {
    __typename?: 'ContentSearchParamsView'
    accountIds?: Array<number> | null
    teamIds?: Array<number> | null
    socialMediaServiceIds?: Array<number> | null
    authorProfileIds?: Array<number> | null
    since?: any | null
    before?: any | null
    timeDuration?: string | null
    timeOffset?: string | null
    containsText?: string | null
    moderationCode?: Array<number> | null
    moderationString?: Array<string> | null
    skipResults?: number | null
    maxResults?: number | null
    adsOrOrganic?: AdsOrOrganicFilterView | null
    contentIds?: Array<number> | null
    postIds?: Array<number> | null
    owned?: boolean | null
    readFilter?: ReadFilterView | null
    excludeOwnComments?: boolean | null
    dmFilter: DmFilter
    hasMedia?: boolean | null
    classifierSearchParams?: Array<{
        __typename?: 'ClassifierSearchParamsView'
        classifierName: string
        threshold?: number | null
        category?: string | null
    }> | null
}

export type ContentFeedViewItemFragment = {
    __typename?: 'ContentFeedView'
    id: number
    userId: number
    displayName: string
    description?: string | null
    createdAt: any
    updatedAt: any
    searchParameters: {
        __typename?: 'ContentSearchParamsView'
        accountIds?: Array<number> | null
        teamIds?: Array<number> | null
        socialMediaServiceIds?: Array<number> | null
        authorProfileIds?: Array<number> | null
        since?: any | null
        before?: any | null
        timeDuration?: string | null
        timeOffset?: string | null
        containsText?: string | null
        moderationCode?: Array<number> | null
        moderationString?: Array<string> | null
        skipResults?: number | null
        maxResults?: number | null
        adsOrOrganic?: AdsOrOrganicFilterView | null
        contentIds?: Array<number> | null
        postIds?: Array<number> | null
        owned?: boolean | null
        readFilter?: ReadFilterView | null
        excludeOwnComments?: boolean | null
        dmFilter: DmFilter
        hasMedia?: boolean | null
        classifierSearchParams?: Array<{
            __typename?: 'ClassifierSearchParamsView'
            classifierName: string
            threshold?: number | null
            category?: string | null
        }> | null
    }
}

export type GetMyContentFeedsQueryVariables = Exact<{ [key: string]: never }>

export type GetMyContentFeedsQuery = {
    __typename?: 'Query'
    getMyContentFeeds: Array<{
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }>
}

export type GetContentFeedsForUserQueryVariables = Exact<{
    userId: Scalars['Int']['input']
}>

export type GetContentFeedsForUserQuery = {
    __typename?: 'Query'
    getContentFeedsForUser: Array<{
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }>
}

export type GetContentFeedQueryVariables = Exact<{
    contentFeedId: Scalars['Int']['input']
}>

export type GetContentFeedQuery = {
    __typename?: 'Query'
    getContentFeed: {
        __typename?: 'ContentFeedView'
        id: number
        userId: number
        displayName: string
        description?: string | null
        createdAt: any
        updatedAt: any
        searchParameters: {
            __typename?: 'ContentSearchParamsView'
            accountIds?: Array<number> | null
            teamIds?: Array<number> | null
            socialMediaServiceIds?: Array<number> | null
            authorProfileIds?: Array<number> | null
            since?: any | null
            before?: any | null
            timeDuration?: string | null
            timeOffset?: string | null
            containsText?: string | null
            moderationCode?: Array<number> | null
            moderationString?: Array<string> | null
            skipResults?: number | null
            maxResults?: number | null
            adsOrOrganic?: AdsOrOrganicFilterView | null
            contentIds?: Array<number> | null
            postIds?: Array<number> | null
            owned?: boolean | null
            readFilter?: ReadFilterView | null
            excludeOwnComments?: boolean | null
            dmFilter: DmFilter
            hasMedia?: boolean | null
            classifierSearchParams?: Array<{
                __typename?: 'ClassifierSearchParamsView'
                classifierName: string
                threshold?: number | null
                category?: string | null
            }> | null
        }
    }
}

export type GetNotificationConfigurationForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type GetNotificationConfigurationForAccountQuery = {
    __typename?: 'Query'
    getNotificationConfigurationForAccount: Array<{
        __typename?: 'NotificationConfigurationView'
        id: number
        accountId: number
        recipientListId: string
        notificationTemplateId: string
    }>
}

export type GetNotificationConfigurationQueryVariables = Exact<{
    notificationConfigurationId: Scalars['Int']['input']
}>

export type GetNotificationConfigurationQuery = {
    __typename?: 'Query'
    getNotificationConfiguration: {
        __typename?: 'NotificationConfigurationView'
        id: number
        accountId: number
        recipientListId: string
        notificationTemplateId: string
    }
}

export type NotificationConfigurationViewItemFragment = {
    __typename?: 'NotificationConfigurationView'
    id: number
    accountId: number
    recipientListId: string
    notificationTemplateId: string
}

export type GetDashboardQueryVariables = Exact<{
    dashboardId: Scalars['Int']['input']
}>

export type GetDashboardQuery = {
    __typename?: 'Query'
    getDashboard: {
        __typename?: 'DashboardView'
        id: number
        displayName: string
        description: string
        extEmbeddedId: string
        createdAt: any
        updatedAt: any
    }
}

export type GetEditableDashboardQueryVariables = Exact<{
    dashboardId: Scalars['Int']['input']
}>

export type GetEditableDashboardQuery = {
    __typename?: 'Query'
    getEditableDashboard: {
        __typename?: 'EditableDashboardView'
        dashboard: {
            __typename?: 'DashboardView'
            id: number
            displayName: string
            description: string
            extEmbeddedId: string
            createdAt: any
            updatedAt: any
        }
        users: Array<{
            __typename?: 'UserView'
            id: number
            username: string
            createdOn: any
            stripeCustomerId?: string | null
            stripeSubscriptionId?: string | null
            stripeSubscriptionStatus?: string | null
            dashboardId?: string | null
            dashboardEnabled?: boolean | null
            referrerId?: number | null
            allowAccessOverride?: boolean | null
            admin?: boolean | null
            canLikeContent: boolean
            canReplyToContent: boolean
            canUseReadStatus: boolean
            feedsEnabled: boolean
            toggles: {
                __typename?: 'UserTogglesView'
                canModifyCrossProfileDefault: boolean
                canEngageCrossProfile: boolean
                canManageShadowBanning: boolean
                keywordsEnabled: boolean
                canViewScreenshots: boolean
                askArwenEnabled: boolean
                canLabelSpam: boolean
                canHideContent: boolean
                canDeleteContent: boolean
                canBlockUser: boolean
                canMuteUser: boolean
                conversationViewEnabled: boolean
            }
        }>
    }
}

export type GetDashboardsQueryVariables = Exact<{ [key: string]: never }>

export type GetDashboardsQuery = {
    __typename?: 'Query'
    getDashboards: Array<{
        __typename?: 'DashboardView'
        id: number
        displayName: string
        description: string
        extEmbeddedId: string
        createdAt: any
        updatedAt: any
    }>
}

export type EditableDashboardViewItemFragment = {
    __typename?: 'EditableDashboardView'
    dashboard: {
        __typename?: 'DashboardView'
        id: number
        displayName: string
        description: string
        extEmbeddedId: string
        createdAt: any
        updatedAt: any
    }
    users: Array<{
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }>
}

export type DashboardViewItemFragment = {
    __typename?: 'DashboardView'
    id: number
    displayName: string
    description: string
    extEmbeddedId: string
    createdAt: any
    updatedAt: any
}

export type GetEmbeddedDashboardQueryVariables = Exact<{
    dashboardId: Scalars['Int']['input']
}>

export type GetEmbeddedDashboardQuery = {
    __typename?: 'Query'
    getEmbeddedDashboard: {
        __typename?: 'EmbeddedDashboardView'
        guestToken: string
        workspaceUrl: string
        dashboard: {
            __typename?: 'DashboardView'
            id: number
            displayName: string
            description: string
            extEmbeddedId: string
            createdAt: any
            updatedAt: any
        }
    }
}

export type EmbeddedDashboardViewItemFragment = {
    __typename?: 'EmbeddedDashboardView'
    guestToken: string
    workspaceUrl: string
    dashboard: {
        __typename?: 'DashboardView'
        id: number
        displayName: string
        description: string
        extEmbeddedId: string
        createdAt: any
        updatedAt: any
    }
}

export type GetModerationBoundariesQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type GetModerationBoundariesQuery = {
    __typename?: 'Query'
    getModerationBoundaries: Array<{
        __typename?: 'ModerationBoundaryView'
        id: number
        account: number
        queue: string
        probability?: number | null
        classifier: {
            __typename?: 'ClassifierView'
            id: number
            shortName: string
            displayName: string
            shortDescription: string
            longDescription: string
        }
    }>
}

export type ModerationBoundaryViewItemFragment = {
    __typename?: 'ModerationBoundaryView'
    id: number
    account: number
    queue: string
    probability?: number | null
    classifier: {
        __typename?: 'ClassifierView'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
    }
}

export type GetLlmReplyPromptQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type GetLlmReplyPromptQuery = {
    __typename?: 'Query'
    getLlmReplyPrompt?: {
        __typename?: 'PromptView'
        id: number
        prompt: string
        model: string
        createdAt: any
    } | null
}

export type PromptViewItemFragment = {
    __typename?: 'PromptView'
    id: number
    prompt: string
    model: string
    createdAt: any
}

export type GetAvailableLlmModelsQueryVariables = Exact<{ [key: string]: never }>

export type GetAvailableLlmModelsQuery = {
    __typename?: 'Query'
    getAvailableLlmModels: Array<{
        __typename?: 'LlmModelInfo'
        id: string
        displayName: string
        isDefault: boolean
    }>
}

export type LlmModelInfoItemFragment = {
    __typename?: 'LlmModelInfo'
    id: string
    displayName: string
    isDefault: boolean
}

export type GetAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type GetAccountQuery = {
    __typename?: 'Query'
    getAccount: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
}

export type GetAccountsInTeamQueryVariables = Exact<{
    params: GetAccountsInTeamParamsView
}>

export type GetAccountsInTeamQuery = {
    __typename?: 'Query'
    getAccountsInTeam: Array<{
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }>
}

export type GetKeywordsForAccountQueryVariables = Exact<{
    params: KeywordParamsList
}>

export type GetKeywordsForAccountQuery = {
    __typename?: 'Query'
    getKeywordsForAccount: Array<{
        __typename?: 'KeywordView'
        id: number
        keyword: string
        regex: boolean
        allowableRegex?: string | null
        description?: string | null
        accountId: number
        classifierDetailsDisplayName: string
        classifierDetailsId: number
        createdAt: any
    }>
}

export type GetUserByIdQueryVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type GetUserByIdQuery = {
    __typename?: 'Query'
    getUserById: {
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }
}

export type GetUsersByTeamIdQueryVariables = Exact<{
    teamId: Scalars['Int']['input']
}>

export type GetUsersByTeamIdQuery = {
    __typename?: 'Query'
    getUsersByTeamId: Array<{
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }>
}

export type GetUserTeamsAdminQueryVariables = Exact<{
    userId: Scalars['Int']['input']
}>

export type GetUserTeamsAdminQuery = {
    __typename?: 'Query'
    getUserTeamsAdmin: Array<{ __typename?: 'TeamView'; id: number; name: string; createdAt: any }>
}

export type GetUserIfAllowedQueryVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type GetUserIfAllowedQuery = {
    __typename?: 'Query'
    getUserIfAllowed: {
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }
}

export type SearchUsersQueryVariables = Exact<{
    params: UserSearchParams
}>

export type SearchUsersQuery = {
    __typename?: 'Query'
    searchUsers: Array<{
        __typename?: 'UserView'
        id: number
        username: string
        createdOn: any
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        dashboardId?: string | null
        dashboardEnabled?: boolean | null
        referrerId?: number | null
        allowAccessOverride?: boolean | null
        admin?: boolean | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        toggles: {
            __typename?: 'UserTogglesView'
            canModifyCrossProfileDefault: boolean
            canEngageCrossProfile: boolean
            canManageShadowBanning: boolean
            keywordsEnabled: boolean
            canViewScreenshots: boolean
            askArwenEnabled: boolean
            canLabelSpam: boolean
            canHideContent: boolean
            canDeleteContent: boolean
            canBlockUser: boolean
            canMuteUser: boolean
            conversationViewEnabled: boolean
        }
    }>
}

export type SearchUsersCountQueryVariables = Exact<{
    params: UserSearchParams
}>

export type SearchUsersCountQuery = { __typename?: 'Query'; searchUsersCount: number }

export type CheckMetaSubscriptionForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type CheckMetaSubscriptionForAccountQuery = {
    __typename?: 'Query'
    checkMetaSubscriptionForAccount: boolean
}

export type CreateMetaSubscriptionForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type CreateMetaSubscriptionForAccountQuery = {
    __typename?: 'Query'
    createMetaSubscriptionForAccount: boolean
}

export type DeleteMetaSubscriptionForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type DeleteMetaSubscriptionForAccountQuery = {
    __typename?: 'Query'
    deleteMetaSubscriptionForAccount: boolean
}

export type DebugMetaAuthorisationForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type DebugMetaAuthorisationForAccountQuery = {
    __typename?: 'Query'
    debugMetaAuthorisationForAccount: {
        __typename?: 'DebugTokenResponseView'
        appId: string
        dataType: string
        application: string
        dataAccessExpiresAt: number
        expiresAt?: number | null
        isValid: boolean
        issuedAt?: number | null
        scopes: Array<string>
        userId: string
    }
}

export type CheckMetaAuthorisationForAccountQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type CheckMetaAuthorisationForAccountQuery = {
    __typename?: 'Query'
    checkMetaAuthorisationForAccount: boolean
}

export type DebugTokenResponseViewItemFragment = {
    __typename?: 'DebugTokenResponseView'
    appId: string
    dataType: string
    application: string
    dataAccessExpiresAt: number
    expiresAt?: number | null
    isValid: boolean
    issuedAt?: number | null
    scopes: Array<string>
    userId: string
}

export type UserItemFragment = {
    __typename?: 'UserView'
    id: number
    username: string
    createdOn: any
    stripeCustomerId?: string | null
    stripeSubscriptionId?: string | null
    stripeSubscriptionStatus?: string | null
    dashboardId?: string | null
    dashboardEnabled?: boolean | null
    referrerId?: number | null
    allowAccessOverride?: boolean | null
    admin?: boolean | null
    canLikeContent: boolean
    canReplyToContent: boolean
    canUseReadStatus: boolean
    feedsEnabled: boolean
    toggles: {
        __typename?: 'UserTogglesView'
        canModifyCrossProfileDefault: boolean
        canEngageCrossProfile: boolean
        canManageShadowBanning: boolean
        keywordsEnabled: boolean
        canViewScreenshots: boolean
        askArwenEnabled: boolean
        canLabelSpam: boolean
        canHideContent: boolean
        canDeleteContent: boolean
        canBlockUser: boolean
        canMuteUser: boolean
        conversationViewEnabled: boolean
    }
}

export type GetUsersPermissionsQueryVariables = Exact<{
    usernames: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type GetUsersPermissionsQuery = {
    __typename?: 'Query'
    getUserPermissions: { __typename?: 'UsersPermissionsView'; userPermissions: any }
}

export type GetTeamByIdQueryVariables = Exact<{
    teamId: Scalars['Int']['input']
}>

export type GetTeamByIdQuery = {
    __typename?: 'Query'
    getTeamById: { __typename?: 'TeamView'; id: number; name: string; createdAt: any }
}

export type GetTeamsQueryVariables = Exact<{ [key: string]: never }>

export type GetTeamsQuery = {
    __typename?: 'Query'
    getTeams: Array<{ __typename?: 'TeamView'; id: number; name: string; createdAt: any }>
}

export type GetOauthUrlQueryVariables = Exact<{
    socialMediaService: Scalars['String']['input']
    baseUrl: Scalars['String']['input']
}>

export type GetOauthUrlQuery = { __typename?: 'Query'; getOauthUrl: string }

export type SearchTeamsQueryVariables = Exact<{
    params: TeamsSearchParamsView
}>

export type SearchTeamsQuery = {
    __typename?: 'Query'
    searchTeams: Array<{ __typename?: 'TeamView'; id: number; name: string; createdAt: any }>
}

export type TeamItemFragment = { __typename?: 'TeamView'; id: number; name: string; createdAt: any }

export type GetProfilesByIdsQueryVariables = Exact<{
    profileIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
    accountId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetProfilesByIdsQuery = {
    __typename?: 'Query'
    getProfilesByIds: Array<{
        __typename?: 'ProfileViewWithShadowBan'
        id: number
        username: string
        serviceProfileId: string
        followers?: number | null
        following?: number | null
        posts?: number | null
        profileImageUrl?: string | null
        profileUrl: string
        profileImagePath?: string | null
        shadowBanStatus?: string | null
        shadowBanStatusCode?: number | null
    }>
}

export type GetProfileQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type GetProfileQuery = {
    __typename?: 'Query'
    getProfile: {
        __typename?: 'ProfileView'
        id: number
        username: string
        serviceProfileId: string
        followers?: number | null
        following?: number | null
        posts?: number | null
        profileImageUrl?: string | null
        profileUrl: string
        profileImagePath?: string | null
    }
}

export type SearchProfilesQueryVariables = Exact<{
    filter?: InputMaybe<ProfileFilterInput>
    sort?: InputMaybe<ProfileSortInput>
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
}>

export type SearchProfilesQuery = {
    __typename?: 'Query'
    searchProfiles: Array<{
        __typename?: 'ProfileView'
        id: number
        username: string
        serviceProfileId: string
        followers?: number | null
        following?: number | null
        posts?: number | null
        profileImageUrl?: string | null
        profileUrl: string
        profileImagePath?: string | null
    }>
}

export type CountProfilesQueryVariables = Exact<{
    filter?: InputMaybe<ProfileFilterInput>
}>

export type CountProfilesQuery = { __typename?: 'Query'; countProfiles: number }

export type SearchShadowBannedProfilesQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    offset: Scalars['Int']['input']
}>

export type SearchShadowBannedProfilesQuery = {
    __typename?: 'Query'
    searchShadowBannedProfiles: Array<{
        __typename?: 'ProfileViewWithShadowBan'
        id: number
        username: string
        serviceProfileId: string
        followers?: number | null
        following?: number | null
        posts?: number | null
        profileImageUrl?: string | null
        profileUrl: string
        profileImagePath?: string | null
        shadowBanStatus?: string | null
        shadowBanStatusCode?: number | null
    }>
}

export type SearchAccountsQueryVariables = Exact<{
    params: SearchAccountsParamsView
}>

export type SearchAccountsQuery = {
    __typename?: 'Query'
    searchAccounts: {
        __typename?: 'SearchAccountResponse'
        total: number
        accounts: Array<{
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }>
    }
}

export type ProfileItemFragment = {
    __typename?: 'ProfileView'
    id: number
    username: string
    serviceProfileId: string
    followers?: number | null
    following?: number | null
    posts?: number | null
    profileImageUrl?: string | null
    profileUrl: string
    profileImagePath?: string | null
}

export type ProfileWithShadowBanItemFragment = {
    __typename?: 'ProfileViewWithShadowBan'
    id: number
    username: string
    serviceProfileId: string
    followers?: number | null
    following?: number | null
    posts?: number | null
    profileImageUrl?: string | null
    profileUrl: string
    profileImagePath?: string | null
    shadowBanStatus?: string | null
    shadowBanStatusCode?: number | null
}

export type GetSummaryForAccountsQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type GetSummaryForAccountsQuery = {
    __typename?: 'Query'
    getSummaryForAccounts: {
        __typename?: 'ContentSummary'
        countSafe?: number | null
        countSuspect?: number | null
        countSevere?: number | null
    }
}

export type ContentSummaryItemFragment = {
    __typename?: 'ContentSummary'
    countSafe?: number | null
    countSuspect?: number | null
    countSevere?: number | null
}

export type ContentSearchQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type ContentSearchQuery = {
    __typename?: 'Query'
    contentSearch: Array<{
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }>
}

export type ContentSearchCountQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type ContentSearchCountQuery = { __typename?: 'Query'; contentSearchCount: number }

export type ContentSearchTotalQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type ContentSearchTotalQuery = { __typename?: 'Query'; contentSearchTotal: number }

export type ContentSearchTaskResultFieldsFragment = {
    __typename?: 'ContentSearchTaskResult'
    status: ContentSearchTaskStatus
    startedAt: any
    completedAt?: any | null
    elapsedMs: number
    message: string
    error?: string | null
    results?: Array<{
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }> | null
}

export type GetContentSearchTaskQueryVariables = Exact<{
    taskId: Scalars['String']['input']
}>

export type GetContentSearchTaskQuery = {
    __typename?: 'Query'
    getContentSearchTask: {
        __typename?: 'ContentSearchTaskResult'
        status: ContentSearchTaskStatus
        startedAt: any
        completedAt?: any | null
        elapsedMs: number
        message: string
        error?: string | null
        results?: Array<{
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        }> | null
    }
}

export type GetContentByIdQueryVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type GetContentByIdQuery = {
    __typename?: 'Query'
    getContentById: {
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }
}

export type ContentViewItemFragment = {
    __typename?: 'ContentView'
    id: number
    serviceContentId: string
    content: string
    contentType: ContentTypeView
    socialMediaServiceName: string
    isPublic: boolean
    serviceAuthorId?: string | null
    serviceAuthorName?: string | null
    serviceAuthorDisplayUsername?: string | null
    shouldEnrich: boolean
    moderation?: string | null
    authorised: boolean
    socialMediaAuthorLink?: string | null
    socialMediaPostLink?: string | null
    socialMediaContentLink?: string | null
    socialMediaContentName: string
    datePosted?: any | null
    isReply: boolean
    inReplyToUserId?: string | null
    inReplyToUsername?: string | null
    inReplyToStatusId?: string | null
    originalPostAuthorId?: string | null
    originalPostAuthorName?: string | null
    originalPostId?: string | null
    originalPostLinkId?: string | null
    originalPostLink?: string | null
    isOwned?: boolean | null
    authorProfileId?: number | null
    account: {
        __typename?: 'AccountRecord'
        id: number
        accountName?: string | null
        autoDeleteSevereContent: boolean
        autoHideSevereContent: boolean
        autoMuteSevereAccount: boolean
        autoHideAllAdComments?: boolean | null
        classifyContent: boolean
        createdAt: any
        fetchContent: boolean
        isSubscribed: boolean
        lastFetched?: any | null
        latestFetchedServiceContentId?: string | null
        pageId?: string | null
        scrapeContent: boolean
        serviceAccountId: string
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        teamId?: number | null
        updatedAt?: any | null
        userId: number
        profileCollectionEnabled: boolean
        profileModerationEnabled: boolean
        llmClassificationEnabled: boolean
        llmEnableSuggestedReplies: boolean
        socialMediaServiceShortName?: string | null
        socialMediaServiceDisplayName?: string | null
        hasAuthorisation: boolean
        teamName?: string | null
        ownedBy?: string | null
        adsLastFetched?: any | null
        postsLastFetched?: any | null
        fetchPosts: boolean
        fetchAds: boolean
        retirePostDays: number
        shadowBanningEnabled: boolean
        shadowBanningThreshold: number
        shadowBanningRangeInDays: number
        dmsEnabled: boolean
        engageAccountId?: number | null
        instagramAuthMethod?: string | null
        toggles: {
            __typename?: 'AccountTogglesView'
            crossProfileEngage: boolean
            enableScreenshots: boolean
        }
    }
    actions: Array<{
        __typename?: 'ContentActionView'
        id: number
        action: string
        actionOn: any
        active: boolean
        automated: boolean
        contentId: number
        queued: boolean
        retryAt?: any | null
        userId?: number | null
        message?: string | null
        replyContentId?: number | null
        actionedByAccountId?: number | null
    }>
    media: Array<{
        __typename?: 'ContentMediaView'
        serviceMediaId: string
        publicUrl: string
        presignedUrl?: string | null
        mediaType: string
        mediaClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classification?: number | null
            classifierName: string
        }>
    }>
    readReceipts: Array<{
        __typename?: 'ReadReceiptView'
        userId: number
        contentOutcomeId: number
        createdAt: any
    }>
    allClassifications: Array<{
        __typename?: 'ContentClassificationView'
        classifierName: string
        classification?: number | null
        classifierDisplayName?: string | null
        result?: ClassificationResultView | null
    }>
}

export type ContentActionItemFragment = {
    __typename?: 'ContentActionView'
    id: number
    action: string
    actionOn: any
    active: boolean
    automated: boolean
    contentId: number
    queued: boolean
    retryAt?: any | null
    userId?: number | null
    message?: string | null
    replyContentId?: number | null
    actionedByAccountId?: number | null
}

export type ContentMediaItemFragment = {
    __typename?: 'ContentMediaView'
    serviceMediaId: string
    publicUrl: string
    presignedUrl?: string | null
    mediaType: string
    mediaClassifications: Array<{
        __typename?: 'ContentClassificationView'
        classification?: number | null
        classifierName: string
    }>
}

export type ReadReceiptItemFragment = {
    __typename?: 'ReadReceiptView'
    userId: number
    contentOutcomeId: number
    createdAt: any
}

export type ContentClassificationItemFragment = {
    __typename?: 'ContentClassificationView'
    classification?: number | null
    classifierName: string
}

export type GetContentClassifierMetadataQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type GetContentClassifierMetadataQuery = {
    __typename?: 'Query'
    getContentClassifierMetadata: Array<{
        __typename?: 'ContentClassifierMetadataView'
        classifierName: string
        classifierDisplayName: string
        classifierId: number
        contentCount: number
    }>
}

export type ContentClassifierMetadataItemFragment = {
    __typename?: 'ContentClassifierMetadataView'
    classifierName: string
    classifierDisplayName: string
    classifierId: number
    contentCount: number
}

export type GetUserAuthEventsQueryVariables = Exact<{
    username: Scalars['String']['input']
}>

export type GetUserAuthEventsQuery = {
    __typename?: 'Query'
    getUserAuthEvents: Array<{
        __typename?: 'UserAuthEventView'
        username: string
        eventType: string
        eventTimestamp?: any | null
        eventResponse: string
        ipAddress: string
        deviceName: string
        city: string
        country: string
    }>
}

export type UserAuthEventItemFragment = {
    __typename?: 'UserAuthEventView'
    username: string
    eventType: string
    eventTimestamp?: any | null
    eventResponse: string
    ipAddress: string
    deviceName: string
    city: string
    country: string
}

export type DetectedLanguageItemFragment = {
    __typename?: 'DetectedLanguageView'
    sourceText: string
    detectedSourceLanguage?: string | null
}

export type DetectLanguagesQueryVariables = Exact<{
    sourceTexts: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type DetectLanguagesQuery = {
    __typename?: 'Query'
    detectLanguages: Array<{
        __typename?: 'DetectedLanguageView'
        sourceText: string
        detectedSourceLanguage?: string | null
    }>
}

export type TranslatedTextItemFragment = {
    __typename?: 'TranslatedTextView'
    sourceText: string
    translatedText: string
    detectedSourceLanguage: string
}

export type TranslateQueryVariables = Exact<{
    sourceTexts: Array<Scalars['String']['input']> | Scalars['String']['input']
    targetLanguage: Scalars['String']['input']
}>

export type TranslateQuery = {
    __typename?: 'Query'
    translate: Array<{
        __typename?: 'TranslatedTextView'
        sourceText: string
        translatedText: string
        detectedSourceLanguage: string
    }>
}

export type TestLlmClassificationPromptsQueryVariables = Exact<{
    prompt: Scalars['String']['input']
    testCases: Array<LlmClassificationTestInput> | LlmClassificationTestInput
    model?: InputMaybe<Scalars['String']['input']>
}>

export type TestLlmClassificationPromptsQuery = {
    __typename?: 'Query'
    testLlmClassificationPrompts: Array<{
        __typename?: 'LlmClassificationView'
        text: string
        target: string
        score?: number | null
        justification: string
    }>
}

export type TestLlmImageClassificationPromptsQueryVariables = Exact<{
    prompt: Scalars['String']['input']
    testCases: Array<LlmImageClassificationTestInput> | LlmImageClassificationTestInput
    model?: InputMaybe<Scalars['String']['input']>
}>

export type TestLlmImageClassificationPromptsQuery = {
    __typename?: 'Query'
    testLlmImageClassificationPrompts: Array<{
        __typename?: 'LlmImageClassificationView'
        fileName: string
        target: string
        score?: number | null
        justification: string
    }>
}

export type GetAllServicesHealthQueryVariables = Exact<{ [key: string]: never }>

export type GetAllServicesHealthQuery = {
    __typename?: 'Query'
    getAllServicesHealth: {
        __typename?: 'ServiceHealthConnection'
        total: number
        items: Array<{
            __typename?: 'ServiceHealth'
            serviceName: string
            lastHeartbeat: any
            expectedIntervalSeconds: number
            healthStatus: HealthStatus
            createdAt: any
            updatedAt?: any | null
        }>
    }
}

export type StartChatMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    sessionId: Scalars['String']['input']
    message: Scalars['String']['input']
}>

export type StartChatMutation = {
    __typename?: 'Mutation'
    startChat: { __typename?: 'StartChatResponse'; taskId: string }
}

export type GetChatTaskStatusQueryVariables = Exact<{
    taskId: Scalars['String']['input']
}>

export type GetChatTaskStatusQuery = {
    __typename?: 'Query'
    getChatTaskStatus: {
        __typename?: 'ChatTaskStatusResponse'
        status: ChatTaskStatusView
        errorMessage?: string | null
        createdAt: any
        updatedAt: any
        result?: { __typename?: 'ChatResponse'; reply: string; summary: string } | null
    }
}

export type StartPrepareChatSessionMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    model: Scalars['String']['input']
    systemPrompt?: InputMaybe<Scalars['String']['input']>
    searchParameters?: InputMaybe<ContentSearchParams>
}>

export type StartPrepareChatSessionMutation = {
    __typename?: 'Mutation'
    startPrepareChatSession: { __typename?: 'StartDatasetPrepResponse'; taskId: string }
}

export type GetDatasetPrepTaskStatusQueryVariables = Exact<{
    taskId: Scalars['String']['input']
}>

export type GetDatasetPrepTaskStatusQuery = {
    __typename?: 'Query'
    getDatasetPrepTaskStatus: {
        __typename?: 'DatasetPrepTaskStatusResponse'
        status: DatasetPrepTaskStatusView
        progressMessage?: string | null
        errorMessage?: string | null
        createdAt: any
        updatedAt: any
        result?: {
            __typename?: 'PreparedChatSession'
            sessionId: string
            itemCount: number
            earliest?: any | null
            latest?: any | null
            summary: string
            dateRangeWasReduced: boolean
        } | null
    }
}

export type GetSuggestedRepliesQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
    numberOfSuggestions: Scalars['Int']['input']
    temperature?: InputMaybe<Scalars['Float']['input']>
}>

export type GetSuggestedRepliesQuery = { __typename?: 'Query'; getSuggestedReplies: Array<string> }

export type TestLlmReplyPromptQueryVariables = Exact<{
    prompt: Scalars['String']['input']
    testMessage: Scalars['String']['input']
    numberOfSuggestions?: InputMaybe<Scalars['Int']['input']>
    temperature?: InputMaybe<Scalars['Float']['input']>
    model?: InputMaybe<Scalars['String']['input']>
}>

export type TestLlmReplyPromptQuery = { __typename?: 'Query'; testLlmReplyPrompt: Array<string> }

export type CookieSummaryItemFragment = {
    __typename?: 'CookieSummary'
    id: number
    platform: CookiePlatform
    serviceUsername: string
    status: CookieStatus
    failCount: number
    lastUsedAt?: any | null
    createdAt: any
    updatedAt: any
    notes?: string | null
}

export type GetCookiesQueryVariables = Exact<{
    platform: CookiePlatform
    status?: InputMaybe<CookieStatus>
}>

export type GetCookiesQuery = {
    __typename?: 'Query'
    getCookies: Array<{
        __typename?: 'CookieSummary'
        id: number
        platform: CookiePlatform
        serviceUsername: string
        status: CookieStatus
        failCount: number
        lastUsedAt?: any | null
        createdAt: any
        updatedAt: any
        notes?: string | null
    }>
}

export type GetCookieQueryVariables = Exact<{
    cookieId: Scalars['Int']['input']
}>

export type GetCookieQuery = {
    __typename?: 'Query'
    getCookie?: {
        __typename?: 'CookieSummary'
        id: number
        platform: CookiePlatform
        serviceUsername: string
        status: CookieStatus
        failCount: number
        lastUsedAt?: any | null
        createdAt: any
        updatedAt: any
        notes?: string | null
    } | null
}

export type ReferrerViewItemFragment = {
    __typename?: 'ReferrerView'
    id: number
    referrer: string
    referrerUuid: string
    signUpEnabled: boolean
    requireSubscription: boolean
    userLimit?: number | null
    allowTrial: boolean
    trialDays?: number | null
    trialEndDate?: any | null
    creditCardRequired: boolean
    isCobranded: boolean
    logoUrl?: string | null
    isGuidedOnboarding: boolean
    userCount: number
}

export type ListReferrersQueryVariables = Exact<{
    offset: Scalars['Int']['input']
    limit: Scalars['Int']['input']
}>

export type ListReferrersQuery = {
    __typename?: 'Query'
    listReferrers: {
        __typename?: 'ReferrerListResponse'
        total: number
        referrers: Array<{
            __typename?: 'ReferrerView'
            id: number
            referrer: string
            referrerUuid: string
            signUpEnabled: boolean
            requireSubscription: boolean
            userLimit?: number | null
            allowTrial: boolean
            trialDays?: number | null
            trialEndDate?: any | null
            creditCardRequired: boolean
            isCobranded: boolean
            logoUrl?: string | null
            isGuidedOnboarding: boolean
            userCount: number
        }>
    }
}

export type ScreenshotItemFragment = {
    __typename?: 'Screenshot'
    id: number
    contentId: number
    s3Url?: string | null
    cookieId?: number | null
    status: ScreenshotStatus
    errorMessage?: string | null
    createdAt: any
}

export type ScreenshotAttemptItemFragment = {
    __typename?: 'ScreenshotAttempt'
    id: number
    contentId: number
    contentText?: string | null
    s3Url?: string | null
    cookieId?: number | null
    status: ScreenshotStatus
    errorMessage?: string | null
    logs?: string | null
    createdAt: any
}

export type GetScreenshotByContentIdQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type GetScreenshotByContentIdQuery = {
    __typename?: 'Query'
    getScreenshotByContentId?: {
        __typename?: 'Screenshot'
        id: number
        contentId: number
        s3Url?: string | null
        cookieId?: number | null
        status: ScreenshotStatus
        errorMessage?: string | null
        createdAt: any
    } | null
}

export type GetScreenshotAdminListQueryVariables = Exact<{
    offset: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    status?: InputMaybe<ScreenshotStatus>
}>

export type GetScreenshotAdminListQuery = {
    __typename?: 'Query'
    getScreenshotAdminList: {
        __typename?: 'ScreenshotAdminListResponse'
        total: number
        items: Array<{
            __typename?: 'ScreenshotAttempt'
            id: number
            contentId: number
            contentText?: string | null
            s3Url?: string | null
            cookieId?: number | null
            status: ScreenshotStatus
            errorMessage?: string | null
            logs?: string | null
            createdAt: any
        }>
    }
}

export type ScreenshotContentSummaryItemFragment = {
    __typename?: 'ScreenshotContentSummary'
    contentId: number
    contentText?: string | null
    accountName?: string | null
    authorName?: string | null
    socialMediaService?: string | null
    totalAttempts: number
    successCount: number
    failedCount: number
    pendingCount: number
    latestCreatedAt: any
    latestScreenshot?: {
        __typename?: 'ScreenshotAttempt'
        id: number
        contentId: number
        contentText?: string | null
        s3Url?: string | null
        cookieId?: number | null
        status: ScreenshotStatus
        errorMessage?: string | null
        logs?: string | null
        createdAt: any
    } | null
}

export type GetScreenshotContentSummaryQueryVariables = Exact<{
    offset: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    status?: InputMaybe<ScreenshotStatus>
}>

export type GetScreenshotContentSummaryQuery = {
    __typename?: 'Query'
    getScreenshotContentSummary: {
        __typename?: 'ScreenshotContentSummaryResponse'
        total: number
        items: Array<{
            __typename?: 'ScreenshotContentSummary'
            contentId: number
            contentText?: string | null
            accountName?: string | null
            authorName?: string | null
            socialMediaService?: string | null
            totalAttempts: number
            successCount: number
            failedCount: number
            pendingCount: number
            latestCreatedAt: any
            latestScreenshot?: {
                __typename?: 'ScreenshotAttempt'
                id: number
                contentId: number
                contentText?: string | null
                s3Url?: string | null
                cookieId?: number | null
                status: ScreenshotStatus
                errorMessage?: string | null
                logs?: string | null
                createdAt: any
            } | null
        }>
    }
}

export type GetScreenshotAttemptsByContentIdQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type GetScreenshotAttemptsByContentIdQuery = {
    __typename?: 'Query'
    getScreenshotAttemptsByContentId: Array<{
        __typename?: 'ScreenshotAttempt'
        id: number
        contentId: number
        contentText?: string | null
        s3Url?: string | null
        cookieId?: number | null
        status: ScreenshotStatus
        errorMessage?: string | null
        logs?: string | null
        createdAt: any
    }>
}

export type MetaAdVisibilityQueryVariables = Exact<{
    accountId: Scalars['Int']['input']
    days?: InputMaybe<Scalars['Int']['input']>
}>

export type MetaAdVisibilityQuery = {
    __typename?: 'Query'
    metaAdVisibility: {
        __typename?: 'MetaAdVisibility'
        accountId: number
        accountName?: string | null
        serviceAccountId: string
        serviceAccountUsername?: string | null
        adsLastFetched?: any | null
        socialMediaService: string
        identityLabel: string
        attachmentLabel: string
        daysWindow: number
        matchedCount: number
        totalCount: number
        totalComments: number
        unmatchedComments: number
        adAccounts: Array<{
            __typename?: 'MetaAdVisibilityAdAccount'
            id: string
            name: string
            isMatch: boolean
            attachments: Array<{
                __typename?: 'MetaAdVisibilityAttachment'
                id: string
                name: string
            }>
        }>
        authoriser?: {
            __typename?: 'MetaAdVisibilityAuthoriser'
            userId: string
            name?: string | null
            email?: string | null
            tokenIsValid: boolean
            tokenExpiresAt?: any | null
            tokenDataAccessExpiresAt?: any | null
            applicationName: string
            scopes: Array<string>
        } | null
    }
}

export type GetSocialMediaServicesQueryVariables = Exact<{ [key: string]: never }>

export type GetSocialMediaServicesQuery = {
    __typename?: 'Query'
    getSocialMediaServices: Array<{
        __typename?: 'SocialMediaServiceView'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
    }>
}

export type GetClassifierDetailsQueryVariables = Exact<{ [key: string]: never }>

export type GetClassifierDetailsQuery = {
    __typename?: 'Query'
    getClassifierDetails: Array<{
        __typename?: 'ClassifierDetailView'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
    }>
}

export type GetContentClassifierOptionsQueryVariables = Exact<{
    params: ContentSearchParams
}>

export type GetContentClassifierOptionsQuery = {
    __typename?: 'Query'
    getContentClassifierOptions: Array<{
        __typename?: 'ClassifierDetailView'
        id: number
        shortName: string
        displayName: string
    }>
}

export type GetYouTubeSubscriptionDiagnosticUrlQueryVariables = Exact<{
    channelId: Scalars['String']['input']
}>

export type GetYouTubeSubscriptionDiagnosticUrlQuery = {
    __typename?: 'Query'
    getYouTubeSubscriptionDiagnosticUrl: {
        __typename?: 'YouTubeSubscriptionDiagrnostics'
        url?: string | null
    }
}

export type ClassifierPromptItemFragment = {
    __typename?: 'ClassifierPrompt'
    id: number
    classifierDetailsId: number
    version: number
    prompt: string
    model: string
    status: ClassifierPromptStatus
    defaultBorderlineThreshold?: number | null
    defaultConfirmedThreshold?: number | null
    createdBy?: number | null
    updatedBy?: number | null
    createdAt: any
    updatedAt: any
}

export type ClassifierDetailFullItemFragment = {
    __typename?: 'ClassifierDetailFull'
    id: number
    shortName: string
    displayName: string
    shortDescription: string
    longDescription: string
    clientFacingName: string
    modality: Modality
    valence: Valence
    archived: boolean
}

export type GetClassifierPromptQueryVariables = Exact<{
    id: Scalars['Int']['input']
}>

export type GetClassifierPromptQuery = {
    __typename?: 'Query'
    getClassifierPrompt: {
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }
}

export type GetClassifierPromptVersionsQueryVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
}>

export type GetClassifierPromptVersionsQuery = {
    __typename?: 'Query'
    getClassifierPromptVersions: Array<{
        __typename?: 'ClassifierPrompt'
        id: number
        classifierDetailsId: number
        version: number
        prompt: string
        model: string
        status: ClassifierPromptStatus
        defaultBorderlineThreshold?: number | null
        defaultConfirmedThreshold?: number | null
        createdBy?: number | null
        updatedBy?: number | null
        createdAt: any
        updatedAt: any
    }>
}

export type GetPromptManagedClassifierIdsQueryVariables = Exact<{ [key: string]: never }>

export type GetPromptManagedClassifierIdsQuery = {
    __typename?: 'Query'
    getPromptManagedClassifierIds: Array<number>
}

export type GetManagedClassifierDetailsQueryVariables = Exact<{ [key: string]: never }>

export type GetManagedClassifierDetailsQuery = {
    __typename?: 'Query'
    getManagedClassifierDetails: Array<{
        __typename?: 'ClassifierDetailFull'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription: string
        clientFacingName: string
        modality: Modality
        valence: Valence
        archived: boolean
    }>
}

export type ClassifierNameAvailabilityQueryVariables = Exact<{
    shortName: Scalars['String']['input']
}>

export type ClassifierNameAvailabilityQuery = {
    __typename?: 'Query'
    classifierNameAvailability: {
        __typename?: 'ClassifierNameAvailability'
        available: boolean
        conflictingDisplayName?: string | null
    }
}

export type ClassifierLibraryRowItemFragment = {
    __typename?: 'ClassifierLibraryRow'
    id: number
    displayName: string
    shortDescription: string
    modality: Modality
    valence: Valence
    model: string
    liveVersion?: number | null
    draftVersion?: number | null
    latestVersion: number
    versionCount: number
    updatedAt: any
    coveredProfiles: number
    coveredTeams: number
    archived: boolean
}

export type GetClassifierLibraryQueryVariables = Exact<{
    params: ClassifierSearchView
}>

export type GetClassifierLibraryQuery = {
    __typename?: 'Query'
    getClassifierLibrary: {
        __typename?: 'ClassifierLibrary'
        total: number
        items: Array<{
            __typename?: 'ClassifierLibraryRow'
            id: number
            displayName: string
            shortDescription: string
            modality: Modality
            valence: Valence
            model: string
            liveVersion?: number | null
            draftVersion?: number | null
            latestVersion: number
            versionCount: number
            updatedAt: any
            coveredProfiles: number
            coveredTeams: number
            archived: boolean
        }>
    }
}

export type GetClassifierDeploymentTeamsQueryVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    search?: InputMaybe<Scalars['String']['input']>
    offset: Scalars['Int']['input']
    limit: Scalars['Int']['input']
}>

export type GetClassifierDeploymentTeamsQuery = {
    __typename?: 'Query'
    getClassifierDeploymentTeams: {
        __typename?: 'ClassifierDeploymentTeams'
        total: number
        items: Array<{
            __typename?: 'TeamCoverage'
            teamId: number
            teamName: string
            deployedCount: number
            totalCount: number
        }>
    }
}

export type GetClassifierDeployedProfilesQueryVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    search?: InputMaybe<Scalars['String']['input']>
    offset: Scalars['Int']['input']
    limit: Scalars['Int']['input']
}>

export type GetClassifierDeployedProfilesQuery = {
    __typename?: 'Query'
    getClassifierDeployedProfiles: {
        __typename?: 'ClassifierDeployedProfiles'
        total: number
        items: Array<{
            __typename?: 'DeployedProfile'
            id: number
            name?: string | null
            platform: string
            teamId?: number | null
            teamName?: string | null
        }>
    }
}

export type GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
}>

export type GetClassifierDeployedProfilesWithoutLlmClassificationQuery = {
    __typename?: 'Query'
    getClassifierDeployedProfilesWithoutLlmClassification: Array<{
        __typename?: 'DeployedProfile'
        id: number
        name?: string | null
        teamId?: number | null
        teamName?: string | null
    }>
}

export type GetClassifierRemainingTeamProfilesQueryVariables = Exact<{
    classifierDetailsId: Scalars['Int']['input']
    teamId: Scalars['Int']['input']
}>

export type GetClassifierRemainingTeamProfilesQuery = {
    __typename?: 'Query'
    getClassifierRemainingTeamProfiles: Array<{
        __typename?: 'DeployedProfile'
        id: number
        name?: string | null
        platform: string
    }>
}

export type ScheduledWorkQueryVariables = Exact<{
    status?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
}>

export type ScheduledWorkQuery = {
    __typename?: 'Query'
    scheduledWork: Array<{
        __typename?: 'ScheduledWork'
        tag: string
        kind: string
        summary: string
        params?: any | null
        status: string
        live: boolean
        rowId: string
        cron?: string | null
        intervalSecs?: number | null
        scheduleEnglish?: string | null
        nextRunAt?: any | null
        attempt: number
        log?: string | null
        lastRunStatus?: string | null
        lastRunLog?: string | null
        lastRunAt?: any | null
        consecutiveFailures: number
        needsAttention: boolean
    }>
}

export type ScheduledWorkAttentionCountQueryVariables = Exact<{ [key: string]: never }>

export type ScheduledWorkAttentionCountQuery = {
    __typename?: 'Query'
    scheduledWorkAttentionCount: number
}

export type FleetJobsQueryVariables = Exact<{ [key: string]: never }>

export type FleetJobsQuery = {
    __typename?: 'Query'
    fleetJobs: Array<{
        __typename?: 'FleetJob'
        key: string
        name: string
        description: string
        tag: string
        cadenceEditable: boolean
        defaultIntervalSecs?: number | null
        minIntervalSecs?: number | null
    }>
}

export type ScheduledWorkHistoryQueryVariables = Exact<{
    tag: Scalars['String']['input']
}>

export type ScheduledWorkHistoryQuery = {
    __typename?: 'Query'
    scheduledWorkHistory: Array<{
        __typename?: 'ScheduledWorkRun'
        rowId: string
        tag: string
        status: string
        attempt: number
        deferralCount: number
        scheduledBy: string
        log?: string | null
        scheduledAt: any
        startedAt?: any | null
        completedAt?: any | null
        durationMs?: number | null
    }>
}

export type AccountMonitoringQueryVariables = Exact<{
    platform: Scalars['String']['input']
    serviceAccountUsername: Scalars['String']['input']
}>

export type AccountMonitoringQuery = {
    __typename?: 'Query'
    accountMonitoring: {
        __typename?: 'AccountMonitoring'
        monitor?: {
            __typename?: 'ScheduledWork'
            tag: string
            kind: string
            status: string
            live: boolean
            rowId: string
            cron?: string | null
            intervalSecs?: number | null
            scheduleEnglish?: string | null
            nextRunAt?: any | null
            attempt: number
            log?: string | null
            lastRunStatus?: string | null
            lastRunLog?: string | null
            lastRunAt?: any | null
            consecutiveFailures: number
            needsAttention: boolean
        } | null
        settings?: {
            __typename?: 'MonitorSettings'
            mode: MonitorMode
            windowDays?: number | null
            since?: any | null
            targets: Array<string>
            scrapeProfile?: string | null
        } | null
        runs: Array<{
            __typename?: 'ScheduledWorkRun'
            rowId: string
            tag: string
            status: string
            attempt: number
            deferralCount: number
            scheduledBy: string
            log?: string | null
            scheduledAt: any
            startedAt?: any | null
            completedAt?: any | null
            durationMs?: number | null
        }>
    }
}

export type MonitoringHealthQueryVariables = Exact<{
    accountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type MonitoringHealthQuery = {
    __typename?: 'Query'
    monitoringHealth: Array<{
        __typename?: 'AccountHealthSignal'
        accountId: number
        status: AccountHealthStatus
        label: string
        detail?: string | null
    }>
}

export type AdminPostItemFragment = {
    __typename?: 'AdminPostView'
    id: number
    accountId: number
    accountName?: string | null
    serviceAccountUsername?: string | null
    socialMediaServiceId: number
    socialMediaServiceShortName: string
    teamId?: number | null
    teamName?: string | null
    servicePostId: string
    title: string
    uri: string
    publishTime: any
    createdAt: any
    lastFetched?: any | null
    platformCommentCount?: number | null
    platformCommentCountFetchedAt?: any | null
    postType: string
    isAd: boolean
    isDeleted: boolean
    shouldFetch: boolean
    collectedCommentCount: number
    safeCount: number
    suspectCount: number
    severeCount: number
}

export type SearchAdminPostsQueryVariables = Exact<{
    params: AdminPostSearchParamsView
}>

export type SearchAdminPostsQuery = {
    __typename?: 'Query'
    searchAdminPosts: {
        __typename?: 'AdminPostSearchResultView'
        total: number
        posts: Array<{
            __typename?: 'AdminPostView'
            id: number
            accountId: number
            accountName?: string | null
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            socialMediaServiceShortName: string
            teamId?: number | null
            teamName?: string | null
            servicePostId: string
            title: string
            uri: string
            publishTime: any
            createdAt: any
            lastFetched?: any | null
            platformCommentCount?: number | null
            platformCommentCountFetchedAt?: any | null
            postType: string
            isAd: boolean
            isDeleted: boolean
            shouldFetch: boolean
            collectedCommentCount: number
            safeCount: number
            suspectCount: number
            severeCount: number
        }>
    }
}

export type GetAdminPostQueryVariables = Exact<{
    postId: Scalars['Int']['input']
}>

export type GetAdminPostQuery = {
    __typename?: 'Query'
    getAdminPost?: {
        __typename?: 'AdminPostView'
        id: number
        accountId: number
        accountName?: string | null
        serviceAccountUsername?: string | null
        socialMediaServiceId: number
        socialMediaServiceShortName: string
        teamId?: number | null
        teamName?: string | null
        servicePostId: string
        title: string
        uri: string
        publishTime: any
        createdAt: any
        lastFetched?: any | null
        platformCommentCount?: number | null
        platformCommentCountFetchedAt?: any | null
        postType: string
        isAd: boolean
        isDeleted: boolean
        shouldFetch: boolean
        collectedCommentCount: number
        safeCount: number
        suspectCount: number
        severeCount: number
    } | null
}

export type GetCommentThreadQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
}>

export type GetCommentThreadQuery = {
    __typename?: 'Query'
    getCommentThread: {
        __typename?: 'CommentThreadView'
        focusContentId: number
        parentMissing: boolean
        canRefresh: boolean
        notices: Array<string>
        post?: {
            __typename?: 'ConversationPostView'
            id: number
            title: string
            uri: string
            publishTime: any
            commentCount?: number | null
        } | null
        root?: {
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        } | null
        replies: Array<{
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        }>
    }
}

export type CommentThreadItemFragment = {
    __typename?: 'CommentThreadView'
    focusContentId: number
    parentMissing: boolean
    canRefresh: boolean
    notices: Array<string>
    post?: {
        __typename?: 'ConversationPostView'
        id: number
        title: string
        uri: string
        publishTime: any
        commentCount?: number | null
    } | null
    root?: {
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    } | null
    replies: Array<{
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }>
}

export type PostConversationReplyItemFragment = {
    __typename?: 'PostConversationReplyView'
    matches: boolean
    awaitingModeration: boolean
    content: {
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }
}

export type PostConversationThreadItemFragment = {
    __typename?: 'PostConversationThreadView'
    rootMatches: boolean
    rootAwaitingModeration: boolean
    replyCount: number
    repliesFilteredCount: number
    repliesAwaitingModerationCount: number
    hasMoreReplies: boolean
    root: {
        __typename?: 'ContentView'
        id: number
        serviceContentId: string
        content: string
        contentType: ContentTypeView
        socialMediaServiceName: string
        isPublic: boolean
        serviceAuthorId?: string | null
        serviceAuthorName?: string | null
        serviceAuthorDisplayUsername?: string | null
        shouldEnrich: boolean
        moderation?: string | null
        authorised: boolean
        socialMediaAuthorLink?: string | null
        socialMediaPostLink?: string | null
        socialMediaContentLink?: string | null
        socialMediaContentName: string
        datePosted?: any | null
        isReply: boolean
        inReplyToUserId?: string | null
        inReplyToUsername?: string | null
        inReplyToStatusId?: string | null
        originalPostAuthorId?: string | null
        originalPostAuthorName?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
        originalPostLink?: string | null
        isOwned?: boolean | null
        authorProfileId?: number | null
        account: {
            __typename?: 'AccountRecord'
            id: number
            accountName?: string | null
            autoDeleteSevereContent: boolean
            autoHideSevereContent: boolean
            autoMuteSevereAccount: boolean
            autoHideAllAdComments?: boolean | null
            classifyContent: boolean
            createdAt: any
            fetchContent: boolean
            isSubscribed: boolean
            lastFetched?: any | null
            latestFetchedServiceContentId?: string | null
            pageId?: string | null
            scrapeContent: boolean
            serviceAccountId: string
            serviceAccountUsername?: string | null
            socialMediaServiceId: number
            teamId?: number | null
            updatedAt?: any | null
            userId: number
            profileCollectionEnabled: boolean
            profileModerationEnabled: boolean
            llmClassificationEnabled: boolean
            llmEnableSuggestedReplies: boolean
            socialMediaServiceShortName?: string | null
            socialMediaServiceDisplayName?: string | null
            hasAuthorisation: boolean
            teamName?: string | null
            ownedBy?: string | null
            adsLastFetched?: any | null
            postsLastFetched?: any | null
            fetchPosts: boolean
            fetchAds: boolean
            retirePostDays: number
            shadowBanningEnabled: boolean
            shadowBanningThreshold: number
            shadowBanningRangeInDays: number
            dmsEnabled: boolean
            engageAccountId?: number | null
            instagramAuthMethod?: string | null
            toggles: {
                __typename?: 'AccountTogglesView'
                crossProfileEngage: boolean
                enableScreenshots: boolean
            }
        }
        actions: Array<{
            __typename?: 'ContentActionView'
            id: number
            action: string
            actionOn: any
            active: boolean
            automated: boolean
            contentId: number
            queued: boolean
            retryAt?: any | null
            userId?: number | null
            message?: string | null
            replyContentId?: number | null
            actionedByAccountId?: number | null
        }>
        media: Array<{
            __typename?: 'ContentMediaView'
            serviceMediaId: string
            publicUrl: string
            presignedUrl?: string | null
            mediaType: string
            mediaClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classification?: number | null
                classifierName: string
            }>
        }>
        readReceipts: Array<{
            __typename?: 'ReadReceiptView'
            userId: number
            contentOutcomeId: number
            createdAt: any
        }>
        allClassifications: Array<{
            __typename?: 'ContentClassificationView'
            classifierName: string
            classification?: number | null
            classifierDisplayName?: string | null
            result?: ClassificationResultView | null
        }>
    }
    replies: Array<{
        __typename?: 'PostConversationReplyView'
        matches: boolean
        awaitingModeration: boolean
        content: {
            __typename?: 'ContentView'
            id: number
            serviceContentId: string
            content: string
            contentType: ContentTypeView
            socialMediaServiceName: string
            isPublic: boolean
            serviceAuthorId?: string | null
            serviceAuthorName?: string | null
            serviceAuthorDisplayUsername?: string | null
            shouldEnrich: boolean
            moderation?: string | null
            authorised: boolean
            socialMediaAuthorLink?: string | null
            socialMediaPostLink?: string | null
            socialMediaContentLink?: string | null
            socialMediaContentName: string
            datePosted?: any | null
            isReply: boolean
            inReplyToUserId?: string | null
            inReplyToUsername?: string | null
            inReplyToStatusId?: string | null
            originalPostAuthorId?: string | null
            originalPostAuthorName?: string | null
            originalPostId?: string | null
            originalPostLinkId?: string | null
            originalPostLink?: string | null
            isOwned?: boolean | null
            authorProfileId?: number | null
            account: {
                __typename?: 'AccountRecord'
                id: number
                accountName?: string | null
                autoDeleteSevereContent: boolean
                autoHideSevereContent: boolean
                autoMuteSevereAccount: boolean
                autoHideAllAdComments?: boolean | null
                classifyContent: boolean
                createdAt: any
                fetchContent: boolean
                isSubscribed: boolean
                lastFetched?: any | null
                latestFetchedServiceContentId?: string | null
                pageId?: string | null
                scrapeContent: boolean
                serviceAccountId: string
                serviceAccountUsername?: string | null
                socialMediaServiceId: number
                teamId?: number | null
                updatedAt?: any | null
                userId: number
                profileCollectionEnabled: boolean
                profileModerationEnabled: boolean
                llmClassificationEnabled: boolean
                llmEnableSuggestedReplies: boolean
                socialMediaServiceShortName?: string | null
                socialMediaServiceDisplayName?: string | null
                hasAuthorisation: boolean
                teamName?: string | null
                ownedBy?: string | null
                adsLastFetched?: any | null
                postsLastFetched?: any | null
                fetchPosts: boolean
                fetchAds: boolean
                retirePostDays: number
                shadowBanningEnabled: boolean
                shadowBanningThreshold: number
                shadowBanningRangeInDays: number
                dmsEnabled: boolean
                engageAccountId?: number | null
                instagramAuthMethod?: string | null
                toggles: {
                    __typename?: 'AccountTogglesView'
                    crossProfileEngage: boolean
                    enableScreenshots: boolean
                }
            }
            actions: Array<{
                __typename?: 'ContentActionView'
                id: number
                action: string
                actionOn: any
                active: boolean
                automated: boolean
                contentId: number
                queued: boolean
                retryAt?: any | null
                userId?: number | null
                message?: string | null
                replyContentId?: number | null
                actionedByAccountId?: number | null
            }>
            media: Array<{
                __typename?: 'ContentMediaView'
                serviceMediaId: string
                publicUrl: string
                presignedUrl?: string | null
                mediaType: string
                mediaClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classification?: number | null
                    classifierName: string
                }>
            }>
            readReceipts: Array<{
                __typename?: 'ReadReceiptView'
                userId: number
                contentOutcomeId: number
                createdAt: any
            }>
            allClassifications: Array<{
                __typename?: 'ContentClassificationView'
                classifierName: string
                classification?: number | null
                classifierDisplayName?: string | null
                result?: ClassificationResultView | null
            }>
        }
    }>
}

export type GetPostConversationPageQueryVariables = Exact<{
    params: ContentSearchParams
    after?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetPostConversationPageQuery = {
    __typename?: 'Query'
    getPostConversationPage: {
        __typename?: 'PostConversationPageView'
        nextCursor?: string | null
        matchingTotal: number
        matchingCapped: boolean
        canRefresh: boolean
        post: {
            __typename?: 'ConversationPostView'
            id: number
            title: string
            uri: string
            publishTime: any
            commentCount?: number | null
        }
        items: Array<{
            __typename?: 'PostConversationItemView'
            gapCount?: number | null
            gapAwaitingModerationCount?: number | null
            thread?: {
                __typename?: 'PostConversationThreadView'
                rootMatches: boolean
                rootAwaitingModeration: boolean
                replyCount: number
                repliesFilteredCount: number
                repliesAwaitingModerationCount: number
                hasMoreReplies: boolean
                root: {
                    __typename?: 'ContentView'
                    id: number
                    serviceContentId: string
                    content: string
                    contentType: ContentTypeView
                    socialMediaServiceName: string
                    isPublic: boolean
                    serviceAuthorId?: string | null
                    serviceAuthorName?: string | null
                    serviceAuthorDisplayUsername?: string | null
                    shouldEnrich: boolean
                    moderation?: string | null
                    authorised: boolean
                    socialMediaAuthorLink?: string | null
                    socialMediaPostLink?: string | null
                    socialMediaContentLink?: string | null
                    socialMediaContentName: string
                    datePosted?: any | null
                    isReply: boolean
                    inReplyToUserId?: string | null
                    inReplyToUsername?: string | null
                    inReplyToStatusId?: string | null
                    originalPostAuthorId?: string | null
                    originalPostAuthorName?: string | null
                    originalPostId?: string | null
                    originalPostLinkId?: string | null
                    originalPostLink?: string | null
                    isOwned?: boolean | null
                    authorProfileId?: number | null
                    account: {
                        __typename?: 'AccountRecord'
                        id: number
                        accountName?: string | null
                        autoDeleteSevereContent: boolean
                        autoHideSevereContent: boolean
                        autoMuteSevereAccount: boolean
                        autoHideAllAdComments?: boolean | null
                        classifyContent: boolean
                        createdAt: any
                        fetchContent: boolean
                        isSubscribed: boolean
                        lastFetched?: any | null
                        latestFetchedServiceContentId?: string | null
                        pageId?: string | null
                        scrapeContent: boolean
                        serviceAccountId: string
                        serviceAccountUsername?: string | null
                        socialMediaServiceId: number
                        teamId?: number | null
                        updatedAt?: any | null
                        userId: number
                        profileCollectionEnabled: boolean
                        profileModerationEnabled: boolean
                        llmClassificationEnabled: boolean
                        llmEnableSuggestedReplies: boolean
                        socialMediaServiceShortName?: string | null
                        socialMediaServiceDisplayName?: string | null
                        hasAuthorisation: boolean
                        teamName?: string | null
                        ownedBy?: string | null
                        adsLastFetched?: any | null
                        postsLastFetched?: any | null
                        fetchPosts: boolean
                        fetchAds: boolean
                        retirePostDays: number
                        shadowBanningEnabled: boolean
                        shadowBanningThreshold: number
                        shadowBanningRangeInDays: number
                        dmsEnabled: boolean
                        engageAccountId?: number | null
                        instagramAuthMethod?: string | null
                        toggles: {
                            __typename?: 'AccountTogglesView'
                            crossProfileEngage: boolean
                            enableScreenshots: boolean
                        }
                    }
                    actions: Array<{
                        __typename?: 'ContentActionView'
                        id: number
                        action: string
                        actionOn: any
                        active: boolean
                        automated: boolean
                        contentId: number
                        queued: boolean
                        retryAt?: any | null
                        userId?: number | null
                        message?: string | null
                        replyContentId?: number | null
                        actionedByAccountId?: number | null
                    }>
                    media: Array<{
                        __typename?: 'ContentMediaView'
                        serviceMediaId: string
                        publicUrl: string
                        presignedUrl?: string | null
                        mediaType: string
                        mediaClassifications: Array<{
                            __typename?: 'ContentClassificationView'
                            classification?: number | null
                            classifierName: string
                        }>
                    }>
                    readReceipts: Array<{
                        __typename?: 'ReadReceiptView'
                        userId: number
                        contentOutcomeId: number
                        createdAt: any
                    }>
                    allClassifications: Array<{
                        __typename?: 'ContentClassificationView'
                        classifierName: string
                        classification?: number | null
                        classifierDisplayName?: string | null
                        result?: ClassificationResultView | null
                    }>
                }
                replies: Array<{
                    __typename?: 'PostConversationReplyView'
                    matches: boolean
                    awaitingModeration: boolean
                    content: {
                        __typename?: 'ContentView'
                        id: number
                        serviceContentId: string
                        content: string
                        contentType: ContentTypeView
                        socialMediaServiceName: string
                        isPublic: boolean
                        serviceAuthorId?: string | null
                        serviceAuthorName?: string | null
                        serviceAuthorDisplayUsername?: string | null
                        shouldEnrich: boolean
                        moderation?: string | null
                        authorised: boolean
                        socialMediaAuthorLink?: string | null
                        socialMediaPostLink?: string | null
                        socialMediaContentLink?: string | null
                        socialMediaContentName: string
                        datePosted?: any | null
                        isReply: boolean
                        inReplyToUserId?: string | null
                        inReplyToUsername?: string | null
                        inReplyToStatusId?: string | null
                        originalPostAuthorId?: string | null
                        originalPostAuthorName?: string | null
                        originalPostId?: string | null
                        originalPostLinkId?: string | null
                        originalPostLink?: string | null
                        isOwned?: boolean | null
                        authorProfileId?: number | null
                        account: {
                            __typename?: 'AccountRecord'
                            id: number
                            accountName?: string | null
                            autoDeleteSevereContent: boolean
                            autoHideSevereContent: boolean
                            autoMuteSevereAccount: boolean
                            autoHideAllAdComments?: boolean | null
                            classifyContent: boolean
                            createdAt: any
                            fetchContent: boolean
                            isSubscribed: boolean
                            lastFetched?: any | null
                            latestFetchedServiceContentId?: string | null
                            pageId?: string | null
                            scrapeContent: boolean
                            serviceAccountId: string
                            serviceAccountUsername?: string | null
                            socialMediaServiceId: number
                            teamId?: number | null
                            updatedAt?: any | null
                            userId: number
                            profileCollectionEnabled: boolean
                            profileModerationEnabled: boolean
                            llmClassificationEnabled: boolean
                            llmEnableSuggestedReplies: boolean
                            socialMediaServiceShortName?: string | null
                            socialMediaServiceDisplayName?: string | null
                            hasAuthorisation: boolean
                            teamName?: string | null
                            ownedBy?: string | null
                            adsLastFetched?: any | null
                            postsLastFetched?: any | null
                            fetchPosts: boolean
                            fetchAds: boolean
                            retirePostDays: number
                            shadowBanningEnabled: boolean
                            shadowBanningThreshold: number
                            shadowBanningRangeInDays: number
                            dmsEnabled: boolean
                            engageAccountId?: number | null
                            instagramAuthMethod?: string | null
                            toggles: {
                                __typename?: 'AccountTogglesView'
                                crossProfileEngage: boolean
                                enableScreenshots: boolean
                            }
                        }
                        actions: Array<{
                            __typename?: 'ContentActionView'
                            id: number
                            action: string
                            actionOn: any
                            active: boolean
                            automated: boolean
                            contentId: number
                            queued: boolean
                            retryAt?: any | null
                            userId?: number | null
                            message?: string | null
                            replyContentId?: number | null
                            actionedByAccountId?: number | null
                        }>
                        media: Array<{
                            __typename?: 'ContentMediaView'
                            serviceMediaId: string
                            publicUrl: string
                            presignedUrl?: string | null
                            mediaType: string
                            mediaClassifications: Array<{
                                __typename?: 'ContentClassificationView'
                                classification?: number | null
                                classifierName: string
                            }>
                        }>
                        readReceipts: Array<{
                            __typename?: 'ReadReceiptView'
                            userId: number
                            contentOutcomeId: number
                            createdAt: any
                        }>
                        allClassifications: Array<{
                            __typename?: 'ContentClassificationView'
                            classifierName: string
                            classification?: number | null
                            classifierDisplayName?: string | null
                            result?: ClassificationResultView | null
                        }>
                    }
                }>
            } | null
        }>
    }
}

export type PostRefreshTaskItemFragment = {
    __typename?: 'PostRefreshTaskResult'
    status: PostRefreshTaskStatus
    completedAt?: any | null
    error?: string | null
    outcome?: {
        __typename?: 'PostRefreshOutcomeView'
        ran: boolean
        platform: string
        notices: Array<string>
        newComments: number
    } | null
}

export type PostConversationRefreshTaskQueryVariables = Exact<{
    taskId: Scalars['String']['input']
}>

export type PostConversationRefreshTaskQuery = {
    __typename?: 'Query'
    postConversationRefreshTask: {
        __typename?: 'PostRefreshTaskResult'
        status: PostRefreshTaskStatus
        completedAt?: any | null
        error?: string | null
        outcome?: {
            __typename?: 'PostRefreshOutcomeView'
            ran: boolean
            platform: string
            notices: Array<string>
            newComments: number
        } | null
    }
}

export type GetMoreThreadRepliesQueryVariables = Exact<{
    contentId: Scalars['Int']['input']
    params: ContentSearchParams
    after?: InputMaybe<Scalars['String']['input']>
    limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetMoreThreadRepliesQuery = {
    __typename?: 'Query'
    getMoreThreadReplies: {
        __typename?: 'MoreThreadRepliesView'
        nextCursor?: string | null
        replies: Array<{
            __typename?: 'PostConversationReplyView'
            matches: boolean
            awaitingModeration: boolean
            content: {
                __typename?: 'ContentView'
                id: number
                serviceContentId: string
                content: string
                contentType: ContentTypeView
                socialMediaServiceName: string
                isPublic: boolean
                serviceAuthorId?: string | null
                serviceAuthorName?: string | null
                serviceAuthorDisplayUsername?: string | null
                shouldEnrich: boolean
                moderation?: string | null
                authorised: boolean
                socialMediaAuthorLink?: string | null
                socialMediaPostLink?: string | null
                socialMediaContentLink?: string | null
                socialMediaContentName: string
                datePosted?: any | null
                isReply: boolean
                inReplyToUserId?: string | null
                inReplyToUsername?: string | null
                inReplyToStatusId?: string | null
                originalPostAuthorId?: string | null
                originalPostAuthorName?: string | null
                originalPostId?: string | null
                originalPostLinkId?: string | null
                originalPostLink?: string | null
                isOwned?: boolean | null
                authorProfileId?: number | null
                account: {
                    __typename?: 'AccountRecord'
                    id: number
                    accountName?: string | null
                    autoDeleteSevereContent: boolean
                    autoHideSevereContent: boolean
                    autoMuteSevereAccount: boolean
                    autoHideAllAdComments?: boolean | null
                    classifyContent: boolean
                    createdAt: any
                    fetchContent: boolean
                    isSubscribed: boolean
                    lastFetched?: any | null
                    latestFetchedServiceContentId?: string | null
                    pageId?: string | null
                    scrapeContent: boolean
                    serviceAccountId: string
                    serviceAccountUsername?: string | null
                    socialMediaServiceId: number
                    teamId?: number | null
                    updatedAt?: any | null
                    userId: number
                    profileCollectionEnabled: boolean
                    profileModerationEnabled: boolean
                    llmClassificationEnabled: boolean
                    llmEnableSuggestedReplies: boolean
                    socialMediaServiceShortName?: string | null
                    socialMediaServiceDisplayName?: string | null
                    hasAuthorisation: boolean
                    teamName?: string | null
                    ownedBy?: string | null
                    adsLastFetched?: any | null
                    postsLastFetched?: any | null
                    fetchPosts: boolean
                    fetchAds: boolean
                    retirePostDays: number
                    shadowBanningEnabled: boolean
                    shadowBanningThreshold: number
                    shadowBanningRangeInDays: number
                    dmsEnabled: boolean
                    engageAccountId?: number | null
                    instagramAuthMethod?: string | null
                    toggles: {
                        __typename?: 'AccountTogglesView'
                        crossProfileEngage: boolean
                        enableScreenshots: boolean
                    }
                }
                actions: Array<{
                    __typename?: 'ContentActionView'
                    id: number
                    action: string
                    actionOn: any
                    active: boolean
                    automated: boolean
                    contentId: number
                    queued: boolean
                    retryAt?: any | null
                    userId?: number | null
                    message?: string | null
                    replyContentId?: number | null
                    actionedByAccountId?: number | null
                }>
                media: Array<{
                    __typename?: 'ContentMediaView'
                    serviceMediaId: string
                    publicUrl: string
                    presignedUrl?: string | null
                    mediaType: string
                    mediaClassifications: Array<{
                        __typename?: 'ContentClassificationView'
                        classification?: number | null
                        classifierName: string
                    }>
                }>
                readReceipts: Array<{
                    __typename?: 'ReadReceiptView'
                    userId: number
                    contentOutcomeId: number
                    createdAt: any
                }>
                allClassifications: Array<{
                    __typename?: 'ContentClassificationView'
                    classifierName: string
                    classification?: number | null
                    classifierDisplayName?: string | null
                    result?: ClassificationResultView | null
                }>
            }
        }>
    }
}

export type AccountRecordItemFragment = {
    __typename?: 'AccountRecord'
    id: number
    accountName?: string | null
    autoDeleteSevereContent: boolean
    autoHideSevereContent: boolean
    autoMuteSevereAccount: boolean
    autoHideAllAdComments?: boolean | null
    classifyContent: boolean
    createdAt: any
    fetchContent: boolean
    isSubscribed: boolean
    lastFetched?: any | null
    latestFetchedServiceContentId?: string | null
    pageId?: string | null
    scrapeContent: boolean
    serviceAccountId: string
    serviceAccountUsername?: string | null
    socialMediaServiceId: number
    teamId?: number | null
    updatedAt?: any | null
    userId: number
    profileCollectionEnabled: boolean
    profileModerationEnabled: boolean
    llmClassificationEnabled: boolean
    llmEnableSuggestedReplies: boolean
    socialMediaServiceShortName?: string | null
    socialMediaServiceDisplayName?: string | null
    hasAuthorisation: boolean
    teamName?: string | null
    ownedBy?: string | null
    adsLastFetched?: any | null
    postsLastFetched?: any | null
    fetchPosts: boolean
    fetchAds: boolean
    retirePostDays: number
    shadowBanningEnabled: boolean
    shadowBanningThreshold: number
    shadowBanningRangeInDays: number
    dmsEnabled: boolean
    engageAccountId?: number | null
    instagramAuthMethod?: string | null
    toggles: {
        __typename?: 'AccountTogglesView'
        crossProfileEngage: boolean
        enableScreenshots: boolean
    }
}

export type DeleteAuthorisationMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type DeleteAuthorisationMutation = {
    __typename?: 'Mutation'
    deleteAuthorisation?: boolean | null
}

export type SaveAuthorisationCodeMutationVariables = Exact<{
    accountId?: InputMaybe<Scalars['Int']['input']>
    socialMediaServiceName?: InputMaybe<Scalars['String']['input']>
    baseUrl?: InputMaybe<Scalars['String']['input']>
    authCode: Scalars['String']['input']
    authVerifier?: InputMaybe<Scalars['String']['input']>
}>

export type SaveAuthorisationCodeMutation = {
    __typename?: 'Mutation'
    saveAuthorisationCode?: {
        __typename?: 'SaveAuthorisationCodeResponse'
        new: Array<number | null>
        updated: Array<number | null>
    } | null
}

export type SaveAuthorisationCodeResponseItemFragment = {
    __typename?: 'SaveAuthorisationCodeResponse'
    new: Array<number | null>
    updated: Array<number | null>
}

export type TakeContentActionMutationVariables = Exact<{
    contentId: Scalars['Int']['input']
    action: ContentAction
    toggle: Scalars['Boolean']['input']
    baseUrl?: InputMaybe<Scalars['String']['input']>
}>

export type TakeContentActionMutation = {
    __typename?: 'Mutation'
    takeContentAction?: {
        __typename?: 'TakeContentActionResponse'
        queued: boolean
        contentAction?: {
            __typename?: 'ContentActionBusiness'
            id?: number | null
            action: string
            actionOn: any
            automated: boolean
            active: boolean
            contentId: number
            createdAt: any
            updatedAt?: any | null
            userId?: number | null
            queued: boolean
            retryAt?: any | null
            message?: string | null
        } | null
    } | null
}

export type ContentActionBusinessItemFragment = {
    __typename?: 'ContentActionBusiness'
    id?: number | null
    action: string
    actionOn: any
    automated: boolean
    active: boolean
    contentId: number
    createdAt: any
    updatedAt?: any | null
    userId?: number | null
    queued: boolean
    retryAt?: any | null
    message?: string | null
}

export type TakeContentActionResponseItemFragment = {
    __typename?: 'TakeContentActionResponse'
    queued: boolean
    contentAction?: {
        __typename?: 'ContentActionBusiness'
        id?: number | null
        action: string
        actionOn: any
        automated: boolean
        active: boolean
        contentId: number
        createdAt: any
        updatedAt?: any | null
        userId?: number | null
        queued: boolean
        retryAt?: any | null
        message?: string | null
    } | null
}

export type TakeContentActionsMutationVariables = Exact<{
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
    action: ContentAction
    toggle: Scalars['Boolean']['input']
    baseUrl?: InputMaybe<Scalars['String']['input']>
}>

export type TakeContentActionsMutation = {
    __typename?: 'Mutation'
    takeContentActions?: {
        __typename?: 'TakeContentActionsResponse'
        contentActions?: Array<{
            __typename?: 'ContentActionBusiness'
            id?: number | null
            action: string
            actionOn: any
            automated: boolean
            active: boolean
            contentId: number
            createdAt: any
            updatedAt?: any | null
            userId?: number | null
            queued: boolean
            retryAt?: any | null
            message?: string | null
        } | null> | null
    } | null
}

export type TakeContentActionsResponseItemFragment = {
    __typename?: 'TakeContentActionsResponse'
    contentActions?: Array<{
        __typename?: 'ContentActionBusiness'
        id?: number | null
        action: string
        actionOn: any
        automated: boolean
        active: boolean
        contentId: number
        createdAt: any
        updatedAt?: any | null
        userId?: number | null
        queued: boolean
        retryAt?: any | null
        message?: string | null
    } | null> | null
}

export type ClassifyContentMutationVariables = Exact<{
    reason?: InputMaybe<Scalars['String']['input']>
}>

export type ClassifyContentMutation = { __typename?: 'Mutation'; classifyContent: number }

export type ModerateContentMutationVariables = Exact<{
    reason?: InputMaybe<Scalars['String']['input']>
}>

export type ModerateContentMutation = { __typename?: 'Mutation'; moderateContent: number }

export type FetchHistoricContentMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
    tweetsRequested: Scalars['Int']['input']
}>

export type FetchHistoricContentMutation = {
    __typename?: 'Mutation'
    fetchHistoricContent?: boolean | null
}

export type FetchHistoricYouTubeVideosMutationVariables = Exact<{
    accountId: Scalars['Int']['input']
}>

export type FetchHistoricYouTubeVideosMutation = {
    __typename?: 'Mutation'
    fetchHistoricYouTubeVideos?: boolean | null
}

export type CreatePaymentPortalMutationVariables = Exact<{
    successUrl: Scalars['String']['input']
    cancelUrl: Scalars['String']['input']
}>

export type CreatePaymentPortalMutation = { __typename?: 'Mutation'; createPaymentPortal: string }

export type AccountItemFragment = {
    __typename?: 'Account'
    id: number
    serviceAccountId: string
    serviceAccountUsername?: string | null
    accountName?: string | null
    authorised: boolean
    isAuthorisationFailing?: boolean | null
    createdAt?: any | null
    ownedBy?: string | null
    autoHideSevereContent: boolean
    autoMuteSevereAccount: boolean
    autoDeleteSevereContent: boolean
    isSubscribed: boolean
    autoFetchContent: boolean
    scrapeContent: boolean
    profileCollectionEnabled: boolean
    profileModerationEnabled: boolean
    llmClassificationEnabled: boolean
    fetchAds: boolean
    fetchPosts: boolean
    adsLastFetched?: any | null
    postsLastFetched?: any | null
    llmEnableSuggestedReplies: boolean
    dmsEnabled: boolean
    socialMediaService: {
        __typename?: 'SocialMediaService'
        id: number
        shortName: string
        displayName: string
        shortDescription: string
        longDescription?: string | null
    }
    team?: { __typename?: 'Team'; id: number; name: string; createdAt: any } | null
}

export type GetCustomerPaymentPortalUrlQueryVariables = Exact<{
    returnUrl: Scalars['String']['input']
}>

export type GetCustomerPaymentPortalUrlQuery = {
    __typename?: 'Query'
    getCustomerPaymentPortalUrl: { __typename?: 'CustomerPaymentPortal'; url?: string | null }
}

export type CountContentQueryVariables = Exact<{
    startDateTime: Scalars['AWSDateTime']['input']
    endDateTime: Scalars['AWSDateTime']['input']
    filter?: InputMaybe<ContentFilterInput>
    keyword?: InputMaybe<Scalars['String']['input']>
}>

export type CountContentQuery = {
    __typename?: 'Query'
    countContent?: { __typename?: 'CountContentConnection'; total?: number | null } | null
}

export type UserFragment = {
    __typename?: 'User'
    id: number
    username: string
    stripeCustomerId?: string | null
    stripeSubscriptionId?: string | null
    stripeSubscriptionStatus?: string | null
    shouldProvisionAccess: boolean
    dashboardEnabled?: boolean | null
    dashboardId?: string | null
    canLikeContent: boolean
    canReplyToContent: boolean
    canUseReadStatus: boolean
    feedsEnabled: boolean
    team?: { __typename?: 'Team'; id: number; name: string; createdAt: any } | null
    referrer?: {
        __typename?: 'Referrer'
        id: number
        referrer: string
        referrerUuid: string
        signUpEnabled: boolean
        userLimit?: number | null
        allowTrial: boolean
        trialDays?: number | null
        trialEndDate?: any | null
        creditCardRequired: boolean
        priceId?: string | null
        isCobranded: boolean
        isGuidedOnboarding: boolean
        logoUrl?: string | null
    } | null
}

export type ReferrerFragment = {
    __typename?: 'Referrer'
    id: number
    referrer: string
    referrerUuid: string
    signUpEnabled: boolean
    userLimit?: number | null
    allowTrial: boolean
    trialDays?: number | null
    trialEndDate?: any | null
    creditCardRequired: boolean
    priceId?: string | null
    isCobranded: boolean
    isGuidedOnboarding: boolean
    logoUrl?: string | null
}

export type ModerationItemFragment = {
    __typename?: 'Moderation'
    id: number
    moderation?: string | null
    moderatedOn: any
    dismissed?: boolean | null
}

export type ClassificationResultItemFragment = {
    __typename?: 'ClassificationResult'
    contentId: number
    classification: number
    classifier?: {
        __typename?: 'ClassifierDetails'
        id?: number | null
        shortName: string
        displayName: string
        shortDescription: string
        longDescription?: string | null
    } | null
}

export type FetchUserDetailsQueryVariables = Exact<{
    socialMediaService: SocialMediaServiceEnum
    serviceAccountUsername: Scalars['String']['input']
}>

export type FetchUserDetailsQuery = {
    __typename?: 'Query'
    fetchUserDetails?: {
        __typename?: 'FetchUserDetailsConnection'
        error?: {
            __typename?: 'FetchUserDetailsErrorDetails'
            message?: string | null
            type?: FetchUserDetailsError | null
        } | null
        userDetails?: {
            __typename?: 'FetchedUserDetails'
            username?: string | null
            serviceAccountId?: string | null
            name?: string | null
        } | null
    } | null
}

export type GetClassificationResultsQueryVariables = Exact<{
    contentId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetClassificationResultsQuery = {
    __typename?: 'Query'
    getClassificationResults: Array<{
        __typename?: 'ClassificationResult'
        contentId: number
        classification: number
        classifier?: {
            __typename?: 'ClassifierDetails'
            id?: number | null
            shortName: string
            displayName: string
            shortDescription: string
            longDescription?: string | null
        } | null
    }>
}

export type GetManyClassificationResultsQueryVariables = Exact<{
    contentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type GetManyClassificationResultsQuery = {
    __typename?: 'Query'
    getManyClassificationResults: Array<{
        __typename?: 'ClassificationResult'
        contentId: number
        classification: number
        classifier?: {
            __typename?: 'ClassifierDetails'
            id?: number | null
            shortName: string
            displayName: string
            shortDescription: string
            longDescription?: string | null
        } | null
    }>
}

export type GetAuthorisationUrlQueryVariables = Exact<{
    socialMediaService: SocialMediaServiceEnum
    accountId: Scalars['Int']['input']
    baseUrl: Scalars['String']['input']
}>

export type GetAuthorisationUrlQuery = { __typename?: 'Query'; getAuthorisationUrl: string }

export type GetUserSubscriptionQueryVariables = Exact<{
    referrer?: InputMaybe<Scalars['String']['input']>
}>

export type GetUserSubscriptionQuery = {
    __typename?: 'Query'
    getUserSubscription: {
        __typename?: 'User'
        id: number
        username: string
        stripeCustomerId?: string | null
        stripeSubscriptionId?: string | null
        stripeSubscriptionStatus?: string | null
        shouldProvisionAccess: boolean
        dashboardEnabled?: boolean | null
        dashboardId?: string | null
        canLikeContent: boolean
        canReplyToContent: boolean
        canUseReadStatus: boolean
        feedsEnabled: boolean
        team?: { __typename?: 'Team'; id: number; name: string; createdAt: any } | null
        referrer?: {
            __typename?: 'Referrer'
            id: number
            referrer: string
            referrerUuid: string
            signUpEnabled: boolean
            userLimit?: number | null
            allowTrial: boolean
            trialDays?: number | null
            trialEndDate?: any | null
            creditCardRequired: boolean
            priceId?: string | null
            isCobranded: boolean
            isGuidedOnboarding: boolean
            logoUrl?: string | null
        } | null
    }
}

export type GetTeamQueryVariables = Exact<{
    teamId: Scalars['Int']['input']
}>

export type GetTeamQuery = {
    __typename?: 'Query'
    getTeam?: {
        __typename?: 'Team'
        id: number
        name: string
        createdAt: any
        updatedAt?: any | null
        users?: Array<{ __typename?: 'User'; id: number; username: string }> | null
        accounts?: Array<{
            __typename?: 'Account'
            accountName?: string | null
            socialMediaService: { __typename?: 'SocialMediaService'; displayName: string }
        }> | null
    } | null
}

export type SpamSearchFragment = {
    __typename?: 'SpamSearchResult'
    contentId?: number | null
    similarityScore?: number | null
}

export type GetLabelledSpamQueryVariables = Exact<{
    message?: InputMaybe<Scalars['String']['input']>
    platform?: InputMaybe<Scalars['String']['input']>
    threshold?: InputMaybe<Scalars['Float']['input']>
}>

export type GetLabelledSpamQuery = {
    __typename?: 'Query'
    getLabelledSpam?: Array<{
        __typename?: 'SpamSearchResult'
        contentId?: number | null
        similarityScore?: number | null
    } | null> | null
}

export type EnrichedContentItemFragment = {
    __typename?: 'EnrichedContent'
    id: number
    serviceAuthorName?: string | null
    serviceAuthorUsername?: string | null
    originalPostId?: string | null
    originalPostLinkId?: string | null
}

export type EnrichContentQueryVariables = Exact<{
    contents: Array<ContentToEnrich> | ContentToEnrich
}>

export type EnrichContentQuery = {
    __typename?: 'Query'
    enrichContent: Array<{
        __typename?: 'EnrichedContent'
        id: number
        serviceAuthorName?: string | null
        serviceAuthorUsername?: string | null
        originalPostId?: string | null
        originalPostLinkId?: string | null
    }>
}

export const ContentActionViewFragmentDoc = gql`
    fragment ContentActionView on ContentActionView {
        id
        action
        actionOn
        automated
        active
        contentId
        userId
        queued
        retryAt
        message
        actionedByAccountId
    }
`
export const ContentActionResultFragmentDoc = gql`
    fragment ContentActionResult on ContentActionResult {
        success
        contentId
        contentAction {
            ...ContentActionView
        }
        message
    }
    ${ContentActionViewFragmentDoc}
`
export const TikTokSessionKeyItemFragmentDoc = gql`
    fragment TikTokSessionKeyItem on TikTokSessionKey {
        key
        expiry
    }
`
export const TikTokAuthorisedAccountItemFragmentDoc = gql`
    fragment TikTokAuthorisedAccountItem on AuthorisedAccountView {
        id
        serviceAccountUsername
        serviceAccountId
        accountName
        pageId
        isFailing
        failureDate
        lastFailureNotificationDate
        socialMediaServiceName
    }
`
export const TikTokUserAccountSelectionItemFragmentDoc = gql`
    fragment TikTokUserAccountSelectionItem on TikTokUserAccountSelectionView {
        key {
            ...TikTokSessionKeyItem
        }
        accountData {
            ...TikTokAuthorisedAccountItem
        }
    }
    ${TikTokSessionKeyItemFragmentDoc}
    ${TikTokAuthorisedAccountItemFragmentDoc}
`
export const TikTokAdAccountItemFragmentDoc = gql`
    fragment TikTokAdAccountItem on TikTokAdAccountView {
        advertiserId
        advertiserName
    }
`
export const TikTokAccountSelectionItemFragmentDoc = gql`
    fragment TikTokAccountSelectionItem on TikTokAccountSelectionView {
        key {
            ...TikTokSessionKeyItem
        }
        adAccounts {
            ...TikTokAdAccountItem
        }
    }
    ${TikTokSessionKeyItemFragmentDoc}
    ${TikTokAdAccountItemFragmentDoc}
`
export const TikTokAccountsSelectionItemFragmentDoc = gql`
    fragment TikTokAccountsSelectionItem on TikTokAccountSelectionView {
        key {
            ...TikTokSessionKeyItem
        }
    }
    ${TikTokSessionKeyItemFragmentDoc}
`
export const ClassifierSearchParamsViewItemFragmentDoc = gql`
    fragment ClassifierSearchParamsViewItem on ClassifierSearchParamsView {
        classifierName
        threshold
        category
    }
`
export const ContentSearchParamsViewItemFragmentDoc = gql`
    fragment ContentSearchParamsViewItem on ContentSearchParamsView {
        accountIds
        teamIds
        socialMediaServiceIds
        authorProfileIds
        since
        before
        timeDuration
        timeOffset
        containsText
        moderationCode
        moderationString
        skipResults
        maxResults
        adsOrOrganic
        contentIds
        postIds
        owned
        readFilter
        classifierSearchParams {
            ...ClassifierSearchParamsViewItem
        }
        excludeOwnComments
        dmFilter
        hasMedia
    }
    ${ClassifierSearchParamsViewItemFragmentDoc}
`
export const ContentFeedViewItemFragmentDoc = gql`
    fragment ContentFeedViewItem on ContentFeedView {
        id
        userId
        displayName
        description
        searchParameters {
            ...ContentSearchParamsViewItem
        }
        createdAt
        updatedAt
    }
    ${ContentSearchParamsViewItemFragmentDoc}
`
export const NotificationConfigurationViewItemFragmentDoc = gql`
    fragment NotificationConfigurationViewItem on NotificationConfigurationView {
        id
        accountId
        recipientListId
        notificationTemplateId
    }
`
export const DashboardViewItemFragmentDoc = gql`
    fragment DashboardViewItem on DashboardView {
        id
        displayName
        description
        extEmbeddedId
        createdAt
        updatedAt
    }
`
export const UserItemFragmentDoc = gql`
    fragment UserItem on UserView {
        id
        username
        createdOn
        stripeCustomerId
        stripeSubscriptionId
        stripeSubscriptionStatus
        dashboardId
        dashboardEnabled
        referrerId
        allowAccessOverride
        admin
        canLikeContent
        canReplyToContent
        canUseReadStatus
        feedsEnabled
        toggles {
            canModifyCrossProfileDefault
            canEngageCrossProfile
            canManageShadowBanning
            keywordsEnabled
            canViewScreenshots
            askArwenEnabled
            canLabelSpam
            canHideContent
            canDeleteContent
            canBlockUser
            canMuteUser
            conversationViewEnabled
        }
    }
`
export const EditableDashboardViewItemFragmentDoc = gql`
    fragment EditableDashboardViewItem on EditableDashboardView {
        dashboard {
            ...DashboardViewItem
        }
        users {
            ...UserItem
        }
    }
    ${DashboardViewItemFragmentDoc}
    ${UserItemFragmentDoc}
`
export const EmbeddedDashboardViewItemFragmentDoc = gql`
    fragment EmbeddedDashboardViewItem on EmbeddedDashboardView {
        dashboard {
            ...DashboardViewItem
        }
        guestToken
        workspaceUrl
    }
    ${DashboardViewItemFragmentDoc}
`
export const ModerationBoundaryViewItemFragmentDoc = gql`
    fragment ModerationBoundaryViewItem on ModerationBoundaryView {
        id
        account
        classifier {
            id
            shortName
            displayName
            shortDescription
            longDescription
        }
        queue
        probability
    }
`
export const PromptViewItemFragmentDoc = gql`
    fragment PromptViewItem on PromptView {
        id
        prompt
        model
        createdAt
    }
`
export const LlmModelInfoItemFragmentDoc = gql`
    fragment LlmModelInfoItem on LlmModelInfo {
        id
        displayName
        isDefault
    }
`
export const DebugTokenResponseViewItemFragmentDoc = gql`
    fragment DebugTokenResponseViewItem on DebugTokenResponseView {
        appId
        dataType
        application
        dataAccessExpiresAt
        expiresAt
        isValid
        issuedAt
        scopes
        userId
    }
`
export const TeamItemFragmentDoc = gql`
    fragment TeamItem on TeamView {
        id
        name
        createdAt
    }
`
export const ProfileItemFragmentDoc = gql`
    fragment ProfileItem on ProfileView {
        id
        username
        serviceProfileId
        followers
        following
        posts
        profileImageUrl
        profileUrl
        profileImagePath
    }
`
export const ProfileWithShadowBanItemFragmentDoc = gql`
    fragment ProfileWithShadowBanItem on ProfileViewWithShadowBan {
        id
        username
        serviceProfileId
        followers
        following
        posts
        profileImageUrl
        profileUrl
        profileImagePath
        shadowBanStatus
        shadowBanStatusCode
    }
`
export const ContentSummaryItemFragmentDoc = gql`
    fragment ContentSummaryItem on ContentSummary {
        countSafe
        countSuspect
        countSevere
    }
`
export const AccountRecordItemFragmentDoc = gql`
    fragment AccountRecordItem on AccountRecord {
        id
        accountName
        autoDeleteSevereContent
        autoHideSevereContent
        autoMuteSevereAccount
        autoHideAllAdComments
        classifyContent
        createdAt
        fetchContent
        isSubscribed
        lastFetched
        latestFetchedServiceContentId
        pageId
        scrapeContent
        serviceAccountId
        serviceAccountUsername
        socialMediaServiceId
        teamId
        updatedAt
        userId
        profileCollectionEnabled
        profileModerationEnabled
        llmClassificationEnabled
        llmEnableSuggestedReplies
        socialMediaServiceShortName
        socialMediaServiceDisplayName
        hasAuthorisation
        teamName
        ownedBy
        adsLastFetched
        postsLastFetched
        fetchPosts
        fetchAds
        retirePostDays
        shadowBanningEnabled
        shadowBanningThreshold
        shadowBanningRangeInDays
        dmsEnabled
        engageAccountId
        toggles {
            crossProfileEngage
            enableScreenshots
        }
        instagramAuthMethod
    }
`
export const ContentActionItemFragmentDoc = gql`
    fragment ContentActionItem on ContentActionView {
        id
        action
        actionOn
        active
        automated
        contentId
        queued
        retryAt
        userId
        message
        replyContentId
        actionedByAccountId
    }
`
export const ContentClassificationItemFragmentDoc = gql`
    fragment ContentClassificationItem on ContentClassificationView {
        classification
        classifierName
    }
`
export const ContentMediaItemFragmentDoc = gql`
    fragment ContentMediaItem on ContentMediaView {
        serviceMediaId
        publicUrl
        presignedUrl
        mediaType
        mediaClassifications {
            ...ContentClassificationItem
        }
    }
    ${ContentClassificationItemFragmentDoc}
`
export const ReadReceiptItemFragmentDoc = gql`
    fragment ReadReceiptItem on ReadReceiptView {
        userId
        contentOutcomeId
        createdAt
    }
`
export const ContentViewItemFragmentDoc = gql`
    fragment ContentViewItem on ContentView {
        id
        serviceContentId
        account {
            ...AccountRecordItem
        }
        content
        contentType
        socialMediaServiceName
        isPublic
        serviceAuthorId
        serviceAuthorName
        serviceAuthorDisplayUsername
        shouldEnrich
        moderation
        authorised
        socialMediaAuthorLink
        socialMediaPostLink
        socialMediaContentLink
        socialMediaContentName
        datePosted
        isReply
        inReplyToUserId
        inReplyToUsername
        inReplyToStatusId
        originalPostAuthorId
        originalPostAuthorName
        originalPostId
        originalPostLinkId
        originalPostLink
        actions {
            ...ContentActionItem
        }
        media {
            ...ContentMediaItem
        }
        readReceipts {
            ...ReadReceiptItem
        }
        allClassifications {
            classifierName
            classification
            classifierDisplayName
            result
        }
        isOwned
        authorProfileId
    }
    ${AccountRecordItemFragmentDoc}
    ${ContentActionItemFragmentDoc}
    ${ContentMediaItemFragmentDoc}
    ${ReadReceiptItemFragmentDoc}
`
export const ContentSearchTaskResultFieldsFragmentDoc = gql`
    fragment ContentSearchTaskResultFields on ContentSearchTaskResult {
        status
        startedAt
        completedAt
        elapsedMs
        message
        error
        results {
            ...ContentViewItem
        }
    }
    ${ContentViewItemFragmentDoc}
`
export const ContentClassifierMetadataItemFragmentDoc = gql`
    fragment ContentClassifierMetadataItem on ContentClassifierMetadataView {
        classifierName
        classifierDisplayName
        classifierId
        contentCount
    }
`
export const UserAuthEventItemFragmentDoc = gql`
    fragment UserAuthEventItem on UserAuthEventView {
        username
        eventType
        eventTimestamp
        eventResponse
        ipAddress
        deviceName
        city
        country
    }
`
export const DetectedLanguageItemFragmentDoc = gql`
    fragment DetectedLanguageItem on DetectedLanguageView {
        sourceText
        detectedSourceLanguage
    }
`
export const TranslatedTextItemFragmentDoc = gql`
    fragment TranslatedTextItem on TranslatedTextView {
        sourceText
        translatedText
        detectedSourceLanguage
    }
`
export const CookieSummaryItemFragmentDoc = gql`
    fragment CookieSummaryItem on CookieSummary {
        id
        platform
        serviceUsername
        status
        failCount
        lastUsedAt
        createdAt
        updatedAt
        notes
    }
`
export const ReferrerViewItemFragmentDoc = gql`
    fragment ReferrerViewItem on ReferrerView {
        id
        referrer
        referrerUuid
        signUpEnabled
        requireSubscription
        userLimit
        allowTrial
        trialDays
        trialEndDate
        creditCardRequired
        isCobranded
        logoUrl
        isGuidedOnboarding
        userCount
    }
`
export const ScreenshotItemFragmentDoc = gql`
    fragment ScreenshotItem on Screenshot {
        id
        contentId
        s3Url
        cookieId
        status
        errorMessage
        createdAt
    }
`
export const ScreenshotAttemptItemFragmentDoc = gql`
    fragment ScreenshotAttemptItem on ScreenshotAttempt {
        id
        contentId
        contentText
        s3Url
        cookieId
        status
        errorMessage
        logs
        createdAt
    }
`
export const ScreenshotContentSummaryItemFragmentDoc = gql`
    fragment ScreenshotContentSummaryItem on ScreenshotContentSummary {
        contentId
        contentText
        accountName
        authorName
        socialMediaService
        totalAttempts
        successCount
        failedCount
        pendingCount
        latestCreatedAt
        latestScreenshot {
            ...ScreenshotAttemptItem
        }
    }
    ${ScreenshotAttemptItemFragmentDoc}
`
export const ClassifierPromptItemFragmentDoc = gql`
    fragment ClassifierPromptItem on ClassifierPrompt {
        id
        classifierDetailsId
        version
        prompt
        model
        status
        defaultBorderlineThreshold
        defaultConfirmedThreshold
        createdBy
        updatedBy
        createdAt
        updatedAt
    }
`
export const ClassifierDetailFullItemFragmentDoc = gql`
    fragment ClassifierDetailFullItem on ClassifierDetailFull {
        id
        shortName
        displayName
        shortDescription
        longDescription
        clientFacingName
        modality
        valence
        archived
    }
`
export const ClassifierLibraryRowItemFragmentDoc = gql`
    fragment ClassifierLibraryRowItem on ClassifierLibraryRow {
        id
        displayName
        shortDescription
        modality
        valence
        model
        liveVersion
        draftVersion
        latestVersion
        versionCount
        updatedAt
        coveredProfiles
        coveredTeams
        archived
    }
`
export const AdminPostItemFragmentDoc = gql`
    fragment AdminPostItem on AdminPostView {
        id
        accountId
        accountName
        serviceAccountUsername
        socialMediaServiceId
        socialMediaServiceShortName
        teamId
        teamName
        servicePostId
        title
        uri
        publishTime
        createdAt
        lastFetched
        platformCommentCount
        platformCommentCountFetchedAt
        postType
        isAd
        isDeleted
        shouldFetch
        collectedCommentCount
        safeCount
        suspectCount
        severeCount
    }
`
export const CommentThreadItemFragmentDoc = gql`
    fragment CommentThreadItem on CommentThreadView {
        focusContentId
        post {
            id
            title
            uri
            publishTime
            commentCount
        }
        root {
            ...ContentViewItem
        }
        replies {
            ...ContentViewItem
        }
        parentMissing
        canRefresh
        notices
    }
    ${ContentViewItemFragmentDoc}
`
export const PostConversationReplyItemFragmentDoc = gql`
    fragment PostConversationReplyItem on PostConversationReplyView {
        matches
        awaitingModeration
        content {
            ...ContentViewItem
        }
    }
    ${ContentViewItemFragmentDoc}
`
export const PostConversationThreadItemFragmentDoc = gql`
    fragment PostConversationThreadItem on PostConversationThreadView {
        rootMatches
        rootAwaitingModeration
        replyCount
        repliesFilteredCount
        repliesAwaitingModerationCount
        hasMoreReplies
        root {
            ...ContentViewItem
        }
        replies {
            ...PostConversationReplyItem
        }
    }
    ${ContentViewItemFragmentDoc}
    ${PostConversationReplyItemFragmentDoc}
`
export const PostRefreshTaskItemFragmentDoc = gql`
    fragment PostRefreshTaskItem on PostRefreshTaskResult {
        status
        completedAt
        error
        outcome {
            ran
            platform
            notices
            newComments
        }
    }
`
export const SaveAuthorisationCodeResponseItemFragmentDoc = gql`
    fragment SaveAuthorisationCodeResponseItem on SaveAuthorisationCodeResponse {
        new
        updated
    }
`
export const ContentActionBusinessItemFragmentDoc = gql`
    fragment ContentActionBusinessItem on ContentActionBusiness {
        id
        action
        actionOn
        automated
        active
        contentId
        createdAt
        updatedAt
        userId
        queued
        retryAt
        message
    }
`
export const TakeContentActionResponseItemFragmentDoc = gql`
    fragment TakeContentActionResponseItem on TakeContentActionResponse {
        contentAction {
            ...ContentActionBusinessItem
        }
        queued
    }
    ${ContentActionBusinessItemFragmentDoc}
`
export const TakeContentActionsResponseItemFragmentDoc = gql`
    fragment TakeContentActionsResponseItem on TakeContentActionsResponse {
        contentActions {
            ...ContentActionBusinessItem
        }
    }
    ${ContentActionBusinessItemFragmentDoc}
`
export const AccountItemFragmentDoc = gql`
    fragment AccountItem on Account {
        id
        serviceAccountId
        serviceAccountUsername
        accountName
        authorised
        isAuthorisationFailing
        createdAt
        ownedBy
        socialMediaService {
            id
            shortName
            displayName
            shortDescription
            longDescription
        }
        autoHideSevereContent
        autoMuteSevereAccount
        autoDeleteSevereContent
        isSubscribed
        autoFetchContent
        scrapeContent
        profileCollectionEnabled
        profileModerationEnabled
        llmClassificationEnabled
        fetchAds
        fetchPosts
        adsLastFetched
        postsLastFetched
        team {
            id
            name
            createdAt
        }
        llmEnableSuggestedReplies
        dmsEnabled
    }
`
export const ReferrerFragmentDoc = gql`
    fragment Referrer on Referrer {
        id
        referrer
        referrerUuid
        signUpEnabled
        userLimit
        allowTrial
        trialDays
        trialEndDate
        creditCardRequired
        priceId
        isCobranded
        isGuidedOnboarding
        logoUrl
    }
`
export const UserFragmentDoc = gql`
    fragment User on User {
        id
        username
        stripeCustomerId
        stripeSubscriptionId
        stripeSubscriptionStatus
        shouldProvisionAccess
        team {
            id
            name
            createdAt
        }
        dashboardEnabled
        dashboardId
        referrer {
            ...Referrer
        }
        canLikeContent
        canReplyToContent
        canUseReadStatus
        feedsEnabled
    }
    ${ReferrerFragmentDoc}
`
export const ModerationItemFragmentDoc = gql`
    fragment ModerationItem on Moderation {
        id
        moderation
        moderatedOn
        dismissed
    }
`
export const ClassificationResultItemFragmentDoc = gql`
    fragment ClassificationResultItem on ClassificationResult {
        contentId
        classification
        classifier {
            id
            shortName
            displayName
            shortDescription
            longDescription
        }
    }
`
export const SpamSearchFragmentDoc = gql`
    fragment SpamSearch on SpamSearchResult {
        contentId
        similarityScore
    }
`
export const EnrichedContentItemFragmentDoc = gql`
    fragment EnrichedContentItem on EnrichedContent {
        id
        serviceAuthorName
        serviceAuthorUsername
        originalPostId
        originalPostLinkId
    }
`
export const SetAccountToggleDocument = gql`
    mutation setAccountToggle($accountId: Int!, $toggleName: String!, $value: Boolean!) {
        setAccountToggle(accountId: $accountId, toggleName: $toggleName, value: $value)
    }
`
export type SetAccountToggleMutationFn = Apollo.MutationFunction<
    SetAccountToggleMutation,
    SetAccountToggleMutationVariables
>

/**
 * __useSetAccountToggleMutation__
 *
 * To run a mutation, you first call `useSetAccountToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccountToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccountToggleMutation, { data, loading, error }] = useSetAccountToggleMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      toggleName: // value for 'toggleName'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetAccountToggleMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetAccountToggleMutation,
        SetAccountToggleMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<SetAccountToggleMutation, SetAccountToggleMutationVariables>(
        SetAccountToggleDocument,
        options
    )
}
export type SetAccountToggleMutationHookResult = ReturnType<typeof useSetAccountToggleMutation>
export type SetAccountToggleMutationResult = Apollo.MutationResult<SetAccountToggleMutation>
export type SetAccountToggleMutationOptions = Apollo.BaseMutationOptions<
    SetAccountToggleMutation,
    SetAccountToggleMutationVariables
>
export const SetUserToggleDocument = gql`
    mutation setUserToggle($userId: Int!, $toggleName: String!, $value: Boolean!) {
        setUserToggle(userId: $userId, toggleName: $toggleName, value: $value)
    }
`
export type SetUserToggleMutationFn = Apollo.MutationFunction<
    SetUserToggleMutation,
    SetUserToggleMutationVariables
>

/**
 * __useSetUserToggleMutation__
 *
 * To run a mutation, you first call `useSetUserToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserToggleMutation, { data, loading, error }] = useSetUserToggleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      toggleName: // value for 'toggleName'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetUserToggleMutation(
    baseOptions?: Apollo.MutationHookOptions<SetUserToggleMutation, SetUserToggleMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<SetUserToggleMutation, SetUserToggleMutationVariables>(
        SetUserToggleDocument,
        options
    )
}
export type SetUserToggleMutationHookResult = ReturnType<typeof useSetUserToggleMutation>
export type SetUserToggleMutationResult = Apollo.MutationResult<SetUserToggleMutation>
export type SetUserToggleMutationOptions = Apollo.BaseMutationOptions<
    SetUserToggleMutation,
    SetUserToggleMutationVariables
>
export const CreateContentFeedDocument = gql`
    mutation createContentFeed($contentFeedNew: ContentFeedCreate!) {
        createContentFeed(contentFeed: $contentFeedNew) {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`
export type CreateContentFeedMutationFn = Apollo.MutationFunction<
    CreateContentFeedMutation,
    CreateContentFeedMutationVariables
>

/**
 * __useCreateContentFeedMutation__
 *
 * To run a mutation, you first call `useCreateContentFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentFeedMutation, { data, loading, error }] = useCreateContentFeedMutation({
 *   variables: {
 *      contentFeedNew: // value for 'contentFeedNew'
 *   },
 * });
 */
export function useCreateContentFeedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateContentFeedMutation,
        CreateContentFeedMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateContentFeedMutation, CreateContentFeedMutationVariables>(
        CreateContentFeedDocument,
        options
    )
}
export type CreateContentFeedMutationHookResult = ReturnType<typeof useCreateContentFeedMutation>
export type CreateContentFeedMutationResult = Apollo.MutationResult<CreateContentFeedMutation>
export type CreateContentFeedMutationOptions = Apollo.BaseMutationOptions<
    CreateContentFeedMutation,
    CreateContentFeedMutationVariables
>
export const DeleteContentFeedDocument = gql`
    mutation deleteContentFeed($contentFeedId: Int!) {
        deleteContentFeed(contentFeedId: $contentFeedId) {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`
export type DeleteContentFeedMutationFn = Apollo.MutationFunction<
    DeleteContentFeedMutation,
    DeleteContentFeedMutationVariables
>

/**
 * __useDeleteContentFeedMutation__
 *
 * To run a mutation, you first call `useDeleteContentFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentFeedMutation, { data, loading, error }] = useDeleteContentFeedMutation({
 *   variables: {
 *      contentFeedId: // value for 'contentFeedId'
 *   },
 * });
 */
export function useDeleteContentFeedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteContentFeedMutation,
        DeleteContentFeedMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteContentFeedMutation, DeleteContentFeedMutationVariables>(
        DeleteContentFeedDocument,
        options
    )
}
export type DeleteContentFeedMutationHookResult = ReturnType<typeof useDeleteContentFeedMutation>
export type DeleteContentFeedMutationResult = Apollo.MutationResult<DeleteContentFeedMutation>
export type DeleteContentFeedMutationOptions = Apollo.BaseMutationOptions<
    DeleteContentFeedMutation,
    DeleteContentFeedMutationVariables
>
export const UpdateContentFeedDocument = gql`
    mutation updateContentFeed($contentFeedUpdate: ContentFeedUpdate!) {
        updateContentFeed(contentFeed: $contentFeedUpdate) {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`
export type UpdateContentFeedMutationFn = Apollo.MutationFunction<
    UpdateContentFeedMutation,
    UpdateContentFeedMutationVariables
>

/**
 * __useUpdateContentFeedMutation__
 *
 * To run a mutation, you first call `useUpdateContentFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentFeedMutation, { data, loading, error }] = useUpdateContentFeedMutation({
 *   variables: {
 *      contentFeedUpdate: // value for 'contentFeedUpdate'
 *   },
 * });
 */
export function useUpdateContentFeedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateContentFeedMutation,
        UpdateContentFeedMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateContentFeedMutation, UpdateContentFeedMutationVariables>(
        UpdateContentFeedDocument,
        options
    )
}
export type UpdateContentFeedMutationHookResult = ReturnType<typeof useUpdateContentFeedMutation>
export type UpdateContentFeedMutationResult = Apollo.MutationResult<UpdateContentFeedMutation>
export type UpdateContentFeedMutationOptions = Apollo.BaseMutationOptions<
    UpdateContentFeedMutation,
    UpdateContentFeedMutationVariables
>
export const CreateDashboardDocument = gql`
    mutation createDashboard($dashboard: NewDashboardView!) {
        createDashboard(dashboard: $dashboard) {
            ...DashboardViewItem
        }
    }
    ${DashboardViewItemFragmentDoc}
`
export type CreateDashboardMutationFn = Apollo.MutationFunction<
    CreateDashboardMutation,
    CreateDashboardMutationVariables
>

/**
 * __useCreateDashboardMutation__
 *
 * To run a mutation, you first call `useCreateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardMutation, { data, loading, error }] = useCreateDashboardMutation({
 *   variables: {
 *      dashboard: // value for 'dashboard'
 *   },
 * });
 */
export function useCreateDashboardMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateDashboardMutation,
        CreateDashboardMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateDashboardMutation, CreateDashboardMutationVariables>(
        CreateDashboardDocument,
        options
    )
}
export type CreateDashboardMutationHookResult = ReturnType<typeof useCreateDashboardMutation>
export type CreateDashboardMutationResult = Apollo.MutationResult<CreateDashboardMutation>
export type CreateDashboardMutationOptions = Apollo.BaseMutationOptions<
    CreateDashboardMutation,
    CreateDashboardMutationVariables
>
export const DeleteDashboardDocument = gql`
    mutation deleteDashboard($dashboardId: Int!) {
        deleteDashboard(dashboardId: $dashboardId)
    }
`
export type DeleteDashboardMutationFn = Apollo.MutationFunction<
    DeleteDashboardMutation,
    DeleteDashboardMutationVariables
>

/**
 * __useDeleteDashboardMutation__
 *
 * To run a mutation, you first call `useDeleteDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDashboardMutation, { data, loading, error }] = useDeleteDashboardMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useDeleteDashboardMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteDashboardMutation,
        DeleteDashboardMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteDashboardMutation, DeleteDashboardMutationVariables>(
        DeleteDashboardDocument,
        options
    )
}
export type DeleteDashboardMutationHookResult = ReturnType<typeof useDeleteDashboardMutation>
export type DeleteDashboardMutationResult = Apollo.MutationResult<DeleteDashboardMutation>
export type DeleteDashboardMutationOptions = Apollo.BaseMutationOptions<
    DeleteDashboardMutation,
    DeleteDashboardMutationVariables
>
export const UpdateDashboardDocument = gql`
    mutation updateDashboard($dashboard: UpdatedDashboardView!) {
        updateDashboard(dashboard: $dashboard)
    }
`
export type UpdateDashboardMutationFn = Apollo.MutationFunction<
    UpdateDashboardMutation,
    UpdateDashboardMutationVariables
>

/**
 * __useUpdateDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardMutation, { data, loading, error }] = useUpdateDashboardMutation({
 *   variables: {
 *      dashboard: // value for 'dashboard'
 *   },
 * });
 */
export function useUpdateDashboardMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateDashboardMutation,
        UpdateDashboardMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateDashboardMutation, UpdateDashboardMutationVariables>(
        UpdateDashboardDocument,
        options
    )
}
export type UpdateDashboardMutationHookResult = ReturnType<typeof useUpdateDashboardMutation>
export type UpdateDashboardMutationResult = Apollo.MutationResult<UpdateDashboardMutation>
export type UpdateDashboardMutationOptions = Apollo.BaseMutationOptions<
    UpdateDashboardMutation,
    UpdateDashboardMutationVariables
>
export const GiveUserAccessToDashboardDocument = gql`
    mutation giveUserAccessToDashboard($userId: Int!, $dashboardId: Int!) {
        giveUserAccessToDashboard(userId: $userId, dashboardId: $dashboardId)
    }
`
export type GiveUserAccessToDashboardMutationFn = Apollo.MutationFunction<
    GiveUserAccessToDashboardMutation,
    GiveUserAccessToDashboardMutationVariables
>

/**
 * __useGiveUserAccessToDashboardMutation__
 *
 * To run a mutation, you first call `useGiveUserAccessToDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveUserAccessToDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveUserAccessToDashboardMutation, { data, loading, error }] = useGiveUserAccessToDashboardMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useGiveUserAccessToDashboardMutation(
    baseOptions?: Apollo.MutationHookOptions<
        GiveUserAccessToDashboardMutation,
        GiveUserAccessToDashboardMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        GiveUserAccessToDashboardMutation,
        GiveUserAccessToDashboardMutationVariables
    >(GiveUserAccessToDashboardDocument, options)
}
export type GiveUserAccessToDashboardMutationHookResult = ReturnType<
    typeof useGiveUserAccessToDashboardMutation
>
export type GiveUserAccessToDashboardMutationResult =
    Apollo.MutationResult<GiveUserAccessToDashboardMutation>
export type GiveUserAccessToDashboardMutationOptions = Apollo.BaseMutationOptions<
    GiveUserAccessToDashboardMutation,
    GiveUserAccessToDashboardMutationVariables
>
export const CreateReadReceiptDocument = gql`
    mutation createReadReceipt($contentId: Int!) {
        createReadReceipt(contentId: $contentId) {
            ...ReadReceiptItem
        }
    }
    ${ReadReceiptItemFragmentDoc}
`
export type CreateReadReceiptMutationFn = Apollo.MutationFunction<
    CreateReadReceiptMutation,
    CreateReadReceiptMutationVariables
>

/**
 * __useCreateReadReceiptMutation__
 *
 * To run a mutation, you first call `useCreateReadReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReadReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReadReceiptMutation, { data, loading, error }] = useCreateReadReceiptMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useCreateReadReceiptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateReadReceiptMutation,
        CreateReadReceiptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateReadReceiptMutation, CreateReadReceiptMutationVariables>(
        CreateReadReceiptDocument,
        options
    )
}
export type CreateReadReceiptMutationHookResult = ReturnType<typeof useCreateReadReceiptMutation>
export type CreateReadReceiptMutationResult = Apollo.MutationResult<CreateReadReceiptMutation>
export type CreateReadReceiptMutationOptions = Apollo.BaseMutationOptions<
    CreateReadReceiptMutation,
    CreateReadReceiptMutationVariables
>
export const CreateReadReceiptsDocument = gql`
    mutation createReadReceipts($contentIds: [Int!]!) {
        createReadReceipts(contentIds: $contentIds) {
            ...ReadReceiptItem
        }
    }
    ${ReadReceiptItemFragmentDoc}
`
export type CreateReadReceiptsMutationFn = Apollo.MutationFunction<
    CreateReadReceiptsMutation,
    CreateReadReceiptsMutationVariables
>

/**
 * __useCreateReadReceiptsMutation__
 *
 * To run a mutation, you first call `useCreateReadReceiptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReadReceiptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReadReceiptsMutation, { data, loading, error }] = useCreateReadReceiptsMutation({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useCreateReadReceiptsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateReadReceiptsMutation,
        CreateReadReceiptsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateReadReceiptsMutation, CreateReadReceiptsMutationVariables>(
        CreateReadReceiptsDocument,
        options
    )
}
export type CreateReadReceiptsMutationHookResult = ReturnType<typeof useCreateReadReceiptsMutation>
export type CreateReadReceiptsMutationResult = Apollo.MutationResult<CreateReadReceiptsMutation>
export type CreateReadReceiptsMutationOptions = Apollo.BaseMutationOptions<
    CreateReadReceiptsMutation,
    CreateReadReceiptsMutationVariables
>
export const DeleteReadReceiptDocument = gql`
    mutation deleteReadReceipt($contentId: Int!) {
        deleteReadReceipt(contentId: $contentId) {
            ...ReadReceiptItem
        }
    }
    ${ReadReceiptItemFragmentDoc}
`
export type DeleteReadReceiptMutationFn = Apollo.MutationFunction<
    DeleteReadReceiptMutation,
    DeleteReadReceiptMutationVariables
>

/**
 * __useDeleteReadReceiptMutation__
 *
 * To run a mutation, you first call `useDeleteReadReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReadReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReadReceiptMutation, { data, loading, error }] = useDeleteReadReceiptMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useDeleteReadReceiptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteReadReceiptMutation,
        DeleteReadReceiptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteReadReceiptMutation, DeleteReadReceiptMutationVariables>(
        DeleteReadReceiptDocument,
        options
    )
}
export type DeleteReadReceiptMutationHookResult = ReturnType<typeof useDeleteReadReceiptMutation>
export type DeleteReadReceiptMutationResult = Apollo.MutationResult<DeleteReadReceiptMutation>
export type DeleteReadReceiptMutationOptions = Apollo.BaseMutationOptions<
    DeleteReadReceiptMutation,
    DeleteReadReceiptMutationVariables
>
export const DeleteReadReceiptsDocument = gql`
    mutation deleteReadReceipts($contentIds: [Int!]!) {
        deleteReadReceipts(contentIds: $contentIds) {
            ...ReadReceiptItem
        }
    }
    ${ReadReceiptItemFragmentDoc}
`
export type DeleteReadReceiptsMutationFn = Apollo.MutationFunction<
    DeleteReadReceiptsMutation,
    DeleteReadReceiptsMutationVariables
>

/**
 * __useDeleteReadReceiptsMutation__
 *
 * To run a mutation, you first call `useDeleteReadReceiptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReadReceiptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReadReceiptsMutation, { data, loading, error }] = useDeleteReadReceiptsMutation({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useDeleteReadReceiptsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteReadReceiptsMutation,
        DeleteReadReceiptsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteReadReceiptsMutation, DeleteReadReceiptsMutationVariables>(
        DeleteReadReceiptsDocument,
        options
    )
}
export type DeleteReadReceiptsMutationHookResult = ReturnType<typeof useDeleteReadReceiptsMutation>
export type DeleteReadReceiptsMutationResult = Apollo.MutationResult<DeleteReadReceiptsMutation>
export type DeleteReadReceiptsMutationOptions = Apollo.BaseMutationOptions<
    DeleteReadReceiptsMutation,
    DeleteReadReceiptsMutationVariables
>
export const CreateNotificationConfigurationDocument = gql`
    mutation createNotificationConfiguration(
        $accountId: Int!
        $recipientListId: String!
        $notificationTemplateId: String!
    ) {
        createNotificationConfiguration(
            accountId: $accountId
            recipientListId: $recipientListId
            notificationTemplateId: $notificationTemplateId
        ) {
            ...NotificationConfigurationViewItem
        }
    }
    ${NotificationConfigurationViewItemFragmentDoc}
`
export type CreateNotificationConfigurationMutationFn = Apollo.MutationFunction<
    CreateNotificationConfigurationMutation,
    CreateNotificationConfigurationMutationVariables
>

/**
 * __useCreateNotificationConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateNotificationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationConfigurationMutation, { data, loading, error }] = useCreateNotificationConfigurationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      recipientListId: // value for 'recipientListId'
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useCreateNotificationConfigurationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateNotificationConfigurationMutation,
        CreateNotificationConfigurationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateNotificationConfigurationMutation,
        CreateNotificationConfigurationMutationVariables
    >(CreateNotificationConfigurationDocument, options)
}
export type CreateNotificationConfigurationMutationHookResult = ReturnType<
    typeof useCreateNotificationConfigurationMutation
>
export type CreateNotificationConfigurationMutationResult =
    Apollo.MutationResult<CreateNotificationConfigurationMutation>
export type CreateNotificationConfigurationMutationOptions = Apollo.BaseMutationOptions<
    CreateNotificationConfigurationMutation,
    CreateNotificationConfigurationMutationVariables
>
export const DeleteNotificationConfigurationDocument = gql`
    mutation deleteNotificationConfiguration($notificationConfigurationId: Int!) {
        deleteNotificationConfiguration(notificationConfigurationId: $notificationConfigurationId) {
            ...NotificationConfigurationViewItem
        }
    }
    ${NotificationConfigurationViewItemFragmentDoc}
`
export type DeleteNotificationConfigurationMutationFn = Apollo.MutationFunction<
    DeleteNotificationConfigurationMutation,
    DeleteNotificationConfigurationMutationVariables
>

/**
 * __useDeleteNotificationConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationConfigurationMutation, { data, loading, error }] = useDeleteNotificationConfigurationMutation({
 *   variables: {
 *      notificationConfigurationId: // value for 'notificationConfigurationId'
 *   },
 * });
 */
export function useDeleteNotificationConfigurationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteNotificationConfigurationMutation,
        DeleteNotificationConfigurationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeleteNotificationConfigurationMutation,
        DeleteNotificationConfigurationMutationVariables
    >(DeleteNotificationConfigurationDocument, options)
}
export type DeleteNotificationConfigurationMutationHookResult = ReturnType<
    typeof useDeleteNotificationConfigurationMutation
>
export type DeleteNotificationConfigurationMutationResult =
    Apollo.MutationResult<DeleteNotificationConfigurationMutation>
export type DeleteNotificationConfigurationMutationOptions = Apollo.BaseMutationOptions<
    DeleteNotificationConfigurationMutation,
    DeleteNotificationConfigurationMutationVariables
>
export const UpdateNotificationConfigurationDocument = gql`
    mutation updateNotificationConfiguration(
        $notificationConfigurationId: Int!
        $accountId: Int!
        $recipientListId: String!
        $notificationTemplateId: String!
    ) {
        updateNotificationConfiguration(
            id: $notificationConfigurationId
            accountId: $accountId
            recipientListId: $recipientListId
            notificationTemplateId: $notificationTemplateId
        ) {
            ...NotificationConfigurationViewItem
        }
    }
    ${NotificationConfigurationViewItemFragmentDoc}
`
export type UpdateNotificationConfigurationMutationFn = Apollo.MutationFunction<
    UpdateNotificationConfigurationMutation,
    UpdateNotificationConfigurationMutationVariables
>

/**
 * __useUpdateNotificationConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationConfigurationMutation, { data, loading, error }] = useUpdateNotificationConfigurationMutation({
 *   variables: {
 *      notificationConfigurationId: // value for 'notificationConfigurationId'
 *      accountId: // value for 'accountId'
 *      recipientListId: // value for 'recipientListId'
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useUpdateNotificationConfigurationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateNotificationConfigurationMutation,
        UpdateNotificationConfigurationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateNotificationConfigurationMutation,
        UpdateNotificationConfigurationMutationVariables
    >(UpdateNotificationConfigurationDocument, options)
}
export type UpdateNotificationConfigurationMutationHookResult = ReturnType<
    typeof useUpdateNotificationConfigurationMutation
>
export type UpdateNotificationConfigurationMutationResult =
    Apollo.MutationResult<UpdateNotificationConfigurationMutation>
export type UpdateNotificationConfigurationMutationOptions = Apollo.BaseMutationOptions<
    UpdateNotificationConfigurationMutation,
    UpdateNotificationConfigurationMutationVariables
>
export const UpdateModerationBoundaryDocument = gql`
    mutation updateModerationBoundary($moderationBoundaryInput: ModerationBoundaryInput!) {
        updateModerationBoundary(moderationBoundary: $moderationBoundaryInput) {
            ...ModerationBoundaryViewItem
        }
    }
    ${ModerationBoundaryViewItemFragmentDoc}
`
export type UpdateModerationBoundaryMutationFn = Apollo.MutationFunction<
    UpdateModerationBoundaryMutation,
    UpdateModerationBoundaryMutationVariables
>

/**
 * __useUpdateModerationBoundaryMutation__
 *
 * To run a mutation, you first call `useUpdateModerationBoundaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModerationBoundaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModerationBoundaryMutation, { data, loading, error }] = useUpdateModerationBoundaryMutation({
 *   variables: {
 *      moderationBoundaryInput: // value for 'moderationBoundaryInput'
 *   },
 * });
 */
export function useUpdateModerationBoundaryMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateModerationBoundaryMutation,
        UpdateModerationBoundaryMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateModerationBoundaryMutation,
        UpdateModerationBoundaryMutationVariables
    >(UpdateModerationBoundaryDocument, options)
}
export type UpdateModerationBoundaryMutationHookResult = ReturnType<
    typeof useUpdateModerationBoundaryMutation
>
export type UpdateModerationBoundaryMutationResult =
    Apollo.MutationResult<UpdateModerationBoundaryMutation>
export type UpdateModerationBoundaryMutationOptions = Apollo.BaseMutationOptions<
    UpdateModerationBoundaryMutation,
    UpdateModerationBoundaryMutationVariables
>
export const CaptureScreenshotDocument = gql`
    mutation captureScreenshot($contentId: Int!) {
        captureScreenshot(contentId: $contentId) {
            ...ScreenshotAttemptItem
        }
    }
    ${ScreenshotAttemptItemFragmentDoc}
`
export type CaptureScreenshotMutationFn = Apollo.MutationFunction<
    CaptureScreenshotMutation,
    CaptureScreenshotMutationVariables
>

/**
 * __useCaptureScreenshotMutation__
 *
 * To run a mutation, you first call `useCaptureScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCaptureScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [captureScreenshotMutation, { data, loading, error }] = useCaptureScreenshotMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useCaptureScreenshotMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CaptureScreenshotMutation,
        CaptureScreenshotMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CaptureScreenshotMutation, CaptureScreenshotMutationVariables>(
        CaptureScreenshotDocument,
        options
    )
}
export type CaptureScreenshotMutationHookResult = ReturnType<typeof useCaptureScreenshotMutation>
export type CaptureScreenshotMutationResult = Apollo.MutationResult<CaptureScreenshotMutation>
export type CaptureScreenshotMutationOptions = Apollo.BaseMutationOptions<
    CaptureScreenshotMutation,
    CaptureScreenshotMutationVariables
>
export const CreateModerationBoundaryDocument = gql`
    mutation createModerationBoundary($moderationBoundary: ModerationBoundaryCreate!) {
        createModerationBoundary(moderationBoundary: $moderationBoundary) {
            ...ModerationBoundaryViewItem
        }
    }
    ${ModerationBoundaryViewItemFragmentDoc}
`
export type CreateModerationBoundaryMutationFn = Apollo.MutationFunction<
    CreateModerationBoundaryMutation,
    CreateModerationBoundaryMutationVariables
>

/**
 * __useCreateModerationBoundaryMutation__
 *
 * To run a mutation, you first call `useCreateModerationBoundaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModerationBoundaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModerationBoundaryMutation, { data, loading, error }] = useCreateModerationBoundaryMutation({
 *   variables: {
 *      moderationBoundary: // value for 'moderationBoundary'
 *   },
 * });
 */
export function useCreateModerationBoundaryMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateModerationBoundaryMutation,
        CreateModerationBoundaryMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateModerationBoundaryMutation,
        CreateModerationBoundaryMutationVariables
    >(CreateModerationBoundaryDocument, options)
}
export type CreateModerationBoundaryMutationHookResult = ReturnType<
    typeof useCreateModerationBoundaryMutation
>
export type CreateModerationBoundaryMutationResult =
    Apollo.MutationResult<CreateModerationBoundaryMutation>
export type CreateModerationBoundaryMutationOptions = Apollo.BaseMutationOptions<
    CreateModerationBoundaryMutation,
    CreateModerationBoundaryMutationVariables
>
export const DeleteModerationBoundaryDocument = gql`
    mutation deleteModerationBoundary($moderationBoundaryId: Int!) {
        deleteModerationBoundary(moderationBoundaryId: $moderationBoundaryId) {
            ...ModerationBoundaryViewItem
        }
    }
    ${ModerationBoundaryViewItemFragmentDoc}
`
export type DeleteModerationBoundaryMutationFn = Apollo.MutationFunction<
    DeleteModerationBoundaryMutation,
    DeleteModerationBoundaryMutationVariables
>

/**
 * __useDeleteModerationBoundaryMutation__
 *
 * To run a mutation, you first call `useDeleteModerationBoundaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModerationBoundaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModerationBoundaryMutation, { data, loading, error }] = useDeleteModerationBoundaryMutation({
 *   variables: {
 *      moderationBoundaryId: // value for 'moderationBoundaryId'
 *   },
 * });
 */
export function useDeleteModerationBoundaryMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteModerationBoundaryMutation,
        DeleteModerationBoundaryMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeleteModerationBoundaryMutation,
        DeleteModerationBoundaryMutationVariables
    >(DeleteModerationBoundaryDocument, options)
}
export type DeleteModerationBoundaryMutationHookResult = ReturnType<
    typeof useDeleteModerationBoundaryMutation
>
export type DeleteModerationBoundaryMutationResult =
    Apollo.MutationResult<DeleteModerationBoundaryMutation>
export type DeleteModerationBoundaryMutationOptions = Apollo.BaseMutationOptions<
    DeleteModerationBoundaryMutation,
    DeleteModerationBoundaryMutationVariables
>
export const BulkUpdateModerationBoundaryDocument = gql`
    mutation bulkUpdateModerationBoundary(
        $accountId: Int!
        $moderationBoundaries: [ModerationBoundaryCreate!]!
    ) {
        bulkUpdateModerationBoundary(
            accountId: $accountId
            moderationBoundaries: $moderationBoundaries
        )
    }
`
export type BulkUpdateModerationBoundaryMutationFn = Apollo.MutationFunction<
    BulkUpdateModerationBoundaryMutation,
    BulkUpdateModerationBoundaryMutationVariables
>

/**
 * __useBulkUpdateModerationBoundaryMutation__
 *
 * To run a mutation, you first call `useBulkUpdateModerationBoundaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateModerationBoundaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateModerationBoundaryMutation, { data, loading, error }] = useBulkUpdateModerationBoundaryMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      moderationBoundaries: // value for 'moderationBoundaries'
 *   },
 * });
 */
export function useBulkUpdateModerationBoundaryMutation(
    baseOptions?: Apollo.MutationHookOptions<
        BulkUpdateModerationBoundaryMutation,
        BulkUpdateModerationBoundaryMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        BulkUpdateModerationBoundaryMutation,
        BulkUpdateModerationBoundaryMutationVariables
    >(BulkUpdateModerationBoundaryDocument, options)
}
export type BulkUpdateModerationBoundaryMutationHookResult = ReturnType<
    typeof useBulkUpdateModerationBoundaryMutation
>
export type BulkUpdateModerationBoundaryMutationResult =
    Apollo.MutationResult<BulkUpdateModerationBoundaryMutation>
export type BulkUpdateModerationBoundaryMutationOptions = Apollo.BaseMutationOptions<
    BulkUpdateModerationBoundaryMutation,
    BulkUpdateModerationBoundaryMutationVariables
>
export const CopyModerationBoundariesDocument = gql`
    mutation copyModerationBoundaries($sourceAccountId: Int!, $targetAccountIds: [Int!]!) {
        copyModerationBoundaries(
            sourceAccountId: $sourceAccountId
            targetAccountIds: $targetAccountIds
        )
    }
`
export type CopyModerationBoundariesMutationFn = Apollo.MutationFunction<
    CopyModerationBoundariesMutation,
    CopyModerationBoundariesMutationVariables
>

/**
 * __useCopyModerationBoundariesMutation__
 *
 * To run a mutation, you first call `useCopyModerationBoundariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyModerationBoundariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyModerationBoundariesMutation, { data, loading, error }] = useCopyModerationBoundariesMutation({
 *   variables: {
 *      sourceAccountId: // value for 'sourceAccountId'
 *      targetAccountIds: // value for 'targetAccountIds'
 *   },
 * });
 */
export function useCopyModerationBoundariesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CopyModerationBoundariesMutation,
        CopyModerationBoundariesMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CopyModerationBoundariesMutation,
        CopyModerationBoundariesMutationVariables
    >(CopyModerationBoundariesDocument, options)
}
export type CopyModerationBoundariesMutationHookResult = ReturnType<
    typeof useCopyModerationBoundariesMutation
>
export type CopyModerationBoundariesMutationResult =
    Apollo.MutationResult<CopyModerationBoundariesMutation>
export type CopyModerationBoundariesMutationOptions = Apollo.BaseMutationOptions<
    CopyModerationBoundariesMutation,
    CopyModerationBoundariesMutationVariables
>
export const SaveLlmReplyPromptDocument = gql`
    mutation saveLlmReplyPrompt($accountId: Int!, $prompt: String!, $model: String) {
        saveLlmReplyPrompt(accountId: $accountId, prompt: $prompt, model: $model) {
            ...PromptViewItem
        }
    }
    ${PromptViewItemFragmentDoc}
`
export type SaveLlmReplyPromptMutationFn = Apollo.MutationFunction<
    SaveLlmReplyPromptMutation,
    SaveLlmReplyPromptMutationVariables
>

/**
 * __useSaveLlmReplyPromptMutation__
 *
 * To run a mutation, you first call `useSaveLlmReplyPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLlmReplyPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLlmReplyPromptMutation, { data, loading, error }] = useSaveLlmReplyPromptMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      prompt: // value for 'prompt'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useSaveLlmReplyPromptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SaveLlmReplyPromptMutation,
        SaveLlmReplyPromptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<SaveLlmReplyPromptMutation, SaveLlmReplyPromptMutationVariables>(
        SaveLlmReplyPromptDocument,
        options
    )
}
export type SaveLlmReplyPromptMutationHookResult = ReturnType<typeof useSaveLlmReplyPromptMutation>
export type SaveLlmReplyPromptMutationResult = Apollo.MutationResult<SaveLlmReplyPromptMutation>
export type SaveLlmReplyPromptMutationOptions = Apollo.BaseMutationOptions<
    SaveLlmReplyPromptMutation,
    SaveLlmReplyPromptMutationVariables
>
export const LikeContentDocument = gql`
    mutation likeContent($like: Boolean!, $contentIds: [Int!]!, $actionByAccountIdOverride: Int) {
        likeContent(
            like: $like
            contentIds: $contentIds
            actionByAccountIdOverride: $actionByAccountIdOverride
        ) {
            ...ContentActionResult
        }
    }
    ${ContentActionResultFragmentDoc}
`
export type LikeContentMutationFn = Apollo.MutationFunction<
    LikeContentMutation,
    LikeContentMutationVariables
>

/**
 * __useLikeContentMutation__
 *
 * To run a mutation, you first call `useLikeContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeContentMutation, { data, loading, error }] = useLikeContentMutation({
 *   variables: {
 *      like: // value for 'like'
 *      contentIds: // value for 'contentIds'
 *      actionByAccountIdOverride: // value for 'actionByAccountIdOverride'
 *   },
 * });
 */
export function useLikeContentMutation(
    baseOptions?: Apollo.MutationHookOptions<LikeContentMutation, LikeContentMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<LikeContentMutation, LikeContentMutationVariables>(
        LikeContentDocument,
        options
    )
}
export type LikeContentMutationHookResult = ReturnType<typeof useLikeContentMutation>
export type LikeContentMutationResult = Apollo.MutationResult<LikeContentMutation>
export type LikeContentMutationOptions = Apollo.BaseMutationOptions<
    LikeContentMutation,
    LikeContentMutationVariables
>
export const ReplyToContentDocument = gql`
    mutation replyToContent(
        $message: String!
        $contentId: Int!
        $suggestedReplies: [String!]
        $actionByAccountIdOverride: Int
    ) {
        replyToContent(
            message: $message
            contentId: $contentId
            suggestedReplies: $suggestedReplies
            actionByAccountIdOverride: $actionByAccountIdOverride
        ) {
            ...ContentActionView
        }
    }
    ${ContentActionViewFragmentDoc}
`
export type ReplyToContentMutationFn = Apollo.MutationFunction<
    ReplyToContentMutation,
    ReplyToContentMutationVariables
>

/**
 * __useReplyToContentMutation__
 *
 * To run a mutation, you first call `useReplyToContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToContentMutation, { data, loading, error }] = useReplyToContentMutation({
 *   variables: {
 *      message: // value for 'message'
 *      contentId: // value for 'contentId'
 *      suggestedReplies: // value for 'suggestedReplies'
 *      actionByAccountIdOverride: // value for 'actionByAccountIdOverride'
 *   },
 * });
 */
export function useReplyToContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ReplyToContentMutation,
        ReplyToContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ReplyToContentMutation, ReplyToContentMutationVariables>(
        ReplyToContentDocument,
        options
    )
}
export type ReplyToContentMutationHookResult = ReturnType<typeof useReplyToContentMutation>
export type ReplyToContentMutationResult = Apollo.MutationResult<ReplyToContentMutation>
export type ReplyToContentMutationOptions = Apollo.BaseMutationOptions<
    ReplyToContentMutation,
    ReplyToContentMutationVariables
>
export const EditAccountTeamDocument = gql`
    mutation editAccountTeam($accountId: Int!, $teamId: Int) {
        editAccountTeam(accountId: $accountId, teamId: $teamId) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type EditAccountTeamMutationFn = Apollo.MutationFunction<
    EditAccountTeamMutation,
    EditAccountTeamMutationVariables
>

/**
 * __useEditAccountTeamMutation__
 *
 * To run a mutation, you first call `useEditAccountTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAccountTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAccountTeamMutation, { data, loading, error }] = useEditAccountTeamMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useEditAccountTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EditAccountTeamMutation,
        EditAccountTeamMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditAccountTeamMutation, EditAccountTeamMutationVariables>(
        EditAccountTeamDocument,
        options
    )
}
export type EditAccountTeamMutationHookResult = ReturnType<typeof useEditAccountTeamMutation>
export type EditAccountTeamMutationResult = Apollo.MutationResult<EditAccountTeamMutation>
export type EditAccountTeamMutationOptions = Apollo.BaseMutationOptions<
    EditAccountTeamMutation,
    EditAccountTeamMutationVariables
>
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($accountId: Int!, $authCode: String) {
        deleteAccount(accountId: $accountId, authCode: $authCode)
    }
`
export type DeleteAccountMutationFn = Apollo.MutationFunction<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
>

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      authCode: // value for 'authCode'
 *   },
 * });
 */
export function useDeleteAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(
        DeleteAccountDocument,
        options
    )
}
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
    DeleteAccountMutation,
    DeleteAccountMutationVariables
>
export const CreateAccountDocument = gql`
    mutation CreateAccount(
        $serviceAccountId: String!
        $accountName: String!
        $serviceAccountUsername: String!
        $description: String
        $serviceName: String!
    ) {
        createAccount(
            serviceAccountId: $serviceAccountId
            accountName: $accountName
            serviceAccountUsername: $serviceAccountUsername
            description: $description
            serviceName: $serviceName
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type CreateAccountMutationFn = Apollo.MutationFunction<
    CreateAccountMutation,
    CreateAccountMutationVariables
>

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      serviceAccountId: // value for 'serviceAccountId'
 *      accountName: // value for 'accountName'
 *      serviceAccountUsername: // value for 'serviceAccountUsername'
 *      description: // value for 'description'
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useCreateAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(
        CreateAccountDocument,
        options
    )
}
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<
    CreateAccountMutation,
    CreateAccountMutationVariables
>
export const CreateMonitoredAccountDocument = gql`
    mutation CreateMonitoredAccount(
        $serviceAccountUsername: String!
        $serviceName: String!
        $teamId: Int!
        $accountName: String
        $youtubeChannelId: String
    ) {
        createMonitoredAccount(
            serviceAccountUsername: $serviceAccountUsername
            serviceName: $serviceName
            teamId: $teamId
            accountName: $accountName
            youtubeChannelId: $youtubeChannelId
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type CreateMonitoredAccountMutationFn = Apollo.MutationFunction<
    CreateMonitoredAccountMutation,
    CreateMonitoredAccountMutationVariables
>

/**
 * __useCreateMonitoredAccountMutation__
 *
 * To run a mutation, you first call `useCreateMonitoredAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitoredAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitoredAccountMutation, { data, loading, error }] = useCreateMonitoredAccountMutation({
 *   variables: {
 *      serviceAccountUsername: // value for 'serviceAccountUsername'
 *      serviceName: // value for 'serviceName'
 *      teamId: // value for 'teamId'
 *      accountName: // value for 'accountName'
 *      youtubeChannelId: // value for 'youtubeChannelId'
 *   },
 * });
 */
export function useCreateMonitoredAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateMonitoredAccountMutation,
        CreateMonitoredAccountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateMonitoredAccountMutation,
        CreateMonitoredAccountMutationVariables
    >(CreateMonitoredAccountDocument, options)
}
export type CreateMonitoredAccountMutationHookResult = ReturnType<
    typeof useCreateMonitoredAccountMutation
>
export type CreateMonitoredAccountMutationResult =
    Apollo.MutationResult<CreateMonitoredAccountMutation>
export type CreateMonitoredAccountMutationOptions = Apollo.BaseMutationOptions<
    CreateMonitoredAccountMutation,
    CreateMonitoredAccountMutationVariables
>
export const UpdateAccountDocument = gql`
    mutation UpdateAccount(
        $id: Int!
        $accountName: String
        $autoMuteSevereAccount: Boolean
        $autoHideSevereContent: Boolean
        $autoDeleteSevereContent: Boolean
        $isSubscribed: Boolean
    ) {
        updateAccount(
            id: $id
            accountName: $accountName
            autoMuteSevereAccount: $autoMuteSevereAccount
            autoHideSevereContent: $autoHideSevereContent
            autoDeleteSevereContent: $autoDeleteSevereContent
            isSubscribed: $isSubscribed
        )
    }
`
export type UpdateAccountMutationFn = Apollo.MutationFunction<
    UpdateAccountMutation,
    UpdateAccountMutationVariables
>

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountName: // value for 'accountName'
 *      autoMuteSevereAccount: // value for 'autoMuteSevereAccount'
 *      autoHideSevereContent: // value for 'autoHideSevereContent'
 *      autoDeleteSevereContent: // value for 'autoDeleteSevereContent'
 *      isSubscribed: // value for 'isSubscribed'
 *   },
 * });
 */
export function useUpdateAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(
        UpdateAccountDocument,
        options
    )
}
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<
    UpdateAccountMutation,
    UpdateAccountMutationVariables
>
export const UpdateShadowBanningDocument = gql`
    mutation updateShadowBanning(
        $accountId: Int!
        $enabled: Boolean!
        $threshold: Int!
        $rangeInDays: Int!
    ) {
        updateShadowBanning(
            accountId: $accountId
            enabled: $enabled
            threshold: $threshold
            rangeInDays: $rangeInDays
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateShadowBanningMutationFn = Apollo.MutationFunction<
    UpdateShadowBanningMutation,
    UpdateShadowBanningMutationVariables
>

/**
 * __useUpdateShadowBanningMutation__
 *
 * To run a mutation, you first call `useUpdateShadowBanningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShadowBanningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShadowBanningMutation, { data, loading, error }] = useUpdateShadowBanningMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      enabled: // value for 'enabled'
 *      threshold: // value for 'threshold'
 *      rangeInDays: // value for 'rangeInDays'
 *   },
 * });
 */
export function useUpdateShadowBanningMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateShadowBanningMutation,
        UpdateShadowBanningMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateShadowBanningMutation, UpdateShadowBanningMutationVariables>(
        UpdateShadowBanningDocument,
        options
    )
}
export type UpdateShadowBanningMutationHookResult = ReturnType<
    typeof useUpdateShadowBanningMutation
>
export type UpdateShadowBanningMutationResult = Apollo.MutationResult<UpdateShadowBanningMutation>
export type UpdateShadowBanningMutationOptions = Apollo.BaseMutationOptions<
    UpdateShadowBanningMutation,
    UpdateShadowBanningMutationVariables
>
export const SetManualShadowBanForAccountDocument = gql`
    mutation setManualShadowBanForAccount(
        $accountId: Int!
        $profileId: Int
        $contentId: Int
        $enabled: Boolean!
    ) {
        setManualShadowBanForAccount(
            accountId: $accountId
            profileId: $profileId
            contentId: $contentId
            enabled: $enabled
        ) {
            success
            profileId
        }
    }
`
export type SetManualShadowBanForAccountMutationFn = Apollo.MutationFunction<
    SetManualShadowBanForAccountMutation,
    SetManualShadowBanForAccountMutationVariables
>

/**
 * __useSetManualShadowBanForAccountMutation__
 *
 * To run a mutation, you first call `useSetManualShadowBanForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetManualShadowBanForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setManualShadowBanForAccountMutation, { data, loading, error }] = useSetManualShadowBanForAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      profileId: // value for 'profileId'
 *      contentId: // value for 'contentId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetManualShadowBanForAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetManualShadowBanForAccountMutation,
        SetManualShadowBanForAccountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        SetManualShadowBanForAccountMutation,
        SetManualShadowBanForAccountMutationVariables
    >(SetManualShadowBanForAccountDocument, options)
}
export type SetManualShadowBanForAccountMutationHookResult = ReturnType<
    typeof useSetManualShadowBanForAccountMutation
>
export type SetManualShadowBanForAccountMutationResult =
    Apollo.MutationResult<SetManualShadowBanForAccountMutation>
export type SetManualShadowBanForAccountMutationOptions = Apollo.BaseMutationOptions<
    SetManualShadowBanForAccountMutation,
    SetManualShadowBanForAccountMutationVariables
>
export const RemoveManualShadowBanForAccountDocument = gql`
    mutation removeManualShadowBanForAccount($accountId: Int!, $profileId: Int!) {
        removeManualShadowBanForAccount(accountId: $accountId, profileId: $profileId) {
            success
            profileId
        }
    }
`
export type RemoveManualShadowBanForAccountMutationFn = Apollo.MutationFunction<
    RemoveManualShadowBanForAccountMutation,
    RemoveManualShadowBanForAccountMutationVariables
>

/**
 * __useRemoveManualShadowBanForAccountMutation__
 *
 * To run a mutation, you first call `useRemoveManualShadowBanForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveManualShadowBanForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeManualShadowBanForAccountMutation, { data, loading, error }] = useRemoveManualShadowBanForAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useRemoveManualShadowBanForAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RemoveManualShadowBanForAccountMutation,
        RemoveManualShadowBanForAccountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        RemoveManualShadowBanForAccountMutation,
        RemoveManualShadowBanForAccountMutationVariables
    >(RemoveManualShadowBanForAccountDocument, options)
}
export type RemoveManualShadowBanForAccountMutationHookResult = ReturnType<
    typeof useRemoveManualShadowBanForAccountMutation
>
export type RemoveManualShadowBanForAccountMutationResult =
    Apollo.MutationResult<RemoveManualShadowBanForAccountMutation>
export type RemoveManualShadowBanForAccountMutationOptions = Apollo.BaseMutationOptions<
    RemoveManualShadowBanForAccountMutation,
    RemoveManualShadowBanForAccountMutationVariables
>
export const ToggleDmsDocument = gql`
    mutation toggleDms($accountId: Int!, $enabled: Boolean!) {
        toggleDms(accountId: $accountId, enabled: $enabled) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type ToggleDmsMutationFn = Apollo.MutationFunction<
    ToggleDmsMutation,
    ToggleDmsMutationVariables
>

/**
 * __useToggleDmsMutation__
 *
 * To run a mutation, you first call `useToggleDmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDmsMutation, { data, loading, error }] = useToggleDmsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleDmsMutation(
    baseOptions?: Apollo.MutationHookOptions<ToggleDmsMutation, ToggleDmsMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ToggleDmsMutation, ToggleDmsMutationVariables>(
        ToggleDmsDocument,
        options
    )
}
export type ToggleDmsMutationHookResult = ReturnType<typeof useToggleDmsMutation>
export type ToggleDmsMutationResult = Apollo.MutationResult<ToggleDmsMutation>
export type ToggleDmsMutationOptions = Apollo.BaseMutationOptions<
    ToggleDmsMutation,
    ToggleDmsMutationVariables
>
export const RefreshMessengerConversationsDocument = gql`
    mutation refreshMessengerConversations($accountId: Int!) {
        refreshMessengerConversations(accountId: $accountId)
    }
`
export type RefreshMessengerConversationsMutationFn = Apollo.MutationFunction<
    RefreshMessengerConversationsMutation,
    RefreshMessengerConversationsMutationVariables
>

/**
 * __useRefreshMessengerConversationsMutation__
 *
 * To run a mutation, you first call `useRefreshMessengerConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMessengerConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMessengerConversationsMutation, { data, loading, error }] = useRefreshMessengerConversationsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRefreshMessengerConversationsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RefreshMessengerConversationsMutation,
        RefreshMessengerConversationsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        RefreshMessengerConversationsMutation,
        RefreshMessengerConversationsMutationVariables
    >(RefreshMessengerConversationsDocument, options)
}
export type RefreshMessengerConversationsMutationHookResult = ReturnType<
    typeof useRefreshMessengerConversationsMutation
>
export type RefreshMessengerConversationsMutationResult =
    Apollo.MutationResult<RefreshMessengerConversationsMutation>
export type RefreshMessengerConversationsMutationOptions = Apollo.BaseMutationOptions<
    RefreshMessengerConversationsMutation,
    RefreshMessengerConversationsMutationVariables
>
export const RemoveSpamItemsDocument = gql`
    mutation removeSpamItems($contentIds: [Int!]!) {
        removeSpamItems(contentIds: $contentIds)
    }
`
export type RemoveSpamItemsMutationFn = Apollo.MutationFunction<
    RemoveSpamItemsMutation,
    RemoveSpamItemsMutationVariables
>

/**
 * __useRemoveSpamItemsMutation__
 *
 * To run a mutation, you first call `useRemoveSpamItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSpamItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSpamItemsMutation, { data, loading, error }] = useRemoveSpamItemsMutation({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useRemoveSpamItemsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RemoveSpamItemsMutation,
        RemoveSpamItemsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RemoveSpamItemsMutation, RemoveSpamItemsMutationVariables>(
        RemoveSpamItemsDocument,
        options
    )
}
export type RemoveSpamItemsMutationHookResult = ReturnType<typeof useRemoveSpamItemsMutation>
export type RemoveSpamItemsMutationResult = Apollo.MutationResult<RemoveSpamItemsMutation>
export type RemoveSpamItemsMutationOptions = Apollo.BaseMutationOptions<
    RemoveSpamItemsMutation,
    RemoveSpamItemsMutationVariables
>
export const CreateTeamDocument = gql`
    mutation createTeam($teamName: String!) {
        createTeam(teamName: $teamName) {
            id
            name
            createdAt
        }
    }
`
export type CreateTeamMutationFn = Apollo.MutationFunction<
    CreateTeamMutation,
    CreateTeamMutationVariables
>

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useCreateTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(
        CreateTeamDocument,
        options
    )
}
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<
    CreateTeamMutation,
    CreateTeamMutationVariables
>
export const EditTeamDocument = gql`
    mutation editTeam($teamId: Int!, $name: String!) {
        editTeam(teamId: $teamId, name: $name) {
            id
            name
        }
    }
`
export type EditTeamMutationFn = Apollo.MutationFunction<
    EditTeamMutation,
    EditTeamMutationVariables
>

/**
 * __useEditTeamMutation__
 *
 * To run a mutation, you first call `useEditTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTeamMutation, { data, loading, error }] = useEditTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<EditTeamMutation, EditTeamMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditTeamMutation, EditTeamMutationVariables>(
        EditTeamDocument,
        options
    )
}
export type EditTeamMutationHookResult = ReturnType<typeof useEditTeamMutation>
export type EditTeamMutationResult = Apollo.MutationResult<EditTeamMutation>
export type EditTeamMutationOptions = Apollo.BaseMutationOptions<
    EditTeamMutation,
    EditTeamMutationVariables
>
export const DeleteTeamDocument = gql`
    mutation deleteTeam($teamId: Int!, $force: Boolean!) {
        deleteTeam(teamId: $teamId, force: $force)
    }
`
export type DeleteTeamMutationFn = Apollo.MutationFunction<
    DeleteTeamMutation,
    DeleteTeamMutationVariables
>

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useDeleteTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(
        DeleteTeamDocument,
        options
    )
}
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<
    DeleteTeamMutation,
    DeleteTeamMutationVariables
>
export const CreateKeywordDocument = gql`
    mutation createKeyword($params: CreateKeywordParamsView!) {
        createKeyword(params: $params) {
            keyword
            regex
            allowableRegex
            description
            accountId
            classifierDetailsId
        }
    }
`
export type CreateKeywordMutationFn = Apollo.MutationFunction<
    CreateKeywordMutation,
    CreateKeywordMutationVariables
>

/**
 * __useCreateKeywordMutation__
 *
 * To run a mutation, you first call `useCreateKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeywordMutation, { data, loading, error }] = useCreateKeywordMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateKeywordMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateKeywordMutation, CreateKeywordMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateKeywordMutation, CreateKeywordMutationVariables>(
        CreateKeywordDocument,
        options
    )
}
export type CreateKeywordMutationHookResult = ReturnType<typeof useCreateKeywordMutation>
export type CreateKeywordMutationResult = Apollo.MutationResult<CreateKeywordMutation>
export type CreateKeywordMutationOptions = Apollo.BaseMutationOptions<
    CreateKeywordMutation,
    CreateKeywordMutationVariables
>
export const DeleteKeywordDocument = gql`
    mutation deleteKeyword($keywordId: Int!) {
        deleteKeyword(keywordId: $keywordId)
    }
`
export type DeleteKeywordMutationFn = Apollo.MutationFunction<
    DeleteKeywordMutation,
    DeleteKeywordMutationVariables
>

/**
 * __useDeleteKeywordMutation__
 *
 * To run a mutation, you first call `useDeleteKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeywordMutation, { data, loading, error }] = useDeleteKeywordMutation({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *   },
 * });
 */
export function useDeleteKeywordMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteKeywordMutation, DeleteKeywordMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteKeywordMutation, DeleteKeywordMutationVariables>(
        DeleteKeywordDocument,
        options
    )
}
export type DeleteKeywordMutationHookResult = ReturnType<typeof useDeleteKeywordMutation>
export type DeleteKeywordMutationResult = Apollo.MutationResult<DeleteKeywordMutation>
export type DeleteKeywordMutationOptions = Apollo.BaseMutationOptions<
    DeleteKeywordMutation,
    DeleteKeywordMutationVariables
>
export const CopyKeywordsToAccountDocument = gql`
    mutation copyKeywordsToAccount($sourceAccountId: Int!, $targetAccountId: Int!) {
        copyKeywordsToAccount(sourceAccountId: $sourceAccountId, targetAccountId: $targetAccountId)
    }
`
export type CopyKeywordsToAccountMutationFn = Apollo.MutationFunction<
    CopyKeywordsToAccountMutation,
    CopyKeywordsToAccountMutationVariables
>

/**
 * __useCopyKeywordsToAccountMutation__
 *
 * To run a mutation, you first call `useCopyKeywordsToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyKeywordsToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyKeywordsToAccountMutation, { data, loading, error }] = useCopyKeywordsToAccountMutation({
 *   variables: {
 *      sourceAccountId: // value for 'sourceAccountId'
 *      targetAccountId: // value for 'targetAccountId'
 *   },
 * });
 */
export function useCopyKeywordsToAccountMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CopyKeywordsToAccountMutation,
        CopyKeywordsToAccountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CopyKeywordsToAccountMutation,
        CopyKeywordsToAccountMutationVariables
    >(CopyKeywordsToAccountDocument, options)
}
export type CopyKeywordsToAccountMutationHookResult = ReturnType<
    typeof useCopyKeywordsToAccountMutation
>
export type CopyKeywordsToAccountMutationResult =
    Apollo.MutationResult<CopyKeywordsToAccountMutation>
export type CopyKeywordsToAccountMutationOptions = Apollo.BaseMutationOptions<
    CopyKeywordsToAccountMutation,
    CopyKeywordsToAccountMutationVariables
>
export const ValidateUserIdentityDocument = gql`
    mutation validateUserIdentity($referrerUuid: String) {
        validateUserIdentity(referrerUuid: $referrerUuid) {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`
export type ValidateUserIdentityMutationFn = Apollo.MutationFunction<
    ValidateUserIdentityMutation,
    ValidateUserIdentityMutationVariables
>

/**
 * __useValidateUserIdentityMutation__
 *
 * To run a mutation, you first call `useValidateUserIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateUserIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateUserIdentityMutation, { data, loading, error }] = useValidateUserIdentityMutation({
 *   variables: {
 *      referrerUuid: // value for 'referrerUuid'
 *   },
 * });
 */
export function useValidateUserIdentityMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ValidateUserIdentityMutation,
        ValidateUserIdentityMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ValidateUserIdentityMutation, ValidateUserIdentityMutationVariables>(
        ValidateUserIdentityDocument,
        options
    )
}
export type ValidateUserIdentityMutationHookResult = ReturnType<
    typeof useValidateUserIdentityMutation
>
export type ValidateUserIdentityMutationResult = Apollo.MutationResult<ValidateUserIdentityMutation>
export type ValidateUserIdentityMutationOptions = Apollo.BaseMutationOptions<
    ValidateUserIdentityMutation,
    ValidateUserIdentityMutationVariables
>
export const AddDocument = gql`
    mutation add {
        validateUserIdentity {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`
export type AddMutationFn = Apollo.MutationFunction<AddMutation, AddMutationVariables>

/**
 * __useAddMutation__
 *
 * To run a mutation, you first call `useAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMutation, { data, loading, error }] = useAddMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddMutation(
    baseOptions?: Apollo.MutationHookOptions<AddMutation, AddMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AddMutation, AddMutationVariables>(AddDocument, options)
}
export type AddMutationHookResult = ReturnType<typeof useAddMutation>
export type AddMutationResult = Apollo.MutationResult<AddMutation>
export type AddMutationOptions = Apollo.BaseMutationOptions<AddMutation, AddMutationVariables>
export const AddDefaultKeywordsDocument = gql`
    mutation addDefaultKeywords($accountId: Int!, $reset: Boolean!) {
        addDefaultKeywords(accountId: $accountId, reset: $reset)
    }
`
export type AddDefaultKeywordsMutationFn = Apollo.MutationFunction<
    AddDefaultKeywordsMutation,
    AddDefaultKeywordsMutationVariables
>

/**
 * __useAddDefaultKeywordsMutation__
 *
 * To run a mutation, you first call `useAddDefaultKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDefaultKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDefaultKeywordsMutation, { data, loading, error }] = useAddDefaultKeywordsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      reset: // value for 'reset'
 *   },
 * });
 */
export function useAddDefaultKeywordsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddDefaultKeywordsMutation,
        AddDefaultKeywordsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AddDefaultKeywordsMutation, AddDefaultKeywordsMutationVariables>(
        AddDefaultKeywordsDocument,
        options
    )
}
export type AddDefaultKeywordsMutationHookResult = ReturnType<typeof useAddDefaultKeywordsMutation>
export type AddDefaultKeywordsMutationResult = Apollo.MutationResult<AddDefaultKeywordsMutation>
export type AddDefaultKeywordsMutationOptions = Apollo.BaseMutationOptions<
    AddDefaultKeywordsMutation,
    AddDefaultKeywordsMutationVariables
>
export const UpdateEngageAccountIdDocument = gql`
    mutation updateEngageAccountId($accountId: Int!, $engageAccountId: Int!) {
        updateEngageAccountId(accountId: $accountId, engageAccountId: $engageAccountId) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateEngageAccountIdMutationFn = Apollo.MutationFunction<
    UpdateEngageAccountIdMutation,
    UpdateEngageAccountIdMutationVariables
>

/**
 * __useUpdateEngageAccountIdMutation__
 *
 * To run a mutation, you first call `useUpdateEngageAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngageAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngageAccountIdMutation, { data, loading, error }] = useUpdateEngageAccountIdMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      engageAccountId: // value for 'engageAccountId'
 *   },
 * });
 */
export function useUpdateEngageAccountIdMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateEngageAccountIdMutation,
        UpdateEngageAccountIdMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateEngageAccountIdMutation,
        UpdateEngageAccountIdMutationVariables
    >(UpdateEngageAccountIdDocument, options)
}
export type UpdateEngageAccountIdMutationHookResult = ReturnType<
    typeof useUpdateEngageAccountIdMutation
>
export type UpdateEngageAccountIdMutationResult =
    Apollo.MutationResult<UpdateEngageAccountIdMutation>
export type UpdateEngageAccountIdMutationOptions = Apollo.BaseMutationOptions<
    UpdateEngageAccountIdMutation,
    UpdateEngageAccountIdMutationVariables
>
export const UpdateScrapeContentDocument = gql`
    mutation updateScrapeContent($accountId: Int!, $scrapeContent: Boolean!) {
        updateScrapeContent(accountId: $accountId, scrapeContent: $scrapeContent) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateScrapeContentMutationFn = Apollo.MutationFunction<
    UpdateScrapeContentMutation,
    UpdateScrapeContentMutationVariables
>

/**
 * __useUpdateScrapeContentMutation__
 *
 * To run a mutation, you first call `useUpdateScrapeContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScrapeContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScrapeContentMutation, { data, loading, error }] = useUpdateScrapeContentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      scrapeContent: // value for 'scrapeContent'
 *   },
 * });
 */
export function useUpdateScrapeContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateScrapeContentMutation,
        UpdateScrapeContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateScrapeContentMutation, UpdateScrapeContentMutationVariables>(
        UpdateScrapeContentDocument,
        options
    )
}
export type UpdateScrapeContentMutationHookResult = ReturnType<
    typeof useUpdateScrapeContentMutation
>
export type UpdateScrapeContentMutationResult = Apollo.MutationResult<UpdateScrapeContentMutation>
export type UpdateScrapeContentMutationOptions = Apollo.BaseMutationOptions<
    UpdateScrapeContentMutation,
    UpdateScrapeContentMutationVariables
>
export const UpdateAutoFetchContentDocument = gql`
    mutation updateAutoFetchContent($accountId: Int!, $autoFetchContent: Boolean!) {
        updateAutoFetchContent(accountId: $accountId, autoFetchContent: $autoFetchContent) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateAutoFetchContentMutationFn = Apollo.MutationFunction<
    UpdateAutoFetchContentMutation,
    UpdateAutoFetchContentMutationVariables
>

/**
 * __useUpdateAutoFetchContentMutation__
 *
 * To run a mutation, you first call `useUpdateAutoFetchContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoFetchContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoFetchContentMutation, { data, loading, error }] = useUpdateAutoFetchContentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      autoFetchContent: // value for 'autoFetchContent'
 *   },
 * });
 */
export function useUpdateAutoFetchContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateAutoFetchContentMutation,
        UpdateAutoFetchContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateAutoFetchContentMutation,
        UpdateAutoFetchContentMutationVariables
    >(UpdateAutoFetchContentDocument, options)
}
export type UpdateAutoFetchContentMutationHookResult = ReturnType<
    typeof useUpdateAutoFetchContentMutation
>
export type UpdateAutoFetchContentMutationResult =
    Apollo.MutationResult<UpdateAutoFetchContentMutation>
export type UpdateAutoFetchContentMutationOptions = Apollo.BaseMutationOptions<
    UpdateAutoFetchContentMutation,
    UpdateAutoFetchContentMutationVariables
>
export const UpdateRetirePostDaysDocument = gql`
    mutation updateRetirePostDays($accountId: Int!, $retirePostDays: Int!) {
        updateRetirePostDays(accountId: $accountId, retirePostDays: $retirePostDays) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateRetirePostDaysMutationFn = Apollo.MutationFunction<
    UpdateRetirePostDaysMutation,
    UpdateRetirePostDaysMutationVariables
>

/**
 * __useUpdateRetirePostDaysMutation__
 *
 * To run a mutation, you first call `useUpdateRetirePostDaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRetirePostDaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRetirePostDaysMutation, { data, loading, error }] = useUpdateRetirePostDaysMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      retirePostDays: // value for 'retirePostDays'
 *   },
 * });
 */
export function useUpdateRetirePostDaysMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateRetirePostDaysMutation,
        UpdateRetirePostDaysMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateRetirePostDaysMutation, UpdateRetirePostDaysMutationVariables>(
        UpdateRetirePostDaysDocument,
        options
    )
}
export type UpdateRetirePostDaysMutationHookResult = ReturnType<
    typeof useUpdateRetirePostDaysMutation
>
export type UpdateRetirePostDaysMutationResult = Apollo.MutationResult<UpdateRetirePostDaysMutation>
export type UpdateRetirePostDaysMutationOptions = Apollo.BaseMutationOptions<
    UpdateRetirePostDaysMutation,
    UpdateRetirePostDaysMutationVariables
>
export const UpdateProfileCollectionEnabledDocument = gql`
    mutation updateProfileCollectionEnabled($accountId: Int!, $profileCollectionEnabled: Boolean!) {
        updateProfileCollectionEnabled(
            accountId: $accountId
            profileCollectionEnabled: $profileCollectionEnabled
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateProfileCollectionEnabledMutationFn = Apollo.MutationFunction<
    UpdateProfileCollectionEnabledMutation,
    UpdateProfileCollectionEnabledMutationVariables
>

/**
 * __useUpdateProfileCollectionEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateProfileCollectionEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileCollectionEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileCollectionEnabledMutation, { data, loading, error }] = useUpdateProfileCollectionEnabledMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      profileCollectionEnabled: // value for 'profileCollectionEnabled'
 *   },
 * });
 */
export function useUpdateProfileCollectionEnabledMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateProfileCollectionEnabledMutation,
        UpdateProfileCollectionEnabledMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateProfileCollectionEnabledMutation,
        UpdateProfileCollectionEnabledMutationVariables
    >(UpdateProfileCollectionEnabledDocument, options)
}
export type UpdateProfileCollectionEnabledMutationHookResult = ReturnType<
    typeof useUpdateProfileCollectionEnabledMutation
>
export type UpdateProfileCollectionEnabledMutationResult =
    Apollo.MutationResult<UpdateProfileCollectionEnabledMutation>
export type UpdateProfileCollectionEnabledMutationOptions = Apollo.BaseMutationOptions<
    UpdateProfileCollectionEnabledMutation,
    UpdateProfileCollectionEnabledMutationVariables
>
export const UpdateProfileModerationEnabledDocument = gql`
    mutation updateProfileModerationEnabled($accountId: Int!, $profileModerationEnabled: Boolean!) {
        updateProfileModerationEnabled(
            accountId: $accountId
            profileModerationEnabled: $profileModerationEnabled
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateProfileModerationEnabledMutationFn = Apollo.MutationFunction<
    UpdateProfileModerationEnabledMutation,
    UpdateProfileModerationEnabledMutationVariables
>

/**
 * __useUpdateProfileModerationEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateProfileModerationEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileModerationEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileModerationEnabledMutation, { data, loading, error }] = useUpdateProfileModerationEnabledMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      profileModerationEnabled: // value for 'profileModerationEnabled'
 *   },
 * });
 */
export function useUpdateProfileModerationEnabledMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateProfileModerationEnabledMutation,
        UpdateProfileModerationEnabledMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateProfileModerationEnabledMutation,
        UpdateProfileModerationEnabledMutationVariables
    >(UpdateProfileModerationEnabledDocument, options)
}
export type UpdateProfileModerationEnabledMutationHookResult = ReturnType<
    typeof useUpdateProfileModerationEnabledMutation
>
export type UpdateProfileModerationEnabledMutationResult =
    Apollo.MutationResult<UpdateProfileModerationEnabledMutation>
export type UpdateProfileModerationEnabledMutationOptions = Apollo.BaseMutationOptions<
    UpdateProfileModerationEnabledMutation,
    UpdateProfileModerationEnabledMutationVariables
>
export const UpdateLlmClassificationEnabledDocument = gql`
    mutation updateLlmClassificationEnabled($accountId: Int!, $llmClassificationEnabled: Boolean!) {
        updateLlmClassificationEnabled(
            accountId: $accountId
            llmClassificationEnabled: $llmClassificationEnabled
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateLlmClassificationEnabledMutationFn = Apollo.MutationFunction<
    UpdateLlmClassificationEnabledMutation,
    UpdateLlmClassificationEnabledMutationVariables
>

/**
 * __useUpdateLlmClassificationEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateLlmClassificationEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLlmClassificationEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLlmClassificationEnabledMutation, { data, loading, error }] = useUpdateLlmClassificationEnabledMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      llmClassificationEnabled: // value for 'llmClassificationEnabled'
 *   },
 * });
 */
export function useUpdateLlmClassificationEnabledMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateLlmClassificationEnabledMutation,
        UpdateLlmClassificationEnabledMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateLlmClassificationEnabledMutation,
        UpdateLlmClassificationEnabledMutationVariables
    >(UpdateLlmClassificationEnabledDocument, options)
}
export type UpdateLlmClassificationEnabledMutationHookResult = ReturnType<
    typeof useUpdateLlmClassificationEnabledMutation
>
export type UpdateLlmClassificationEnabledMutationResult =
    Apollo.MutationResult<UpdateLlmClassificationEnabledMutation>
export type UpdateLlmClassificationEnabledMutationOptions = Apollo.BaseMutationOptions<
    UpdateLlmClassificationEnabledMutation,
    UpdateLlmClassificationEnabledMutationVariables
>
export const UpdateLlmSuggestedReplyEnabledDocument = gql`
    mutation updateLlmSuggestedReplyEnabled($accountId: Int!, $llmSuggestedReplyEnabled: Boolean!) {
        updateLlmSuggestedReplyEnabled(
            accountId: $accountId
            llmSuggestedReplyEnabled: $llmSuggestedReplyEnabled
        ) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateLlmSuggestedReplyEnabledMutationFn = Apollo.MutationFunction<
    UpdateLlmSuggestedReplyEnabledMutation,
    UpdateLlmSuggestedReplyEnabledMutationVariables
>

/**
 * __useUpdateLlmSuggestedReplyEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateLlmSuggestedReplyEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLlmSuggestedReplyEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLlmSuggestedReplyEnabledMutation, { data, loading, error }] = useUpdateLlmSuggestedReplyEnabledMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      llmSuggestedReplyEnabled: // value for 'llmSuggestedReplyEnabled'
 *   },
 * });
 */
export function useUpdateLlmSuggestedReplyEnabledMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateLlmSuggestedReplyEnabledMutation,
        UpdateLlmSuggestedReplyEnabledMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateLlmSuggestedReplyEnabledMutation,
        UpdateLlmSuggestedReplyEnabledMutationVariables
    >(UpdateLlmSuggestedReplyEnabledDocument, options)
}
export type UpdateLlmSuggestedReplyEnabledMutationHookResult = ReturnType<
    typeof useUpdateLlmSuggestedReplyEnabledMutation
>
export type UpdateLlmSuggestedReplyEnabledMutationResult =
    Apollo.MutationResult<UpdateLlmSuggestedReplyEnabledMutation>
export type UpdateLlmSuggestedReplyEnabledMutationOptions = Apollo.BaseMutationOptions<
    UpdateLlmSuggestedReplyEnabledMutation,
    UpdateLlmSuggestedReplyEnabledMutationVariables
>
export const UpdateFetchAdsDocument = gql`
    mutation updateFetchAds($accountId: Int!, $fetchAds: Boolean!) {
        updateFetchAds(accountId: $accountId, fetchAds: $fetchAds) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateFetchAdsMutationFn = Apollo.MutationFunction<
    UpdateFetchAdsMutation,
    UpdateFetchAdsMutationVariables
>

/**
 * __useUpdateFetchAdsMutation__
 *
 * To run a mutation, you first call `useUpdateFetchAdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFetchAdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFetchAdsMutation, { data, loading, error }] = useUpdateFetchAdsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fetchAds: // value for 'fetchAds'
 *   },
 * });
 */
export function useUpdateFetchAdsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateFetchAdsMutation,
        UpdateFetchAdsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateFetchAdsMutation, UpdateFetchAdsMutationVariables>(
        UpdateFetchAdsDocument,
        options
    )
}
export type UpdateFetchAdsMutationHookResult = ReturnType<typeof useUpdateFetchAdsMutation>
export type UpdateFetchAdsMutationResult = Apollo.MutationResult<UpdateFetchAdsMutation>
export type UpdateFetchAdsMutationOptions = Apollo.BaseMutationOptions<
    UpdateFetchAdsMutation,
    UpdateFetchAdsMutationVariables
>
export const UpdateFetchPostsDocument = gql`
    mutation updateFetchPosts($accountId: Int!, $fetchPosts: Boolean!) {
        updateFetchPosts(accountId: $accountId, fetchPosts: $fetchPosts) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateFetchPostsMutationFn = Apollo.MutationFunction<
    UpdateFetchPostsMutation,
    UpdateFetchPostsMutationVariables
>

/**
 * __useUpdateFetchPostsMutation__
 *
 * To run a mutation, you first call `useUpdateFetchPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFetchPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFetchPostsMutation, { data, loading, error }] = useUpdateFetchPostsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      fetchPosts: // value for 'fetchPosts'
 *   },
 * });
 */
export function useUpdateFetchPostsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateFetchPostsMutation,
        UpdateFetchPostsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateFetchPostsMutation, UpdateFetchPostsMutationVariables>(
        UpdateFetchPostsDocument,
        options
    )
}
export type UpdateFetchPostsMutationHookResult = ReturnType<typeof useUpdateFetchPostsMutation>
export type UpdateFetchPostsMutationResult = Apollo.MutationResult<UpdateFetchPostsMutation>
export type UpdateFetchPostsMutationOptions = Apollo.BaseMutationOptions<
    UpdateFetchPostsMutation,
    UpdateFetchPostsMutationVariables
>
export const UpdateAutoHideAdCommentsDocument = gql`
    mutation updateAutoHideAdComments($accountId: Int!, $autoHideAdComments: Boolean!) {
        updateAutoHideAdComments(accountId: $accountId, autoHideAdComments: $autoHideAdComments) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`
export type UpdateAutoHideAdCommentsMutationFn = Apollo.MutationFunction<
    UpdateAutoHideAdCommentsMutation,
    UpdateAutoHideAdCommentsMutationVariables
>

/**
 * __useUpdateAutoHideAdCommentsMutation__
 *
 * To run a mutation, you first call `useUpdateAutoHideAdCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoHideAdCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoHideAdCommentsMutation, { data, loading, error }] = useUpdateAutoHideAdCommentsMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      autoHideAdComments: // value for 'autoHideAdComments'
 *   },
 * });
 */
export function useUpdateAutoHideAdCommentsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateAutoHideAdCommentsMutation,
        UpdateAutoHideAdCommentsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateAutoHideAdCommentsMutation,
        UpdateAutoHideAdCommentsMutationVariables
    >(UpdateAutoHideAdCommentsDocument, options)
}
export type UpdateAutoHideAdCommentsMutationHookResult = ReturnType<
    typeof useUpdateAutoHideAdCommentsMutation
>
export type UpdateAutoHideAdCommentsMutationResult =
    Apollo.MutationResult<UpdateAutoHideAdCommentsMutation>
export type UpdateAutoHideAdCommentsMutationOptions = Apollo.BaseMutationOptions<
    UpdateAutoHideAdCommentsMutation,
    UpdateAutoHideAdCommentsMutationVariables
>
export const CreateUserDocument = gql`
    mutation createUser($userParams: UserCreateParamsView!) {
        createUser(userParams: $userParams)
    }
`
export type CreateUserMutationFn = Apollo.MutationFunction<
    CreateUserMutation,
    CreateUserMutationVariables
>

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function useCreateUserMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
        CreateUserDocument,
        options
    )
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
    CreateUserMutation,
    CreateUserMutationVariables
>
export const EditUserDocument = gql`
    mutation editUser($userParams: UserEditParamsView!) {
        editUser(userParams: $userParams)
    }
`
export type EditUserMutationFn = Apollo.MutationFunction<
    EditUserMutation,
    EditUserMutationVariables
>

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function useEditUserMutation(
    baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(
        EditUserDocument,
        options
    )
}
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>
export type EditUserMutationOptions = Apollo.BaseMutationOptions<
    EditUserMutation,
    EditUserMutationVariables
>
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: Int!) {
        deleteUser(userId: $userId)
    }
`
export type DeleteUserMutationFn = Apollo.MutationFunction<
    DeleteUserMutation,
    DeleteUserMutationVariables
>

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
        DeleteUserDocument,
        options
    )
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
>
export const MetaHistoricFetchDocument = gql`
    mutation metaHistoricFetch($accountId: Int!, $from: DateTime!, $to: DateTime!) {
        metaHistoricFetch(accountId: $accountId, from: $from, to: $to)
    }
`
export type MetaHistoricFetchMutationFn = Apollo.MutationFunction<
    MetaHistoricFetchMutation,
    MetaHistoricFetchMutationVariables
>

/**
 * __useMetaHistoricFetchMutation__
 *
 * To run a mutation, you first call `useMetaHistoricFetchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMetaHistoricFetchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [metaHistoricFetchMutation, { data, loading, error }] = useMetaHistoricFetchMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMetaHistoricFetchMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MetaHistoricFetchMutation,
        MetaHistoricFetchMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<MetaHistoricFetchMutation, MetaHistoricFetchMutationVariables>(
        MetaHistoricFetchDocument,
        options
    )
}
export type MetaHistoricFetchMutationHookResult = ReturnType<typeof useMetaHistoricFetchMutation>
export type MetaHistoricFetchMutationResult = Apollo.MutationResult<MetaHistoricFetchMutation>
export type MetaHistoricFetchMutationOptions = Apollo.BaseMutationOptions<
    MetaHistoricFetchMutation,
    MetaHistoricFetchMutationVariables
>
export const InstagramAuthCodeToAccessTokenDocument = gql`
    mutation instagramAuthCodeToAccessToken($code: String!, $redirectUri: String!) {
        instagramAuthCodeToAccessToken(code: $code, redirectUri: $redirectUri) {
            new
            updated
        }
    }
`
export type InstagramAuthCodeToAccessTokenMutationFn = Apollo.MutationFunction<
    InstagramAuthCodeToAccessTokenMutation,
    InstagramAuthCodeToAccessTokenMutationVariables
>

/**
 * __useInstagramAuthCodeToAccessTokenMutation__
 *
 * To run a mutation, you first call `useInstagramAuthCodeToAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstagramAuthCodeToAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [instagramAuthCodeToAccessTokenMutation, { data, loading, error }] = useInstagramAuthCodeToAccessTokenMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useInstagramAuthCodeToAccessTokenMutation(
    baseOptions?: Apollo.MutationHookOptions<
        InstagramAuthCodeToAccessTokenMutation,
        InstagramAuthCodeToAccessTokenMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        InstagramAuthCodeToAccessTokenMutation,
        InstagramAuthCodeToAccessTokenMutationVariables
    >(InstagramAuthCodeToAccessTokenDocument, options)
}
export type InstagramAuthCodeToAccessTokenMutationHookResult = ReturnType<
    typeof useInstagramAuthCodeToAccessTokenMutation
>
export type InstagramAuthCodeToAccessTokenMutationResult =
    Apollo.MutationResult<InstagramAuthCodeToAccessTokenMutation>
export type InstagramAuthCodeToAccessTokenMutationOptions = Apollo.BaseMutationOptions<
    InstagramAuthCodeToAccessTokenMutation,
    InstagramAuthCodeToAccessTokenMutationVariables
>
export const TiktokAuthCodeToAccessTokenDocument = gql`
    mutation tiktokAuthCodeToAccessToken($authCode: String!, $code: String!) {
        tiktokAuthCodeToAccessToken(authCode: $authCode, code: $code) {
            ...TikTokAccountSelectionItem
        }
    }
    ${TikTokAccountSelectionItemFragmentDoc}
`
export type TiktokAuthCodeToAccessTokenMutationFn = Apollo.MutationFunction<
    TiktokAuthCodeToAccessTokenMutation,
    TiktokAuthCodeToAccessTokenMutationVariables
>

/**
 * __useTiktokAuthCodeToAccessTokenMutation__
 *
 * To run a mutation, you first call `useTiktokAuthCodeToAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTiktokAuthCodeToAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tiktokAuthCodeToAccessTokenMutation, { data, loading, error }] = useTiktokAuthCodeToAccessTokenMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTiktokAuthCodeToAccessTokenMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TiktokAuthCodeToAccessTokenMutation,
        TiktokAuthCodeToAccessTokenMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        TiktokAuthCodeToAccessTokenMutation,
        TiktokAuthCodeToAccessTokenMutationVariables
    >(TiktokAuthCodeToAccessTokenDocument, options)
}
export type TiktokAuthCodeToAccessTokenMutationHookResult = ReturnType<
    typeof useTiktokAuthCodeToAccessTokenMutation
>
export type TiktokAuthCodeToAccessTokenMutationResult =
    Apollo.MutationResult<TiktokAuthCodeToAccessTokenMutation>
export type TiktokAuthCodeToAccessTokenMutationOptions = Apollo.BaseMutationOptions<
    TiktokAuthCodeToAccessTokenMutation,
    TiktokAuthCodeToAccessTokenMutationVariables
>
export const TiktokCreateUserAccountWithAuthDocument = gql`
    mutation tiktokCreateUserAccountWithAuth(
        $authCode: String!
        $code: String!
        $redirectUri: String!
    ) {
        tiktokCreateUserAccountWithAuth(
            authCode: $authCode
            code: $code
            redirectUri: $redirectUri
        ) {
            ...TikTokUserAccountSelectionItem
        }
    }
    ${TikTokUserAccountSelectionItemFragmentDoc}
`
export type TiktokCreateUserAccountWithAuthMutationFn = Apollo.MutationFunction<
    TiktokCreateUserAccountWithAuthMutation,
    TiktokCreateUserAccountWithAuthMutationVariables
>

/**
 * __useTiktokCreateUserAccountWithAuthMutation__
 *
 * To run a mutation, you first call `useTiktokCreateUserAccountWithAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTiktokCreateUserAccountWithAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tiktokCreateUserAccountWithAuthMutation, { data, loading, error }] = useTiktokCreateUserAccountWithAuthMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      code: // value for 'code'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useTiktokCreateUserAccountWithAuthMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TiktokCreateUserAccountWithAuthMutation,
        TiktokCreateUserAccountWithAuthMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        TiktokCreateUserAccountWithAuthMutation,
        TiktokCreateUserAccountWithAuthMutationVariables
    >(TiktokCreateUserAccountWithAuthDocument, options)
}
export type TiktokCreateUserAccountWithAuthMutationHookResult = ReturnType<
    typeof useTiktokCreateUserAccountWithAuthMutation
>
export type TiktokCreateUserAccountWithAuthMutationResult =
    Apollo.MutationResult<TiktokCreateUserAccountWithAuthMutation>
export type TiktokCreateUserAccountWithAuthMutationOptions = Apollo.BaseMutationOptions<
    TiktokCreateUserAccountWithAuthMutation,
    TiktokCreateUserAccountWithAuthMutationVariables
>
export const CreateTiktokAccountsDocument = gql`
    mutation createTiktokAccounts($sessionKey: String!, $adAccountIds: [String!]!) {
        createTiktokAccounts(sessionKey: $sessionKey, adAccountIds: $adAccountIds) {
            ...TikTokAuthorisedAccountItem
        }
    }
    ${TikTokAuthorisedAccountItemFragmentDoc}
`
export type CreateTiktokAccountsMutationFn = Apollo.MutationFunction<
    CreateTiktokAccountsMutation,
    CreateTiktokAccountsMutationVariables
>

/**
 * __useCreateTiktokAccountsMutation__
 *
 * To run a mutation, you first call `useCreateTiktokAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTiktokAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTiktokAccountsMutation, { data, loading, error }] = useCreateTiktokAccountsMutation({
 *   variables: {
 *      sessionKey: // value for 'sessionKey'
 *      adAccountIds: // value for 'adAccountIds'
 *   },
 * });
 */
export function useCreateTiktokAccountsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateTiktokAccountsMutation,
        CreateTiktokAccountsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateTiktokAccountsMutation, CreateTiktokAccountsMutationVariables>(
        CreateTiktokAccountsDocument,
        options
    )
}
export type CreateTiktokAccountsMutationHookResult = ReturnType<
    typeof useCreateTiktokAccountsMutation
>
export type CreateTiktokAccountsMutationResult = Apollo.MutationResult<CreateTiktokAccountsMutation>
export type CreateTiktokAccountsMutationOptions = Apollo.BaseMutationOptions<
    CreateTiktokAccountsMutation,
    CreateTiktokAccountsMutationVariables
>
export const DeleteReplyDocument = gql`
    mutation deleteReply($actionId: Int!) {
        deleteReply(actionId: $actionId) {
            ...ContentActionView
        }
    }
    ${ContentActionViewFragmentDoc}
`
export type DeleteReplyMutationFn = Apollo.MutationFunction<
    DeleteReplyMutation,
    DeleteReplyMutationVariables
>

/**
 * __useDeleteReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplyMutation, { data, loading, error }] = useDeleteReplyMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDeleteReplyMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteReplyMutation, DeleteReplyMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteReplyMutation, DeleteReplyMutationVariables>(
        DeleteReplyDocument,
        options
    )
}
export type DeleteReplyMutationHookResult = ReturnType<typeof useDeleteReplyMutation>
export type DeleteReplyMutationResult = Apollo.MutationResult<DeleteReplyMutation>
export type DeleteReplyMutationOptions = Apollo.BaseMutationOptions<
    DeleteReplyMutation,
    DeleteReplyMutationVariables
>
export const CreateCookieDocument = gql`
    mutation CreateCookie($input: CreateCookieInput!) {
        createCookie(params: $input) {
            ...CookieSummaryItem
        }
    }
    ${CookieSummaryItemFragmentDoc}
`
export type CreateCookieMutationFn = Apollo.MutationFunction<
    CreateCookieMutation,
    CreateCookieMutationVariables
>

/**
 * __useCreateCookieMutation__
 *
 * To run a mutation, you first call `useCreateCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCookieMutation, { data, loading, error }] = useCreateCookieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCookieMutation(
    baseOptions?: Apollo.MutationHookOptions<CreateCookieMutation, CreateCookieMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreateCookieMutation, CreateCookieMutationVariables>(
        CreateCookieDocument,
        options
    )
}
export type CreateCookieMutationHookResult = ReturnType<typeof useCreateCookieMutation>
export type CreateCookieMutationResult = Apollo.MutationResult<CreateCookieMutation>
export type CreateCookieMutationOptions = Apollo.BaseMutationOptions<
    CreateCookieMutation,
    CreateCookieMutationVariables
>
export const UpdateCookieDocument = gql`
    mutation UpdateCookie($input: UpdateCookieInput!) {
        updateCookie(params: $input) {
            ...CookieSummaryItem
        }
    }
    ${CookieSummaryItemFragmentDoc}
`
export type UpdateCookieMutationFn = Apollo.MutationFunction<
    UpdateCookieMutation,
    UpdateCookieMutationVariables
>

/**
 * __useUpdateCookieMutation__
 *
 * To run a mutation, you first call `useUpdateCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCookieMutation, { data, loading, error }] = useUpdateCookieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCookieMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateCookieMutation, UpdateCookieMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<UpdateCookieMutation, UpdateCookieMutationVariables>(
        UpdateCookieDocument,
        options
    )
}
export type UpdateCookieMutationHookResult = ReturnType<typeof useUpdateCookieMutation>
export type UpdateCookieMutationResult = Apollo.MutationResult<UpdateCookieMutation>
export type UpdateCookieMutationOptions = Apollo.BaseMutationOptions<
    UpdateCookieMutation,
    UpdateCookieMutationVariables
>
export const MarkCookieDeadDocument = gql`
    mutation MarkCookieDead($cookieId: Int!, $reason: String) {
        markCookieDead(cookieId: $cookieId, reason: $reason)
    }
`
export type MarkCookieDeadMutationFn = Apollo.MutationFunction<
    MarkCookieDeadMutation,
    MarkCookieDeadMutationVariables
>

/**
 * __useMarkCookieDeadMutation__
 *
 * To run a mutation, you first call `useMarkCookieDeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCookieDeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCookieDeadMutation, { data, loading, error }] = useMarkCookieDeadMutation({
 *   variables: {
 *      cookieId: // value for 'cookieId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useMarkCookieDeadMutation(
    baseOptions?: Apollo.MutationHookOptions<
        MarkCookieDeadMutation,
        MarkCookieDeadMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<MarkCookieDeadMutation, MarkCookieDeadMutationVariables>(
        MarkCookieDeadDocument,
        options
    )
}
export type MarkCookieDeadMutationHookResult = ReturnType<typeof useMarkCookieDeadMutation>
export type MarkCookieDeadMutationResult = Apollo.MutationResult<MarkCookieDeadMutation>
export type MarkCookieDeadMutationOptions = Apollo.BaseMutationOptions<
    MarkCookieDeadMutation,
    MarkCookieDeadMutationVariables
>
export const IncrementCookieFailCountDocument = gql`
    mutation IncrementCookieFailCount($cookieId: Int!) {
        incrementCookieFailCount(cookieId: $cookieId)
    }
`
export type IncrementCookieFailCountMutationFn = Apollo.MutationFunction<
    IncrementCookieFailCountMutation,
    IncrementCookieFailCountMutationVariables
>

/**
 * __useIncrementCookieFailCountMutation__
 *
 * To run a mutation, you first call `useIncrementCookieFailCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncrementCookieFailCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [incrementCookieFailCountMutation, { data, loading, error }] = useIncrementCookieFailCountMutation({
 *   variables: {
 *      cookieId: // value for 'cookieId'
 *   },
 * });
 */
export function useIncrementCookieFailCountMutation(
    baseOptions?: Apollo.MutationHookOptions<
        IncrementCookieFailCountMutation,
        IncrementCookieFailCountMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        IncrementCookieFailCountMutation,
        IncrementCookieFailCountMutationVariables
    >(IncrementCookieFailCountDocument, options)
}
export type IncrementCookieFailCountMutationHookResult = ReturnType<
    typeof useIncrementCookieFailCountMutation
>
export type IncrementCookieFailCountMutationResult =
    Apollo.MutationResult<IncrementCookieFailCountMutation>
export type IncrementCookieFailCountMutationOptions = Apollo.BaseMutationOptions<
    IncrementCookieFailCountMutation,
    IncrementCookieFailCountMutationVariables
>
export const DeleteCookieDocument = gql`
    mutation DeleteCookie($cookieId: Int!) {
        deleteCookie(cookieId: $cookieId)
    }
`
export type DeleteCookieMutationFn = Apollo.MutationFunction<
    DeleteCookieMutation,
    DeleteCookieMutationVariables
>

/**
 * __useDeleteCookieMutation__
 *
 * To run a mutation, you first call `useDeleteCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCookieMutation, { data, loading, error }] = useDeleteCookieMutation({
 *   variables: {
 *      cookieId: // value for 'cookieId'
 *   },
 * });
 */
export function useDeleteCookieMutation(
    baseOptions?: Apollo.MutationHookOptions<DeleteCookieMutation, DeleteCookieMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteCookieMutation, DeleteCookieMutationVariables>(
        DeleteCookieDocument,
        options
    )
}
export type DeleteCookieMutationHookResult = ReturnType<typeof useDeleteCookieMutation>
export type DeleteCookieMutationResult = Apollo.MutationResult<DeleteCookieMutation>
export type DeleteCookieMutationOptions = Apollo.BaseMutationOptions<
    DeleteCookieMutation,
    DeleteCookieMutationVariables
>
export const RefreshContentMediaDocument = gql`
    mutation RefreshContentMedia($contentId: Int!) {
        refreshContentMedia(contentId: $contentId) {
            serviceMediaId
            publicUrl
            presignedUrl
            mediaType
            mediaClassifications {
                classification
                classifierName
            }
        }
    }
`
export type RefreshContentMediaMutationFn = Apollo.MutationFunction<
    RefreshContentMediaMutation,
    RefreshContentMediaMutationVariables
>

/**
 * __useRefreshContentMediaMutation__
 *
 * To run a mutation, you first call `useRefreshContentMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshContentMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshContentMediaMutation, { data, loading, error }] = useRefreshContentMediaMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useRefreshContentMediaMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RefreshContentMediaMutation,
        RefreshContentMediaMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RefreshContentMediaMutation, RefreshContentMediaMutationVariables>(
        RefreshContentMediaDocument,
        options
    )
}
export type RefreshContentMediaMutationHookResult = ReturnType<
    typeof useRefreshContentMediaMutation
>
export type RefreshContentMediaMutationResult = Apollo.MutationResult<RefreshContentMediaMutation>
export type RefreshContentMediaMutationOptions = Apollo.BaseMutationOptions<
    RefreshContentMediaMutation,
    RefreshContentMediaMutationVariables
>
export const StartContentSearchDocument = gql`
    mutation StartContentSearch($params: ContentSearchParams!) {
        startContentSearch(params: $params) {
            taskId
            startedAt
            result {
                ...ContentSearchTaskResultFields
            }
        }
    }
    ${ContentSearchTaskResultFieldsFragmentDoc}
`
export type StartContentSearchMutationFn = Apollo.MutationFunction<
    StartContentSearchMutation,
    StartContentSearchMutationVariables
>

/**
 * __useStartContentSearchMutation__
 *
 * To run a mutation, you first call `useStartContentSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartContentSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startContentSearchMutation, { data, loading, error }] = useStartContentSearchMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useStartContentSearchMutation(
    baseOptions?: Apollo.MutationHookOptions<
        StartContentSearchMutation,
        StartContentSearchMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<StartContentSearchMutation, StartContentSearchMutationVariables>(
        StartContentSearchDocument,
        options
    )
}
export type StartContentSearchMutationHookResult = ReturnType<typeof useStartContentSearchMutation>
export type StartContentSearchMutationResult = Apollo.MutationResult<StartContentSearchMutation>
export type StartContentSearchMutationOptions = Apollo.BaseMutationOptions<
    StartContentSearchMutation,
    StartContentSearchMutationVariables
>
export const SendNewAccountNotificationDocument = gql`
    mutation SendNewAccountNotification($accountIds: [Int!]!) {
        sendNewAccountNotification(accountIds: $accountIds) {
            success
            message
        }
    }
`
export type SendNewAccountNotificationMutationFn = Apollo.MutationFunction<
    SendNewAccountNotificationMutation,
    SendNewAccountNotificationMutationVariables
>

/**
 * __useSendNewAccountNotificationMutation__
 *
 * To run a mutation, you first call `useSendNewAccountNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewAccountNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewAccountNotificationMutation, { data, loading, error }] = useSendNewAccountNotificationMutation({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useSendNewAccountNotificationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SendNewAccountNotificationMutation,
        SendNewAccountNotificationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        SendNewAccountNotificationMutation,
        SendNewAccountNotificationMutationVariables
    >(SendNewAccountNotificationDocument, options)
}
export type SendNewAccountNotificationMutationHookResult = ReturnType<
    typeof useSendNewAccountNotificationMutation
>
export type SendNewAccountNotificationMutationResult =
    Apollo.MutationResult<SendNewAccountNotificationMutation>
export type SendNewAccountNotificationMutationOptions = Apollo.BaseMutationOptions<
    SendNewAccountNotificationMutation,
    SendNewAccountNotificationMutationVariables
>
export const AddTwitterSubscriptionDocument = gql`
    mutation addTwitterSubscription($accountId: Int!) {
        addTwitterSubscription(accountId: $accountId)
    }
`
export type AddTwitterSubscriptionMutationFn = Apollo.MutationFunction<
    AddTwitterSubscriptionMutation,
    AddTwitterSubscriptionMutationVariables
>

/**
 * __useAddTwitterSubscriptionMutation__
 *
 * To run a mutation, you first call `useAddTwitterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTwitterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTwitterSubscriptionMutation, { data, loading, error }] = useAddTwitterSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAddTwitterSubscriptionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddTwitterSubscriptionMutation,
        AddTwitterSubscriptionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        AddTwitterSubscriptionMutation,
        AddTwitterSubscriptionMutationVariables
    >(AddTwitterSubscriptionDocument, options)
}
export type AddTwitterSubscriptionMutationHookResult = ReturnType<
    typeof useAddTwitterSubscriptionMutation
>
export type AddTwitterSubscriptionMutationResult =
    Apollo.MutationResult<AddTwitterSubscriptionMutation>
export type AddTwitterSubscriptionMutationOptions = Apollo.BaseMutationOptions<
    AddTwitterSubscriptionMutation,
    AddTwitterSubscriptionMutationVariables
>
export const RemoveTwitterSubscriptionDocument = gql`
    mutation removeTwitterSubscription($accountId: Int!) {
        removeTwitterSubscription(accountId: $accountId)
    }
`
export type RemoveTwitterSubscriptionMutationFn = Apollo.MutationFunction<
    RemoveTwitterSubscriptionMutation,
    RemoveTwitterSubscriptionMutationVariables
>

/**
 * __useRemoveTwitterSubscriptionMutation__
 *
 * To run a mutation, you first call `useRemoveTwitterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTwitterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTwitterSubscriptionMutation, { data, loading, error }] = useRemoveTwitterSubscriptionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRemoveTwitterSubscriptionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RemoveTwitterSubscriptionMutation,
        RemoveTwitterSubscriptionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        RemoveTwitterSubscriptionMutation,
        RemoveTwitterSubscriptionMutationVariables
    >(RemoveTwitterSubscriptionDocument, options)
}
export type RemoveTwitterSubscriptionMutationHookResult = ReturnType<
    typeof useRemoveTwitterSubscriptionMutation
>
export type RemoveTwitterSubscriptionMutationResult =
    Apollo.MutationResult<RemoveTwitterSubscriptionMutation>
export type RemoveTwitterSubscriptionMutationOptions = Apollo.BaseMutationOptions<
    RemoveTwitterSubscriptionMutation,
    RemoveTwitterSubscriptionMutationVariables
>
export const CreateClassifierPromptDocument = gql`
    mutation CreateClassifierPrompt($input: CreateClassifierPromptInput!) {
        createClassifierPrompt(input: $input) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`
export type CreateClassifierPromptMutationFn = Apollo.MutationFunction<
    CreateClassifierPromptMutation,
    CreateClassifierPromptMutationVariables
>

/**
 * __useCreateClassifierPromptMutation__
 *
 * To run a mutation, you first call `useCreateClassifierPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassifierPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassifierPromptMutation, { data, loading, error }] = useCreateClassifierPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassifierPromptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateClassifierPromptMutation,
        CreateClassifierPromptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateClassifierPromptMutation,
        CreateClassifierPromptMutationVariables
    >(CreateClassifierPromptDocument, options)
}
export type CreateClassifierPromptMutationHookResult = ReturnType<
    typeof useCreateClassifierPromptMutation
>
export type CreateClassifierPromptMutationResult =
    Apollo.MutationResult<CreateClassifierPromptMutation>
export type CreateClassifierPromptMutationOptions = Apollo.BaseMutationOptions<
    CreateClassifierPromptMutation,
    CreateClassifierPromptMutationVariables
>
export const UpdateClassifierPromptDocument = gql`
    mutation UpdateClassifierPrompt($input: UpdateClassifierPromptInput!) {
        updateClassifierPrompt(input: $input) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`
export type UpdateClassifierPromptMutationFn = Apollo.MutationFunction<
    UpdateClassifierPromptMutation,
    UpdateClassifierPromptMutationVariables
>

/**
 * __useUpdateClassifierPromptMutation__
 *
 * To run a mutation, you first call `useUpdateClassifierPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassifierPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassifierPromptMutation, { data, loading, error }] = useUpdateClassifierPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassifierPromptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateClassifierPromptMutation,
        UpdateClassifierPromptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateClassifierPromptMutation,
        UpdateClassifierPromptMutationVariables
    >(UpdateClassifierPromptDocument, options)
}
export type UpdateClassifierPromptMutationHookResult = ReturnType<
    typeof useUpdateClassifierPromptMutation
>
export type UpdateClassifierPromptMutationResult =
    Apollo.MutationResult<UpdateClassifierPromptMutation>
export type UpdateClassifierPromptMutationOptions = Apollo.BaseMutationOptions<
    UpdateClassifierPromptMutation,
    UpdateClassifierPromptMutationVariables
>
export const GoLiveClassifierPromptDocument = gql`
    mutation GoLiveClassifierPrompt($id: Int!) {
        goLiveClassifierPrompt(id: $id) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`
export type GoLiveClassifierPromptMutationFn = Apollo.MutationFunction<
    GoLiveClassifierPromptMutation,
    GoLiveClassifierPromptMutationVariables
>

/**
 * __useGoLiveClassifierPromptMutation__
 *
 * To run a mutation, you first call `useGoLiveClassifierPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoLiveClassifierPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [goLiveClassifierPromptMutation, { data, loading, error }] = useGoLiveClassifierPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoLiveClassifierPromptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        GoLiveClassifierPromptMutation,
        GoLiveClassifierPromptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        GoLiveClassifierPromptMutation,
        GoLiveClassifierPromptMutationVariables
    >(GoLiveClassifierPromptDocument, options)
}
export type GoLiveClassifierPromptMutationHookResult = ReturnType<
    typeof useGoLiveClassifierPromptMutation
>
export type GoLiveClassifierPromptMutationResult =
    Apollo.MutationResult<GoLiveClassifierPromptMutation>
export type GoLiveClassifierPromptMutationOptions = Apollo.BaseMutationOptions<
    GoLiveClassifierPromptMutation,
    GoLiveClassifierPromptMutationVariables
>
export const DiscardClassifierPromptDraftDocument = gql`
    mutation DiscardClassifierPromptDraft($id: Int!) {
        discardClassifierPromptDraft(id: $id) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`
export type DiscardClassifierPromptDraftMutationFn = Apollo.MutationFunction<
    DiscardClassifierPromptDraftMutation,
    DiscardClassifierPromptDraftMutationVariables
>

/**
 * __useDiscardClassifierPromptDraftMutation__
 *
 * To run a mutation, you first call `useDiscardClassifierPromptDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardClassifierPromptDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardClassifierPromptDraftMutation, { data, loading, error }] = useDiscardClassifierPromptDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscardClassifierPromptDraftMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DiscardClassifierPromptDraftMutation,
        DiscardClassifierPromptDraftMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DiscardClassifierPromptDraftMutation,
        DiscardClassifierPromptDraftMutationVariables
    >(DiscardClassifierPromptDraftDocument, options)
}
export type DiscardClassifierPromptDraftMutationHookResult = ReturnType<
    typeof useDiscardClassifierPromptDraftMutation
>
export type DiscardClassifierPromptDraftMutationResult =
    Apollo.MutationResult<DiscardClassifierPromptDraftMutation>
export type DiscardClassifierPromptDraftMutationOptions = Apollo.BaseMutationOptions<
    DiscardClassifierPromptDraftMutation,
    DiscardClassifierPromptDraftMutationVariables
>
export const DeleteClassifierPromptDocument = gql`
    mutation DeleteClassifierPrompt($id: Int!) {
        deleteClassifierPrompt(id: $id)
    }
`
export type DeleteClassifierPromptMutationFn = Apollo.MutationFunction<
    DeleteClassifierPromptMutation,
    DeleteClassifierPromptMutationVariables
>

/**
 * __useDeleteClassifierPromptMutation__
 *
 * To run a mutation, you first call `useDeleteClassifierPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassifierPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassifierPromptMutation, { data, loading, error }] = useDeleteClassifierPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClassifierPromptMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteClassifierPromptMutation,
        DeleteClassifierPromptMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeleteClassifierPromptMutation,
        DeleteClassifierPromptMutationVariables
    >(DeleteClassifierPromptDocument, options)
}
export type DeleteClassifierPromptMutationHookResult = ReturnType<
    typeof useDeleteClassifierPromptMutation
>
export type DeleteClassifierPromptMutationResult =
    Apollo.MutationResult<DeleteClassifierPromptMutation>
export type DeleteClassifierPromptMutationOptions = Apollo.BaseMutationOptions<
    DeleteClassifierPromptMutation,
    DeleteClassifierPromptMutationVariables
>
export const CreateClassifierDetailDocument = gql`
    mutation CreateClassifierDetail($input: CreateClassifierDetailInput!) {
        createClassifierDetail(input: $input) {
            ...ClassifierDetailFullItem
        }
    }
    ${ClassifierDetailFullItemFragmentDoc}
`
export type CreateClassifierDetailMutationFn = Apollo.MutationFunction<
    CreateClassifierDetailMutation,
    CreateClassifierDetailMutationVariables
>

/**
 * __useCreateClassifierDetailMutation__
 *
 * To run a mutation, you first call `useCreateClassifierDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassifierDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassifierDetailMutation, { data, loading, error }] = useCreateClassifierDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassifierDetailMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateClassifierDetailMutation,
        CreateClassifierDetailMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateClassifierDetailMutation,
        CreateClassifierDetailMutationVariables
    >(CreateClassifierDetailDocument, options)
}
export type CreateClassifierDetailMutationHookResult = ReturnType<
    typeof useCreateClassifierDetailMutation
>
export type CreateClassifierDetailMutationResult =
    Apollo.MutationResult<CreateClassifierDetailMutation>
export type CreateClassifierDetailMutationOptions = Apollo.BaseMutationOptions<
    CreateClassifierDetailMutation,
    CreateClassifierDetailMutationVariables
>
export const UpdateClassifierDetailDocument = gql`
    mutation UpdateClassifierDetail($input: UpdateClassifierDetailInput!) {
        updateClassifierDetail(input: $input) {
            ...ClassifierDetailFullItem
        }
    }
    ${ClassifierDetailFullItemFragmentDoc}
`
export type UpdateClassifierDetailMutationFn = Apollo.MutationFunction<
    UpdateClassifierDetailMutation,
    UpdateClassifierDetailMutationVariables
>

/**
 * __useUpdateClassifierDetailMutation__
 *
 * To run a mutation, you first call `useUpdateClassifierDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassifierDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClassifierDetailMutation, { data, loading, error }] = useUpdateClassifierDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassifierDetailMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateClassifierDetailMutation,
        UpdateClassifierDetailMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UpdateClassifierDetailMutation,
        UpdateClassifierDetailMutationVariables
    >(UpdateClassifierDetailDocument, options)
}
export type UpdateClassifierDetailMutationHookResult = ReturnType<
    typeof useUpdateClassifierDetailMutation
>
export type UpdateClassifierDetailMutationResult =
    Apollo.MutationResult<UpdateClassifierDetailMutation>
export type UpdateClassifierDetailMutationOptions = Apollo.BaseMutationOptions<
    UpdateClassifierDetailMutation,
    UpdateClassifierDetailMutationVariables
>
export const DeleteClassifierDetailDocument = gql`
    mutation DeleteClassifierDetail($id: Int!) {
        deleteClassifierDetail(id: $id)
    }
`
export type DeleteClassifierDetailMutationFn = Apollo.MutationFunction<
    DeleteClassifierDetailMutation,
    DeleteClassifierDetailMutationVariables
>

/**
 * __useDeleteClassifierDetailMutation__
 *
 * To run a mutation, you first call `useDeleteClassifierDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClassifierDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClassifierDetailMutation, { data, loading, error }] = useDeleteClassifierDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClassifierDetailMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteClassifierDetailMutation,
        DeleteClassifierDetailMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeleteClassifierDetailMutation,
        DeleteClassifierDetailMutationVariables
    >(DeleteClassifierDetailDocument, options)
}
export type DeleteClassifierDetailMutationHookResult = ReturnType<
    typeof useDeleteClassifierDetailMutation
>
export type DeleteClassifierDetailMutationResult =
    Apollo.MutationResult<DeleteClassifierDetailMutation>
export type DeleteClassifierDetailMutationOptions = Apollo.BaseMutationOptions<
    DeleteClassifierDetailMutation,
    DeleteClassifierDetailMutationVariables
>
export const ArchiveClassifierDetailDocument = gql`
    mutation ArchiveClassifierDetail($id: Int!) {
        archiveClassifierDetail(id: $id) {
            ...ClassifierDetailFullItem
        }
    }
    ${ClassifierDetailFullItemFragmentDoc}
`
export type ArchiveClassifierDetailMutationFn = Apollo.MutationFunction<
    ArchiveClassifierDetailMutation,
    ArchiveClassifierDetailMutationVariables
>

/**
 * __useArchiveClassifierDetailMutation__
 *
 * To run a mutation, you first call `useArchiveClassifierDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveClassifierDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveClassifierDetailMutation, { data, loading, error }] = useArchiveClassifierDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveClassifierDetailMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ArchiveClassifierDetailMutation,
        ArchiveClassifierDetailMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        ArchiveClassifierDetailMutation,
        ArchiveClassifierDetailMutationVariables
    >(ArchiveClassifierDetailDocument, options)
}
export type ArchiveClassifierDetailMutationHookResult = ReturnType<
    typeof useArchiveClassifierDetailMutation
>
export type ArchiveClassifierDetailMutationResult =
    Apollo.MutationResult<ArchiveClassifierDetailMutation>
export type ArchiveClassifierDetailMutationOptions = Apollo.BaseMutationOptions<
    ArchiveClassifierDetailMutation,
    ArchiveClassifierDetailMutationVariables
>
export const UnarchiveClassifierDetailDocument = gql`
    mutation UnarchiveClassifierDetail($id: Int!) {
        unarchiveClassifierDetail(id: $id) {
            ...ClassifierDetailFullItem
        }
    }
    ${ClassifierDetailFullItemFragmentDoc}
`
export type UnarchiveClassifierDetailMutationFn = Apollo.MutationFunction<
    UnarchiveClassifierDetailMutation,
    UnarchiveClassifierDetailMutationVariables
>

/**
 * __useUnarchiveClassifierDetailMutation__
 *
 * To run a mutation, you first call `useUnarchiveClassifierDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveClassifierDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveClassifierDetailMutation, { data, loading, error }] = useUnarchiveClassifierDetailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveClassifierDetailMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UnarchiveClassifierDetailMutation,
        UnarchiveClassifierDetailMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UnarchiveClassifierDetailMutation,
        UnarchiveClassifierDetailMutationVariables
    >(UnarchiveClassifierDetailDocument, options)
}
export type UnarchiveClassifierDetailMutationHookResult = ReturnType<
    typeof useUnarchiveClassifierDetailMutation
>
export type UnarchiveClassifierDetailMutationResult =
    Apollo.MutationResult<UnarchiveClassifierDetailMutation>
export type UnarchiveClassifierDetailMutationOptions = Apollo.BaseMutationOptions<
    UnarchiveClassifierDetailMutation,
    UnarchiveClassifierDetailMutationVariables
>
export const DeployClassifierToAccountsDocument = gql`
    mutation DeployClassifierToAccounts($classifierDetailsId: Int!, $accountIds: [Int!]!) {
        deployClassifierToAccounts(
            classifierDetailsId: $classifierDetailsId
            accountIds: $accountIds
        )
    }
`
export type DeployClassifierToAccountsMutationFn = Apollo.MutationFunction<
    DeployClassifierToAccountsMutation,
    DeployClassifierToAccountsMutationVariables
>

/**
 * __useDeployClassifierToAccountsMutation__
 *
 * To run a mutation, you first call `useDeployClassifierToAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployClassifierToAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployClassifierToAccountsMutation, { data, loading, error }] = useDeployClassifierToAccountsMutation({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useDeployClassifierToAccountsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeployClassifierToAccountsMutation,
        DeployClassifierToAccountsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeployClassifierToAccountsMutation,
        DeployClassifierToAccountsMutationVariables
    >(DeployClassifierToAccountsDocument, options)
}
export type DeployClassifierToAccountsMutationHookResult = ReturnType<
    typeof useDeployClassifierToAccountsMutation
>
export type DeployClassifierToAccountsMutationResult =
    Apollo.MutationResult<DeployClassifierToAccountsMutation>
export type DeployClassifierToAccountsMutationOptions = Apollo.BaseMutationOptions<
    DeployClassifierToAccountsMutation,
    DeployClassifierToAccountsMutationVariables
>
export const DeployClassifierToTeamDocument = gql`
    mutation DeployClassifierToTeam($classifierDetailsId: Int!, $teamId: Int!) {
        deployClassifierToTeam(classifierDetailsId: $classifierDetailsId, teamId: $teamId)
    }
`
export type DeployClassifierToTeamMutationFn = Apollo.MutationFunction<
    DeployClassifierToTeamMutation,
    DeployClassifierToTeamMutationVariables
>

/**
 * __useDeployClassifierToTeamMutation__
 *
 * To run a mutation, you first call `useDeployClassifierToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployClassifierToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployClassifierToTeamMutation, { data, loading, error }] = useDeployClassifierToTeamMutation({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeployClassifierToTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeployClassifierToTeamMutation,
        DeployClassifierToTeamMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        DeployClassifierToTeamMutation,
        DeployClassifierToTeamMutationVariables
    >(DeployClassifierToTeamDocument, options)
}
export type DeployClassifierToTeamMutationHookResult = ReturnType<
    typeof useDeployClassifierToTeamMutation
>
export type DeployClassifierToTeamMutationResult =
    Apollo.MutationResult<DeployClassifierToTeamMutation>
export type DeployClassifierToTeamMutationOptions = Apollo.BaseMutationOptions<
    DeployClassifierToTeamMutation,
    DeployClassifierToTeamMutationVariables
>
export const UndeployClassifierFromAccountsDocument = gql`
    mutation UndeployClassifierFromAccounts($classifierDetailsId: Int!, $accountIds: [Int!]!) {
        undeployClassifierFromAccounts(
            classifierDetailsId: $classifierDetailsId
            accountIds: $accountIds
        )
    }
`
export type UndeployClassifierFromAccountsMutationFn = Apollo.MutationFunction<
    UndeployClassifierFromAccountsMutation,
    UndeployClassifierFromAccountsMutationVariables
>

/**
 * __useUndeployClassifierFromAccountsMutation__
 *
 * To run a mutation, you first call `useUndeployClassifierFromAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeployClassifierFromAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeployClassifierFromAccountsMutation, { data, loading, error }] = useUndeployClassifierFromAccountsMutation({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useUndeployClassifierFromAccountsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UndeployClassifierFromAccountsMutation,
        UndeployClassifierFromAccountsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UndeployClassifierFromAccountsMutation,
        UndeployClassifierFromAccountsMutationVariables
    >(UndeployClassifierFromAccountsDocument, options)
}
export type UndeployClassifierFromAccountsMutationHookResult = ReturnType<
    typeof useUndeployClassifierFromAccountsMutation
>
export type UndeployClassifierFromAccountsMutationResult =
    Apollo.MutationResult<UndeployClassifierFromAccountsMutation>
export type UndeployClassifierFromAccountsMutationOptions = Apollo.BaseMutationOptions<
    UndeployClassifierFromAccountsMutation,
    UndeployClassifierFromAccountsMutationVariables
>
export const UndeployClassifierFromTeamDocument = gql`
    mutation UndeployClassifierFromTeam($classifierDetailsId: Int!, $teamId: Int!) {
        undeployClassifierFromTeam(classifierDetailsId: $classifierDetailsId, teamId: $teamId)
    }
`
export type UndeployClassifierFromTeamMutationFn = Apollo.MutationFunction<
    UndeployClassifierFromTeamMutation,
    UndeployClassifierFromTeamMutationVariables
>

/**
 * __useUndeployClassifierFromTeamMutation__
 *
 * To run a mutation, you first call `useUndeployClassifierFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeployClassifierFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeployClassifierFromTeamMutation, { data, loading, error }] = useUndeployClassifierFromTeamMutation({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useUndeployClassifierFromTeamMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UndeployClassifierFromTeamMutation,
        UndeployClassifierFromTeamMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        UndeployClassifierFromTeamMutation,
        UndeployClassifierFromTeamMutationVariables
    >(UndeployClassifierFromTeamDocument, options)
}
export type UndeployClassifierFromTeamMutationHookResult = ReturnType<
    typeof useUndeployClassifierFromTeamMutation
>
export type UndeployClassifierFromTeamMutationResult =
    Apollo.MutationResult<UndeployClassifierFromTeamMutation>
export type UndeployClassifierFromTeamMutationOptions = Apollo.BaseMutationOptions<
    UndeployClassifierFromTeamMutation,
    UndeployClassifierFromTeamMutationVariables
>
export const CreateMonitorProfileScheduleDocument = gql`
    mutation CreateMonitorProfileSchedule($input: CreateMonitorProfileScheduleInput!) {
        createMonitorProfileSchedule(input: $input) {
            tag
            kind
            status
            rowId
            cron
            intervalSecs
            scheduleEnglish
            nextRunAt
            attempt
            log
        }
    }
`
export type CreateMonitorProfileScheduleMutationFn = Apollo.MutationFunction<
    CreateMonitorProfileScheduleMutation,
    CreateMonitorProfileScheduleMutationVariables
>

/**
 * __useCreateMonitorProfileScheduleMutation__
 *
 * To run a mutation, you first call `useCreateMonitorProfileScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMonitorProfileScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMonitorProfileScheduleMutation, { data, loading, error }] = useCreateMonitorProfileScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMonitorProfileScheduleMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateMonitorProfileScheduleMutation,
        CreateMonitorProfileScheduleMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateMonitorProfileScheduleMutation,
        CreateMonitorProfileScheduleMutationVariables
    >(CreateMonitorProfileScheduleDocument, options)
}
export type CreateMonitorProfileScheduleMutationHookResult = ReturnType<
    typeof useCreateMonitorProfileScheduleMutation
>
export type CreateMonitorProfileScheduleMutationResult =
    Apollo.MutationResult<CreateMonitorProfileScheduleMutation>
export type CreateMonitorProfileScheduleMutationOptions = Apollo.BaseMutationOptions<
    CreateMonitorProfileScheduleMutation,
    CreateMonitorProfileScheduleMutationVariables
>
export const StopScheduledWorkDocument = gql`
    mutation StopScheduledWork($tag: String!) {
        stopScheduledWork(tag: $tag) {
            changed
            outcome
            message
        }
    }
`
export type StopScheduledWorkMutationFn = Apollo.MutationFunction<
    StopScheduledWorkMutation,
    StopScheduledWorkMutationVariables
>

/**
 * __useStopScheduledWorkMutation__
 *
 * To run a mutation, you first call `useStopScheduledWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopScheduledWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopScheduledWorkMutation, { data, loading, error }] = useStopScheduledWorkMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useStopScheduledWorkMutation(
    baseOptions?: Apollo.MutationHookOptions<
        StopScheduledWorkMutation,
        StopScheduledWorkMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<StopScheduledWorkMutation, StopScheduledWorkMutationVariables>(
        StopScheduledWorkDocument,
        options
    )
}
export type StopScheduledWorkMutationHookResult = ReturnType<typeof useStopScheduledWorkMutation>
export type StopScheduledWorkMutationResult = Apollo.MutationResult<StopScheduledWorkMutation>
export type StopScheduledWorkMutationOptions = Apollo.BaseMutationOptions<
    StopScheduledWorkMutation,
    StopScheduledWorkMutationVariables
>
export const RunScheduledWorkNowDocument = gql`
    mutation RunScheduledWorkNow($tag: String!) {
        runScheduledWorkNow(tag: $tag) {
            changed
            outcome
            message
        }
    }
`
export type RunScheduledWorkNowMutationFn = Apollo.MutationFunction<
    RunScheduledWorkNowMutation,
    RunScheduledWorkNowMutationVariables
>

/**
 * __useRunScheduledWorkNowMutation__
 *
 * To run a mutation, you first call `useRunScheduledWorkNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunScheduledWorkNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runScheduledWorkNowMutation, { data, loading, error }] = useRunScheduledWorkNowMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useRunScheduledWorkNowMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RunScheduledWorkNowMutation,
        RunScheduledWorkNowMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RunScheduledWorkNowMutation, RunScheduledWorkNowMutationVariables>(
        RunScheduledWorkNowDocument,
        options
    )
}
export type RunScheduledWorkNowMutationHookResult = ReturnType<
    typeof useRunScheduledWorkNowMutation
>
export type RunScheduledWorkNowMutationResult = Apollo.MutationResult<RunScheduledWorkNowMutation>
export type RunScheduledWorkNowMutationOptions = Apollo.BaseMutationOptions<
    RunScheduledWorkNowMutation,
    RunScheduledWorkNowMutationVariables
>
export const ChangeFleetJobCadenceDocument = gql`
    mutation ChangeFleetJobCadence($key: String!, $expectedRowId: String!, $intervalSecs: Int!) {
        changeFleetJobCadence(
            key: $key
            expectedRowId: $expectedRowId
            intervalSecs: $intervalSecs
        ) {
            changed
            outcome
            message
        }
    }
`
export type ChangeFleetJobCadenceMutationFn = Apollo.MutationFunction<
    ChangeFleetJobCadenceMutation,
    ChangeFleetJobCadenceMutationVariables
>

/**
 * __useChangeFleetJobCadenceMutation__
 *
 * To run a mutation, you first call `useChangeFleetJobCadenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeFleetJobCadenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeFleetJobCadenceMutation, { data, loading, error }] = useChangeFleetJobCadenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      expectedRowId: // value for 'expectedRowId'
 *      intervalSecs: // value for 'intervalSecs'
 *   },
 * });
 */
export function useChangeFleetJobCadenceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ChangeFleetJobCadenceMutation,
        ChangeFleetJobCadenceMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        ChangeFleetJobCadenceMutation,
        ChangeFleetJobCadenceMutationVariables
    >(ChangeFleetJobCadenceDocument, options)
}
export type ChangeFleetJobCadenceMutationHookResult = ReturnType<
    typeof useChangeFleetJobCadenceMutation
>
export type ChangeFleetJobCadenceMutationResult =
    Apollo.MutationResult<ChangeFleetJobCadenceMutation>
export type ChangeFleetJobCadenceMutationOptions = Apollo.BaseMutationOptions<
    ChangeFleetJobCadenceMutation,
    ChangeFleetJobCadenceMutationVariables
>
export const AddMonitorTargetsDocument = gql`
    mutation AddMonitorTargets($monitorTag: String!, $targets: [String!]!) {
        addMonitorTargets(monitorTag: $monitorTag, targets: $targets) {
            changed
            outcome
            message
        }
    }
`
export type AddMonitorTargetsMutationFn = Apollo.MutationFunction<
    AddMonitorTargetsMutation,
    AddMonitorTargetsMutationVariables
>

/**
 * __useAddMonitorTargetsMutation__
 *
 * To run a mutation, you first call `useAddMonitorTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMonitorTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMonitorTargetsMutation, { data, loading, error }] = useAddMonitorTargetsMutation({
 *   variables: {
 *      monitorTag: // value for 'monitorTag'
 *      targets: // value for 'targets'
 *   },
 * });
 */
export function useAddMonitorTargetsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddMonitorTargetsMutation,
        AddMonitorTargetsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<AddMonitorTargetsMutation, AddMonitorTargetsMutationVariables>(
        AddMonitorTargetsDocument,
        options
    )
}
export type AddMonitorTargetsMutationHookResult = ReturnType<typeof useAddMonitorTargetsMutation>
export type AddMonitorTargetsMutationResult = Apollo.MutationResult<AddMonitorTargetsMutation>
export type AddMonitorTargetsMutationOptions = Apollo.BaseMutationOptions<
    AddMonitorTargetsMutation,
    AddMonitorTargetsMutationVariables
>
export const CreateScrapedHistoricFetchDocument = gql`
    mutation CreateScrapedHistoricFetch(
        $monitorTag: String!
        $since: NaiveDate!
        $scrapeProfile: String
    ) {
        createScrapedHistoricFetch(
            monitorTag: $monitorTag
            since: $since
            scrapeProfile: $scrapeProfile
        ) {
            alreadyExisted
            message
            work {
                tag
                kind
                status
                rowId
                cron
                intervalSecs
                scheduleEnglish
                nextRunAt
                attempt
                log
            }
        }
    }
`
export type CreateScrapedHistoricFetchMutationFn = Apollo.MutationFunction<
    CreateScrapedHistoricFetchMutation,
    CreateScrapedHistoricFetchMutationVariables
>

/**
 * __useCreateScrapedHistoricFetchMutation__
 *
 * To run a mutation, you first call `useCreateScrapedHistoricFetchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScrapedHistoricFetchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScrapedHistoricFetchMutation, { data, loading, error }] = useCreateScrapedHistoricFetchMutation({
 *   variables: {
 *      monitorTag: // value for 'monitorTag'
 *      since: // value for 'since'
 *      scrapeProfile: // value for 'scrapeProfile'
 *   },
 * });
 */
export function useCreateScrapedHistoricFetchMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateScrapedHistoricFetchMutation,
        CreateScrapedHistoricFetchMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        CreateScrapedHistoricFetchMutation,
        CreateScrapedHistoricFetchMutationVariables
    >(CreateScrapedHistoricFetchDocument, options)
}
export type CreateScrapedHistoricFetchMutationHookResult = ReturnType<
    typeof useCreateScrapedHistoricFetchMutation
>
export type CreateScrapedHistoricFetchMutationResult =
    Apollo.MutationResult<CreateScrapedHistoricFetchMutation>
export type CreateScrapedHistoricFetchMutationOptions = Apollo.BaseMutationOptions<
    CreateScrapedHistoricFetchMutation,
    CreateScrapedHistoricFetchMutationVariables
>
export const RefreshCommentThreadDocument = gql`
    mutation refreshCommentThread($contentId: Int!) {
        refreshCommentThread(contentId: $contentId) {
            ...CommentThreadItem
        }
    }
    ${CommentThreadItemFragmentDoc}
`
export type RefreshCommentThreadMutationFn = Apollo.MutationFunction<
    RefreshCommentThreadMutation,
    RefreshCommentThreadMutationVariables
>

/**
 * __useRefreshCommentThreadMutation__
 *
 * To run a mutation, you first call `useRefreshCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCommentThreadMutation, { data, loading, error }] = useRefreshCommentThreadMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useRefreshCommentThreadMutation(
    baseOptions?: Apollo.MutationHookOptions<
        RefreshCommentThreadMutation,
        RefreshCommentThreadMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<RefreshCommentThreadMutation, RefreshCommentThreadMutationVariables>(
        RefreshCommentThreadDocument,
        options
    )
}
export type RefreshCommentThreadMutationHookResult = ReturnType<
    typeof useRefreshCommentThreadMutation
>
export type RefreshCommentThreadMutationResult = Apollo.MutationResult<RefreshCommentThreadMutation>
export type RefreshCommentThreadMutationOptions = Apollo.BaseMutationOptions<
    RefreshCommentThreadMutation,
    RefreshCommentThreadMutationVariables
>
export const StartPostConversationRefreshDocument = gql`
    mutation startPostConversationRefresh($postId: Int!) {
        startPostConversationRefresh(postId: $postId) {
            taskId
            startedAt
            result {
                ...PostRefreshTaskItem
            }
        }
    }
    ${PostRefreshTaskItemFragmentDoc}
`
export type StartPostConversationRefreshMutationFn = Apollo.MutationFunction<
    StartPostConversationRefreshMutation,
    StartPostConversationRefreshMutationVariables
>

/**
 * __useStartPostConversationRefreshMutation__
 *
 * To run a mutation, you first call `useStartPostConversationRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPostConversationRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPostConversationRefreshMutation, { data, loading, error }] = useStartPostConversationRefreshMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useStartPostConversationRefreshMutation(
    baseOptions?: Apollo.MutationHookOptions<
        StartPostConversationRefreshMutation,
        StartPostConversationRefreshMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        StartPostConversationRefreshMutation,
        StartPostConversationRefreshMutationVariables
    >(StartPostConversationRefreshDocument, options)
}
export type StartPostConversationRefreshMutationHookResult = ReturnType<
    typeof useStartPostConversationRefreshMutation
>
export type StartPostConversationRefreshMutationResult =
    Apollo.MutationResult<StartPostConversationRefreshMutation>
export type StartPostConversationRefreshMutationOptions = Apollo.BaseMutationOptions<
    StartPostConversationRefreshMutation,
    StartPostConversationRefreshMutationVariables
>
export const GetMyContentFeedsDocument = gql`
    query GetMyContentFeeds {
        getMyContentFeeds {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`

/**
 * __useGetMyContentFeedsQuery__
 *
 * To run a query within a React component, call `useGetMyContentFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContentFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContentFeedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyContentFeedsQuery(
    baseOptions?: Apollo.QueryHookOptions<GetMyContentFeedsQuery, GetMyContentFeedsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetMyContentFeedsQuery, GetMyContentFeedsQueryVariables>(
        GetMyContentFeedsDocument,
        options
    )
}
export function useGetMyContentFeedsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMyContentFeedsQuery,
        GetMyContentFeedsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetMyContentFeedsQuery, GetMyContentFeedsQueryVariables>(
        GetMyContentFeedsDocument,
        options
    )
}
export type GetMyContentFeedsQueryHookResult = ReturnType<typeof useGetMyContentFeedsQuery>
export type GetMyContentFeedsLazyQueryHookResult = ReturnType<typeof useGetMyContentFeedsLazyQuery>
export type GetMyContentFeedsQueryResult = Apollo.QueryResult<
    GetMyContentFeedsQuery,
    GetMyContentFeedsQueryVariables
>
export const GetContentFeedsForUserDocument = gql`
    query GetContentFeedsForUser($userId: Int!) {
        getContentFeedsForUser(userId: $userId) {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`

/**
 * __useGetContentFeedsForUserQuery__
 *
 * To run a query within a React component, call `useGetContentFeedsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFeedsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFeedsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetContentFeedsForUserQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentFeedsForUserQuery,
        GetContentFeedsForUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetContentFeedsForUserQuery, GetContentFeedsForUserQueryVariables>(
        GetContentFeedsForUserDocument,
        options
    )
}
export function useGetContentFeedsForUserLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentFeedsForUserQuery,
        GetContentFeedsForUserQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetContentFeedsForUserQuery, GetContentFeedsForUserQueryVariables>(
        GetContentFeedsForUserDocument,
        options
    )
}
export type GetContentFeedsForUserQueryHookResult = ReturnType<
    typeof useGetContentFeedsForUserQuery
>
export type GetContentFeedsForUserLazyQueryHookResult = ReturnType<
    typeof useGetContentFeedsForUserLazyQuery
>
export type GetContentFeedsForUserQueryResult = Apollo.QueryResult<
    GetContentFeedsForUserQuery,
    GetContentFeedsForUserQueryVariables
>
export const GetContentFeedDocument = gql`
    query GetContentFeed($contentFeedId: Int!) {
        getContentFeed(contentFeedId: $contentFeedId) {
            ...ContentFeedViewItem
        }
    }
    ${ContentFeedViewItemFragmentDoc}
`

/**
 * __useGetContentFeedQuery__
 *
 * To run a query within a React component, call `useGetContentFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFeedQuery({
 *   variables: {
 *      contentFeedId: // value for 'contentFeedId'
 *   },
 * });
 */
export function useGetContentFeedQuery(
    baseOptions: Apollo.QueryHookOptions<GetContentFeedQuery, GetContentFeedQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetContentFeedQuery, GetContentFeedQueryVariables>(
        GetContentFeedDocument,
        options
    )
}
export function useGetContentFeedLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetContentFeedQuery, GetContentFeedQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetContentFeedQuery, GetContentFeedQueryVariables>(
        GetContentFeedDocument,
        options
    )
}
export type GetContentFeedQueryHookResult = ReturnType<typeof useGetContentFeedQuery>
export type GetContentFeedLazyQueryHookResult = ReturnType<typeof useGetContentFeedLazyQuery>
export type GetContentFeedQueryResult = Apollo.QueryResult<
    GetContentFeedQuery,
    GetContentFeedQueryVariables
>
export const GetNotificationConfigurationForAccountDocument = gql`
    query GetNotificationConfigurationForAccount($accountId: Int!) {
        getNotificationConfigurationForAccount(accountId: $accountId) {
            ...NotificationConfigurationViewItem
        }
    }
    ${NotificationConfigurationViewItemFragmentDoc}
`

/**
 * __useGetNotificationConfigurationForAccountQuery__
 *
 * To run a query within a React component, call `useGetNotificationConfigurationForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationConfigurationForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationConfigurationForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetNotificationConfigurationForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetNotificationConfigurationForAccountQuery,
        GetNotificationConfigurationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetNotificationConfigurationForAccountQuery,
        GetNotificationConfigurationForAccountQueryVariables
    >(GetNotificationConfigurationForAccountDocument, options)
}
export function useGetNotificationConfigurationForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetNotificationConfigurationForAccountQuery,
        GetNotificationConfigurationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetNotificationConfigurationForAccountQuery,
        GetNotificationConfigurationForAccountQueryVariables
    >(GetNotificationConfigurationForAccountDocument, options)
}
export type GetNotificationConfigurationForAccountQueryHookResult = ReturnType<
    typeof useGetNotificationConfigurationForAccountQuery
>
export type GetNotificationConfigurationForAccountLazyQueryHookResult = ReturnType<
    typeof useGetNotificationConfigurationForAccountLazyQuery
>
export type GetNotificationConfigurationForAccountQueryResult = Apollo.QueryResult<
    GetNotificationConfigurationForAccountQuery,
    GetNotificationConfigurationForAccountQueryVariables
>
export const GetNotificationConfigurationDocument = gql`
    query GetNotificationConfiguration($notificationConfigurationId: Int!) {
        getNotificationConfiguration(notificationConfigurationId: $notificationConfigurationId) {
            ...NotificationConfigurationViewItem
        }
    }
    ${NotificationConfigurationViewItemFragmentDoc}
`

/**
 * __useGetNotificationConfigurationQuery__
 *
 * To run a query within a React component, call `useGetNotificationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationConfigurationQuery({
 *   variables: {
 *      notificationConfigurationId: // value for 'notificationConfigurationId'
 *   },
 * });
 */
export function useGetNotificationConfigurationQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetNotificationConfigurationQuery,
        GetNotificationConfigurationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetNotificationConfigurationQuery,
        GetNotificationConfigurationQueryVariables
    >(GetNotificationConfigurationDocument, options)
}
export function useGetNotificationConfigurationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetNotificationConfigurationQuery,
        GetNotificationConfigurationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetNotificationConfigurationQuery,
        GetNotificationConfigurationQueryVariables
    >(GetNotificationConfigurationDocument, options)
}
export type GetNotificationConfigurationQueryHookResult = ReturnType<
    typeof useGetNotificationConfigurationQuery
>
export type GetNotificationConfigurationLazyQueryHookResult = ReturnType<
    typeof useGetNotificationConfigurationLazyQuery
>
export type GetNotificationConfigurationQueryResult = Apollo.QueryResult<
    GetNotificationConfigurationQuery,
    GetNotificationConfigurationQueryVariables
>
export const GetDashboardDocument = gql`
    query GetDashboard($dashboardId: Int!) {
        getDashboard(dashboardId: $dashboardId) {
            ...DashboardViewItem
        }
    }
    ${DashboardViewItemFragmentDoc}
`

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useGetDashboardQuery(
    baseOptions: Apollo.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(
        GetDashboardDocument,
        options
    )
}
export function useGetDashboardLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(
        GetDashboardDocument,
        options
    )
}
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>
export type GetDashboardQueryResult = Apollo.QueryResult<
    GetDashboardQuery,
    GetDashboardQueryVariables
>
export const GetEditableDashboardDocument = gql`
    query GetEditableDashboard($dashboardId: Int!) {
        getEditableDashboard(dashboardId: $dashboardId) {
            ...EditableDashboardViewItem
        }
    }
    ${EditableDashboardViewItemFragmentDoc}
`

/**
 * __useGetEditableDashboardQuery__
 *
 * To run a query within a React component, call `useGetEditableDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditableDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditableDashboardQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useGetEditableDashboardQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEditableDashboardQuery,
        GetEditableDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetEditableDashboardQuery, GetEditableDashboardQueryVariables>(
        GetEditableDashboardDocument,
        options
    )
}
export function useGetEditableDashboardLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEditableDashboardQuery,
        GetEditableDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetEditableDashboardQuery, GetEditableDashboardQueryVariables>(
        GetEditableDashboardDocument,
        options
    )
}
export type GetEditableDashboardQueryHookResult = ReturnType<typeof useGetEditableDashboardQuery>
export type GetEditableDashboardLazyQueryHookResult = ReturnType<
    typeof useGetEditableDashboardLazyQuery
>
export type GetEditableDashboardQueryResult = Apollo.QueryResult<
    GetEditableDashboardQuery,
    GetEditableDashboardQueryVariables
>
export const GetDashboardsDocument = gql`
    query GetDashboards {
        getDashboards {
            ...DashboardViewItem
        }
    }
    ${DashboardViewItemFragmentDoc}
`

/**
 * __useGetDashboardsQuery__
 *
 * To run a query within a React component, call `useGetDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardsQuery(
    baseOptions?: Apollo.QueryHookOptions<GetDashboardsQuery, GetDashboardsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDashboardsQuery, GetDashboardsQueryVariables>(
        GetDashboardsDocument,
        options
    )
}
export function useGetDashboardsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardsQuery, GetDashboardsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetDashboardsQuery, GetDashboardsQueryVariables>(
        GetDashboardsDocument,
        options
    )
}
export type GetDashboardsQueryHookResult = ReturnType<typeof useGetDashboardsQuery>
export type GetDashboardsLazyQueryHookResult = ReturnType<typeof useGetDashboardsLazyQuery>
export type GetDashboardsQueryResult = Apollo.QueryResult<
    GetDashboardsQuery,
    GetDashboardsQueryVariables
>
export const GetEmbeddedDashboardDocument = gql`
    query getEmbeddedDashboard($dashboardId: Int!) {
        getEmbeddedDashboard(dashboardId: $dashboardId) {
            ...EmbeddedDashboardViewItem
        }
    }
    ${EmbeddedDashboardViewItemFragmentDoc}
`

/**
 * __useGetEmbeddedDashboardQuery__
 *
 * To run a query within a React component, call `useGetEmbeddedDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbeddedDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbeddedDashboardQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useGetEmbeddedDashboardQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetEmbeddedDashboardQuery,
        GetEmbeddedDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetEmbeddedDashboardQuery, GetEmbeddedDashboardQueryVariables>(
        GetEmbeddedDashboardDocument,
        options
    )
}
export function useGetEmbeddedDashboardLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEmbeddedDashboardQuery,
        GetEmbeddedDashboardQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetEmbeddedDashboardQuery, GetEmbeddedDashboardQueryVariables>(
        GetEmbeddedDashboardDocument,
        options
    )
}
export type GetEmbeddedDashboardQueryHookResult = ReturnType<typeof useGetEmbeddedDashboardQuery>
export type GetEmbeddedDashboardLazyQueryHookResult = ReturnType<
    typeof useGetEmbeddedDashboardLazyQuery
>
export type GetEmbeddedDashboardQueryResult = Apollo.QueryResult<
    GetEmbeddedDashboardQuery,
    GetEmbeddedDashboardQueryVariables
>
export const GetModerationBoundariesDocument = gql`
    query GetModerationBoundaries($accountId: Int!) {
        getModerationBoundaries(accountId: $accountId) {
            ...ModerationBoundaryViewItem
        }
    }
    ${ModerationBoundaryViewItemFragmentDoc}
`

/**
 * __useGetModerationBoundariesQuery__
 *
 * To run a query within a React component, call `useGetModerationBoundariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModerationBoundariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModerationBoundariesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetModerationBoundariesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetModerationBoundariesQuery,
        GetModerationBoundariesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetModerationBoundariesQuery, GetModerationBoundariesQueryVariables>(
        GetModerationBoundariesDocument,
        options
    )
}
export function useGetModerationBoundariesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetModerationBoundariesQuery,
        GetModerationBoundariesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetModerationBoundariesQuery, GetModerationBoundariesQueryVariables>(
        GetModerationBoundariesDocument,
        options
    )
}
export type GetModerationBoundariesQueryHookResult = ReturnType<
    typeof useGetModerationBoundariesQuery
>
export type GetModerationBoundariesLazyQueryHookResult = ReturnType<
    typeof useGetModerationBoundariesLazyQuery
>
export type GetModerationBoundariesQueryResult = Apollo.QueryResult<
    GetModerationBoundariesQuery,
    GetModerationBoundariesQueryVariables
>
export const GetLlmReplyPromptDocument = gql`
    query getLlmReplyPrompt($accountId: Int!) {
        getLlmReplyPrompt(accountId: $accountId) {
            ...PromptViewItem
        }
    }
    ${PromptViewItemFragmentDoc}
`

/**
 * __useGetLlmReplyPromptQuery__
 *
 * To run a query within a React component, call `useGetLlmReplyPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLlmReplyPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLlmReplyPromptQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetLlmReplyPromptQuery(
    baseOptions: Apollo.QueryHookOptions<GetLlmReplyPromptQuery, GetLlmReplyPromptQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetLlmReplyPromptQuery, GetLlmReplyPromptQueryVariables>(
        GetLlmReplyPromptDocument,
        options
    )
}
export function useGetLlmReplyPromptLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetLlmReplyPromptQuery,
        GetLlmReplyPromptQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetLlmReplyPromptQuery, GetLlmReplyPromptQueryVariables>(
        GetLlmReplyPromptDocument,
        options
    )
}
export type GetLlmReplyPromptQueryHookResult = ReturnType<typeof useGetLlmReplyPromptQuery>
export type GetLlmReplyPromptLazyQueryHookResult = ReturnType<typeof useGetLlmReplyPromptLazyQuery>
export type GetLlmReplyPromptQueryResult = Apollo.QueryResult<
    GetLlmReplyPromptQuery,
    GetLlmReplyPromptQueryVariables
>
export const GetAvailableLlmModelsDocument = gql`
    query getAvailableLlmModels {
        getAvailableLlmModels {
            ...LlmModelInfoItem
        }
    }
    ${LlmModelInfoItemFragmentDoc}
`

/**
 * __useGetAvailableLlmModelsQuery__
 *
 * To run a query within a React component, call `useGetAvailableLlmModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableLlmModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableLlmModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableLlmModelsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAvailableLlmModelsQuery,
        GetAvailableLlmModelsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAvailableLlmModelsQuery, GetAvailableLlmModelsQueryVariables>(
        GetAvailableLlmModelsDocument,
        options
    )
}
export function useGetAvailableLlmModelsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAvailableLlmModelsQuery,
        GetAvailableLlmModelsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAvailableLlmModelsQuery, GetAvailableLlmModelsQueryVariables>(
        GetAvailableLlmModelsDocument,
        options
    )
}
export type GetAvailableLlmModelsQueryHookResult = ReturnType<typeof useGetAvailableLlmModelsQuery>
export type GetAvailableLlmModelsLazyQueryHookResult = ReturnType<
    typeof useGetAvailableLlmModelsLazyQuery
>
export type GetAvailableLlmModelsQueryResult = Apollo.QueryResult<
    GetAvailableLlmModelsQuery,
    GetAvailableLlmModelsQueryVariables
>
export const GetAccountDocument = gql`
    query getAccount($accountId: Int!) {
        getAccount(accountId: $accountId) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountQuery(
    baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options)
}
export function useGetAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(
        GetAccountDocument,
        options
    )
}
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>
export const GetAccountsInTeamDocument = gql`
    query getAccountsInTeam($params: GetAccountsInTeamParamsView!) {
        getAccountsInTeam(params: $params) {
            ...AccountRecordItem
        }
    }
    ${AccountRecordItemFragmentDoc}
`

/**
 * __useGetAccountsInTeamQuery__
 *
 * To run a query within a React component, call `useGetAccountsInTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsInTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsInTeamQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAccountsInTeamQuery(
    baseOptions: Apollo.QueryHookOptions<GetAccountsInTeamQuery, GetAccountsInTeamQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAccountsInTeamQuery, GetAccountsInTeamQueryVariables>(
        GetAccountsInTeamDocument,
        options
    )
}
export function useGetAccountsInTeamLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAccountsInTeamQuery,
        GetAccountsInTeamQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAccountsInTeamQuery, GetAccountsInTeamQueryVariables>(
        GetAccountsInTeamDocument,
        options
    )
}
export type GetAccountsInTeamQueryHookResult = ReturnType<typeof useGetAccountsInTeamQuery>
export type GetAccountsInTeamLazyQueryHookResult = ReturnType<typeof useGetAccountsInTeamLazyQuery>
export type GetAccountsInTeamQueryResult = Apollo.QueryResult<
    GetAccountsInTeamQuery,
    GetAccountsInTeamQueryVariables
>
export const GetKeywordsForAccountDocument = gql`
    query getKeywordsForAccount($params: KeywordParamsList!) {
        getKeywordsForAccount(params: $params) {
            id
            keyword
            regex
            allowableRegex
            description
            accountId
            classifierDetailsDisplayName
            classifierDetailsId
            createdAt
        }
    }
`

/**
 * __useGetKeywordsForAccountQuery__
 *
 * To run a query within a React component, call `useGetKeywordsForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordsForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordsForAccountQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetKeywordsForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetKeywordsForAccountQuery,
        GetKeywordsForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetKeywordsForAccountQuery, GetKeywordsForAccountQueryVariables>(
        GetKeywordsForAccountDocument,
        options
    )
}
export function useGetKeywordsForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetKeywordsForAccountQuery,
        GetKeywordsForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetKeywordsForAccountQuery, GetKeywordsForAccountQueryVariables>(
        GetKeywordsForAccountDocument,
        options
    )
}
export type GetKeywordsForAccountQueryHookResult = ReturnType<typeof useGetKeywordsForAccountQuery>
export type GetKeywordsForAccountLazyQueryHookResult = ReturnType<
    typeof useGetKeywordsForAccountLazyQuery
>
export type GetKeywordsForAccountQueryResult = Apollo.QueryResult<
    GetKeywordsForAccountQuery,
    GetKeywordsForAccountQueryVariables
>
export const GetUserByIdDocument = gql`
    query getUserById($id: Int!) {
        getUserById(id: $id) {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(
        GetUserByIdDocument,
        options
    )
}
export function useGetUserByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(
        GetUserByIdDocument,
        options
    )
}
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>
export const GetUsersByTeamIdDocument = gql`
    query getUsersByTeamId($teamId: Int!) {
        getUsersByTeamId(teamId: $teamId) {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`

/**
 * __useGetUsersByTeamIdQuery__
 *
 * To run a query within a React component, call `useGetUsersByTeamIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByTeamIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByTeamIdQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetUsersByTeamIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetUsersByTeamIdQuery, GetUsersByTeamIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUsersByTeamIdQuery, GetUsersByTeamIdQueryVariables>(
        GetUsersByTeamIdDocument,
        options
    )
}
export function useGetUsersByTeamIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByTeamIdQuery, GetUsersByTeamIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUsersByTeamIdQuery, GetUsersByTeamIdQueryVariables>(
        GetUsersByTeamIdDocument,
        options
    )
}
export type GetUsersByTeamIdQueryHookResult = ReturnType<typeof useGetUsersByTeamIdQuery>
export type GetUsersByTeamIdLazyQueryHookResult = ReturnType<typeof useGetUsersByTeamIdLazyQuery>
export type GetUsersByTeamIdQueryResult = Apollo.QueryResult<
    GetUsersByTeamIdQuery,
    GetUsersByTeamIdQueryVariables
>
export const GetUserTeamsAdminDocument = gql`
    query getUserTeamsAdmin($userId: Int!) {
        getUserTeamsAdmin(userId: $userId) {
            ...TeamItem
        }
    }
    ${TeamItemFragmentDoc}
`

/**
 * __useGetUserTeamsAdminQuery__
 *
 * To run a query within a React component, call `useGetUserTeamsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTeamsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTeamsAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserTeamsAdminQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserTeamsAdminQuery, GetUserTeamsAdminQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserTeamsAdminQuery, GetUserTeamsAdminQueryVariables>(
        GetUserTeamsAdminDocument,
        options
    )
}
export function useGetUserTeamsAdminLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserTeamsAdminQuery,
        GetUserTeamsAdminQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserTeamsAdminQuery, GetUserTeamsAdminQueryVariables>(
        GetUserTeamsAdminDocument,
        options
    )
}
export type GetUserTeamsAdminQueryHookResult = ReturnType<typeof useGetUserTeamsAdminQuery>
export type GetUserTeamsAdminLazyQueryHookResult = ReturnType<typeof useGetUserTeamsAdminLazyQuery>
export type GetUserTeamsAdminQueryResult = Apollo.QueryResult<
    GetUserTeamsAdminQuery,
    GetUserTeamsAdminQueryVariables
>
export const GetUserIfAllowedDocument = gql`
    query getUserIfAllowed($id: Int!) {
        getUserIfAllowed(id: $id) {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`

/**
 * __useGetUserIfAllowedQuery__
 *
 * To run a query within a React component, call `useGetUserIfAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIfAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIfAllowedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserIfAllowedQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserIfAllowedQuery, GetUserIfAllowedQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserIfAllowedQuery, GetUserIfAllowedQueryVariables>(
        GetUserIfAllowedDocument,
        options
    )
}
export function useGetUserIfAllowedLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetUserIfAllowedQuery, GetUserIfAllowedQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserIfAllowedQuery, GetUserIfAllowedQueryVariables>(
        GetUserIfAllowedDocument,
        options
    )
}
export type GetUserIfAllowedQueryHookResult = ReturnType<typeof useGetUserIfAllowedQuery>
export type GetUserIfAllowedLazyQueryHookResult = ReturnType<typeof useGetUserIfAllowedLazyQuery>
export type GetUserIfAllowedQueryResult = Apollo.QueryResult<
    GetUserIfAllowedQuery,
    GetUserIfAllowedQueryVariables
>
export const SearchUsersDocument = gql`
    query searchUsers($params: UserSearchParams!) {
        searchUsers(params: $params) {
            ...UserItem
        }
    }
    ${UserItemFragmentDoc}
`

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchUsersQuery(
    baseOptions: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(
        SearchUsersDocument,
        options
    )
}
export function useSearchUsersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(
        SearchUsersDocument,
        options
    )
}
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>
export const SearchUsersCountDocument = gql`
    query searchUsersCount($params: UserSearchParams!) {
        searchUsersCount(params: $params)
    }
`

/**
 * __useSearchUsersCountQuery__
 *
 * To run a query within a React component, call `useSearchUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersCountQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchUsersCountQuery(
    baseOptions: Apollo.QueryHookOptions<SearchUsersCountQuery, SearchUsersCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchUsersCountQuery, SearchUsersCountQueryVariables>(
        SearchUsersCountDocument,
        options
    )
}
export function useSearchUsersCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersCountQuery, SearchUsersCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchUsersCountQuery, SearchUsersCountQueryVariables>(
        SearchUsersCountDocument,
        options
    )
}
export type SearchUsersCountQueryHookResult = ReturnType<typeof useSearchUsersCountQuery>
export type SearchUsersCountLazyQueryHookResult = ReturnType<typeof useSearchUsersCountLazyQuery>
export type SearchUsersCountQueryResult = Apollo.QueryResult<
    SearchUsersCountQuery,
    SearchUsersCountQueryVariables
>
export const CheckMetaSubscriptionForAccountDocument = gql`
    query checkMetaSubscriptionForAccount($accountId: Int!) {
        checkMetaSubscriptionForAccount(accountId: $accountId)
    }
`

/**
 * __useCheckMetaSubscriptionForAccountQuery__
 *
 * To run a query within a React component, call `useCheckMetaSubscriptionForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMetaSubscriptionForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMetaSubscriptionForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCheckMetaSubscriptionForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        CheckMetaSubscriptionForAccountQuery,
        CheckMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        CheckMetaSubscriptionForAccountQuery,
        CheckMetaSubscriptionForAccountQueryVariables
    >(CheckMetaSubscriptionForAccountDocument, options)
}
export function useCheckMetaSubscriptionForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CheckMetaSubscriptionForAccountQuery,
        CheckMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        CheckMetaSubscriptionForAccountQuery,
        CheckMetaSubscriptionForAccountQueryVariables
    >(CheckMetaSubscriptionForAccountDocument, options)
}
export type CheckMetaSubscriptionForAccountQueryHookResult = ReturnType<
    typeof useCheckMetaSubscriptionForAccountQuery
>
export type CheckMetaSubscriptionForAccountLazyQueryHookResult = ReturnType<
    typeof useCheckMetaSubscriptionForAccountLazyQuery
>
export type CheckMetaSubscriptionForAccountQueryResult = Apollo.QueryResult<
    CheckMetaSubscriptionForAccountQuery,
    CheckMetaSubscriptionForAccountQueryVariables
>
export const CreateMetaSubscriptionForAccountDocument = gql`
    query createMetaSubscriptionForAccount($accountId: Int!) {
        createMetaSubscriptionForAccount(accountId: $accountId)
    }
`

/**
 * __useCreateMetaSubscriptionForAccountQuery__
 *
 * To run a query within a React component, call `useCreateMetaSubscriptionForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaSubscriptionForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateMetaSubscriptionForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCreateMetaSubscriptionForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        CreateMetaSubscriptionForAccountQuery,
        CreateMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        CreateMetaSubscriptionForAccountQuery,
        CreateMetaSubscriptionForAccountQueryVariables
    >(CreateMetaSubscriptionForAccountDocument, options)
}
export function useCreateMetaSubscriptionForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CreateMetaSubscriptionForAccountQuery,
        CreateMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        CreateMetaSubscriptionForAccountQuery,
        CreateMetaSubscriptionForAccountQueryVariables
    >(CreateMetaSubscriptionForAccountDocument, options)
}
export type CreateMetaSubscriptionForAccountQueryHookResult = ReturnType<
    typeof useCreateMetaSubscriptionForAccountQuery
>
export type CreateMetaSubscriptionForAccountLazyQueryHookResult = ReturnType<
    typeof useCreateMetaSubscriptionForAccountLazyQuery
>
export type CreateMetaSubscriptionForAccountQueryResult = Apollo.QueryResult<
    CreateMetaSubscriptionForAccountQuery,
    CreateMetaSubscriptionForAccountQueryVariables
>
export const DeleteMetaSubscriptionForAccountDocument = gql`
    query deleteMetaSubscriptionForAccount($accountId: Int!) {
        deleteMetaSubscriptionForAccount(accountId: $accountId)
    }
`

/**
 * __useDeleteMetaSubscriptionForAccountQuery__
 *
 * To run a query within a React component, call `useDeleteMetaSubscriptionForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteMetaSubscriptionForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteMetaSubscriptionForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteMetaSubscriptionForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        DeleteMetaSubscriptionForAccountQuery,
        DeleteMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        DeleteMetaSubscriptionForAccountQuery,
        DeleteMetaSubscriptionForAccountQueryVariables
    >(DeleteMetaSubscriptionForAccountDocument, options)
}
export function useDeleteMetaSubscriptionForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        DeleteMetaSubscriptionForAccountQuery,
        DeleteMetaSubscriptionForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        DeleteMetaSubscriptionForAccountQuery,
        DeleteMetaSubscriptionForAccountQueryVariables
    >(DeleteMetaSubscriptionForAccountDocument, options)
}
export type DeleteMetaSubscriptionForAccountQueryHookResult = ReturnType<
    typeof useDeleteMetaSubscriptionForAccountQuery
>
export type DeleteMetaSubscriptionForAccountLazyQueryHookResult = ReturnType<
    typeof useDeleteMetaSubscriptionForAccountLazyQuery
>
export type DeleteMetaSubscriptionForAccountQueryResult = Apollo.QueryResult<
    DeleteMetaSubscriptionForAccountQuery,
    DeleteMetaSubscriptionForAccountQueryVariables
>
export const DebugMetaAuthorisationForAccountDocument = gql`
    query debugMetaAuthorisationForAccount($accountId: Int!) {
        debugMetaAuthorisationForAccount(accountId: $accountId) {
            ...DebugTokenResponseViewItem
        }
    }
    ${DebugTokenResponseViewItemFragmentDoc}
`

/**
 * __useDebugMetaAuthorisationForAccountQuery__
 *
 * To run a query within a React component, call `useDebugMetaAuthorisationForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugMetaAuthorisationForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugMetaAuthorisationForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDebugMetaAuthorisationForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        DebugMetaAuthorisationForAccountQuery,
        DebugMetaAuthorisationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        DebugMetaAuthorisationForAccountQuery,
        DebugMetaAuthorisationForAccountQueryVariables
    >(DebugMetaAuthorisationForAccountDocument, options)
}
export function useDebugMetaAuthorisationForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        DebugMetaAuthorisationForAccountQuery,
        DebugMetaAuthorisationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        DebugMetaAuthorisationForAccountQuery,
        DebugMetaAuthorisationForAccountQueryVariables
    >(DebugMetaAuthorisationForAccountDocument, options)
}
export type DebugMetaAuthorisationForAccountQueryHookResult = ReturnType<
    typeof useDebugMetaAuthorisationForAccountQuery
>
export type DebugMetaAuthorisationForAccountLazyQueryHookResult = ReturnType<
    typeof useDebugMetaAuthorisationForAccountLazyQuery
>
export type DebugMetaAuthorisationForAccountQueryResult = Apollo.QueryResult<
    DebugMetaAuthorisationForAccountQuery,
    DebugMetaAuthorisationForAccountQueryVariables
>
export const CheckMetaAuthorisationForAccountDocument = gql`
    query checkMetaAuthorisationForAccount($accountId: Int!) {
        checkMetaAuthorisationForAccount(accountId: $accountId)
    }
`

/**
 * __useCheckMetaAuthorisationForAccountQuery__
 *
 * To run a query within a React component, call `useCheckMetaAuthorisationForAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMetaAuthorisationForAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMetaAuthorisationForAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCheckMetaAuthorisationForAccountQuery(
    baseOptions: Apollo.QueryHookOptions<
        CheckMetaAuthorisationForAccountQuery,
        CheckMetaAuthorisationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        CheckMetaAuthorisationForAccountQuery,
        CheckMetaAuthorisationForAccountQueryVariables
    >(CheckMetaAuthorisationForAccountDocument, options)
}
export function useCheckMetaAuthorisationForAccountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CheckMetaAuthorisationForAccountQuery,
        CheckMetaAuthorisationForAccountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        CheckMetaAuthorisationForAccountQuery,
        CheckMetaAuthorisationForAccountQueryVariables
    >(CheckMetaAuthorisationForAccountDocument, options)
}
export type CheckMetaAuthorisationForAccountQueryHookResult = ReturnType<
    typeof useCheckMetaAuthorisationForAccountQuery
>
export type CheckMetaAuthorisationForAccountLazyQueryHookResult = ReturnType<
    typeof useCheckMetaAuthorisationForAccountLazyQuery
>
export type CheckMetaAuthorisationForAccountQueryResult = Apollo.QueryResult<
    CheckMetaAuthorisationForAccountQuery,
    CheckMetaAuthorisationForAccountQueryVariables
>
export const GetUsersPermissionsDocument = gql`
    query getUsersPermissions($usernames: [String!]!) {
        getUserPermissions(usernames: $usernames) {
            userPermissions
        }
    }
`

/**
 * __useGetUsersPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUsersPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersPermissionsQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useGetUsersPermissionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUsersPermissionsQuery,
        GetUsersPermissionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUsersPermissionsQuery, GetUsersPermissionsQueryVariables>(
        GetUsersPermissionsDocument,
        options
    )
}
export function useGetUsersPermissionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUsersPermissionsQuery,
        GetUsersPermissionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUsersPermissionsQuery, GetUsersPermissionsQueryVariables>(
        GetUsersPermissionsDocument,
        options
    )
}
export type GetUsersPermissionsQueryHookResult = ReturnType<typeof useGetUsersPermissionsQuery>
export type GetUsersPermissionsLazyQueryHookResult = ReturnType<
    typeof useGetUsersPermissionsLazyQuery
>
export type GetUsersPermissionsQueryResult = Apollo.QueryResult<
    GetUsersPermissionsQuery,
    GetUsersPermissionsQueryVariables
>
export const GetTeamByIdDocument = gql`
    query getTeamById($teamId: Int!) {
        getTeamById(teamId: $teamId) {
            ...TeamItem
        }
    }
    ${TeamItemFragmentDoc}
`

/**
 * __useGetTeamByIdQuery__
 *
 * To run a query within a React component, call `useGetTeamByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamByIdQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetTeamByIdQuery, GetTeamByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTeamByIdQuery, GetTeamByIdQueryVariables>(
        GetTeamByIdDocument,
        options
    )
}
export function useGetTeamByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTeamByIdQuery, GetTeamByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTeamByIdQuery, GetTeamByIdQueryVariables>(
        GetTeamByIdDocument,
        options
    )
}
export type GetTeamByIdQueryHookResult = ReturnType<typeof useGetTeamByIdQuery>
export type GetTeamByIdLazyQueryHookResult = ReturnType<typeof useGetTeamByIdLazyQuery>
export type GetTeamByIdQueryResult = Apollo.QueryResult<GetTeamByIdQuery, GetTeamByIdQueryVariables>
export const GetTeamsDocument = gql`
    query getTeams {
        getTeams {
            ...TeamItem
        }
    }
    ${TeamItemFragmentDoc}
`

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamsQuery(
    baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options)
}
export function useGetTeamsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options)
}
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>
export const GetOauthUrlDocument = gql`
    query getOauthUrl($socialMediaService: String!, $baseUrl: String!) {
        getOauthUrl(socialMediaService: $socialMediaService, baseUrl: $baseUrl)
    }
`

/**
 * __useGetOauthUrlQuery__
 *
 * To run a query within a React component, call `useGetOauthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthUrlQuery({
 *   variables: {
 *      socialMediaService: // value for 'socialMediaService'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useGetOauthUrlQuery(
    baseOptions: Apollo.QueryHookOptions<GetOauthUrlQuery, GetOauthUrlQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetOauthUrlQuery, GetOauthUrlQueryVariables>(
        GetOauthUrlDocument,
        options
    )
}
export function useGetOauthUrlLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetOauthUrlQuery, GetOauthUrlQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetOauthUrlQuery, GetOauthUrlQueryVariables>(
        GetOauthUrlDocument,
        options
    )
}
export type GetOauthUrlQueryHookResult = ReturnType<typeof useGetOauthUrlQuery>
export type GetOauthUrlLazyQueryHookResult = ReturnType<typeof useGetOauthUrlLazyQuery>
export type GetOauthUrlQueryResult = Apollo.QueryResult<GetOauthUrlQuery, GetOauthUrlQueryVariables>
export const SearchTeamsDocument = gql`
    query searchTeams($params: TeamsSearchParamsView!) {
        searchTeams(params: $params) {
            ...TeamItem
        }
    }
    ${TeamItemFragmentDoc}
`

/**
 * __useSearchTeamsQuery__
 *
 * To run a query within a React component, call `useSearchTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTeamsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchTeamsQuery(
    baseOptions: Apollo.QueryHookOptions<SearchTeamsQuery, SearchTeamsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchTeamsQuery, SearchTeamsQueryVariables>(
        SearchTeamsDocument,
        options
    )
}
export function useSearchTeamsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchTeamsQuery, SearchTeamsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchTeamsQuery, SearchTeamsQueryVariables>(
        SearchTeamsDocument,
        options
    )
}
export type SearchTeamsQueryHookResult = ReturnType<typeof useSearchTeamsQuery>
export type SearchTeamsLazyQueryHookResult = ReturnType<typeof useSearchTeamsLazyQuery>
export type SearchTeamsQueryResult = Apollo.QueryResult<SearchTeamsQuery, SearchTeamsQueryVariables>
export const GetProfilesByIdsDocument = gql`
    query getProfilesByIds($profileIds: [Int!]!, $accountId: Int) {
        getProfilesByIds(profileIds: $profileIds, accountId: $accountId) {
            ...ProfileWithShadowBanItem
        }
    }
    ${ProfileWithShadowBanItemFragmentDoc}
`

/**
 * __useGetProfilesByIdsQuery__
 *
 * To run a query within a React component, call `useGetProfilesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilesByIdsQuery({
 *   variables: {
 *      profileIds: // value for 'profileIds'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetProfilesByIdsQuery(
    baseOptions: Apollo.QueryHookOptions<GetProfilesByIdsQuery, GetProfilesByIdsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetProfilesByIdsQuery, GetProfilesByIdsQueryVariables>(
        GetProfilesByIdsDocument,
        options
    )
}
export function useGetProfilesByIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetProfilesByIdsQuery, GetProfilesByIdsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetProfilesByIdsQuery, GetProfilesByIdsQueryVariables>(
        GetProfilesByIdsDocument,
        options
    )
}
export type GetProfilesByIdsQueryHookResult = ReturnType<typeof useGetProfilesByIdsQuery>
export type GetProfilesByIdsLazyQueryHookResult = ReturnType<typeof useGetProfilesByIdsLazyQuery>
export type GetProfilesByIdsQueryResult = Apollo.QueryResult<
    GetProfilesByIdsQuery,
    GetProfilesByIdsQueryVariables
>
export const GetProfileDocument = gql`
    query getProfile($contentId: Int!) {
        getProfile(contentId: $contentId) {
            ...ProfileItem
        }
    }
    ${ProfileItemFragmentDoc}
`

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetProfileQuery(
    baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options)
}
export function useGetProfileLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
        GetProfileDocument,
        options
    )
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>
export const SearchProfilesDocument = gql`
    query searchProfiles(
        $filter: ProfileFilterInput
        $sort: ProfileSortInput
        $limit: Int!
        $offset: Int!
    ) {
        searchProfiles(filter: $filter, sort: $sort, limit: $limit, offset: $offset) {
            ...ProfileItem
        }
    }
    ${ProfileItemFragmentDoc}
`

/**
 * __useSearchProfilesQuery__
 *
 * To run a query within a React component, call `useSearchProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchProfilesQuery(
    baseOptions: Apollo.QueryHookOptions<SearchProfilesQuery, SearchProfilesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchProfilesQuery, SearchProfilesQueryVariables>(
        SearchProfilesDocument,
        options
    )
}
export function useSearchProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchProfilesQuery, SearchProfilesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchProfilesQuery, SearchProfilesQueryVariables>(
        SearchProfilesDocument,
        options
    )
}
export type SearchProfilesQueryHookResult = ReturnType<typeof useSearchProfilesQuery>
export type SearchProfilesLazyQueryHookResult = ReturnType<typeof useSearchProfilesLazyQuery>
export type SearchProfilesQueryResult = Apollo.QueryResult<
    SearchProfilesQuery,
    SearchProfilesQueryVariables
>
export const CountProfilesDocument = gql`
    query countProfiles($filter: ProfileFilterInput) {
        countProfiles(filter: $filter)
    }
`

/**
 * __useCountProfilesQuery__
 *
 * To run a query within a React component, call `useCountProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountProfilesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountProfilesQuery(
    baseOptions?: Apollo.QueryHookOptions<CountProfilesQuery, CountProfilesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CountProfilesQuery, CountProfilesQueryVariables>(
        CountProfilesDocument,
        options
    )
}
export function useCountProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CountProfilesQuery, CountProfilesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CountProfilesQuery, CountProfilesQueryVariables>(
        CountProfilesDocument,
        options
    )
}
export type CountProfilesQueryHookResult = ReturnType<typeof useCountProfilesQuery>
export type CountProfilesLazyQueryHookResult = ReturnType<typeof useCountProfilesLazyQuery>
export type CountProfilesQueryResult = Apollo.QueryResult<
    CountProfilesQuery,
    CountProfilesQueryVariables
>
export const SearchShadowBannedProfilesDocument = gql`
    query searchShadowBannedProfiles($accountId: Int!, $limit: Int!, $offset: Int!) {
        searchShadowBannedProfiles(accountId: $accountId, limit: $limit, offset: $offset) {
            ...ProfileWithShadowBanItem
        }
    }
    ${ProfileWithShadowBanItemFragmentDoc}
`

/**
 * __useSearchShadowBannedProfilesQuery__
 *
 * To run a query within a React component, call `useSearchShadowBannedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchShadowBannedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchShadowBannedProfilesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchShadowBannedProfilesQuery(
    baseOptions: Apollo.QueryHookOptions<
        SearchShadowBannedProfilesQuery,
        SearchShadowBannedProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        SearchShadowBannedProfilesQuery,
        SearchShadowBannedProfilesQueryVariables
    >(SearchShadowBannedProfilesDocument, options)
}
export function useSearchShadowBannedProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        SearchShadowBannedProfilesQuery,
        SearchShadowBannedProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        SearchShadowBannedProfilesQuery,
        SearchShadowBannedProfilesQueryVariables
    >(SearchShadowBannedProfilesDocument, options)
}
export type SearchShadowBannedProfilesQueryHookResult = ReturnType<
    typeof useSearchShadowBannedProfilesQuery
>
export type SearchShadowBannedProfilesLazyQueryHookResult = ReturnType<
    typeof useSearchShadowBannedProfilesLazyQuery
>
export type SearchShadowBannedProfilesQueryResult = Apollo.QueryResult<
    SearchShadowBannedProfilesQuery,
    SearchShadowBannedProfilesQueryVariables
>
export const SearchAccountsDocument = gql`
    query searchAccounts($params: SearchAccountsParamsView!) {
        searchAccounts(params: $params) {
            accounts {
                ...AccountRecordItem
            }
            total
        }
    }
    ${AccountRecordItemFragmentDoc}
`

/**
 * __useSearchAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchAccountsQuery(
    baseOptions: Apollo.QueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(
        SearchAccountsDocument,
        options
    )
}
export function useSearchAccountsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(
        SearchAccountsDocument,
        options
    )
}
export type SearchAccountsQueryHookResult = ReturnType<typeof useSearchAccountsQuery>
export type SearchAccountsLazyQueryHookResult = ReturnType<typeof useSearchAccountsLazyQuery>
export type SearchAccountsQueryResult = Apollo.QueryResult<
    SearchAccountsQuery,
    SearchAccountsQueryVariables
>
export const GetSummaryForAccountsDocument = gql`
    query getSummaryForAccounts($params: ContentSearchParams!) {
        getSummaryForAccounts(params: $params) {
            ...ContentSummaryItem
        }
    }
    ${ContentSummaryItemFragmentDoc}
`

/**
 * __useGetSummaryForAccountsQuery__
 *
 * To run a query within a React component, call `useGetSummaryForAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryForAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSummaryForAccountsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetSummaryForAccountsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSummaryForAccountsQuery,
        GetSummaryForAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetSummaryForAccountsQuery, GetSummaryForAccountsQueryVariables>(
        GetSummaryForAccountsDocument,
        options
    )
}
export function useGetSummaryForAccountsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSummaryForAccountsQuery,
        GetSummaryForAccountsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetSummaryForAccountsQuery, GetSummaryForAccountsQueryVariables>(
        GetSummaryForAccountsDocument,
        options
    )
}
export type GetSummaryForAccountsQueryHookResult = ReturnType<typeof useGetSummaryForAccountsQuery>
export type GetSummaryForAccountsLazyQueryHookResult = ReturnType<
    typeof useGetSummaryForAccountsLazyQuery
>
export type GetSummaryForAccountsQueryResult = Apollo.QueryResult<
    GetSummaryForAccountsQuery,
    GetSummaryForAccountsQueryVariables
>
export const ContentSearchDocument = gql`
    query contentSearch($params: ContentSearchParams!) {
        contentSearch(params: $params) {
            ...ContentViewItem
        }
    }
    ${ContentViewItemFragmentDoc}
`

/**
 * __useContentSearchQuery__
 *
 * To run a query within a React component, call `useContentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSearchQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContentSearchQuery(
    baseOptions: Apollo.QueryHookOptions<ContentSearchQuery, ContentSearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ContentSearchQuery, ContentSearchQueryVariables>(
        ContentSearchDocument,
        options
    )
}
export function useContentSearchLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ContentSearchQuery, ContentSearchQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ContentSearchQuery, ContentSearchQueryVariables>(
        ContentSearchDocument,
        options
    )
}
export type ContentSearchQueryHookResult = ReturnType<typeof useContentSearchQuery>
export type ContentSearchLazyQueryHookResult = ReturnType<typeof useContentSearchLazyQuery>
export type ContentSearchQueryResult = Apollo.QueryResult<
    ContentSearchQuery,
    ContentSearchQueryVariables
>
export const ContentSearchCountDocument = gql`
    query contentSearchCount($params: ContentSearchParams!) {
        contentSearchCount(params: $params)
    }
`

/**
 * __useContentSearchCountQuery__
 *
 * To run a query within a React component, call `useContentSearchCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSearchCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSearchCountQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContentSearchCountQuery(
    baseOptions: Apollo.QueryHookOptions<ContentSearchCountQuery, ContentSearchCountQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ContentSearchCountQuery, ContentSearchCountQueryVariables>(
        ContentSearchCountDocument,
        options
    )
}
export function useContentSearchCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentSearchCountQuery,
        ContentSearchCountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ContentSearchCountQuery, ContentSearchCountQueryVariables>(
        ContentSearchCountDocument,
        options
    )
}
export type ContentSearchCountQueryHookResult = ReturnType<typeof useContentSearchCountQuery>
export type ContentSearchCountLazyQueryHookResult = ReturnType<
    typeof useContentSearchCountLazyQuery
>
export type ContentSearchCountQueryResult = Apollo.QueryResult<
    ContentSearchCountQuery,
    ContentSearchCountQueryVariables
>
export const ContentSearchTotalDocument = gql`
    query contentSearchTotal($params: ContentSearchParams!) {
        contentSearchTotal(params: $params)
    }
`

/**
 * __useContentSearchTotalQuery__
 *
 * To run a query within a React component, call `useContentSearchTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSearchTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSearchTotalQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContentSearchTotalQuery(
    baseOptions: Apollo.QueryHookOptions<ContentSearchTotalQuery, ContentSearchTotalQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ContentSearchTotalQuery, ContentSearchTotalQueryVariables>(
        ContentSearchTotalDocument,
        options
    )
}
export function useContentSearchTotalLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentSearchTotalQuery,
        ContentSearchTotalQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ContentSearchTotalQuery, ContentSearchTotalQueryVariables>(
        ContentSearchTotalDocument,
        options
    )
}
export type ContentSearchTotalQueryHookResult = ReturnType<typeof useContentSearchTotalQuery>
export type ContentSearchTotalLazyQueryHookResult = ReturnType<
    typeof useContentSearchTotalLazyQuery
>
export type ContentSearchTotalQueryResult = Apollo.QueryResult<
    ContentSearchTotalQuery,
    ContentSearchTotalQueryVariables
>
export const GetContentSearchTaskDocument = gql`
    query getContentSearchTask($taskId: String!) {
        getContentSearchTask(taskId: $taskId) {
            ...ContentSearchTaskResultFields
        }
    }
    ${ContentSearchTaskResultFieldsFragmentDoc}
`

/**
 * __useGetContentSearchTaskQuery__
 *
 * To run a query within a React component, call `useGetContentSearchTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSearchTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSearchTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetContentSearchTaskQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentSearchTaskQuery,
        GetContentSearchTaskQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetContentSearchTaskQuery, GetContentSearchTaskQueryVariables>(
        GetContentSearchTaskDocument,
        options
    )
}
export function useGetContentSearchTaskLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentSearchTaskQuery,
        GetContentSearchTaskQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetContentSearchTaskQuery, GetContentSearchTaskQueryVariables>(
        GetContentSearchTaskDocument,
        options
    )
}
export type GetContentSearchTaskQueryHookResult = ReturnType<typeof useGetContentSearchTaskQuery>
export type GetContentSearchTaskLazyQueryHookResult = ReturnType<
    typeof useGetContentSearchTaskLazyQuery
>
export type GetContentSearchTaskQueryResult = Apollo.QueryResult<
    GetContentSearchTaskQuery,
    GetContentSearchTaskQueryVariables
>
export const GetContentByIdDocument = gql`
    query getContentById($id: Int!) {
        getContentById(id: $id) {
            ...ContentViewItem
        }
    }
    ${ContentViewItemFragmentDoc}
`

/**
 * __useGetContentByIdQuery__
 *
 * To run a query within a React component, call `useGetContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentByIdQuery(
    baseOptions: Apollo.QueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetContentByIdQuery, GetContentByIdQueryVariables>(
        GetContentByIdDocument,
        options
    )
}
export function useGetContentByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetContentByIdQuery, GetContentByIdQueryVariables>(
        GetContentByIdDocument,
        options
    )
}
export type GetContentByIdQueryHookResult = ReturnType<typeof useGetContentByIdQuery>
export type GetContentByIdLazyQueryHookResult = ReturnType<typeof useGetContentByIdLazyQuery>
export type GetContentByIdQueryResult = Apollo.QueryResult<
    GetContentByIdQuery,
    GetContentByIdQueryVariables
>
export const GetContentClassifierMetadataDocument = gql`
    query getContentClassifierMetadata($params: ContentSearchParams!) {
        getContentClassifierMetadata(params: $params) {
            ...ContentClassifierMetadataItem
        }
    }
    ${ContentClassifierMetadataItemFragmentDoc}
`

/**
 * __useGetContentClassifierMetadataQuery__
 *
 * To run a query within a React component, call `useGetContentClassifierMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentClassifierMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentClassifierMetadataQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetContentClassifierMetadataQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentClassifierMetadataQuery,
        GetContentClassifierMetadataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetContentClassifierMetadataQuery,
        GetContentClassifierMetadataQueryVariables
    >(GetContentClassifierMetadataDocument, options)
}
export function useGetContentClassifierMetadataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentClassifierMetadataQuery,
        GetContentClassifierMetadataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetContentClassifierMetadataQuery,
        GetContentClassifierMetadataQueryVariables
    >(GetContentClassifierMetadataDocument, options)
}
export type GetContentClassifierMetadataQueryHookResult = ReturnType<
    typeof useGetContentClassifierMetadataQuery
>
export type GetContentClassifierMetadataLazyQueryHookResult = ReturnType<
    typeof useGetContentClassifierMetadataLazyQuery
>
export type GetContentClassifierMetadataQueryResult = Apollo.QueryResult<
    GetContentClassifierMetadataQuery,
    GetContentClassifierMetadataQueryVariables
>
export const GetUserAuthEventsDocument = gql`
    query getUserAuthEvents($username: String!) {
        getUserAuthEvents(username: $username) {
            ...UserAuthEventItem
        }
    }
    ${UserAuthEventItemFragmentDoc}
`

/**
 * __useGetUserAuthEventsQuery__
 *
 * To run a query within a React component, call `useGetUserAuthEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuthEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAuthEventsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserAuthEventsQuery(
    baseOptions: Apollo.QueryHookOptions<GetUserAuthEventsQuery, GetUserAuthEventsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserAuthEventsQuery, GetUserAuthEventsQueryVariables>(
        GetUserAuthEventsDocument,
        options
    )
}
export function useGetUserAuthEventsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserAuthEventsQuery,
        GetUserAuthEventsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserAuthEventsQuery, GetUserAuthEventsQueryVariables>(
        GetUserAuthEventsDocument,
        options
    )
}
export type GetUserAuthEventsQueryHookResult = ReturnType<typeof useGetUserAuthEventsQuery>
export type GetUserAuthEventsLazyQueryHookResult = ReturnType<typeof useGetUserAuthEventsLazyQuery>
export type GetUserAuthEventsQueryResult = Apollo.QueryResult<
    GetUserAuthEventsQuery,
    GetUserAuthEventsQueryVariables
>
export const DetectLanguagesDocument = gql`
    query detectLanguages($sourceTexts: [String!]!) {
        detectLanguages(sourceTexts: $sourceTexts) {
            ...DetectedLanguageItem
        }
    }
    ${DetectedLanguageItemFragmentDoc}
`

/**
 * __useDetectLanguagesQuery__
 *
 * To run a query within a React component, call `useDetectLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectLanguagesQuery({
 *   variables: {
 *      sourceTexts: // value for 'sourceTexts'
 *   },
 * });
 */
export function useDetectLanguagesQuery(
    baseOptions: Apollo.QueryHookOptions<DetectLanguagesQuery, DetectLanguagesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<DetectLanguagesQuery, DetectLanguagesQueryVariables>(
        DetectLanguagesDocument,
        options
    )
}
export function useDetectLanguagesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<DetectLanguagesQuery, DetectLanguagesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<DetectLanguagesQuery, DetectLanguagesQueryVariables>(
        DetectLanguagesDocument,
        options
    )
}
export type DetectLanguagesQueryHookResult = ReturnType<typeof useDetectLanguagesQuery>
export type DetectLanguagesLazyQueryHookResult = ReturnType<typeof useDetectLanguagesLazyQuery>
export type DetectLanguagesQueryResult = Apollo.QueryResult<
    DetectLanguagesQuery,
    DetectLanguagesQueryVariables
>
export const TranslateDocument = gql`
    query translate($sourceTexts: [String!]!, $targetLanguage: String!) {
        translate(sourceTexts: $sourceTexts, targetLanguage: $targetLanguage) {
            ...TranslatedTextItem
        }
    }
    ${TranslatedTextItemFragmentDoc}
`

/**
 * __useTranslateQuery__
 *
 * To run a query within a React component, call `useTranslateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslateQuery({
 *   variables: {
 *      sourceTexts: // value for 'sourceTexts'
 *      targetLanguage: // value for 'targetLanguage'
 *   },
 * });
 */
export function useTranslateQuery(
    baseOptions: Apollo.QueryHookOptions<TranslateQuery, TranslateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TranslateQuery, TranslateQueryVariables>(TranslateDocument, options)
}
export function useTranslateLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TranslateQuery, TranslateQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TranslateQuery, TranslateQueryVariables>(TranslateDocument, options)
}
export type TranslateQueryHookResult = ReturnType<typeof useTranslateQuery>
export type TranslateLazyQueryHookResult = ReturnType<typeof useTranslateLazyQuery>
export type TranslateQueryResult = Apollo.QueryResult<TranslateQuery, TranslateQueryVariables>
export const TestLlmClassificationPromptsDocument = gql`
    query TestLlmClassificationPrompts(
        $prompt: String!
        $testCases: [LlmClassificationTestInput!]!
        $model: String
    ) {
        testLlmClassificationPrompts(prompt: $prompt, testCases: $testCases, model: $model) {
            text
            target
            score
            justification
        }
    }
`

/**
 * __useTestLlmClassificationPromptsQuery__
 *
 * To run a query within a React component, call `useTestLlmClassificationPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestLlmClassificationPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestLlmClassificationPromptsQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      testCases: // value for 'testCases'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useTestLlmClassificationPromptsQuery(
    baseOptions: Apollo.QueryHookOptions<
        TestLlmClassificationPromptsQuery,
        TestLlmClassificationPromptsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        TestLlmClassificationPromptsQuery,
        TestLlmClassificationPromptsQueryVariables
    >(TestLlmClassificationPromptsDocument, options)
}
export function useTestLlmClassificationPromptsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestLlmClassificationPromptsQuery,
        TestLlmClassificationPromptsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        TestLlmClassificationPromptsQuery,
        TestLlmClassificationPromptsQueryVariables
    >(TestLlmClassificationPromptsDocument, options)
}
export type TestLlmClassificationPromptsQueryHookResult = ReturnType<
    typeof useTestLlmClassificationPromptsQuery
>
export type TestLlmClassificationPromptsLazyQueryHookResult = ReturnType<
    typeof useTestLlmClassificationPromptsLazyQuery
>
export type TestLlmClassificationPromptsQueryResult = Apollo.QueryResult<
    TestLlmClassificationPromptsQuery,
    TestLlmClassificationPromptsQueryVariables
>
export const TestLlmImageClassificationPromptsDocument = gql`
    query TestLlmImageClassificationPrompts(
        $prompt: String!
        $testCases: [LlmImageClassificationTestInput!]!
        $model: String
    ) {
        testLlmImageClassificationPrompts(prompt: $prompt, testCases: $testCases, model: $model) {
            fileName
            target
            score
            justification
        }
    }
`

/**
 * __useTestLlmImageClassificationPromptsQuery__
 *
 * To run a query within a React component, call `useTestLlmImageClassificationPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestLlmImageClassificationPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestLlmImageClassificationPromptsQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      testCases: // value for 'testCases'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useTestLlmImageClassificationPromptsQuery(
    baseOptions: Apollo.QueryHookOptions<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >(TestLlmImageClassificationPromptsDocument, options)
}
export function useTestLlmImageClassificationPromptsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        TestLlmImageClassificationPromptsQuery,
        TestLlmImageClassificationPromptsQueryVariables
    >(TestLlmImageClassificationPromptsDocument, options)
}
export type TestLlmImageClassificationPromptsQueryHookResult = ReturnType<
    typeof useTestLlmImageClassificationPromptsQuery
>
export type TestLlmImageClassificationPromptsLazyQueryHookResult = ReturnType<
    typeof useTestLlmImageClassificationPromptsLazyQuery
>
export type TestLlmImageClassificationPromptsQueryResult = Apollo.QueryResult<
    TestLlmImageClassificationPromptsQuery,
    TestLlmImageClassificationPromptsQueryVariables
>
export const GetAllServicesHealthDocument = gql`
    query GetAllServicesHealth {
        getAllServicesHealth {
            items {
                serviceName
                lastHeartbeat
                expectedIntervalSeconds
                healthStatus
                createdAt
                updatedAt
            }
            total
        }
    }
`

/**
 * __useGetAllServicesHealthQuery__
 *
 * To run a query within a React component, call `useGetAllServicesHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServicesHealthQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetAllServicesHealthQuery,
        GetAllServicesHealthQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAllServicesHealthQuery, GetAllServicesHealthQueryVariables>(
        GetAllServicesHealthDocument,
        options
    )
}
export function useGetAllServicesHealthLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAllServicesHealthQuery,
        GetAllServicesHealthQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAllServicesHealthQuery, GetAllServicesHealthQueryVariables>(
        GetAllServicesHealthDocument,
        options
    )
}
export type GetAllServicesHealthQueryHookResult = ReturnType<typeof useGetAllServicesHealthQuery>
export type GetAllServicesHealthLazyQueryHookResult = ReturnType<
    typeof useGetAllServicesHealthLazyQuery
>
export type GetAllServicesHealthQueryResult = Apollo.QueryResult<
    GetAllServicesHealthQuery,
    GetAllServicesHealthQueryVariables
>
export const StartChatDocument = gql`
    mutation StartChat($accountId: Int!, $sessionId: String!, $message: String!) {
        startChat(accountId: $accountId, sessionId: $sessionId, message: $message) {
            taskId
        }
    }
`
export type StartChatMutationFn = Apollo.MutationFunction<
    StartChatMutation,
    StartChatMutationVariables
>

/**
 * __useStartChatMutation__
 *
 * To run a mutation, you first call `useStartChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startChatMutation, { data, loading, error }] = useStartChatMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      sessionId: // value for 'sessionId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useStartChatMutation(
    baseOptions?: Apollo.MutationHookOptions<StartChatMutation, StartChatMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<StartChatMutation, StartChatMutationVariables>(
        StartChatDocument,
        options
    )
}
export type StartChatMutationHookResult = ReturnType<typeof useStartChatMutation>
export type StartChatMutationResult = Apollo.MutationResult<StartChatMutation>
export type StartChatMutationOptions = Apollo.BaseMutationOptions<
    StartChatMutation,
    StartChatMutationVariables
>
export const GetChatTaskStatusDocument = gql`
    query GetChatTaskStatus($taskId: String!) {
        getChatTaskStatus(taskId: $taskId) {
            status
            result {
                reply
                summary
            }
            errorMessage
            createdAt
            updatedAt
        }
    }
`

/**
 * __useGetChatTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetChatTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetChatTaskStatusQuery(
    baseOptions: Apollo.QueryHookOptions<GetChatTaskStatusQuery, GetChatTaskStatusQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetChatTaskStatusQuery, GetChatTaskStatusQueryVariables>(
        GetChatTaskStatusDocument,
        options
    )
}
export function useGetChatTaskStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetChatTaskStatusQuery,
        GetChatTaskStatusQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetChatTaskStatusQuery, GetChatTaskStatusQueryVariables>(
        GetChatTaskStatusDocument,
        options
    )
}
export type GetChatTaskStatusQueryHookResult = ReturnType<typeof useGetChatTaskStatusQuery>
export type GetChatTaskStatusLazyQueryHookResult = ReturnType<typeof useGetChatTaskStatusLazyQuery>
export type GetChatTaskStatusQueryResult = Apollo.QueryResult<
    GetChatTaskStatusQuery,
    GetChatTaskStatusQueryVariables
>
export const StartPrepareChatSessionDocument = gql`
    mutation StartPrepareChatSession(
        $accountId: Int!
        $model: String!
        $systemPrompt: String
        $searchParameters: ContentSearchParams
    ) {
        startPrepareChatSession(
            accountId: $accountId
            model: $model
            systemPrompt: $systemPrompt
            searchParameters: $searchParameters
        ) {
            taskId
        }
    }
`
export type StartPrepareChatSessionMutationFn = Apollo.MutationFunction<
    StartPrepareChatSessionMutation,
    StartPrepareChatSessionMutationVariables
>

/**
 * __useStartPrepareChatSessionMutation__
 *
 * To run a mutation, you first call `useStartPrepareChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPrepareChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPrepareChatSessionMutation, { data, loading, error }] = useStartPrepareChatSessionMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      model: // value for 'model'
 *      systemPrompt: // value for 'systemPrompt'
 *      searchParameters: // value for 'searchParameters'
 *   },
 * });
 */
export function useStartPrepareChatSessionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        StartPrepareChatSessionMutation,
        StartPrepareChatSessionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        StartPrepareChatSessionMutation,
        StartPrepareChatSessionMutationVariables
    >(StartPrepareChatSessionDocument, options)
}
export type StartPrepareChatSessionMutationHookResult = ReturnType<
    typeof useStartPrepareChatSessionMutation
>
export type StartPrepareChatSessionMutationResult =
    Apollo.MutationResult<StartPrepareChatSessionMutation>
export type StartPrepareChatSessionMutationOptions = Apollo.BaseMutationOptions<
    StartPrepareChatSessionMutation,
    StartPrepareChatSessionMutationVariables
>
export const GetDatasetPrepTaskStatusDocument = gql`
    query GetDatasetPrepTaskStatus($taskId: String!) {
        getDatasetPrepTaskStatus(taskId: $taskId) {
            status
            progressMessage
            result {
                sessionId
                itemCount
                earliest
                latest
                summary
                dateRangeWasReduced
            }
            errorMessage
            createdAt
            updatedAt
        }
    }
`

/**
 * __useGetDatasetPrepTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetDatasetPrepTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetPrepTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetPrepTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetDatasetPrepTaskStatusQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDatasetPrepTaskStatusQuery,
        GetDatasetPrepTaskStatusQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetDatasetPrepTaskStatusQuery, GetDatasetPrepTaskStatusQueryVariables>(
        GetDatasetPrepTaskStatusDocument,
        options
    )
}
export function useGetDatasetPrepTaskStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDatasetPrepTaskStatusQuery,
        GetDatasetPrepTaskStatusQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetDatasetPrepTaskStatusQuery,
        GetDatasetPrepTaskStatusQueryVariables
    >(GetDatasetPrepTaskStatusDocument, options)
}
export type GetDatasetPrepTaskStatusQueryHookResult = ReturnType<
    typeof useGetDatasetPrepTaskStatusQuery
>
export type GetDatasetPrepTaskStatusLazyQueryHookResult = ReturnType<
    typeof useGetDatasetPrepTaskStatusLazyQuery
>
export type GetDatasetPrepTaskStatusQueryResult = Apollo.QueryResult<
    GetDatasetPrepTaskStatusQuery,
    GetDatasetPrepTaskStatusQueryVariables
>
export const GetSuggestedRepliesDocument = gql`
    query getSuggestedReplies($contentId: Int!, $numberOfSuggestions: Int!, $temperature: Float) {
        getSuggestedReplies(
            contentId: $contentId
            numberOfSuggestions: $numberOfSuggestions
            temperature: $temperature
        )
    }
`

/**
 * __useGetSuggestedRepliesQuery__
 *
 * To run a query within a React component, call `useGetSuggestedRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedRepliesQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      numberOfSuggestions: // value for 'numberOfSuggestions'
 *      temperature: // value for 'temperature'
 *   },
 * });
 */
export function useGetSuggestedRepliesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetSuggestedRepliesQuery,
        GetSuggestedRepliesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetSuggestedRepliesQuery, GetSuggestedRepliesQueryVariables>(
        GetSuggestedRepliesDocument,
        options
    )
}
export function useGetSuggestedRepliesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSuggestedRepliesQuery,
        GetSuggestedRepliesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetSuggestedRepliesQuery, GetSuggestedRepliesQueryVariables>(
        GetSuggestedRepliesDocument,
        options
    )
}
export type GetSuggestedRepliesQueryHookResult = ReturnType<typeof useGetSuggestedRepliesQuery>
export type GetSuggestedRepliesLazyQueryHookResult = ReturnType<
    typeof useGetSuggestedRepliesLazyQuery
>
export type GetSuggestedRepliesQueryResult = Apollo.QueryResult<
    GetSuggestedRepliesQuery,
    GetSuggestedRepliesQueryVariables
>
export const TestLlmReplyPromptDocument = gql`
    query TestLlmReplyPrompt(
        $prompt: String!
        $testMessage: String!
        $numberOfSuggestions: Int
        $temperature: Float
        $model: String
    ) {
        testLlmReplyPrompt(
            prompt: $prompt
            testMessage: $testMessage
            numberOfSuggestions: $numberOfSuggestions
            temperature: $temperature
            model: $model
        )
    }
`

/**
 * __useTestLlmReplyPromptQuery__
 *
 * To run a query within a React component, call `useTestLlmReplyPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestLlmReplyPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestLlmReplyPromptQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      testMessage: // value for 'testMessage'
 *      numberOfSuggestions: // value for 'numberOfSuggestions'
 *      temperature: // value for 'temperature'
 *      model: // value for 'model'
 *   },
 * });
 */
export function useTestLlmReplyPromptQuery(
    baseOptions: Apollo.QueryHookOptions<TestLlmReplyPromptQuery, TestLlmReplyPromptQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<TestLlmReplyPromptQuery, TestLlmReplyPromptQueryVariables>(
        TestLlmReplyPromptDocument,
        options
    )
}
export function useTestLlmReplyPromptLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TestLlmReplyPromptQuery,
        TestLlmReplyPromptQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<TestLlmReplyPromptQuery, TestLlmReplyPromptQueryVariables>(
        TestLlmReplyPromptDocument,
        options
    )
}
export type TestLlmReplyPromptQueryHookResult = ReturnType<typeof useTestLlmReplyPromptQuery>
export type TestLlmReplyPromptLazyQueryHookResult = ReturnType<
    typeof useTestLlmReplyPromptLazyQuery
>
export type TestLlmReplyPromptQueryResult = Apollo.QueryResult<
    TestLlmReplyPromptQuery,
    TestLlmReplyPromptQueryVariables
>
export const GetCookiesDocument = gql`
    query GetCookies($platform: CookiePlatform!, $status: CookieStatus) {
        getCookies(platform: $platform, status: $status) {
            ...CookieSummaryItem
        }
    }
    ${CookieSummaryItemFragmentDoc}
`

/**
 * __useGetCookiesQuery__
 *
 * To run a query within a React component, call `useGetCookiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCookiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCookiesQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetCookiesQuery(
    baseOptions: Apollo.QueryHookOptions<GetCookiesQuery, GetCookiesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCookiesQuery, GetCookiesQueryVariables>(GetCookiesDocument, options)
}
export function useGetCookiesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCookiesQuery, GetCookiesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCookiesQuery, GetCookiesQueryVariables>(
        GetCookiesDocument,
        options
    )
}
export type GetCookiesQueryHookResult = ReturnType<typeof useGetCookiesQuery>
export type GetCookiesLazyQueryHookResult = ReturnType<typeof useGetCookiesLazyQuery>
export type GetCookiesQueryResult = Apollo.QueryResult<GetCookiesQuery, GetCookiesQueryVariables>
export const GetCookieDocument = gql`
    query GetCookie($cookieId: Int!) {
        getCookie(cookieId: $cookieId) {
            ...CookieSummaryItem
        }
    }
    ${CookieSummaryItemFragmentDoc}
`

/**
 * __useGetCookieQuery__
 *
 * To run a query within a React component, call `useGetCookieQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCookieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCookieQuery({
 *   variables: {
 *      cookieId: // value for 'cookieId'
 *   },
 * });
 */
export function useGetCookieQuery(
    baseOptions: Apollo.QueryHookOptions<GetCookieQuery, GetCookieQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCookieQuery, GetCookieQueryVariables>(GetCookieDocument, options)
}
export function useGetCookieLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCookieQuery, GetCookieQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCookieQuery, GetCookieQueryVariables>(GetCookieDocument, options)
}
export type GetCookieQueryHookResult = ReturnType<typeof useGetCookieQuery>
export type GetCookieLazyQueryHookResult = ReturnType<typeof useGetCookieLazyQuery>
export type GetCookieQueryResult = Apollo.QueryResult<GetCookieQuery, GetCookieQueryVariables>
export const ListReferrersDocument = gql`
    query ListReferrers($offset: Int!, $limit: Int!) {
        listReferrers(offset: $offset, limit: $limit) {
            referrers {
                ...ReferrerViewItem
            }
            total
        }
    }
    ${ReferrerViewItemFragmentDoc}
`

/**
 * __useListReferrersQuery__
 *
 * To run a query within a React component, call `useListReferrersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReferrersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReferrersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListReferrersQuery(
    baseOptions: Apollo.QueryHookOptions<ListReferrersQuery, ListReferrersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ListReferrersQuery, ListReferrersQueryVariables>(
        ListReferrersDocument,
        options
    )
}
export function useListReferrersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ListReferrersQuery, ListReferrersQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ListReferrersQuery, ListReferrersQueryVariables>(
        ListReferrersDocument,
        options
    )
}
export type ListReferrersQueryHookResult = ReturnType<typeof useListReferrersQuery>
export type ListReferrersLazyQueryHookResult = ReturnType<typeof useListReferrersLazyQuery>
export type ListReferrersQueryResult = Apollo.QueryResult<
    ListReferrersQuery,
    ListReferrersQueryVariables
>
export const GetScreenshotByContentIdDocument = gql`
    query GetScreenshotByContentId($contentId: Int!) {
        getScreenshotByContentId(contentId: $contentId) {
            ...ScreenshotItem
        }
    }
    ${ScreenshotItemFragmentDoc}
`

/**
 * __useGetScreenshotByContentIdQuery__
 *
 * To run a query within a React component, call `useGetScreenshotByContentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenshotByContentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenshotByContentIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetScreenshotByContentIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenshotByContentIdQuery,
        GetScreenshotByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetScreenshotByContentIdQuery, GetScreenshotByContentIdQueryVariables>(
        GetScreenshotByContentIdDocument,
        options
    )
}
export function useGetScreenshotByContentIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenshotByContentIdQuery,
        GetScreenshotByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetScreenshotByContentIdQuery,
        GetScreenshotByContentIdQueryVariables
    >(GetScreenshotByContentIdDocument, options)
}
export type GetScreenshotByContentIdQueryHookResult = ReturnType<
    typeof useGetScreenshotByContentIdQuery
>
export type GetScreenshotByContentIdLazyQueryHookResult = ReturnType<
    typeof useGetScreenshotByContentIdLazyQuery
>
export type GetScreenshotByContentIdQueryResult = Apollo.QueryResult<
    GetScreenshotByContentIdQuery,
    GetScreenshotByContentIdQueryVariables
>
export const GetScreenshotAdminListDocument = gql`
    query GetScreenshotAdminList($offset: Int!, $limit: Int!, $status: ScreenshotStatus) {
        getScreenshotAdminList(offset: $offset, limit: $limit, status: $status) {
            items {
                ...ScreenshotAttemptItem
            }
            total
        }
    }
    ${ScreenshotAttemptItemFragmentDoc}
`

/**
 * __useGetScreenshotAdminListQuery__
 *
 * To run a query within a React component, call `useGetScreenshotAdminListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenshotAdminListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenshotAdminListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetScreenshotAdminListQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenshotAdminListQuery,
        GetScreenshotAdminListQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetScreenshotAdminListQuery, GetScreenshotAdminListQueryVariables>(
        GetScreenshotAdminListDocument,
        options
    )
}
export function useGetScreenshotAdminListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenshotAdminListQuery,
        GetScreenshotAdminListQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetScreenshotAdminListQuery, GetScreenshotAdminListQueryVariables>(
        GetScreenshotAdminListDocument,
        options
    )
}
export type GetScreenshotAdminListQueryHookResult = ReturnType<
    typeof useGetScreenshotAdminListQuery
>
export type GetScreenshotAdminListLazyQueryHookResult = ReturnType<
    typeof useGetScreenshotAdminListLazyQuery
>
export type GetScreenshotAdminListQueryResult = Apollo.QueryResult<
    GetScreenshotAdminListQuery,
    GetScreenshotAdminListQueryVariables
>
export const GetScreenshotContentSummaryDocument = gql`
    query GetScreenshotContentSummary($offset: Int!, $limit: Int!, $status: ScreenshotStatus) {
        getScreenshotContentSummary(offset: $offset, limit: $limit, status: $status) {
            items {
                ...ScreenshotContentSummaryItem
            }
            total
        }
    }
    ${ScreenshotContentSummaryItemFragmentDoc}
`

/**
 * __useGetScreenshotContentSummaryQuery__
 *
 * To run a query within a React component, call `useGetScreenshotContentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenshotContentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenshotContentSummaryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetScreenshotContentSummaryQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenshotContentSummaryQuery,
        GetScreenshotContentSummaryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetScreenshotContentSummaryQuery,
        GetScreenshotContentSummaryQueryVariables
    >(GetScreenshotContentSummaryDocument, options)
}
export function useGetScreenshotContentSummaryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenshotContentSummaryQuery,
        GetScreenshotContentSummaryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetScreenshotContentSummaryQuery,
        GetScreenshotContentSummaryQueryVariables
    >(GetScreenshotContentSummaryDocument, options)
}
export type GetScreenshotContentSummaryQueryHookResult = ReturnType<
    typeof useGetScreenshotContentSummaryQuery
>
export type GetScreenshotContentSummaryLazyQueryHookResult = ReturnType<
    typeof useGetScreenshotContentSummaryLazyQuery
>
export type GetScreenshotContentSummaryQueryResult = Apollo.QueryResult<
    GetScreenshotContentSummaryQuery,
    GetScreenshotContentSummaryQueryVariables
>
export const GetScreenshotAttemptsByContentIdDocument = gql`
    query GetScreenshotAttemptsByContentId($contentId: Int!) {
        getScreenshotAttemptsByContentId(contentId: $contentId) {
            ...ScreenshotAttemptItem
        }
    }
    ${ScreenshotAttemptItemFragmentDoc}
`

/**
 * __useGetScreenshotAttemptsByContentIdQuery__
 *
 * To run a query within a React component, call `useGetScreenshotAttemptsByContentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenshotAttemptsByContentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenshotAttemptsByContentIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetScreenshotAttemptsByContentIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetScreenshotAttemptsByContentIdQuery,
        GetScreenshotAttemptsByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetScreenshotAttemptsByContentIdQuery,
        GetScreenshotAttemptsByContentIdQueryVariables
    >(GetScreenshotAttemptsByContentIdDocument, options)
}
export function useGetScreenshotAttemptsByContentIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetScreenshotAttemptsByContentIdQuery,
        GetScreenshotAttemptsByContentIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetScreenshotAttemptsByContentIdQuery,
        GetScreenshotAttemptsByContentIdQueryVariables
    >(GetScreenshotAttemptsByContentIdDocument, options)
}
export type GetScreenshotAttemptsByContentIdQueryHookResult = ReturnType<
    typeof useGetScreenshotAttemptsByContentIdQuery
>
export type GetScreenshotAttemptsByContentIdLazyQueryHookResult = ReturnType<
    typeof useGetScreenshotAttemptsByContentIdLazyQuery
>
export type GetScreenshotAttemptsByContentIdQueryResult = Apollo.QueryResult<
    GetScreenshotAttemptsByContentIdQuery,
    GetScreenshotAttemptsByContentIdQueryVariables
>
export const MetaAdVisibilityDocument = gql`
    query MetaAdVisibility($accountId: Int!, $days: Int) {
        metaAdVisibility(accountId: $accountId, days: $days) {
            accountId
            accountName
            serviceAccountId
            serviceAccountUsername
            adsLastFetched
            socialMediaService
            identityLabel
            attachmentLabel
            daysWindow
            matchedCount
            totalCount
            totalComments
            unmatchedComments
            adAccounts {
                id
                name
                isMatch
                attachments {
                    id
                    name
                }
            }
            authoriser {
                userId
                name
                email
                tokenIsValid
                tokenExpiresAt
                tokenDataAccessExpiresAt
                applicationName
                scopes
            }
        }
    }
`

/**
 * __useMetaAdVisibilityQuery__
 *
 * To run a query within a React component, call `useMetaAdVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaAdVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaAdVisibilityQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useMetaAdVisibilityQuery(
    baseOptions: Apollo.QueryHookOptions<MetaAdVisibilityQuery, MetaAdVisibilityQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<MetaAdVisibilityQuery, MetaAdVisibilityQueryVariables>(
        MetaAdVisibilityDocument,
        options
    )
}
export function useMetaAdVisibilityLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MetaAdVisibilityQuery, MetaAdVisibilityQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<MetaAdVisibilityQuery, MetaAdVisibilityQueryVariables>(
        MetaAdVisibilityDocument,
        options
    )
}
export type MetaAdVisibilityQueryHookResult = ReturnType<typeof useMetaAdVisibilityQuery>
export type MetaAdVisibilityLazyQueryHookResult = ReturnType<typeof useMetaAdVisibilityLazyQuery>
export type MetaAdVisibilityQueryResult = Apollo.QueryResult<
    MetaAdVisibilityQuery,
    MetaAdVisibilityQueryVariables
>
export const GetSocialMediaServicesDocument = gql`
    query getSocialMediaServices {
        getSocialMediaServices {
            id
            shortName
            displayName
            shortDescription
            longDescription
        }
    }
`

/**
 * __useGetSocialMediaServicesQuery__
 *
 * To run a query within a React component, call `useGetSocialMediaServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialMediaServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialMediaServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialMediaServicesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetSocialMediaServicesQuery,
        GetSocialMediaServicesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetSocialMediaServicesQuery, GetSocialMediaServicesQueryVariables>(
        GetSocialMediaServicesDocument,
        options
    )
}
export function useGetSocialMediaServicesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetSocialMediaServicesQuery,
        GetSocialMediaServicesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetSocialMediaServicesQuery, GetSocialMediaServicesQueryVariables>(
        GetSocialMediaServicesDocument,
        options
    )
}
export type GetSocialMediaServicesQueryHookResult = ReturnType<
    typeof useGetSocialMediaServicesQuery
>
export type GetSocialMediaServicesLazyQueryHookResult = ReturnType<
    typeof useGetSocialMediaServicesLazyQuery
>
export type GetSocialMediaServicesQueryResult = Apollo.QueryResult<
    GetSocialMediaServicesQuery,
    GetSocialMediaServicesQueryVariables
>
export const GetClassifierDetailsDocument = gql`
    query getClassifierDetails {
        getClassifierDetails {
            id
            shortName
            displayName
            shortDescription
            longDescription
        }
    }
`

/**
 * __useGetClassifierDetailsQuery__
 *
 * To run a query within a React component, call `useGetClassifierDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassifierDetailsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetClassifierDetailsQuery,
        GetClassifierDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetClassifierDetailsQuery, GetClassifierDetailsQueryVariables>(
        GetClassifierDetailsDocument,
        options
    )
}
export function useGetClassifierDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierDetailsQuery,
        GetClassifierDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetClassifierDetailsQuery, GetClassifierDetailsQueryVariables>(
        GetClassifierDetailsDocument,
        options
    )
}
export type GetClassifierDetailsQueryHookResult = ReturnType<typeof useGetClassifierDetailsQuery>
export type GetClassifierDetailsLazyQueryHookResult = ReturnType<
    typeof useGetClassifierDetailsLazyQuery
>
export type GetClassifierDetailsQueryResult = Apollo.QueryResult<
    GetClassifierDetailsQuery,
    GetClassifierDetailsQueryVariables
>
export const GetContentClassifierOptionsDocument = gql`
    query getContentClassifierOptions($params: ContentSearchParams!) {
        getContentClassifierOptions(params: $params) {
            id
            shortName
            displayName
        }
    }
`

/**
 * __useGetContentClassifierOptionsQuery__
 *
 * To run a query within a React component, call `useGetContentClassifierOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentClassifierOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentClassifierOptionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetContentClassifierOptionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetContentClassifierOptionsQuery,
        GetContentClassifierOptionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetContentClassifierOptionsQuery,
        GetContentClassifierOptionsQueryVariables
    >(GetContentClassifierOptionsDocument, options)
}
export function useGetContentClassifierOptionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetContentClassifierOptionsQuery,
        GetContentClassifierOptionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetContentClassifierOptionsQuery,
        GetContentClassifierOptionsQueryVariables
    >(GetContentClassifierOptionsDocument, options)
}
export type GetContentClassifierOptionsQueryHookResult = ReturnType<
    typeof useGetContentClassifierOptionsQuery
>
export type GetContentClassifierOptionsLazyQueryHookResult = ReturnType<
    typeof useGetContentClassifierOptionsLazyQuery
>
export type GetContentClassifierOptionsQueryResult = Apollo.QueryResult<
    GetContentClassifierOptionsQuery,
    GetContentClassifierOptionsQueryVariables
>
export const GetYouTubeSubscriptionDiagnosticUrlDocument = gql`
    query getYouTubeSubscriptionDiagnosticUrl($channelId: String!) {
        getYouTubeSubscriptionDiagnosticUrl(channelId: $channelId) {
            url
        }
    }
`

/**
 * __useGetYouTubeSubscriptionDiagnosticUrlQuery__
 *
 * To run a query within a React component, call `useGetYouTubeSubscriptionDiagnosticUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYouTubeSubscriptionDiagnosticUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYouTubeSubscriptionDiagnosticUrlQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetYouTubeSubscriptionDiagnosticUrlQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetYouTubeSubscriptionDiagnosticUrlQuery,
        GetYouTubeSubscriptionDiagnosticUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetYouTubeSubscriptionDiagnosticUrlQuery,
        GetYouTubeSubscriptionDiagnosticUrlQueryVariables
    >(GetYouTubeSubscriptionDiagnosticUrlDocument, options)
}
export function useGetYouTubeSubscriptionDiagnosticUrlLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetYouTubeSubscriptionDiagnosticUrlQuery,
        GetYouTubeSubscriptionDiagnosticUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetYouTubeSubscriptionDiagnosticUrlQuery,
        GetYouTubeSubscriptionDiagnosticUrlQueryVariables
    >(GetYouTubeSubscriptionDiagnosticUrlDocument, options)
}
export type GetYouTubeSubscriptionDiagnosticUrlQueryHookResult = ReturnType<
    typeof useGetYouTubeSubscriptionDiagnosticUrlQuery
>
export type GetYouTubeSubscriptionDiagnosticUrlLazyQueryHookResult = ReturnType<
    typeof useGetYouTubeSubscriptionDiagnosticUrlLazyQuery
>
export type GetYouTubeSubscriptionDiagnosticUrlQueryResult = Apollo.QueryResult<
    GetYouTubeSubscriptionDiagnosticUrlQuery,
    GetYouTubeSubscriptionDiagnosticUrlQueryVariables
>
export const GetClassifierPromptDocument = gql`
    query GetClassifierPrompt($id: Int!) {
        getClassifierPrompt(id: $id) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`

/**
 * __useGetClassifierPromptQuery__
 *
 * To run a query within a React component, call `useGetClassifierPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierPromptQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClassifierPromptQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierPromptQuery,
        GetClassifierPromptQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetClassifierPromptQuery, GetClassifierPromptQueryVariables>(
        GetClassifierPromptDocument,
        options
    )
}
export function useGetClassifierPromptLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierPromptQuery,
        GetClassifierPromptQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetClassifierPromptQuery, GetClassifierPromptQueryVariables>(
        GetClassifierPromptDocument,
        options
    )
}
export type GetClassifierPromptQueryHookResult = ReturnType<typeof useGetClassifierPromptQuery>
export type GetClassifierPromptLazyQueryHookResult = ReturnType<
    typeof useGetClassifierPromptLazyQuery
>
export type GetClassifierPromptQueryResult = Apollo.QueryResult<
    GetClassifierPromptQuery,
    GetClassifierPromptQueryVariables
>
export const GetClassifierPromptVersionsDocument = gql`
    query GetClassifierPromptVersions($classifierDetailsId: Int!) {
        getClassifierPromptVersions(classifierDetailsId: $classifierDetailsId) {
            ...ClassifierPromptItem
        }
    }
    ${ClassifierPromptItemFragmentDoc}
`

/**
 * __useGetClassifierPromptVersionsQuery__
 *
 * To run a query within a React component, call `useGetClassifierPromptVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierPromptVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierPromptVersionsQuery({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *   },
 * });
 */
export function useGetClassifierPromptVersionsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierPromptVersionsQuery,
        GetClassifierPromptVersionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetClassifierPromptVersionsQuery,
        GetClassifierPromptVersionsQueryVariables
    >(GetClassifierPromptVersionsDocument, options)
}
export function useGetClassifierPromptVersionsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierPromptVersionsQuery,
        GetClassifierPromptVersionsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassifierPromptVersionsQuery,
        GetClassifierPromptVersionsQueryVariables
    >(GetClassifierPromptVersionsDocument, options)
}
export type GetClassifierPromptVersionsQueryHookResult = ReturnType<
    typeof useGetClassifierPromptVersionsQuery
>
export type GetClassifierPromptVersionsLazyQueryHookResult = ReturnType<
    typeof useGetClassifierPromptVersionsLazyQuery
>
export type GetClassifierPromptVersionsQueryResult = Apollo.QueryResult<
    GetClassifierPromptVersionsQuery,
    GetClassifierPromptVersionsQueryVariables
>
export const GetPromptManagedClassifierIdsDocument = gql`
    query GetPromptManagedClassifierIds {
        getPromptManagedClassifierIds
    }
`

/**
 * __useGetPromptManagedClassifierIdsQuery__
 *
 * To run a query within a React component, call `useGetPromptManagedClassifierIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromptManagedClassifierIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromptManagedClassifierIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromptManagedClassifierIdsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetPromptManagedClassifierIdsQuery,
        GetPromptManagedClassifierIdsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetPromptManagedClassifierIdsQuery,
        GetPromptManagedClassifierIdsQueryVariables
    >(GetPromptManagedClassifierIdsDocument, options)
}
export function useGetPromptManagedClassifierIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPromptManagedClassifierIdsQuery,
        GetPromptManagedClassifierIdsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetPromptManagedClassifierIdsQuery,
        GetPromptManagedClassifierIdsQueryVariables
    >(GetPromptManagedClassifierIdsDocument, options)
}
export type GetPromptManagedClassifierIdsQueryHookResult = ReturnType<
    typeof useGetPromptManagedClassifierIdsQuery
>
export type GetPromptManagedClassifierIdsLazyQueryHookResult = ReturnType<
    typeof useGetPromptManagedClassifierIdsLazyQuery
>
export type GetPromptManagedClassifierIdsQueryResult = Apollo.QueryResult<
    GetPromptManagedClassifierIdsQuery,
    GetPromptManagedClassifierIdsQueryVariables
>
export const GetManagedClassifierDetailsDocument = gql`
    query GetManagedClassifierDetails {
        getManagedClassifierDetails {
            ...ClassifierDetailFullItem
        }
    }
    ${ClassifierDetailFullItemFragmentDoc}
`

/**
 * __useGetManagedClassifierDetailsQuery__
 *
 * To run a query within a React component, call `useGetManagedClassifierDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedClassifierDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedClassifierDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagedClassifierDetailsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetManagedClassifierDetailsQuery,
        GetManagedClassifierDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetManagedClassifierDetailsQuery,
        GetManagedClassifierDetailsQueryVariables
    >(GetManagedClassifierDetailsDocument, options)
}
export function useGetManagedClassifierDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetManagedClassifierDetailsQuery,
        GetManagedClassifierDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetManagedClassifierDetailsQuery,
        GetManagedClassifierDetailsQueryVariables
    >(GetManagedClassifierDetailsDocument, options)
}
export type GetManagedClassifierDetailsQueryHookResult = ReturnType<
    typeof useGetManagedClassifierDetailsQuery
>
export type GetManagedClassifierDetailsLazyQueryHookResult = ReturnType<
    typeof useGetManagedClassifierDetailsLazyQuery
>
export type GetManagedClassifierDetailsQueryResult = Apollo.QueryResult<
    GetManagedClassifierDetailsQuery,
    GetManagedClassifierDetailsQueryVariables
>
export const ClassifierNameAvailabilityDocument = gql`
    query ClassifierNameAvailability($shortName: String!) {
        classifierNameAvailability(shortName: $shortName) {
            available
            conflictingDisplayName
        }
    }
`

/**
 * __useClassifierNameAvailabilityQuery__
 *
 * To run a query within a React component, call `useClassifierNameAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassifierNameAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassifierNameAvailabilityQuery({
 *   variables: {
 *      shortName: // value for 'shortName'
 *   },
 * });
 */
export function useClassifierNameAvailabilityQuery(
    baseOptions: Apollo.QueryHookOptions<
        ClassifierNameAvailabilityQuery,
        ClassifierNameAvailabilityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        ClassifierNameAvailabilityQuery,
        ClassifierNameAvailabilityQueryVariables
    >(ClassifierNameAvailabilityDocument, options)
}
export function useClassifierNameAvailabilityLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ClassifierNameAvailabilityQuery,
        ClassifierNameAvailabilityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        ClassifierNameAvailabilityQuery,
        ClassifierNameAvailabilityQueryVariables
    >(ClassifierNameAvailabilityDocument, options)
}
export type ClassifierNameAvailabilityQueryHookResult = ReturnType<
    typeof useClassifierNameAvailabilityQuery
>
export type ClassifierNameAvailabilityLazyQueryHookResult = ReturnType<
    typeof useClassifierNameAvailabilityLazyQuery
>
export type ClassifierNameAvailabilityQueryResult = Apollo.QueryResult<
    ClassifierNameAvailabilityQuery,
    ClassifierNameAvailabilityQueryVariables
>
export const GetClassifierLibraryDocument = gql`
    query GetClassifierLibrary($params: ClassifierSearchView!) {
        getClassifierLibrary(params: $params) {
            total
            items {
                ...ClassifierLibraryRowItem
            }
        }
    }
    ${ClassifierLibraryRowItemFragmentDoc}
`

/**
 * __useGetClassifierLibraryQuery__
 *
 * To run a query within a React component, call `useGetClassifierLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierLibraryQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetClassifierLibraryQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierLibraryQuery,
        GetClassifierLibraryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetClassifierLibraryQuery, GetClassifierLibraryQueryVariables>(
        GetClassifierLibraryDocument,
        options
    )
}
export function useGetClassifierLibraryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierLibraryQuery,
        GetClassifierLibraryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetClassifierLibraryQuery, GetClassifierLibraryQueryVariables>(
        GetClassifierLibraryDocument,
        options
    )
}
export type GetClassifierLibraryQueryHookResult = ReturnType<typeof useGetClassifierLibraryQuery>
export type GetClassifierLibraryLazyQueryHookResult = ReturnType<
    typeof useGetClassifierLibraryLazyQuery
>
export type GetClassifierLibraryQueryResult = Apollo.QueryResult<
    GetClassifierLibraryQuery,
    GetClassifierLibraryQueryVariables
>
export const GetClassifierDeploymentTeamsDocument = gql`
    query GetClassifierDeploymentTeams(
        $classifierDetailsId: Int!
        $search: String
        $offset: Int!
        $limit: Int!
    ) {
        getClassifierDeploymentTeams(
            classifierDetailsId: $classifierDetailsId
            search: $search
            offset: $offset
            limit: $limit
        ) {
            total
            items {
                teamId
                teamName
                deployedCount
                totalCount
            }
        }
    }
`

/**
 * __useGetClassifierDeploymentTeamsQuery__
 *
 * To run a query within a React component, call `useGetClassifierDeploymentTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierDeploymentTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierDeploymentTeamsQuery({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClassifierDeploymentTeamsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierDeploymentTeamsQuery,
        GetClassifierDeploymentTeamsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetClassifierDeploymentTeamsQuery,
        GetClassifierDeploymentTeamsQueryVariables
    >(GetClassifierDeploymentTeamsDocument, options)
}
export function useGetClassifierDeploymentTeamsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierDeploymentTeamsQuery,
        GetClassifierDeploymentTeamsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassifierDeploymentTeamsQuery,
        GetClassifierDeploymentTeamsQueryVariables
    >(GetClassifierDeploymentTeamsDocument, options)
}
export type GetClassifierDeploymentTeamsQueryHookResult = ReturnType<
    typeof useGetClassifierDeploymentTeamsQuery
>
export type GetClassifierDeploymentTeamsLazyQueryHookResult = ReturnType<
    typeof useGetClassifierDeploymentTeamsLazyQuery
>
export type GetClassifierDeploymentTeamsQueryResult = Apollo.QueryResult<
    GetClassifierDeploymentTeamsQuery,
    GetClassifierDeploymentTeamsQueryVariables
>
export const GetClassifierDeployedProfilesDocument = gql`
    query GetClassifierDeployedProfiles(
        $classifierDetailsId: Int!
        $search: String
        $offset: Int!
        $limit: Int!
    ) {
        getClassifierDeployedProfiles(
            classifierDetailsId: $classifierDetailsId
            search: $search
            offset: $offset
            limit: $limit
        ) {
            total
            items {
                id
                name
                platform
                teamId
                teamName
            }
        }
    }
`

/**
 * __useGetClassifierDeployedProfilesQuery__
 *
 * To run a query within a React component, call `useGetClassifierDeployedProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierDeployedProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierDeployedProfilesQuery({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClassifierDeployedProfilesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierDeployedProfilesQuery,
        GetClassifierDeployedProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetClassifierDeployedProfilesQuery,
        GetClassifierDeployedProfilesQueryVariables
    >(GetClassifierDeployedProfilesDocument, options)
}
export function useGetClassifierDeployedProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierDeployedProfilesQuery,
        GetClassifierDeployedProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassifierDeployedProfilesQuery,
        GetClassifierDeployedProfilesQueryVariables
    >(GetClassifierDeployedProfilesDocument, options)
}
export type GetClassifierDeployedProfilesQueryHookResult = ReturnType<
    typeof useGetClassifierDeployedProfilesQuery
>
export type GetClassifierDeployedProfilesLazyQueryHookResult = ReturnType<
    typeof useGetClassifierDeployedProfilesLazyQuery
>
export type GetClassifierDeployedProfilesQueryResult = Apollo.QueryResult<
    GetClassifierDeployedProfilesQuery,
    GetClassifierDeployedProfilesQueryVariables
>
export const GetClassifierDeployedProfilesWithoutLlmClassificationDocument = gql`
    query GetClassifierDeployedProfilesWithoutLlmClassification($classifierDetailsId: Int!) {
        getClassifierDeployedProfilesWithoutLlmClassification(
            classifierDetailsId: $classifierDetailsId
        ) {
            id
            name
            teamId
            teamName
        }
    }
`

/**
 * __useGetClassifierDeployedProfilesWithoutLlmClassificationQuery__
 *
 * To run a query within a React component, call `useGetClassifierDeployedProfilesWithoutLlmClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierDeployedProfilesWithoutLlmClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierDeployedProfilesWithoutLlmClassificationQuery({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *   },
 * });
 */
export function useGetClassifierDeployedProfilesWithoutLlmClassificationQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierDeployedProfilesWithoutLlmClassificationQuery,
        GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetClassifierDeployedProfilesWithoutLlmClassificationQuery,
        GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables
    >(GetClassifierDeployedProfilesWithoutLlmClassificationDocument, options)
}
export function useGetClassifierDeployedProfilesWithoutLlmClassificationLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierDeployedProfilesWithoutLlmClassificationQuery,
        GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassifierDeployedProfilesWithoutLlmClassificationQuery,
        GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables
    >(GetClassifierDeployedProfilesWithoutLlmClassificationDocument, options)
}
export type GetClassifierDeployedProfilesWithoutLlmClassificationQueryHookResult = ReturnType<
    typeof useGetClassifierDeployedProfilesWithoutLlmClassificationQuery
>
export type GetClassifierDeployedProfilesWithoutLlmClassificationLazyQueryHookResult = ReturnType<
    typeof useGetClassifierDeployedProfilesWithoutLlmClassificationLazyQuery
>
export type GetClassifierDeployedProfilesWithoutLlmClassificationQueryResult = Apollo.QueryResult<
    GetClassifierDeployedProfilesWithoutLlmClassificationQuery,
    GetClassifierDeployedProfilesWithoutLlmClassificationQueryVariables
>
export const GetClassifierRemainingTeamProfilesDocument = gql`
    query GetClassifierRemainingTeamProfiles($classifierDetailsId: Int!, $teamId: Int!) {
        getClassifierRemainingTeamProfiles(
            classifierDetailsId: $classifierDetailsId
            teamId: $teamId
        ) {
            id
            name
            platform
        }
    }
`

/**
 * __useGetClassifierRemainingTeamProfilesQuery__
 *
 * To run a query within a React component, call `useGetClassifierRemainingTeamProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassifierRemainingTeamProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassifierRemainingTeamProfilesQuery({
 *   variables: {
 *      classifierDetailsId: // value for 'classifierDetailsId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetClassifierRemainingTeamProfilesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetClassifierRemainingTeamProfilesQuery,
        GetClassifierRemainingTeamProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetClassifierRemainingTeamProfilesQuery,
        GetClassifierRemainingTeamProfilesQueryVariables
    >(GetClassifierRemainingTeamProfilesDocument, options)
}
export function useGetClassifierRemainingTeamProfilesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassifierRemainingTeamProfilesQuery,
        GetClassifierRemainingTeamProfilesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassifierRemainingTeamProfilesQuery,
        GetClassifierRemainingTeamProfilesQueryVariables
    >(GetClassifierRemainingTeamProfilesDocument, options)
}
export type GetClassifierRemainingTeamProfilesQueryHookResult = ReturnType<
    typeof useGetClassifierRemainingTeamProfilesQuery
>
export type GetClassifierRemainingTeamProfilesLazyQueryHookResult = ReturnType<
    typeof useGetClassifierRemainingTeamProfilesLazyQuery
>
export type GetClassifierRemainingTeamProfilesQueryResult = Apollo.QueryResult<
    GetClassifierRemainingTeamProfilesQuery,
    GetClassifierRemainingTeamProfilesQueryVariables
>
export const ScheduledWorkDocument = gql`
    query scheduledWork($status: String, $limit: Int) {
        scheduledWork(status: $status, limit: $limit) {
            tag
            kind
            summary
            params
            status
            live
            rowId
            cron
            intervalSecs
            scheduleEnglish
            nextRunAt
            attempt
            log
            lastRunStatus
            lastRunLog
            lastRunAt
            consecutiveFailures
            needsAttention
        }
    }
`

/**
 * __useScheduledWorkQuery__
 *
 * To run a query within a React component, call `useScheduledWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledWorkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledWorkQuery({
 *   variables: {
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useScheduledWorkQuery(
    baseOptions?: Apollo.QueryHookOptions<ScheduledWorkQuery, ScheduledWorkQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ScheduledWorkQuery, ScheduledWorkQueryVariables>(
        ScheduledWorkDocument,
        options
    )
}
export function useScheduledWorkLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ScheduledWorkQuery, ScheduledWorkQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ScheduledWorkQuery, ScheduledWorkQueryVariables>(
        ScheduledWorkDocument,
        options
    )
}
export type ScheduledWorkQueryHookResult = ReturnType<typeof useScheduledWorkQuery>
export type ScheduledWorkLazyQueryHookResult = ReturnType<typeof useScheduledWorkLazyQuery>
export type ScheduledWorkQueryResult = Apollo.QueryResult<
    ScheduledWorkQuery,
    ScheduledWorkQueryVariables
>
export const ScheduledWorkAttentionCountDocument = gql`
    query scheduledWorkAttentionCount {
        scheduledWorkAttentionCount
    }
`

/**
 * __useScheduledWorkAttentionCountQuery__
 *
 * To run a query within a React component, call `useScheduledWorkAttentionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledWorkAttentionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledWorkAttentionCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledWorkAttentionCountQuery(
    baseOptions?: Apollo.QueryHookOptions<
        ScheduledWorkAttentionCountQuery,
        ScheduledWorkAttentionCountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        ScheduledWorkAttentionCountQuery,
        ScheduledWorkAttentionCountQueryVariables
    >(ScheduledWorkAttentionCountDocument, options)
}
export function useScheduledWorkAttentionCountLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ScheduledWorkAttentionCountQuery,
        ScheduledWorkAttentionCountQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        ScheduledWorkAttentionCountQuery,
        ScheduledWorkAttentionCountQueryVariables
    >(ScheduledWorkAttentionCountDocument, options)
}
export type ScheduledWorkAttentionCountQueryHookResult = ReturnType<
    typeof useScheduledWorkAttentionCountQuery
>
export type ScheduledWorkAttentionCountLazyQueryHookResult = ReturnType<
    typeof useScheduledWorkAttentionCountLazyQuery
>
export type ScheduledWorkAttentionCountQueryResult = Apollo.QueryResult<
    ScheduledWorkAttentionCountQuery,
    ScheduledWorkAttentionCountQueryVariables
>
export const FleetJobsDocument = gql`
    query fleetJobs {
        fleetJobs {
            key
            name
            description
            tag
            cadenceEditable
            defaultIntervalSecs
            minIntervalSecs
        }
    }
`

/**
 * __useFleetJobsQuery__
 *
 * To run a query within a React component, call `useFleetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFleetJobsQuery(
    baseOptions?: Apollo.QueryHookOptions<FleetJobsQuery, FleetJobsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<FleetJobsQuery, FleetJobsQueryVariables>(FleetJobsDocument, options)
}
export function useFleetJobsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<FleetJobsQuery, FleetJobsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<FleetJobsQuery, FleetJobsQueryVariables>(FleetJobsDocument, options)
}
export type FleetJobsQueryHookResult = ReturnType<typeof useFleetJobsQuery>
export type FleetJobsLazyQueryHookResult = ReturnType<typeof useFleetJobsLazyQuery>
export type FleetJobsQueryResult = Apollo.QueryResult<FleetJobsQuery, FleetJobsQueryVariables>
export const ScheduledWorkHistoryDocument = gql`
    query scheduledWorkHistory($tag: String!) {
        scheduledWorkHistory(tag: $tag) {
            rowId
            tag
            status
            attempt
            deferralCount
            scheduledBy
            log
            scheduledAt
            startedAt
            completedAt
            durationMs
        }
    }
`

/**
 * __useScheduledWorkHistoryQuery__
 *
 * To run a query within a React component, call `useScheduledWorkHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledWorkHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledWorkHistoryQuery({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useScheduledWorkHistoryQuery(
    baseOptions: Apollo.QueryHookOptions<
        ScheduledWorkHistoryQuery,
        ScheduledWorkHistoryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<ScheduledWorkHistoryQuery, ScheduledWorkHistoryQueryVariables>(
        ScheduledWorkHistoryDocument,
        options
    )
}
export function useScheduledWorkHistoryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ScheduledWorkHistoryQuery,
        ScheduledWorkHistoryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<ScheduledWorkHistoryQuery, ScheduledWorkHistoryQueryVariables>(
        ScheduledWorkHistoryDocument,
        options
    )
}
export type ScheduledWorkHistoryQueryHookResult = ReturnType<typeof useScheduledWorkHistoryQuery>
export type ScheduledWorkHistoryLazyQueryHookResult = ReturnType<
    typeof useScheduledWorkHistoryLazyQuery
>
export type ScheduledWorkHistoryQueryResult = Apollo.QueryResult<
    ScheduledWorkHistoryQuery,
    ScheduledWorkHistoryQueryVariables
>
export const AccountMonitoringDocument = gql`
    query accountMonitoring($platform: String!, $serviceAccountUsername: String!) {
        accountMonitoring(platform: $platform, serviceAccountUsername: $serviceAccountUsername) {
            monitor {
                tag
                kind
                status
                live
                rowId
                cron
                intervalSecs
                scheduleEnglish
                nextRunAt
                attempt
                log
                lastRunStatus
                lastRunLog
                lastRunAt
                consecutiveFailures
                needsAttention
            }
            settings {
                mode
                windowDays
                since
                targets
                scrapeProfile
            }
            runs {
                rowId
                tag
                status
                attempt
                deferralCount
                scheduledBy
                log
                scheduledAt
                startedAt
                completedAt
                durationMs
            }
        }
    }
`

/**
 * __useAccountMonitoringQuery__
 *
 * To run a query within a React component, call `useAccountMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMonitoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMonitoringQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      serviceAccountUsername: // value for 'serviceAccountUsername'
 *   },
 * });
 */
export function useAccountMonitoringQuery(
    baseOptions: Apollo.QueryHookOptions<AccountMonitoringQuery, AccountMonitoringQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<AccountMonitoringQuery, AccountMonitoringQueryVariables>(
        AccountMonitoringDocument,
        options
    )
}
export function useAccountMonitoringLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AccountMonitoringQuery,
        AccountMonitoringQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<AccountMonitoringQuery, AccountMonitoringQueryVariables>(
        AccountMonitoringDocument,
        options
    )
}
export type AccountMonitoringQueryHookResult = ReturnType<typeof useAccountMonitoringQuery>
export type AccountMonitoringLazyQueryHookResult = ReturnType<typeof useAccountMonitoringLazyQuery>
export type AccountMonitoringQueryResult = Apollo.QueryResult<
    AccountMonitoringQuery,
    AccountMonitoringQueryVariables
>
export const MonitoringHealthDocument = gql`
    query monitoringHealth($accountIds: [Int!]!) {
        monitoringHealth(accountIds: $accountIds) {
            accountId
            status
            label
            detail
        }
    }
`

/**
 * __useMonitoringHealthQuery__
 *
 * To run a query within a React component, call `useMonitoringHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoringHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoringHealthQuery({
 *   variables: {
 *      accountIds: // value for 'accountIds'
 *   },
 * });
 */
export function useMonitoringHealthQuery(
    baseOptions: Apollo.QueryHookOptions<MonitoringHealthQuery, MonitoringHealthQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<MonitoringHealthQuery, MonitoringHealthQueryVariables>(
        MonitoringHealthDocument,
        options
    )
}
export function useMonitoringHealthLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MonitoringHealthQuery, MonitoringHealthQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<MonitoringHealthQuery, MonitoringHealthQueryVariables>(
        MonitoringHealthDocument,
        options
    )
}
export type MonitoringHealthQueryHookResult = ReturnType<typeof useMonitoringHealthQuery>
export type MonitoringHealthLazyQueryHookResult = ReturnType<typeof useMonitoringHealthLazyQuery>
export type MonitoringHealthQueryResult = Apollo.QueryResult<
    MonitoringHealthQuery,
    MonitoringHealthQueryVariables
>
export const SearchAdminPostsDocument = gql`
    query SearchAdminPosts($params: AdminPostSearchParamsView!) {
        searchAdminPosts(params: $params) {
            posts {
                ...AdminPostItem
            }
            total
        }
    }
    ${AdminPostItemFragmentDoc}
`

/**
 * __useSearchAdminPostsQuery__
 *
 * To run a query within a React component, call `useSearchAdminPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdminPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdminPostsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchAdminPostsQuery(
    baseOptions: Apollo.QueryHookOptions<SearchAdminPostsQuery, SearchAdminPostsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<SearchAdminPostsQuery, SearchAdminPostsQueryVariables>(
        SearchAdminPostsDocument,
        options
    )
}
export function useSearchAdminPostsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchAdminPostsQuery, SearchAdminPostsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<SearchAdminPostsQuery, SearchAdminPostsQueryVariables>(
        SearchAdminPostsDocument,
        options
    )
}
export type SearchAdminPostsQueryHookResult = ReturnType<typeof useSearchAdminPostsQuery>
export type SearchAdminPostsLazyQueryHookResult = ReturnType<typeof useSearchAdminPostsLazyQuery>
export type SearchAdminPostsQueryResult = Apollo.QueryResult<
    SearchAdminPostsQuery,
    SearchAdminPostsQueryVariables
>
export const GetAdminPostDocument = gql`
    query GetAdminPost($postId: Int!) {
        getAdminPost(postId: $postId) {
            ...AdminPostItem
        }
    }
    ${AdminPostItemFragmentDoc}
`

/**
 * __useGetAdminPostQuery__
 *
 * To run a query within a React component, call `useGetAdminPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetAdminPostQuery(
    baseOptions: Apollo.QueryHookOptions<GetAdminPostQuery, GetAdminPostQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAdminPostQuery, GetAdminPostQueryVariables>(
        GetAdminPostDocument,
        options
    )
}
export function useGetAdminPostLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetAdminPostQuery, GetAdminPostQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAdminPostQuery, GetAdminPostQueryVariables>(
        GetAdminPostDocument,
        options
    )
}
export type GetAdminPostQueryHookResult = ReturnType<typeof useGetAdminPostQuery>
export type GetAdminPostLazyQueryHookResult = ReturnType<typeof useGetAdminPostLazyQuery>
export type GetAdminPostQueryResult = Apollo.QueryResult<
    GetAdminPostQuery,
    GetAdminPostQueryVariables
>
export const GetCommentThreadDocument = gql`
    query getCommentThread($contentId: Int!) {
        getCommentThread(contentId: $contentId) {
            ...CommentThreadItem
        }
    }
    ${CommentThreadItemFragmentDoc}
`

/**
 * __useGetCommentThreadQuery__
 *
 * To run a query within a React component, call `useGetCommentThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentThreadQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetCommentThreadQuery(
    baseOptions: Apollo.QueryHookOptions<GetCommentThreadQuery, GetCommentThreadQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCommentThreadQuery, GetCommentThreadQueryVariables>(
        GetCommentThreadDocument,
        options
    )
}
export function useGetCommentThreadLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCommentThreadQuery, GetCommentThreadQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCommentThreadQuery, GetCommentThreadQueryVariables>(
        GetCommentThreadDocument,
        options
    )
}
export type GetCommentThreadQueryHookResult = ReturnType<typeof useGetCommentThreadQuery>
export type GetCommentThreadLazyQueryHookResult = ReturnType<typeof useGetCommentThreadLazyQuery>
export type GetCommentThreadQueryResult = Apollo.QueryResult<
    GetCommentThreadQuery,
    GetCommentThreadQueryVariables
>
export const GetPostConversationPageDocument = gql`
    query getPostConversationPage($params: ContentSearchParams!, $after: String, $limit: Int) {
        getPostConversationPage(params: $params, after: $after, limit: $limit) {
            post {
                id
                title
                uri
                publishTime
                commentCount
            }
            items {
                gapCount
                gapAwaitingModerationCount
                thread {
                    ...PostConversationThreadItem
                }
            }
            nextCursor
            matchingTotal
            matchingCapped
            canRefresh
        }
    }
    ${PostConversationThreadItemFragmentDoc}
`

/**
 * __useGetPostConversationPageQuery__
 *
 * To run a query within a React component, call `useGetPostConversationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostConversationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostConversationPageQuery({
 *   variables: {
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostConversationPageQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPostConversationPageQuery,
        GetPostConversationPageQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetPostConversationPageQuery, GetPostConversationPageQueryVariables>(
        GetPostConversationPageDocument,
        options
    )
}
export function useGetPostConversationPageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPostConversationPageQuery,
        GetPostConversationPageQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetPostConversationPageQuery, GetPostConversationPageQueryVariables>(
        GetPostConversationPageDocument,
        options
    )
}
export type GetPostConversationPageQueryHookResult = ReturnType<
    typeof useGetPostConversationPageQuery
>
export type GetPostConversationPageLazyQueryHookResult = ReturnType<
    typeof useGetPostConversationPageLazyQuery
>
export type GetPostConversationPageQueryResult = Apollo.QueryResult<
    GetPostConversationPageQuery,
    GetPostConversationPageQueryVariables
>
export const PostConversationRefreshTaskDocument = gql`
    query postConversationRefreshTask($taskId: String!) {
        postConversationRefreshTask(taskId: $taskId) {
            ...PostRefreshTaskItem
        }
    }
    ${PostRefreshTaskItemFragmentDoc}
`

/**
 * __usePostConversationRefreshTaskQuery__
 *
 * To run a query within a React component, call `usePostConversationRefreshTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostConversationRefreshTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostConversationRefreshTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function usePostConversationRefreshTaskQuery(
    baseOptions: Apollo.QueryHookOptions<
        PostConversationRefreshTaskQuery,
        PostConversationRefreshTaskQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        PostConversationRefreshTaskQuery,
        PostConversationRefreshTaskQueryVariables
    >(PostConversationRefreshTaskDocument, options)
}
export function usePostConversationRefreshTaskLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PostConversationRefreshTaskQuery,
        PostConversationRefreshTaskQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        PostConversationRefreshTaskQuery,
        PostConversationRefreshTaskQueryVariables
    >(PostConversationRefreshTaskDocument, options)
}
export type PostConversationRefreshTaskQueryHookResult = ReturnType<
    typeof usePostConversationRefreshTaskQuery
>
export type PostConversationRefreshTaskLazyQueryHookResult = ReturnType<
    typeof usePostConversationRefreshTaskLazyQuery
>
export type PostConversationRefreshTaskQueryResult = Apollo.QueryResult<
    PostConversationRefreshTaskQuery,
    PostConversationRefreshTaskQueryVariables
>
export const GetMoreThreadRepliesDocument = gql`
    query getMoreThreadReplies(
        $contentId: Int!
        $params: ContentSearchParams!
        $after: String
        $limit: Int
    ) {
        getMoreThreadReplies(contentId: $contentId, params: $params, after: $after, limit: $limit) {
            replies {
                ...PostConversationReplyItem
            }
            nextCursor
        }
    }
    ${PostConversationReplyItemFragmentDoc}
`

/**
 * __useGetMoreThreadRepliesQuery__
 *
 * To run a query within a React component, call `useGetMoreThreadRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoreThreadRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoreThreadRepliesQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      params: // value for 'params'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMoreThreadRepliesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetMoreThreadRepliesQuery,
        GetMoreThreadRepliesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetMoreThreadRepliesQuery, GetMoreThreadRepliesQueryVariables>(
        GetMoreThreadRepliesDocument,
        options
    )
}
export function useGetMoreThreadRepliesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetMoreThreadRepliesQuery,
        GetMoreThreadRepliesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetMoreThreadRepliesQuery, GetMoreThreadRepliesQueryVariables>(
        GetMoreThreadRepliesDocument,
        options
    )
}
export type GetMoreThreadRepliesQueryHookResult = ReturnType<typeof useGetMoreThreadRepliesQuery>
export type GetMoreThreadRepliesLazyQueryHookResult = ReturnType<
    typeof useGetMoreThreadRepliesLazyQuery
>
export type GetMoreThreadRepliesQueryResult = Apollo.QueryResult<
    GetMoreThreadRepliesQuery,
    GetMoreThreadRepliesQueryVariables
>
export const DeleteAuthorisationDocument = gql`
    mutation DeleteAuthorisation($accountId: Int!) {
        deleteAuthorisation(accountId: $accountId)
    }
`
export type DeleteAuthorisationMutationFn = Apollo.MutationFunction<
    DeleteAuthorisationMutation,
    DeleteAuthorisationMutationVariables
>

/**
 * __useDeleteAuthorisationMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorisationMutation, { data, loading, error }] = useDeleteAuthorisationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteAuthorisationMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteAuthorisationMutation,
        DeleteAuthorisationMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<DeleteAuthorisationMutation, DeleteAuthorisationMutationVariables>(
        DeleteAuthorisationDocument,
        options
    )
}
export type DeleteAuthorisationMutationHookResult = ReturnType<
    typeof useDeleteAuthorisationMutation
>
export type DeleteAuthorisationMutationResult = Apollo.MutationResult<DeleteAuthorisationMutation>
export type DeleteAuthorisationMutationOptions = Apollo.BaseMutationOptions<
    DeleteAuthorisationMutation,
    DeleteAuthorisationMutationVariables
>
export const SaveAuthorisationCodeDocument = gql`
    mutation SaveAuthorisationCode(
        $accountId: Int
        $socialMediaServiceName: String
        $baseUrl: String
        $authCode: String!
        $authVerifier: String
    ) {
        saveAuthorisationCode(
            accountId: $accountId
            socialMediaServiceName: $socialMediaServiceName
            baseUrl: $baseUrl
            authCode: $authCode
            authVerifier: $authVerifier
        ) {
            ...SaveAuthorisationCodeResponseItem
        }
    }
    ${SaveAuthorisationCodeResponseItemFragmentDoc}
`
export type SaveAuthorisationCodeMutationFn = Apollo.MutationFunction<
    SaveAuthorisationCodeMutation,
    SaveAuthorisationCodeMutationVariables
>

/**
 * __useSaveAuthorisationCodeMutation__
 *
 * To run a mutation, you first call `useSaveAuthorisationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAuthorisationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAuthorisationCodeMutation, { data, loading, error }] = useSaveAuthorisationCodeMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      socialMediaServiceName: // value for 'socialMediaServiceName'
 *      baseUrl: // value for 'baseUrl'
 *      authCode: // value for 'authCode'
 *      authVerifier: // value for 'authVerifier'
 *   },
 * });
 */
export function useSaveAuthorisationCodeMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SaveAuthorisationCodeMutation,
        SaveAuthorisationCodeMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        SaveAuthorisationCodeMutation,
        SaveAuthorisationCodeMutationVariables
    >(SaveAuthorisationCodeDocument, options)
}
export type SaveAuthorisationCodeMutationHookResult = ReturnType<
    typeof useSaveAuthorisationCodeMutation
>
export type SaveAuthorisationCodeMutationResult =
    Apollo.MutationResult<SaveAuthorisationCodeMutation>
export type SaveAuthorisationCodeMutationOptions = Apollo.BaseMutationOptions<
    SaveAuthorisationCodeMutation,
    SaveAuthorisationCodeMutationVariables
>
export const TakeContentActionDocument = gql`
    mutation TakeContentAction(
        $contentId: Int!
        $action: ContentAction!
        $toggle: Boolean!
        $baseUrl: String
    ) {
        takeContentAction(
            contentId: $contentId
            action: $action
            toggle: $toggle
            baseUrl: $baseUrl
        ) {
            ...TakeContentActionResponseItem
        }
    }
    ${TakeContentActionResponseItemFragmentDoc}
`
export type TakeContentActionMutationFn = Apollo.MutationFunction<
    TakeContentActionMutation,
    TakeContentActionMutationVariables
>

/**
 * __useTakeContentActionMutation__
 *
 * To run a mutation, you first call `useTakeContentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeContentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeContentActionMutation, { data, loading, error }] = useTakeContentActionMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      action: // value for 'action'
 *      toggle: // value for 'toggle'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useTakeContentActionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TakeContentActionMutation,
        TakeContentActionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<TakeContentActionMutation, TakeContentActionMutationVariables>(
        TakeContentActionDocument,
        options
    )
}
export type TakeContentActionMutationHookResult = ReturnType<typeof useTakeContentActionMutation>
export type TakeContentActionMutationResult = Apollo.MutationResult<TakeContentActionMutation>
export type TakeContentActionMutationOptions = Apollo.BaseMutationOptions<
    TakeContentActionMutation,
    TakeContentActionMutationVariables
>
export const TakeContentActionsDocument = gql`
    mutation TakeContentActions(
        $contentIds: [Int!]!
        $action: ContentAction!
        $toggle: Boolean!
        $baseUrl: String
    ) {
        takeContentActions(
            contentIds: $contentIds
            action: $action
            toggle: $toggle
            baseUrl: $baseUrl
        ) {
            ...TakeContentActionsResponseItem
        }
    }
    ${TakeContentActionsResponseItemFragmentDoc}
`
export type TakeContentActionsMutationFn = Apollo.MutationFunction<
    TakeContentActionsMutation,
    TakeContentActionsMutationVariables
>

/**
 * __useTakeContentActionsMutation__
 *
 * To run a mutation, you first call `useTakeContentActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeContentActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeContentActionsMutation, { data, loading, error }] = useTakeContentActionsMutation({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *      action: // value for 'action'
 *      toggle: // value for 'toggle'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useTakeContentActionsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TakeContentActionsMutation,
        TakeContentActionsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<TakeContentActionsMutation, TakeContentActionsMutationVariables>(
        TakeContentActionsDocument,
        options
    )
}
export type TakeContentActionsMutationHookResult = ReturnType<typeof useTakeContentActionsMutation>
export type TakeContentActionsMutationResult = Apollo.MutationResult<TakeContentActionsMutation>
export type TakeContentActionsMutationOptions = Apollo.BaseMutationOptions<
    TakeContentActionsMutation,
    TakeContentActionsMutationVariables
>
export const ClassifyContentDocument = gql`
    mutation ClassifyContent($reason: String) {
        classifyContent(reason: $reason)
    }
`
export type ClassifyContentMutationFn = Apollo.MutationFunction<
    ClassifyContentMutation,
    ClassifyContentMutationVariables
>

/**
 * __useClassifyContentMutation__
 *
 * To run a mutation, you first call `useClassifyContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassifyContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classifyContentMutation, { data, loading, error }] = useClassifyContentMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useClassifyContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ClassifyContentMutation,
        ClassifyContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ClassifyContentMutation, ClassifyContentMutationVariables>(
        ClassifyContentDocument,
        options
    )
}
export type ClassifyContentMutationHookResult = ReturnType<typeof useClassifyContentMutation>
export type ClassifyContentMutationResult = Apollo.MutationResult<ClassifyContentMutation>
export type ClassifyContentMutationOptions = Apollo.BaseMutationOptions<
    ClassifyContentMutation,
    ClassifyContentMutationVariables
>
export const ModerateContentDocument = gql`
    mutation ModerateContent($reason: String) {
        moderateContent(reason: $reason)
    }
`
export type ModerateContentMutationFn = Apollo.MutationFunction<
    ModerateContentMutation,
    ModerateContentMutationVariables
>

/**
 * __useModerateContentMutation__
 *
 * To run a mutation, you first call `useModerateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModerateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moderateContentMutation, { data, loading, error }] = useModerateContentMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useModerateContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ModerateContentMutation,
        ModerateContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<ModerateContentMutation, ModerateContentMutationVariables>(
        ModerateContentDocument,
        options
    )
}
export type ModerateContentMutationHookResult = ReturnType<typeof useModerateContentMutation>
export type ModerateContentMutationResult = Apollo.MutationResult<ModerateContentMutation>
export type ModerateContentMutationOptions = Apollo.BaseMutationOptions<
    ModerateContentMutation,
    ModerateContentMutationVariables
>
export const FetchHistoricContentDocument = gql`
    mutation FetchHistoricContent($accountId: Int!, $tweetsRequested: Int!) {
        fetchHistoricContent(accountId: $accountId, tweetsRequested: $tweetsRequested)
    }
`
export type FetchHistoricContentMutationFn = Apollo.MutationFunction<
    FetchHistoricContentMutation,
    FetchHistoricContentMutationVariables
>

/**
 * __useFetchHistoricContentMutation__
 *
 * To run a mutation, you first call `useFetchHistoricContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchHistoricContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchHistoricContentMutation, { data, loading, error }] = useFetchHistoricContentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      tweetsRequested: // value for 'tweetsRequested'
 *   },
 * });
 */
export function useFetchHistoricContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        FetchHistoricContentMutation,
        FetchHistoricContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<FetchHistoricContentMutation, FetchHistoricContentMutationVariables>(
        FetchHistoricContentDocument,
        options
    )
}
export type FetchHistoricContentMutationHookResult = ReturnType<
    typeof useFetchHistoricContentMutation
>
export type FetchHistoricContentMutationResult = Apollo.MutationResult<FetchHistoricContentMutation>
export type FetchHistoricContentMutationOptions = Apollo.BaseMutationOptions<
    FetchHistoricContentMutation,
    FetchHistoricContentMutationVariables
>
export const FetchHistoricYouTubeVideosDocument = gql`
    mutation FetchHistoricYouTubeVideos($accountId: Int!) {
        fetchHistoricYouTubeVideos(accountId: $accountId)
    }
`
export type FetchHistoricYouTubeVideosMutationFn = Apollo.MutationFunction<
    FetchHistoricYouTubeVideosMutation,
    FetchHistoricYouTubeVideosMutationVariables
>

/**
 * __useFetchHistoricYouTubeVideosMutation__
 *
 * To run a mutation, you first call `useFetchHistoricYouTubeVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchHistoricYouTubeVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchHistoricYouTubeVideosMutation, { data, loading, error }] = useFetchHistoricYouTubeVideosMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFetchHistoricYouTubeVideosMutation(
    baseOptions?: Apollo.MutationHookOptions<
        FetchHistoricYouTubeVideosMutation,
        FetchHistoricYouTubeVideosMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<
        FetchHistoricYouTubeVideosMutation,
        FetchHistoricYouTubeVideosMutationVariables
    >(FetchHistoricYouTubeVideosDocument, options)
}
export type FetchHistoricYouTubeVideosMutationHookResult = ReturnType<
    typeof useFetchHistoricYouTubeVideosMutation
>
export type FetchHistoricYouTubeVideosMutationResult =
    Apollo.MutationResult<FetchHistoricYouTubeVideosMutation>
export type FetchHistoricYouTubeVideosMutationOptions = Apollo.BaseMutationOptions<
    FetchHistoricYouTubeVideosMutation,
    FetchHistoricYouTubeVideosMutationVariables
>
export const CreatePaymentPortalDocument = gql`
    mutation createPaymentPortal($successUrl: String!, $cancelUrl: String!) {
        createPaymentPortal(successUrl: $successUrl, cancelUrl: $cancelUrl)
    }
`
export type CreatePaymentPortalMutationFn = Apollo.MutationFunction<
    CreatePaymentPortalMutation,
    CreatePaymentPortalMutationVariables
>

/**
 * __useCreatePaymentPortalMutation__
 *
 * To run a mutation, you first call `useCreatePaymentPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentPortalMutation, { data, loading, error }] = useCreatePaymentPortalMutation({
 *   variables: {
 *      successUrl: // value for 'successUrl'
 *      cancelUrl: // value for 'cancelUrl'
 *   },
 * });
 */
export function useCreatePaymentPortalMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreatePaymentPortalMutation,
        CreatePaymentPortalMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useMutation<CreatePaymentPortalMutation, CreatePaymentPortalMutationVariables>(
        CreatePaymentPortalDocument,
        options
    )
}
export type CreatePaymentPortalMutationHookResult = ReturnType<
    typeof useCreatePaymentPortalMutation
>
export type CreatePaymentPortalMutationResult = Apollo.MutationResult<CreatePaymentPortalMutation>
export type CreatePaymentPortalMutationOptions = Apollo.BaseMutationOptions<
    CreatePaymentPortalMutation,
    CreatePaymentPortalMutationVariables
>
export const GetCustomerPaymentPortalUrlDocument = gql`
    query getCustomerPaymentPortalUrl($returnUrl: String!) {
        getCustomerPaymentPortalUrl(returnUrl: $returnUrl) {
            url
        }
    }
`

/**
 * __useGetCustomerPaymentPortalUrlQuery__
 *
 * To run a query within a React component, call `useGetCustomerPaymentPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerPaymentPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerPaymentPortalUrlQuery({
 *   variables: {
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useGetCustomerPaymentPortalUrlQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCustomerPaymentPortalUrlQuery,
        GetCustomerPaymentPortalUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetCustomerPaymentPortalUrlQuery,
        GetCustomerPaymentPortalUrlQueryVariables
    >(GetCustomerPaymentPortalUrlDocument, options)
}
export function useGetCustomerPaymentPortalUrlLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCustomerPaymentPortalUrlQuery,
        GetCustomerPaymentPortalUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetCustomerPaymentPortalUrlQuery,
        GetCustomerPaymentPortalUrlQueryVariables
    >(GetCustomerPaymentPortalUrlDocument, options)
}
export type GetCustomerPaymentPortalUrlQueryHookResult = ReturnType<
    typeof useGetCustomerPaymentPortalUrlQuery
>
export type GetCustomerPaymentPortalUrlLazyQueryHookResult = ReturnType<
    typeof useGetCustomerPaymentPortalUrlLazyQuery
>
export type GetCustomerPaymentPortalUrlQueryResult = Apollo.QueryResult<
    GetCustomerPaymentPortalUrlQuery,
    GetCustomerPaymentPortalUrlQueryVariables
>
export const CountContentDocument = gql`
    query CountContent(
        $startDateTime: AWSDateTime!
        $endDateTime: AWSDateTime!
        $filter: ContentFilterInput
        $keyword: String
    ) {
        countContent(
            filter: $filter
            startDateTime: $startDateTime
            endDateTime: $endDateTime
            keyword: $keyword
        ) {
            total
        }
    }
`

/**
 * __useCountContentQuery__
 *
 * To run a query within a React component, call `useCountContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountContentQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      filter: // value for 'filter'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useCountContentQuery(
    baseOptions: Apollo.QueryHookOptions<CountContentQuery, CountContentQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<CountContentQuery, CountContentQueryVariables>(
        CountContentDocument,
        options
    )
}
export function useCountContentLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<CountContentQuery, CountContentQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<CountContentQuery, CountContentQueryVariables>(
        CountContentDocument,
        options
    )
}
export type CountContentQueryHookResult = ReturnType<typeof useCountContentQuery>
export type CountContentLazyQueryHookResult = ReturnType<typeof useCountContentLazyQuery>
export type CountContentQueryResult = Apollo.QueryResult<
    CountContentQuery,
    CountContentQueryVariables
>
export const FetchUserDetailsDocument = gql`
    query FetchUserDetails(
        $socialMediaService: SocialMediaServiceEnum!
        $serviceAccountUsername: String!
    ) {
        fetchUserDetails(
            socialMediaService: $socialMediaService
            serviceAccountUsername: $serviceAccountUsername
        ) {
            error {
                message
                type
            }
            userDetails {
                username
                serviceAccountId
                name
            }
        }
    }
`

/**
 * __useFetchUserDetailsQuery__
 *
 * To run a query within a React component, call `useFetchUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserDetailsQuery({
 *   variables: {
 *      socialMediaService: // value for 'socialMediaService'
 *      serviceAccountUsername: // value for 'serviceAccountUsername'
 *   },
 * });
 */
export function useFetchUserDetailsQuery(
    baseOptions: Apollo.QueryHookOptions<FetchUserDetailsQuery, FetchUserDetailsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<FetchUserDetailsQuery, FetchUserDetailsQueryVariables>(
        FetchUserDetailsDocument,
        options
    )
}
export function useFetchUserDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<FetchUserDetailsQuery, FetchUserDetailsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<FetchUserDetailsQuery, FetchUserDetailsQueryVariables>(
        FetchUserDetailsDocument,
        options
    )
}
export type FetchUserDetailsQueryHookResult = ReturnType<typeof useFetchUserDetailsQuery>
export type FetchUserDetailsLazyQueryHookResult = ReturnType<typeof useFetchUserDetailsLazyQuery>
export type FetchUserDetailsQueryResult = Apollo.QueryResult<
    FetchUserDetailsQuery,
    FetchUserDetailsQueryVariables
>
export const GetClassificationResultsDocument = gql`
    query GetClassificationResults($contentId: Int) {
        getClassificationResults(contentId: $contentId) {
            ...ClassificationResultItem
        }
    }
    ${ClassificationResultItemFragmentDoc}
`

/**
 * __useGetClassificationResultsQuery__
 *
 * To run a query within a React component, call `useGetClassificationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationResultsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetClassificationResultsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetClassificationResultsQuery,
        GetClassificationResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetClassificationResultsQuery, GetClassificationResultsQueryVariables>(
        GetClassificationResultsDocument,
        options
    )
}
export function useGetClassificationResultsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetClassificationResultsQuery,
        GetClassificationResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetClassificationResultsQuery,
        GetClassificationResultsQueryVariables
    >(GetClassificationResultsDocument, options)
}
export type GetClassificationResultsQueryHookResult = ReturnType<
    typeof useGetClassificationResultsQuery
>
export type GetClassificationResultsLazyQueryHookResult = ReturnType<
    typeof useGetClassificationResultsLazyQuery
>
export type GetClassificationResultsQueryResult = Apollo.QueryResult<
    GetClassificationResultsQuery,
    GetClassificationResultsQueryVariables
>
export const GetManyClassificationResultsDocument = gql`
    query GetManyClassificationResults($contentIds: [Int!]!) {
        getManyClassificationResults(contentIds: $contentIds) {
            ...ClassificationResultItem
        }
    }
    ${ClassificationResultItemFragmentDoc}
`

/**
 * __useGetManyClassificationResultsQuery__
 *
 * To run a query within a React component, call `useGetManyClassificationResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManyClassificationResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManyClassificationResultsQuery({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useGetManyClassificationResultsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetManyClassificationResultsQuery,
        GetManyClassificationResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<
        GetManyClassificationResultsQuery,
        GetManyClassificationResultsQueryVariables
    >(GetManyClassificationResultsDocument, options)
}
export function useGetManyClassificationResultsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetManyClassificationResultsQuery,
        GetManyClassificationResultsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<
        GetManyClassificationResultsQuery,
        GetManyClassificationResultsQueryVariables
    >(GetManyClassificationResultsDocument, options)
}
export type GetManyClassificationResultsQueryHookResult = ReturnType<
    typeof useGetManyClassificationResultsQuery
>
export type GetManyClassificationResultsLazyQueryHookResult = ReturnType<
    typeof useGetManyClassificationResultsLazyQuery
>
export type GetManyClassificationResultsQueryResult = Apollo.QueryResult<
    GetManyClassificationResultsQuery,
    GetManyClassificationResultsQueryVariables
>
export const GetAuthorisationUrlDocument = gql`
    query GetAuthorisationUrl(
        $socialMediaService: SocialMediaServiceEnum!
        $accountId: Int!
        $baseUrl: String!
    ) {
        getAuthorisationUrl(
            socialMediaService: $socialMediaService
            accountId: $accountId
            baseUrl: $baseUrl
        )
    }
`

/**
 * __useGetAuthorisationUrlQuery__
 *
 * To run a query within a React component, call `useGetAuthorisationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorisationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorisationUrlQuery({
 *   variables: {
 *      socialMediaService: // value for 'socialMediaService'
 *      accountId: // value for 'accountId'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useGetAuthorisationUrlQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetAuthorisationUrlQuery,
        GetAuthorisationUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetAuthorisationUrlQuery, GetAuthorisationUrlQueryVariables>(
        GetAuthorisationUrlDocument,
        options
    )
}
export function useGetAuthorisationUrlLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetAuthorisationUrlQuery,
        GetAuthorisationUrlQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetAuthorisationUrlQuery, GetAuthorisationUrlQueryVariables>(
        GetAuthorisationUrlDocument,
        options
    )
}
export type GetAuthorisationUrlQueryHookResult = ReturnType<typeof useGetAuthorisationUrlQuery>
export type GetAuthorisationUrlLazyQueryHookResult = ReturnType<
    typeof useGetAuthorisationUrlLazyQuery
>
export type GetAuthorisationUrlQueryResult = Apollo.QueryResult<
    GetAuthorisationUrlQuery,
    GetAuthorisationUrlQueryVariables
>
export const GetUserSubscriptionDocument = gql`
    query GetUserSubscription($referrer: String) {
        getUserSubscription(referrer: $referrer) {
            ...User
        }
    }
    ${UserFragmentDoc}
`

/**
 * __useGetUserSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionQuery({
 *   variables: {
 *      referrer: // value for 'referrer'
 *   },
 * });
 */
export function useGetUserSubscriptionQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetUserSubscriptionQuery,
        GetUserSubscriptionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetUserSubscriptionQuery, GetUserSubscriptionQueryVariables>(
        GetUserSubscriptionDocument,
        options
    )
}
export function useGetUserSubscriptionLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserSubscriptionQuery,
        GetUserSubscriptionQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetUserSubscriptionQuery, GetUserSubscriptionQueryVariables>(
        GetUserSubscriptionDocument,
        options
    )
}
export type GetUserSubscriptionQueryHookResult = ReturnType<typeof useGetUserSubscriptionQuery>
export type GetUserSubscriptionLazyQueryHookResult = ReturnType<
    typeof useGetUserSubscriptionLazyQuery
>
export type GetUserSubscriptionQueryResult = Apollo.QueryResult<
    GetUserSubscriptionQuery,
    GetUserSubscriptionQueryVariables
>
export const GetTeamDocument = gql`
    query GetTeam($teamId: Int!) {
        getTeam(teamId: $teamId) {
            id
            name
            createdAt
            updatedAt
            users {
                id
                username
            }
            accounts {
                accountName
                socialMediaService {
                    displayName
                }
            }
        }
    }
`

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamQuery(
    baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options)
}
export function useGetTeamLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options)
}
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>
export const GetLabelledSpamDocument = gql`
    query GetLabelledSpam($message: String, $platform: String, $threshold: Float) {
        getLabelledSpam(message: $message, platform: $platform, threshold: $threshold) {
            ...SpamSearch
        }
    }
    ${SpamSearchFragmentDoc}
`

/**
 * __useGetLabelledSpamQuery__
 *
 * To run a query within a React component, call `useGetLabelledSpamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelledSpamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelledSpamQuery({
 *   variables: {
 *      message: // value for 'message'
 *      platform: // value for 'platform'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useGetLabelledSpamQuery(
    baseOptions?: Apollo.QueryHookOptions<GetLabelledSpamQuery, GetLabelledSpamQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetLabelledSpamQuery, GetLabelledSpamQueryVariables>(
        GetLabelledSpamDocument,
        options
    )
}
export function useGetLabelledSpamLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetLabelledSpamQuery, GetLabelledSpamQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetLabelledSpamQuery, GetLabelledSpamQueryVariables>(
        GetLabelledSpamDocument,
        options
    )
}
export type GetLabelledSpamQueryHookResult = ReturnType<typeof useGetLabelledSpamQuery>
export type GetLabelledSpamLazyQueryHookResult = ReturnType<typeof useGetLabelledSpamLazyQuery>
export type GetLabelledSpamQueryResult = Apollo.QueryResult<
    GetLabelledSpamQuery,
    GetLabelledSpamQueryVariables
>
export const EnrichContentDocument = gql`
    query enrichContent($contents: [ContentToEnrich!]!) {
        enrichContent(contents: $contents) {
            ...EnrichedContentItem
        }
    }
    ${EnrichedContentItemFragmentDoc}
`

/**
 * __useEnrichContentQuery__
 *
 * To run a query within a React component, call `useEnrichContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichContentQuery({
 *   variables: {
 *      contents: // value for 'contents'
 *   },
 * });
 */
export function useEnrichContentQuery(
    baseOptions: Apollo.QueryHookOptions<EnrichContentQuery, EnrichContentQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<EnrichContentQuery, EnrichContentQueryVariables>(
        EnrichContentDocument,
        options
    )
}
export function useEnrichContentLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<EnrichContentQuery, EnrichContentQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<EnrichContentQuery, EnrichContentQueryVariables>(
        EnrichContentDocument,
        options
    )
}
export type EnrichContentQueryHookResult = ReturnType<typeof useEnrichContentQuery>
export type EnrichContentLazyQueryHookResult = ReturnType<typeof useEnrichContentLazyQuery>
export type EnrichContentQueryResult = Apollo.QueryResult<
    EnrichContentQuery,
    EnrichContentQueryVariables
>
